/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		"main": 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([0,"vendor"]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ "./build/content.json":
/*!****************************!*\
  !*** ./build/content.json ***!
  \****************************/
/*! exports provided: indexHeaderText, indexReasonsText, aboutServicesText, indicators, indicatorsText, aboutReasonText, reviews, reviewsText, indexNews, vacancyHome, cta, footer, aboutHeaderText, aboutCompanyText, aboutValuesText, aboutAdvantagesText, aboutTeamText, teamMemberName, teamMemberTitle, attendanceHeaderText, hook, attendanceText, otherHeaderText, attendanceServText, configuratorText, configurator, dedicatedHeaderText, dedicatedText, dedicatedServersText, cloudHeaderText, cloudText, cloudServersText, antiHeaderText, antiText, antiServersText, adminHeaderText, adminText, adminServersText, aboutServersText, faqHeaderText, faqQuestionTextSearch, faqQuestionText, newsHeaderText, newsWidget, newsWidgetText, contactsHeaderText, contactsFormText, contactsForm, notText, Vacancy1HeaderText, Vacancy1Text, Vacancy2HeaderText, Vacancy2Text, Vacancy3HeaderText, Vacancy3Text, Vacancy4HeaderText, Vacancy4Text, termsHeaderText, termsText, privacyHeaderText, privacyText, Cookies, button, navText, titles, additionalinf, popup, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"indexHeaderText\":{\"caption\":{\"bg\":\"IT Soft Services\",\"en\":\"IT Soft Services\",\"ua\":\"IT Soft Services\"},\"title\":{\"bg\":\"Наети сървъри\",\"en\":\"Dedicated servers\",\"ua\":\"Виділені сервери\"},\"text\":{\"bg\":\"Наетите сървъри предоставят на вашия бизнес ексклузивен достъп до ресурси, гарантирайки максимална продуктивност, пълен контрол, висока сигурност и надеждност за изпълнение на всякакви изчислителни задачи.\",\"en\":\"Dedicated servers provide your business with exclusive access to resources, guaranteeing maximum performance, full control, high security and reliability for any computing task.\",\"ua\":\"Виділені сервери надають вашому бізнесу ексклюзивний доступ до ресурсів, гарантуючи максимальну продуктивність, повний контроль, високу безпеку та надійність для реалізації будь-яких обчислювальних завдань.\"}},\"indexReasonsText\":{\"item\":{\"h2\":{\"bg\":\"Защита на IT инфраструктурата\",\"en\":\"Protect your IT infrastructure\",\"ua\":\"Захист IT-інфраструктури\"},\"text\":{\"bg\":\"Защитата на IT инфраструктурата от DDOS атаки осигурява безпроблемна работа на вашите системи, благодарение на съвременните методи за филтриране на трафика, мониторинг и бързо реагиране на заплахи в режим 24/7.\",\"en\":\"Protecting your IT infrastructure from DDOS attacks ensures the uninterrupted operation of your systems through modern methods of traffic filtering, monitoring, and prompt response to threats 24/7.\",\"ua\":\"Захист IT-інфраструктури від DDOS-атак забезпечує безперебійну роботу ваших систем завдяки сучасним методам фільтрації трафіку, моніторингу та оперативному реагуванню на загрози в режимі 24/7.\"}},\"item1\":{\"h2\":{\"bg\":\"Облачен хостинг\",\"en\":\"Cloud hosting\",\"ua\":\"Хмарний хостинг\"},\"text\":{\"bg\":\"Облачният хостинг осигурява сигурно съхранение и обработка на данни с гъвкаво мащабиране на ресурсите, висока производителност, достъп 24/7 и минимални разходи за поддръжка на собствена инфраструктура.\",\"en\":\"Cloud hosting provides secure data storage and processing with flexible resource scaling, high performance, 24/7 access, and minimal costs for maintaining your own infrastructure.ac\",\"ua\":\"Хмарний хостинг забезпечує безпечне зберігання та обробку даних із гнучким масштабуванням ресурсів, високою продуктивністю, доступом 24/7 та мінімальними затратами на підтримку власної інфраструктури.\"}},\"item2\":{\"h2\":{\"bg\":\"Администриране на сървъри\",\"en\":\"Server administration\",\"ua\":\"Адміністрування серверів\"},\"text\":{\"bg\":\"Настройка и администрирането на сървъри осигурява оптимално използване на ресурси, стабилност на работата, мащабируемост и сигурност на IT инфраструктурата, благодарение на професионалното управление на виртуалните среди.\",\"en\":\"Configuring and administering servers ensures optimal resource utilization, stability, scalability, and security of the IT infrastructure through professional management of virtual environments.\",\"ua\":\"Налаштування та адміністрування серверів забезпечує оптимальне використання ресурсів, стабільність роботи, масштабованість та безпека IT-інфраструктури завдяки професійному управлінню віртуальними середовищами.\"}}},\"aboutServicesText\":{\"item\":{\"h3\":{\"bg\":\"<span>Технологии, </span> които ние използваме\",\"en\":\"<span>Technologies</span> we use\",\"ua\":\"<span>Технології,</span> які ми використовуємо\"},\"caption\":{\"bg\":\"Нашите услуги\",\"en\":\"Our services\",\"ua\":\"Наші послуги\"},\"h2\":{\"bg\":\"Услуги, които ние <span>предлагаме</span>\",\"en\":\"Services we <span>offer</span>\",\"ua\":\"Послуги які ми <span>пропонуємо</span>\"},\"text\":{\"bg\":\"Ние предлагаме широк спектър от IT услуги за осигуряване на стабилност, сигурност и ефективност на вашата инфраструктура. Нашите решения обхващат мониторинг, киберсигурност, техническа поддръжка, настройка на сървъри и облачни платформи, които отговарят на нуждите на съвременния бизнес.\",\"en\":\"We offer a wide range of IT services to ensure the stability, security, and efficiency of your infrastructure. Our solutions include monitoring, cybersecurity, technical support, server and cloud platform setup, and customization to meet the needs of modern business.\",\"ua\":\"Ми пропонуємо широкий спектр IT-послуг для забезпечення стабільності, безпеки та ефективності вашої інфраструктури. Наші рішення охоплюють моніторинг, кіберзахист, технічну підтримку, налаштування серверів і хмарних платформ, що відповідають потребам сучасного бізнесу.\"}},\"item1\":{\"h3\":{\"bg\":\"Мониторинг\",\"en\":\"Monitoring\",\"ua\":\"Моніторинг\"},\"text\":{\"bg\":\"Ние наблюдаваме работоспособността на сървърите 24/7, откривайки и бързо отстранявайки повреди, за да осигурим непрекъсната работа на вашата IT инфраструктура.\",\"en\":\"We monitor server performance 24/7, detecting and promptly resolving malfunctions to ensure the smooth operation of your IT infrastructure.\",\"ua\":\"Ми моніторимо працездатність серверів 24/7, виявляючи та оперативно усуваючи несправності, щоб забезпечити безперебійну роботу вашої IT-інфраструктури.\"}},\"item2\":{\"h3\":{\"bg\":\"Филтриране и обработка на трафика\",\"en\":\"Traffic filtering and processing\",\"ua\":\"Фільтрація та обробка трафіку\"},\"text\":{\"bg\":\"Ние защитаваме вашата инфраструктура от атаки и осигуряваме оптимална скорост и сигурност на данните за стабилна работа на бизнеса.\",\"en\":\"We protect your infrastructure from attacks and ensure optimal data speed and security for stable business operations.\",\"ua\":\"Захищаємо вашу інфраструктуру від атак та забезпечуємо оптимальну швидкість і безпеку даних для стабільної роботи бізнесу.\"}},\"item3\":{\"h3\":{\"bg\":\"Настройка на системи за резервни копия\",\"en\":\"Setting up backup systems\",\"ua\":\"Налаштування систем резервного копіювання\"},\"text\":{\"bg\":\"Ние осигуряваме надеждно съхранение на данни и бързо възстановяване при неуспех, гарантирайки сигурността на вашата информация във всякакви ситуации.\",\"en\":\"We provide reliable data storage and fast recovery in case of failure, ensuring the safety of your information in any situation\",\"ua\":\"Забезпечуємо надійне збереження даних і швидке відновлення в разі збою, гарантуючи безпеку вашої інформації в будь-яких ситуаціях\"}},\"item4\":{\"h3\":{\"bg\":\"Администриране на виртуални машини и сървъри\",\"en\":\"Administration of virtual machines and servers\",\"ua\":\"Адміністрування віртуальних машин та серверів\"},\"text\":{\"bg\":\"Ние осигуряваме стабилна работа на виртуални машини и сървъри, настройваме и оптимизираме ресурси за постигане на най-добра производителност на вашия бизнес.\",\"en\":\"We ensure the stable operation of virtual machines and servers, configure and optimize resources to achieve the best performance for your business.\",\"ua\":\"Забезпечуємо стабільну роботу віртуальних машин та серверів, налаштовуємо та оптимізуємо ресурси для досягнення найкращої продуктивності вашого бізнесу.\"}},\"item5\":{\"h3\":{\"bg\":\"Актуализация на софтуер и операционни системи\",\"en\":\"Software and OS updates\",\"ua\":\"Оновлення ПЗ та ОС\"},\"text\":{\"bg\":\"Ние осигуряваме висока продуктивност, сигурност и стабилност на работата на вашите системи, намалявайки рисковете от уязвимости.\",\"en\":\"We ensure high performance, security, and stability of your systems, reducing the risks of vulnerabilities.\",\"ua\":\"Забезпечуємо високу продуктивність, безпеку та стабільність роботи ваших систем, знижуючи ризики від вразливостей.\"}},\"item6\":{\"h3\":{\"bg\":\"Техническа поддръжка\",\"en\":\"Technical support\",\"ua\":\"Технічна підтримка\"},\"text\":{\"bg\":\"Бързо решаваме всякакви проблеми и осигуряваме непрекъсната работа на вашите системи и услуги.\",\"en\":\"We promptly solve any problems and ensure the smooth operation of your systems and services.\",\"ua\":\"Оперативно вирішуємо будь-які проблеми та забезпечуємо безперебійну роботу ваших систем і сервісів.\"}},\"item7\":{\"h3\":{\"bg\":\"Предоставяне на облачен хостинг\",\"en\":\"Providing cloud hosting\",\"ua\":\"Надання хмарного хостингу\"},\"text\":{\"bg\":\"Ние гарантираме сигурно съхранение на данни, гъвкавост при мащабиране на ресурсите и стабилна работа на вашите уебсайтове и приложения.\",\"en\":\"We guarantee secure data storage, flexible resource scaling, and stable operation of your websites and applications.\",\"ua\":\"Гарантуємо безпечне зберігання даних, гнучкість у масштабуванні ресурсів та стабільну роботу ваших вебсайтів і додатків.\"}},\"item8\":{\"h3\":{\"bg\":\"Защита на IT инфраструктурата от DDOS атаки\",\"en\":\"Protecting IT infrastructure from DDOS attacks\",\"ua\":\"Захист IT-інфраструктури від DDOS-атак\"},\"text\":{\"bg\":\"Ние гарантираме непрекъсната работа на системите чрез съвременни технологии за филтриране и бързо реагиране на заплахи.\",\"en\":\"We guarantee the uninterrupted operation of systems with the help of modern filtering technologies and rapid response to threats.\",\"ua\":\"Гарантуємо безперебійну роботу систем за допомогою сучасних технологій фільтрації та швидкого реагування на загрози.\"}},\"item9\":{\"h3\":{\"bg\":\"Предоставяне на Наети сървъри\",\"en\":\"Provision of dedicated servers\",\"ua\":\"Надання виділених серверів\"},\"text\":{\"bg\":\"Ние гарантираме висока производителност, максимален контрол и надеждност за вашите ресурси.\",\"en\":\"We guarantee high performance, maximum control and reliability for your resources.\",\"ua\":\"Гарантуємо високу продуктивність, максимальний контроль та надійність для ваших ресурсів.\"}}},\"indicators\":{\"item\":{\"caption\":{\"bg\":\"Показатели\",\"en\":\"Indicators\",\"ua\":\"Показники\"},\"h2\":{\"bg\":\"За нас в цифри\",\"en\":\"About us in numbers\",\"ua\":\"Про нас в цифрах\"},\"text\":{\"bg\":\"Запознайте се с показателите на нашата компания, които демонстрират високата ефективност и надеждност на нашите решения.\",\"en\":\"Get acquainted with our company's indicators that demonstrate the high efficiency and reliability of our solutions\",\"ua\":\"Ознайомтеся з показниками нашої компанії, які демонструють високу ефективність та надійність наших рішень\"}}},\"indicatorsText\":{\"item1\":{\"caption\":{\"bg\":\"Проекти\",\"en\":\"Projects\",\"ua\":\"Проєктів\"},\"h3\":{\"bg\":\"25\",\"en\":\"25\",\"ua\":\"25\"},\"text\":{\"bg\":\"Ние успешно реализирахме 25 проекта в сферата на IT, от настройка на сървърите до защита на инфраструктурата, осигурявайки стабилна работа на клиентските системи.\",\"en\":\"We have successfully implemented 25 IT projects, from server setup to infrastructure protection, ensuring the stable operation of client systems.\",\"ua\":\"Ми успішно реалізували 25 проєктів у сфері IT, від налаштування серверів до захисту інфраструктури, забезпечуючи стабільну роботу клієнтських систем.\"}},\"item2\":{\"caption\":{\"bg\":\"Основни направления\",\"en\":\"Key Directions\",\"ua\":\"Основних напрямків\"},\"h3\":{\"bg\":\"6\",\"en\":\"6\",\"ua\":\"6\"},\"text\":{\"bg\":\"Предоставяне на наети сървъри и облачен хостинг, защита на IT инфраструктура, настройка и администриране на сървъри и 24/7 поддръжка на нашите клиенти.\",\"en\":\"Provision of dedicated servers and cloud hosting, IT infrastructure protection, server configuration and administration, and 24/7 support for our clients.\",\"ua\":\"Надання виділених серверів та хмарного хостингу,  захист IT-інфраструктури,  налаштування та адміністрування серверів та цілодобова підтримка наших клієнтів.\"}},\"item3\":{\"caption\":{\"bg\":\"Партньори\",\"en\":\"Partners\",\"ua\":\"Партнерів\"},\"h3\":{\"bg\":\"31\",\"en\":\"31\",\"ua\":\"31\"},\"text\":{\"bg\":\"Ние сътрудничим с 31 надеждни партньори, включително и водещи доставчици на облачни решения, оборудване и софтуер от световна класа.\",\"en\":\"We cooperate with 31 reliable partners, including leading providers of world-class cloud solutions, hardware and software.\",\"ua\":\"Ми співпрацюємо з 31 надійним партнером, включаючи провідних постачальників хмарних рішень, обладнання та програмного забезпечення світового рівня.\"}}},\"aboutReasonText\":{\"item\":{\"caption\":{\"bg\":\"Нашите предимства\",\"en\":\"Our advantages\",\"ua\":\"Наші переваги\"},\"h2\":{\"bg\":\"Защо да изберете нас?\",\"en\":\"Why choose us?\",\"ua\":\"Чому обирають нас?\"}},\"item1\":{\"caption\":{\"bg\":\"Техническа поддръжка\",\"en\":\"Technical support\",\"ua\":\"Технічна підтримка\"},\"h3\":{\"bg\":\"Гаранция за бързо реагиране 24/7\",\"en\":\"Guaranteed fast response 24/7\",\"ua\":\"Гарантія швидкого реагування 24/7\"},\"text\":{\"bg\":\"Гарантираме бързо реагиране 24/7 на всички технически запитвания и проблеми. Нашият екип винаги е готов да реши всякакви въпроси, за да осигури непрекъсната работа на вашата инфраструктура.\",\"en\":\"We guarantee a 24/7 response to all technical inquiries and problems. Our team is always ready to quickly resolve any issues to ensure the smooth operation of your infrastructure.\",\"ua\":\"Гарантуємо швидке реагування 24/7 на всі технічні запити та проблеми. Наша команда завжди готова оперативно вирішити будь-які питання, щоб забезпечити безперебійну роботу вашої інфраструктури.\"}},\"item2\":{\"caption\":{\"bg\":\"Киберсигурност\",\"en\":\"Cyber defense\",\"ua\":\"Кіберзахист\"},\"h3\":{\"bg\":\"Използване на съвременни методи за киберсигурност\",\"en\":\"Using modern methods of cyber defense\",\"ua\":\"Використання сучасних методів кіберзахисту\"},\"text\":{\"bg\":\"Ние използваме съвременни методи за киберсигурност, за да осигурим надеждна защита на вашата IT инфраструктура. Чрез напреднали технологии за филтриране на трафика, мониторинг на заплахи и редовни актуализации ефективно защитаваме вашите данни и системи от потенциални атаки и уязвимости.\",\"en\":\"We use modern cybersecurity methods to ensure reliable security of your IT infrastructure. Thanks to advanced traffic filtering technologies, threat monitoring, and regular updates, we effectively protect your data and systems from potential attacks and vulnerabilities.\",\"ua\":\"Ми використовуємо сучасні методи кіберзахисту для забезпечення надійної безпеки вашої IT-інфраструктури. Завдяки передовим технологіям фільтрації трафіку, моніторингу загроз та регулярним оновленням ми ефективно захищаємо ваші дані та системи від потенційних атак і вразливостей.\"}},\"item3\":{\"caption\":{\"bg\":\"Стабилност на работата\",\"en\":\"Stable operation\",\"ua\":\"Стабільність роботи\"},\"h3\":{\"bg\":\"99,9% време на безотказна работа\",\"en\":\"99.9% uptime\",\"ua\":\"99,9% часу безвідмовної роботи\"},\"text\":{\"bg\":\"Ние осигуряваме 99,9% време на безотказна работа благодарение на високата надеждност на нашите системи и инфраструктура. Постоянният мониторинг, резервирането и съвременните методи на защита гарантират стабилността и непрекъсната работа на вашите услуги дори при най-сложни условия.\",\"en\":\"We provide 99.9% uptime due to the high reliability of our systems and infrastructure. Continuous monitoring, redundancy, and advanced security methods ensure that your services are stable and uninterrupted, even in the most challenging conditions.\",\"ua\":\"Ми забезпечуємо 99,9% часу безвідмовної роботи завдяки високій надійності наших систем та інфраструктури. Постійний моніторинг, резервування та сучасні методи захисту гарантують стабільність та безперебійну роботу ваших сервісів, навіть у найскладніших умовах.\"}}},\"reviews\":{\"caption\":{\"bg\":\"Отзиви\",\"en\":\"Feedback\",\"ua\":\"Відгуки\"},\"h2\":{\"bg\":\"Обратна връзка от нашите <span>клиенти</span>\",\"en\":\"Feedback from our clients\",\"ua\":\"Зворотний зв'язок від наших <span>клієнтів</span>\"}},\"reviewsText\":{\"item1\":{\"h3\":{\"bg\":\"Андрей В.\",\"en\":\"Andrii V.\",\"ua\":\"Андрій В.\"},\"text\":{\"bg\":\"Преходът към техните Наети сървъри беше най-доброто решение за нашата компания. Увеличението на производителността стана мигновено, а техният екип за поддръжка е изключителен.\",\"en\":\"Moving to their dedicated servers was the best solution for our company. The performance improvement was instantaneous and their support team is exceptional.\",\"ua\":\"Перехід на їхні виділені сервери був найкращим рішенням для нашої компанії. Підвищення продуктивності відбулося миттєво, а їхня команда підтримки виняткова.\"}},\"item2\":{\"h3\":{\"bg\":\"Максим Д.\",\"en\":\"Maksym D.\",\"ua\":\"Максим Д.\"},\"text\":{\"bg\":\"Избрахме тази компания за настройка и администриране на нашите сървъри и не съжаляваме. Всички процеси са автоматизирани, а актуализациите се правят навреме. Препоръчвам!\",\"en\":\"We chose this company to set up and administer our servers and have not regretted it. All processes are automated, and updates are made in a timely manner. Highly recommended!\",\"ua\":\"Ми обрали цю компанію для налаштування та адміністрування наших серверів і не пошкодували. Всі процеси автоматизовані, а оновлення проводяться своєчасно. Рекомендую!\"}},\"item3\":{\"h3\":{\"bg\":\"Катерина А.\",\"en\":\"Kateryna A.\",\"ua\":\"Катерина А.\"},\"text\":{\"bg\":\"Много е трудно да се намери достоен партньор, но най-накрая успяхме. Специални благодарности на техническата поддръжка, такова бързо реагиране не съм виждала никъде!\",\"en\":\"It is very difficult to find a worthy partner, but we finally succeeded. Special thanks to the technical support, I have never seen such a quick response anywhere!\",\"ua\":\"Дуже важко знайти гідного партнера, але нарешті нам вдалося. Окреме дякую технічній підтримці, настільки швидкого реагування я ніде не бачила!\"}},\"item4\":{\"h3\":{\"bg\":\"Владимир Л.\",\"en\":\"Volodymyr L.\",\"ua\":\"Володимир Л.\"},\"text\":{\"bg\":\"За нас е важна непрекъсната работа на системите и тази компания се справя с задачата на 100%. Те постоянно наблюдават сървърите, актуализират софтуера навреме и осигуряват високо ниво на защита на данните. Много съм благодарен за такова качествено обслужване!\",\"en\":\"Continuous operation of systems is important to us, and this company copes with the task 100%. They constantly monitor servers, promptly update software, and provide a high level of data protection. I am very grateful for such a quality service!\",\"ua\":\"Для нас важлива безперервна робота систем, і ця компанія справляється із завданням на всі 100%. Вони постійно моніторять сервери, оперативно оновлюють ПЗ і забезпечують високий рівень захисту даних. Дуже вдячний за такий якісний сервіс!\"}}},\"indexNews\":{\"caption\":{\"bg\":\"Новини\",\"en\":\"News\",\"ua\":\"Новини\"},\"h2\":{\"bg\":\"Бъдете в крак с последните новини\",\"en\":\"Stay up to date with the latest news\",\"ua\":\"Будьте в курсі останніх новин\"}},\"vacancyHome\":{\"caption\":{\"bg\":\"Отворени работни позиции\",\"en\":\"Open vacancies\",\"ua\":\"Відкриті вакансії\"},\"h2\":{\"bg\":\"Търсим специалист\",\"en\":\"We are looking for a specialist\",\"ua\":\"Шукаємо спеціаліста\"},\"item1\":{\"bg\":\"Системен администратор L3 (Windows)\",\"en\":\"System administrator L3 (Windows)\",\"ua\":\"System administrator L3 (Windows)\"},\"item2\":{\"bg\":\"SOC инженер\",\"en\":\"SOC Engineer\",\"ua\":\"SOC Engineer\"},\"item3\":{\"bg\":\"Penetration Tester\",\"en\":\"Penetration Tester\",\"ua\":\"Penetration Tester\"},\"item4\":{\"bg\":\"Мрежов анализатор\",\"en\":\"Network Analyst\",\"ua\":\"Network Analyst\"}},\"cta\":{\"caption\":{\"bg\":\"Готови ли сте за нови възможности за вашия бизнес?\",\"en\":\"Are you ready for new opportunities for your business?\",\"ua\":\"Ви готові до нових можливостей для вашого бізнесу?\"},\"h2\":{\"bg\":\"Свържете се с нас днес и ние ще ви помогнем да намерите оптимално IT решение за вашия успех!\",\"en\":\"Contact us today and we will help you find the best IT solution for your success!\",\"ua\":\"Зв’яжіться з нами сьогодні, і ми допоможемо знайти оптимальне IT-рішення для вашого успіху!\"}},\"footer\":{\"text\":{\"bg\":\"Свържете се с нас днес, за да разберете как нашият хостинг и IT решения могат да допринесат за развитието на вашия бизнес.\",\"en\":\"Contact us today to find out how our hosting and IT solutions can help your business grow.\",\"ua\":\"Зв’яжіться з нами сьогодні, щоб дізнатися, як наш хостинг та ІТ-рішення можуть сприяти розвитку вашого бізнесу.\"},\"item1\":{\"h3\":{\"bg\":\"Начало\",\"en\":\"Home\",\"ua\":\"Головна\"},\"text1\":{\"bg\":\"Компания\",\"en\":\"Company\",\"ua\":\"Компанія\"},\"text2\":{\"bg\":\"Решения\",\"en\":\"Solutions\",\"ua\":\"Рішення\"},\"text3\":{\"bg\":\"Контакти\",\"en\":\"Contact us\",\"ua\":\"Контакти\"}},\"item2\":{\"h3\":{\"bg\":\"Услуги\",\"en\":\"Services\",\"ua\":\"Послуги\"},\"text1\":{\"bg\":\"Наети сървъри\",\"en\":\"Dedicated servers\",\"ua\":\"Виділені сервери\"},\"text2\":{\"bg\":\"Облачен хостинг\",\"en\":\"Cloud hosting\",\"ua\":\"Хмарний хостинг\"},\"text3\":{\"bg\":\"Защита от DDoS атаки\",\"en\":\"Protection against DDoS attacks\",\"ua\":\"Захист від DDoS-атаки\"},\"text4\":{\"bg\":\"Системно администриране\",\"en\":\"System administration\",\"ua\":\"Системне адміністрування\"}},\"item3\":{\"h3\":{\"bg\":\"Други\",\"en\":\"Other services\",\"ua\":\"Інше\"},\"text1\":{\"bg\":\"Често задавани въпроси (FAQ)\",\"en\":\"FAQ\",\"ua\":\"FAQ\"},\"text2\":{\"bg\":\"Актуални новини\",\"en\":\"Current news\",\"ua\":\"Актуальні новини\"},\"text3\":{\"bg\":\"Политика за конфиденциалност\",\"en\":\"Privacy policy\",\"ua\":\"Політика конфіденційності\"},\"text4\":{\"bg\":\"Условия за предоставяне на услуги\",\"en\":\"Terms of service\",\"ua\":\"Умови надання послуг\"}},\"item4\":{\"h3\":{\"bg\":\"IT Soft Services LTD. Всички права запазени.\",\"en\":\"IT Soft Services LTD. All rights reserved.\",\"ua\":\"IT Soft Services LTD. Всі права захищені.\"}},\"item5\":{\"h3\":{\"bg\":\"Имейл\",\"en\":\"Email\",\"ua\":\"Email\"},\"text1\":{\"bg\":\"info@itsoftservice.com\",\"en\":\"info@itsoftservice.com\",\"ua\":\"info@itsoftservice.com\"}},\"item6\":{\"h3\":{\"bg\":\"Главен офис:\",\"en\":\"Head office\",\"ua\":\"Головний офіс\"},\"text1\":{\"bg\":\"1A, 1/1, ул. Рачо Димчев 8300, Средец, София, България\",\"en\":\"1A, 1/1, Racho Dimchev Str. 8300, Sredets, Sofia, Bulgaria\",\"ua\":\"1A, 1/1, Racho Dimchev Str. 8300, Sredets, Sofia, Bulgaria\"}}},\"aboutHeaderText\":{\"caption\":{\"bg\":\"За нас\",\"en\":\"About us\",\"ua\":\"Про нас\"},\"title\":{\"bg\":\"История на нашата компания\",\"en\":\"History of our company\",\"ua\":\"Історія нашої компанії\"},\"text\":{\"bg\":\"Нашата компания беше основана с цел предоставяне на висококачествени IT услуги за бизнеси с различен мащаб. От самото начало се фокусирахме върху иновации, надеждност и стабилност.\",\"en\":\"Our company was founded to provide high-quality IT services for businesses of all sizes. From the very first days, we focused on innovation, reliability and stability.\",\"ua\":\"Наша компанія була заснована з метою надання високоякісних IT-послуг для бізнесів різного масштабу. Від перших днів ми зосереджувалися на інноваціях, надійності та стабільності.\"}},\"aboutCompanyText\":{\"item\":{\"caption\":{\"bg\":\"За компанията\",\"en\":\"About the company\",\"ua\":\"Про компанію\"},\"text\":{\"bg\":\"Основаване на компанията\",\"en\":\"The foundation of the company\",\"ua\":\"Заснування компанії\"},\"h2\":{\"bg\":\"Нашата компания беше основана с целта да създаде надеждни и ефективни IT решения за предприятията. Започнахме с малък екип от съмишленици, фокусирани върху предоставяне на висококачествени услуги в сферата на IT поддръжката.\",\"en\":\"Our company was founded to create reliable and efficient IT solutions for businesses. We started with a small team of like-minded people, focusing on providing high-quality IT support services.\",\"ua\":\"Наша компанія була заснована з метою створення надійних та ефективних IT-рішень для підприємств. Ми почали з невеликої команди однодумців, зосередившись на наданні високоякісних послуг у сфері IT-підтримки.\"}},\"item1\":{\"text\":{\"bg\":\"Разширяване на услугите\",\"en\":\"Expanding our services\",\"ua\":\"Розширення послуг\"},\"h3\":{\"bg\":\"Активно разширявахме обхвата на нашите услуги, включително системи за резервни копия, облачни решения и защита от киберзаплахи. Благодарение на постоянния ни напредък, станахме надежден партньор за нашите клиенти.\",\"en\":\"We have been actively expanding the range of our services, including backup systems, cloud solutions, and protection against cyber threats. Through continuous development, we have become a reliable partner for our customers.\",\"ua\":\"Ми активно розширювали спектр наших послуг, включаючи системи резервного копіювання, хмарні рішення та захист від кіберзагроз. Завдяки постійному розвитку, ми стали надійним партнером для наших клієнтів.\"}},\"item2\":{\"text\":{\"bg\":\"Въвеждане на иновации\",\"en\":\"Implementing innovations\",\"ua\":\"Впровадження інновацій\"},\"h3\":{\"bg\":\"Винаги сме били насочени към новаторски технологии. Въвеждайки иновационни решения във всички области, успяхме да осигурим на нашите клиенти стабилност и сигурност в работата на техните системи.\",\"en\":\"We have always been focused on the latest technologies. By implementing innovative solutions in all areas, we have been able to provide our customers with stability and security in their systems.\",\"ua\":\"Ми завжди були орієнтовані на новітні технології. Впроваджуючи інноваційні рішення в усіх напрямках, ми змогли забезпечити нашим клієнтам стабільність і безпеку в роботі їхніх систем.\"}},\"item3\":{\"text\":{\"bg\":\"Съвременен етап на развитие\",\"en\":\"The current stage of development\",\"ua\":\"Сучасний етап розвитку\"},\"h3\":{\"bg\":\"Днес нашата компания продължава активно да се развива, интегрирайки нови технологии, подобрявайки клиентската поддръжка и предлагаща високо-продуктивни IT решения за бизнеси от всякакъв размер.\",\"en\":\"Today, our company continues to grow rapidly, integrating new technologies, improving customer support, and offering high-performance IT solutions for businesses of all sizes.\",\"ua\":\"Сьогодні наша компанія продовжує активно розвиватися, інтегруючи нові технології, покращуючи клієнтську підтримку і пропонуючи високопродуктивні IT-рішення для бізнесів будь-яких розмірів.\"}}},\"aboutValuesText\":{\"item\":{\"caption\":{\"bg\":\"Нашата мисия\",\"en\":\"Our mission\",\"ua\":\"Наша місія\"},\"h2\":{\"bg\":\"Нашите основни <span>ценности</span>\",\"en\":\"Our core <span>values</span>\",\"ua\":\"Наші основні <span>цінності</span>\"}},\"item1\":{\"text\":{\"bg\":\"Нашият опит ни позволява ефективно да решаваме най-сложните задачи и да предлагаме оптимални решения на клиентите си. Знаем как да се адаптираме към промените и да прилагаме доказани практики, които осигуряват стабилност и успех в дългосрочен план.\",\"en\":\"Our experience allows us to effectively solve the most complex problems and offer our clients optimal solutions. We know how to adapt to changes and implement proven practices that ensure stability and success in the long term.\",\"ua\":\"Наш досвід дозволяє ефективно вирішувати найскладніші завдання та пропонувати клієнтам оптимальні рішення. Ми знаємо, як адаптуватися до змін і впроваджувати перевірені практики, що забезпечують стабільність та успіх у довгостроковій перспективі.\"},\"h3\":{\"bg\":\"Безценен опит\",\"en\":\"Invaluable experience\",\"ua\":\"Безцінний досвід\"}},\"item2\":{\"text\":{\"bg\":\"Ние използваме най-съвременните технологии, за да отговорим на най-високите стандарти и нуждите на клиентите. Внедряването на иновациите ни позволява да създаваме ефективни решения, които осигуряват сигурност, производителност и отговорност на предизвикателствата на времето.\",\"en\":\"We use cutting-edge technology to meet the highest standards and client needs. Innovations allow us to create effective solutions that ensure safety, productivity and compliance with the challenges of the times.\",\"ua\":\"Ми використовуємо передові технології, щоб відповідати найвищим стандартам і потребам клієнтів. Впровадження інновацій дозволяє нам створювати ефективні рішення, які забезпечують безпеку, продуктивність та відповідність викликам часу.\"},\"h3\":{\"bg\":\"Съвременни технологии\",\"en\":\"Modern technologies\",\"ua\":\"Сучасні технології\"}},\"item3\":{\"h3\":{\"bg\":\"Уникални подходи\",\"en\":\"Unique approaches\",\"ua\":\"Унікальні підходи\"},\"text\":{\"bg\":\"Всеки проект за нас е индивидуално предизвикателство и ние винаги намираме уникални решения. Благодарение на персонализирания подход към всеки клиент, създаваме продукти и услуги, които точно отговарят на техните нужди и помагат да постигнат бизнес целите си.\",\"en\":\"Each project is an individual challenge for us, and we always find unique solutions. Thanks to our personalized approach to each client, we create products and services that exactly meet their needs and help them achieve their business goals.\",\"ua\":\"Кожен проєкт для нас – це індивідуальний виклик, і ми завжди знаходимо унікальні рішення. Завдяки персоналізованому підходу до кожного клієнта, ми створюємо продукти та сервіси, які точно відповідають їхнім потребам і допомагають досягти бізнес-цілей.\"}},\"item4\":{\"h3\":{\"bg\":\"Партньорство\",\"en\":\"Partnership\",\"ua\":\"Партнерство\"},\"text\":{\"bg\":\"Ние изграждаме отношения, основани на доверие, откритост и взаимна подкрепа. Нашият подход към сътрудничеството е насочен към постигане на общи цели, което ни прави не просто доставчик на услуги, но и истински партньор за нашите клиенти.\",\"en\":\"We build relationships based on trust, openness and mutual support. Our approach to cooperation is aimed at achieving common goals, which makes us not just a service provider, but a true partner for our clients.\",\"ua\":\"Ми будуємо відносини, засновані на довірі, відкритості та взаємній підтримці. Наш підхід до співпраці спрямований на досягнення спільних цілей, що робить нас не просто постачальником послуг, а справжнім партнером для наших клієнтів.\"}}},\"aboutAdvantagesText\":{\"captions\":{\"bg\":\"Предимства\",\"en\":\"Advantages\",\"ua\":\"Переваги\"},\"h2\":{\"bg\":\"Предимства на нашата компания\",\"en\":\"Advantages of our company\",\"ua\":\"Переваги нашої компанії\"},\"text\":{\"bg\":\"Ключовите предимства на нашата компания са съчетанието на професионализъм, индивидуален подход, използването на най-съвременните технологии и надеждна поддръжка. Създаваме решения, които отговарят на вашите нужди, осигурявайки стабилност, сигурност и успешен растеж на вашия бизнес.\",\"en\":\"The key advantages of our company are a combination of professionalism, individual approach, use of advanced technologies and reliable support. We create solutions that meet your needs, ensuring the stability, security and successful development of your business.\",\"ua\":\"Ключові переваги нашої компанії — це поєднання професіоналізму, індивідуального підходу, використання передових технологій та надійної підтримки. Ми створюємо рішення, які відповідають вашим потребам, забезпечуючи стабільність, безпеку та успішний розвиток вашого бізнесу.\"},\"item1\":{\"h3\":{\"bg\":\"Високо ниво на експертиза\",\"en\":\"High level of expertise\",\"ua\":\"Високий рівень експертизи\"},\"text\":{\"bg\":\"Нашият екип се състои от опитни специалисти с дълбоки знания и умения за решаване на най-сложни задачи, осигурявайки качествени резултати за всеки клиент.\",\"en\":\"Our team consists of experienced professionals who have in-depth knowledge and skills to solve the most complex problems, guaranteeing a quality result for each client.\",\"ua\":\"Наша команда складається з досвідчених фахівців, які володіють глибокими знаннями та навичками для вирішення найскладніших завдань, гарантуючи якісний результат для кожного клієнта.\"}},\"item2\":{\"h3\":{\"bg\":\"Индивидуален подход\",\"en\":\"Individual approach\",\"ua\":\"Індивідуальний підхід\"},\"text\":{\"bg\":\"Ние се съобразяваме със спецификата на всеки проект и нуждите на клиента, като разработваме решения, които напълно отговарят на техните цели и осигуряват максимална ефективност.\",\"en\":\"We take into account the specifics of each project and the needs of the client, developing solutions that fully meet their goals and maximize efficiency.\",\"ua\":\"Ми враховуємо специфіку кожного проєкту та потреби клієнта, розробляючи рішення, які повністю відповідають їхнім цілям та забезпечують максимальну ефективність.\"}},\"item3\":{\"h3\":{\"bg\":\"Иновации и технологии\",\"en\":\"Innovation and technology\",\"ua\":\"Інноваційність та технології\"},\"text\":{\"bg\":\"Ние прилагаме най-съвременните технологии и иновационни методи за създаване на решения, които отговарят на съвременните предизвикателства, гарантирайки сигурността и стабилността на IT инфраструктурата.\",\"en\":\"We introduce advanced technologies and innovative methods to create solutions that meet modern challenges, ensuring the security and stability of the IT infrastructure.\",\"ua\":\"Ми впроваджуємо передові технології та інноваційні методи для створення рішень, які відповідають сучасним викликам, гарантуючи безпеку та стабільність IT-інфраструктури.\"}}},\"aboutTeamText\":{\"item\":{\"caption\":{\"bg\":\"Екип\",\"en\":\"Team\",\"ua\":\"Команда\"},\"h2\":{\"bg\":\"Нашият <span>екип</span>\",\"en\":\"Our <span>team</span>\",\"ua\":\"Наша <span>команда</span>\"}},\"item1\":{\"text\":{\"bg\":\"Нашият екип е съставен от опитни специалисти, които обединяват своите знания и енергия, за да създадат иновационни IT решения. Работим като единен механизъм, осигурявайки ефективност, стабилност и качество на всеки проект.\",\"en\":\"Our team consists of experienced professionals who have combined their knowledge and energy to create innovative IT solutions. We work as a single mechanism, ensuring the efficiency, stability, and quality of each project.\",\"ua\":\"Наша команда — це досвідчені фахівці, які об’єднали свої знання та енергію для створення інноваційних IT-рішень. Ми працюємо як єдиний механізм, забезпечуючи ефективність, стабільність і якість кожного проєкту.\"}},\"item2\":{\"text\":{\"bg\":\"Запознайте се с нашите експерти — професионалисти в своята област, които винаги са готови за нови предизвикателства.\",\"en\":\"Meet our experts – dedicated professionals who excel in their field and embrace every new challenge with enthusiasm.\",\"ua\":\"Познайомтесь з нашими експертами — професіоналами своєї справи, які завжди готові до нових викликів.\"}}},\"teamMemberName\":{\"item1\":{\"text\":{\"bg\":\"Олександр Д.\",\"en\":\"Oleksandr D.\",\"ua\":\"Олександр Д.\"}},\"item2\":{\"text\":{\"bg\":\"Андрий П.\",\"en\":\"Andrii P.\",\"ua\":\"Андрій П.\"}},\"item3\":{\"text\":{\"bg\":\"Олена Ц.\",\"en\":\"Olena T.\",\"ua\":\"Олена Ц.\"}},\"item4\":{\"text\":{\"bg\":\"Тетяна О.\",\"en\":\"Tetiana O.\",\"ua\":\"Тетяна О.\"}},\"item5\":{\"text\":{\"bg\":\"Сергий С.\",\"en\":\"Serhii S.\",\"ua\":\"Сергій С.\"}},\"item6\":{\"text\":{\"bg\":\"Павло З.\",\"en\":\"Pavlo Z.\",\"ua\":\"Павло З.\"}},\"item7\":{\"text\":{\"bg\":\"Мария Х.\",\"en\":\"Mariia H.\",\"ua\":\"Марія Х.\"}},\"item8\":{\"text\":{\"bg\":\"Олександр Л.\",\"en\":\"Oleksandr L.\",\"ua\":\"Олександр Л.\"}},\"item9\":{\"text\":{\"bg\":\"Игор Г.\",\"en\":\"Ihor G.\",\"ua\":\"Ігор Г.\"}},\"item10\":{\"text\":{\"bg\":\"Евген Ф.\",\"en\":\"Yevhen F.\",\"ua\":\"Євген Ф.\"}}},\"teamMemberTitle\":{\"item1\":{\"text\":{\"bg\":\"CTO\",\"en\":\"CTO\",\"ua\":\"CTO\"}},\"item2\":{\"text\":{\"bg\":\"COO\",\"en\":\"COO\",\"ua\":\"COO\"}},\"item3\":{\"text\":{\"bg\":\"Analyst\",\"en\":\"Analyst\",\"ua\":\"Analyst\"}},\"item4\":{\"text\":{\"bg\":\"BA\",\"en\":\"BA\",\"ua\":\"BA\"}},\"item5\":{\"text\":{\"bg\":\"PM\",\"en\":\"PM\",\"ua\":\"PM\"}},\"item6\":{\"text\":{\"bg\":\"SysAdmin\",\"en\":\"SysAdmin\",\"ua\":\"SysAdmin\"}},\"item7\":{\"text\":{\"bg\":\"DevOps\",\"en\":\"DevOps\",\"ua\":\"DevOps\"}},\"item8\":{\"text\":{\"bg\":\"Tech Support\",\"en\":\"Tech Support\",\"ua\":\"Tech Support\"}},\"item9\":{\"text\":{\"bg\":\"HR\",\"en\":\"HR\",\"ua\":\"HR\"}},\"item10\":{\"text\":{\"bg\":\"Support\",\"en\":\"Support\",\"ua\":\"Support\"}}},\"attendanceHeaderText\":{\"caption\":{\"bg\":\"Услуги\",\"en\":\"Services\",\"ua\":\"Послуги\"},\"title\":{\"bg\":\"Нашите услуги\",\"en\":\"Our services\",\"ua\":\"Наші послуги\"},\"text\":{\"bg\":\"Ние предлагаме широк спектър от IT услуги, за да осигурим стабилност, сигурност и ефективност на вашата инфраструктура. Нашите решения обхващат мониторинг, киберзащита, техническа поддръжка, конфигуриране на сървъри и облачни платформи, които отговарят на нуждите на съвременния бизнес.\",\"en\":\"We offer a wide range of IT services to ensure the stability, security, and efficiency of your infrastructure. Our solutions include monitoring, cybersecurity, technical support, server and cloud platform setup, and customization to meet the needs of modern business.\",\"ua\":\"Ми пропонуємо широкий спектр IT-послуг для забезпечення стабільності, безпеки та ефективності вашої інфраструктури. Наші рішення охоплюють моніторинг, кіберзахист, технічну підтримку, налаштування серверів і хмарних платформ, що відповідають потребам сучасного бізнесу.\"}},\"hook\":{\"item1\":{\"text1\":{\"bg\":\"Наети сървъри\",\"en\":\"Dedicated servers\",\"ua\":\"Виділені сервери\"}},\"item2\":{\"text2\":{\"bg\":\"Защита от DDoS\",\"en\":\"DDoS protection\",\"ua\":\"Захист від DDoS\"}},\"item3\":{\"text3\":{\"bg\":\"Администриране\",\"en\":\"Administration\",\"ua\":\"Адміністрування\"}},\"item4\":{\"text4\":{\"bg\":\"Облачен хостинг\",\"en\":\"Cloud hosting\",\"ua\":\"Хмарний хостинг\"}}},\"attendanceText\":{\"item1\":{\"h3\":{\"bg\":\"Предоставяне на наети сървъри\",\"en\":\"Provision of dedicated servers\",\"ua\":\"Надання виділених серверів\"},\"text1\":{\"bg\":\"Ние предлагаме наети сървъри с висока производителност, контрол и надеждност, които са идеални за сложни задачи и големи проекти.\",\"en\":\"We offer dedicated servers with high performance, control, and reliability, ideal for demanding tasks and large projects.\",\"ua\":\"Ми пропонуємо виділені сервери з високою продуктивністю, контролем і надійністю, що ідеально підходять для вимогливих завдань та великих проєктів.\"},\"text2\":{\"bg\":\"Нашите наети сървъри поддържат мащабируемост, интеграция с различни платформи и осигуряват защита на вашите данни на най-високо ниво.\",\"en\":\"Our dedicated servers support scalability, integration with various platforms, and provide the highest level of data protection.\",\"ua\":\"Наші виділені сервери підтримують масштабування, інтеграцію із різними платформами та забезпечують захист ваших даних на найвищому рівні.\"}},\"item2\":{\"h3\":{\"bg\":\"Защита на IT инфраструктура от DDOS атаки\",\"en\":\"Protecting IT infrastructure from DDOS attacks\",\"ua\":\"Захист IT-інфраструктури від DDOS-атак\"},\"text1\":{\"bg\":\"Ние осигуряваме защита от DDOS атаки, използвайки съвременни технологии за филтриране на трафика и оперативно реагиране на заплахи, за да гарантираме безпроблемна работа на вашите системи.\",\"en\":\"We provide protection against DDOS attacks by using state-of-the-art traffic filtering technologies and responding quickly to threats to ensure that your systems are up and running.\",\"ua\":\"Ми забезпечуємо захист від DDOS-атак, використовуючи сучасні технології фільтрації трафіку та оперативно реагуючи на загрози, щоб гарантувати безперебійну роботу ваших систем.\"},\"text2\":{\"bg\":\"Нашият екип наблюдава мрежовата активност 24/7, открива подозрителна активност в реално време и предотвратява всякакви опити за претоварване.\",\"en\":\"Our team monitors network activity around the clock, detecting suspicious activity in real time and preventing any overload attempts.\",\"ua\":\"Наша команда цілодобово моніторить активність мережі, виявляє підозрілу активність у режимі реального часу та запобігає будь-яким спробам перевантаження.\"}},\"item3\":{\"h3\":{\"bg\":\"Системно администриране\",\"en\":\"System administration\",\"ua\":\"Системне адміністрування\"},\"text1\":{\"bg\":\"Ние администрираме виртуални среди, осигурявайки стабилност на работата, оптимизация на ресурсите и сигурност, за да работи вашата IT инфраструктура възможно най-ефективно.\",\"en\":\"We administer virtual environments, ensuring stability, resource optimization, and security to keep your IT infrastructure running as efficiently as possible.\",\"ua\":\"Ми адмініструємо віртуальні середовища, забезпечуючи стабільність роботи, оптимізацію ресурсів і безпеку, щоб ваша IT-інфраструктура працювала максимально ефективно.\"},\"text2\":{\"bg\":\"Нашите специалисти поемат пълният цикъл на управление – от конфигуриране и мониторинг до отстраняване на проблеми и обновления.\",\"en\":\"Our experts handle the entire management lifecycle – from configuration and monitoring to troubleshooting and updates.\",\"ua\":\"Наші фахівці беруть на себе повний цикл управління – від налаштування та моніторингу до усунення несправностей і оновлень\"}},\"item4\":{\"h3\":{\"bg\":\"Предоставяне на облачен хостинг\",\"en\":\"Providing cloud hosting\",\"ua\":\"Надання хмарного хостингу\"},\"text1\":{\"bg\":\"Ние предоставяме облачен хостинг за безопасно съхранение на данни, гъвкаво мащабиране на ресурсите и стабилна работа на вашите приложения без разходи за собствена инфраструктура.\",\"en\":\"We provide cloud hosting for secure data storage, flexible resource scaling, and stable operation of your applications without the cost of your own infrastructure.\",\"ua\":\"Ми надаємо хмарний хостинг для безпечного зберігання даних, гнучкого масштабування ресурсів та стабільної роботи ваших додатків без затрат на власну інфраструктуру.\"},\"text2\":{\"bg\":\"С помощта на резервни копия и съвременни средства за защита, вашите данни остават напълно сигурни, а бизнесът ви е подготвен за всякакви предизвикателства.\",\"en\":\"With backups and advanced security features, your data remains completely safe and your business is ready for any challenge.\",\"ua\":\"Завдяки резервному копіюванню та сучасним засобам захисту ваші дані залишаються у повній безпеці, а бізнес – готовим до будь-яких викликів.\"}}},\"otherHeaderText\":{\"caption\":{\"bg\":\"Друго\",\"en\":\"Other\",\"ua\":\"Інше\"},\"h2\":{\"bg\":\"Други <span>услуги</span>\",\"en\":\"Additional <span>services</span>\",\"ua\":\"Додаткові <span>послуги</span>\"},\"text\":{\"bg\":\"Ние предлагаме широк спектър от IT услуги за осигуряване на стабилност, сигурност и ефективност на вашата инфраструктура. Нашите решения обхващат мониторинг, киберзащита, техническа поддръжка, конфигуриране на сървъри и облачни платформи, които отговарят на нуждите на съвременния бизнес.\",\"en\":\"We offer a wide range of IT services to ensure the stability, security, and efficiency of your infrastructure. Our solutions include monitoring, cybersecurity, technical support, server and cloud platform setup, and customization to meet the needs of modern businesses.\",\"ua\":\"Ми пропонуємо широкий спектр IT-послуг для забезпечення стабільності, безпеки та ефективності вашої інфраструктури. Наші рішення охоплюють моніторинг, кіберзахист, технічну підтримку, налаштування серверів і хмарних платформ, що відповідають потребам сучасного бізнесу.\"}},\"attendanceServText\":{\"item1\":{\"h3\":{\"bg\":\"Филтриране и обработка на трафик\",\"en\":\"Traffic filtering and processing\",\"ua\":\"Фільтрація та обробка трафіку\"},\"text1\":{\"bg\":\"Ние анализираме и почистваме мрежовия трафик, защитавайки вашите системи от злонамерени влияния и осигурявайки ефективен трансфер на данни за стабилната работа на бизнеса.\",\"en\":\"We analyze and clean up network traffic, protecting your systems from malicious influences and ensuring efficient data transfer for stable business operations.\",\"ua\":\"Ми аналізуємо та очищуємо мережевий трафік, захищаючи ваші системи від шкідливого впливу та забезпечуючи ефективну передачу даних для стабільної роботи бізнесу.\"},\"text2\":{\"bg\":\"Използваме съвременни алгоритми за филтриране и осигуряваме висока скорост на обработка на данни дори при пикови натоварвания.\",\"en\":\"We use advanced filtering algorithms to ensure high data processing speeds even during peak loads.\",\"ua\":\"Ми використовуємо передові алгоритми фільтрації та забезпечуємо високу швидкість обробки даних навіть під час пікових навантажень.\"}},\"item2\":{\"h3\":{\"bg\":\"Защита файъруол\",\"en\":\"Firewall protection\",\"ua\":\"Захист брандмауером\"},\"text1\":{\"bg\":\"Нашите сървъри са оборудвани с мощни решения за защита от външни заплахи чрез файъруол. Благодарение на това можете да сте сигурни в безопасността на вашите данни и ресурси.\",\"en\":\"Our servers are equipped with powerful firewall solutions to protect against external threats. Thanks to this, you can be sure of the security of your data and resources.\",\"ua\":\"Наші сервери оснащені потужними рішеннями для захисту від зовнішніх загроз за допомогою брандмауера. Завдяки цьому ви можете бути впевнені в безпеці своїх даних та ресурсів.\"},\"text2\":{\"bg\":\"Постоянното обновяване на правилата и наблюдение на трафика ни позволяват да реагираме бързо на новите заплахи.\",\"en\":\"Constantly updating rules and monitoring traffic allows you to respond quickly to new threats.\",\"ua\":\"Постійне оновлення правил і моніторинг трафіку дозволяють оперативно реагувати на нові загрози.\"}},\"item3\":{\"h3\":{\"bg\":\"Конфигуриране на системи за резервни копия\",\"en\":\"Setting up backup systems\",\"ua\":\"Налаштування систем резервного копіювання\"},\"text1\":{\"bg\":\"Ние създаваме и внедряваме системи за резервно копие, които гарантират съхранението на данни и бързо възстановяване на информация при сривове, осигурявайки надеждност и сигурност.\",\"en\":\"We create and implement backup systems that guarantee data safety and quick recovery of information in the event of failures, ensuring reliability and security.\",\"ua\":\"Ми створюємо та впроваджуємо системи резервного копіювання, що гарантують збереження даних і швидке відновлення інформації в разі збоїв, забезпечуючи надійність та безпеку.\"},\"text2\":{\"bg\":\"Ние предоставяме контрол на достъпа, криптиране на данни и редовна проверка на целостта на резервните копия, за да минимизираме рисковете от загуба на информация.\",\"en\":\"We provide access control, data encryption, and regular backup integrity checks to minimize the risk of data loss.\",\"ua\":\"Ми забезпечуємо контроль доступу, шифрування даних і регулярну перевірку цілісності резервних копій, щоб мінімізувати ризики втрати інформації.\"}},\"item4\":{\"h3\":{\"bg\":\"Техническа поддръжка\",\"en\":\"Technical support\",\"ua\":\"Технічна підтримка\"},\"text1\":{\"bg\":\"Нашата техническа поддръжка работи 24/7, като бързо разрешава всички проблеми и помага да поддържате безпроблемна работа на вашите системи по всяко време.\",\"en\":\"Our technical support team is available 24/7 to resolve any issues and help keep your systems running smoothly at all times.\",\"ua\":\"Наша технічна підтримка працює 24/7, оперативно вирішуючи будь-які питання та допомагаючи підтримувати безперебійну роботу ваших систем у будь-який час.\"},\"text2\":{\"bg\":\"С професионален подход и бързо реагиране, вашата IT инфраструктура остава стабилна, а бизнесът ви е защитен от прекъсвания.\",\"en\":\"Thanks to our professional approach and quick response, your IT infrastructure remains stable and your business is protected from downtime.\",\"ua\":\"Завдяки професійному підходу та швидкому реагуванню ваша IT-інфраструктура залишається стабільною, а бізнес – захищеним від простоїв.\"}},\"item5\":{\"h3\":{\"bg\":\"Актуализация на софтуер и операционни системи\",\"en\":\"Software and operating system updates\",\"ua\":\"Оновлення програмного забезпечення та операційної системи\"},\"text1\":{\"bg\":\"Ние извършваме редовни актуализации на софтуера и операционните системи, като повишаваме производителността, сигурността и стабилността на вашата IT инфраструктура и минимизираме рисковете от уязвимости.\",\"en\":\"We perform regular software and OS updates to improve the performance, security, and stability of your IT infrastructure, minimizing the risk of vulnerabilities.\",\"ua\":\"Ми проводимо регулярне оновлення програмного забезпечення та ОС, підвищуючи продуктивність, захищеність та стабільність вашої IT-інфраструктури, мінімізуючи ризики вразливостей.\"},\"text2\":{\"bg\":\"Ние тестваме всички актуализации преди внедряване, за да гарантираме съвместимост и да избегнем евентуални сривове в работата на системите.\",\"en\":\"We test all updates before implementation to ensure compatibility and avoid possible system failures.\",\"ua\":\"Ми тестуємо всі оновлення перед впровадженням, щоб гарантувати сумісність і уникнути можливих збоїв у роботі систем.\"}}},\"configuratorText\":{\"caption\":{\"bg\":\"Конфигуратор\",\"en\":\"Configurator\",\"ua\":\"Конфігуратор\"},\"h2\":{\"bg\":\"Конфигуратор на услуги\",\"en\":\"Service configurator\",\"ua\":\"Конфігуратор послуг\"},\"text\":{\"bg\":\"Можете самостоятелно да създадете набор от услуги, които ви интересуват.\",\"en\":\"You can create a set of services you are interested in on your own\",\"ua\":\"Ви можете самостійно створити набір послуг, які тебе зацікавили\"}},\"configurator\":{\"item1\":{\"text1\":{\"bg\":\"Наети сървъри\",\"en\":\"Dedicated servers\",\"ua\":\"Виділені сервери\"},\"text2\":{\"bg\":\"Защита от DDoS\",\"en\":\"DDoS protection\",\"ua\":\"Захист від DDoS\"},\"text3\":{\"bg\":\"Системно администриране\",\"en\":\"System administration\",\"ua\":\"Системне адміністрування\"},\"text4\":{\"bg\":\"Облачен хостинг\",\"en\":\"Cloud hosting\",\"ua\":\"Хмарний хостинг\"}},\"item2\":{\"text1\":{\"bg\":\"CPU:\",\"text\":{\"bg\":\"Централен процесор\",\"en\":\"Central processor\",\"ua\":\"Центральний процесор\"},\"option1\":{\"bg\":\"E5-2690v3\",\"en\":\"E5-2690v3\",\"ua\":\"E5-2690v3\"},\"option2\":{\"bg\":\"Silver 4116\",\"en\":\"Silver 4116\",\"ua\":\"Silver 4116\"},\"option3\":{\"bg\":\"GPU Tesla M60\",\"en\":\"GPU Tesla M60\",\"ua\":\"GPU Tesla M60\"},\"option4\":{\"bg\":\"GPU Tesla K80\",\"en\":\"GPU Tesla K80\",\"ua\":\"GPU Tesla K80\"},\"en\":\"CPU:\",\"ua\":\"CPU:\"},\"text2\":{\"bg\":\"RAM:\",\"text\":{\"bg\":\"Оперативна памет\",\"en\":\"RAM\",\"ua\":\"Оперативна пам'ять\"},\"option1\":{\"bg\":\"256 GB DDR3\",\"en\":\"256GB DDR3\",\"ua\":\"256 GB DDR3\"},\"option2\":{\"bg\":\"256 GB DDR4\",\"en\":\"256 GB DDR4\",\"ua\":\"256 GB DDR4\"},\"option3\":{\"bg\":\"512 GB DDR4\",\"en\":\"512 GB DDR4\",\"ua\":\"512 GB DDR4\"},\"en\":\"RAM:\",\"ua\":\"RAM:\"},\"text3\":{\"bg\":\"HDD:\",\"text\":{\"bg\":\"Хард диск\",\"en\":\"Hard disk drive\",\"ua\":\"Жорсткий диск\"},\"option1\":{\"bg\":\"240GB\",\"en\":\"240GB\",\"ua\":\"240GB\"},\"option2\":{\"bg\":\"800GB\",\"en\":\"800GB\",\"ua\":\"800GB\"},\"option3\":{\"bg\":\"4TB\",\"en\":\"4TB\",\"ua\":\"4TB\"},\"en\":\"HDD.\",\"ua\":\"HDD\"},\"text4\":{\"bg\":\"GPU:\",\"text\":{\"bg\":\"Видео карта\",\"en\":\"Video card\",\"ua\":\"Відеокарта\"},\"option1\":{\"bg\":\"Няма\",\"en\":\"Not available\",\"ua\":\"Відсутня\"},\"option2\":{\"bg\":\"Tesla M60\",\"en\":\"Tesla M60\",\"ua\":\"Tesla M60\"},\"option3\":{\"bg\":\"Tesla K80\",\"en\":\"Tesla K80\",\"ua\":\"Tesla K80\"},\"en\":\"GPU\",\"ua\":\"GPU\"}},\"item3\":{\"text1\":{\"bg\":\"Готови решения\",\"en\":\"Ready-made solutions\",\"ua\":\"Готові рішення\"},\"text2\":{\"bg\":\"Ние вече сме подготвили няколко варианта на готови решения, които са популярни сред нашите клиенти.\",\"en\":\"We have already prepared several options for ready-made solutions that are in demand\",\"ua\":\"Ми вже підготували кілька варіантів готових рішень, які користуються попитом\"},\"option1\":{\"bg\":\"2x Xeon E5-2690v3\",\"en\":\"2x Xeon E5-2690v3\",\"ua\":\"2x Xeon E5-2690v3\"},\"option2\":{\"bg\":\"2x Xeon Silver 4116\",\"en\":\"2x Xeon Silver 4116\",\"ua\":\"2x Xeon Silver 4116\"},\"option3\":{\"bg\":\"2x Xeon E5-2670v3 / GPU Tesla M60\",\"en\":\"2x Xeon E5-2670v3 / Tesla M60 GPU\",\"ua\":\"2x Xeon E5-2670v3 / GPU Tesla M60\"},\"option4\":{\"bg\":\"2x Xeon E5-2690v3 / GPU Tesla K80\",\"en\":\"2x Xeon E5-2690v3 / GPU Tesla K80\",\"ua\":\"2x Xeon E5-2690v3 / GPU Tesla K80\"}},\"item4\":{\"text1\":{\"bg\":\"Допълнителни опции\",\"en\":\"Additional options\",\"ua\":\"Додаткові опції\"},\"text2\":{\"bg\":\"Ние също предлагаме редица допълнителни услуги, които са търсени от нашите клиенти.\",\"en\":\"We also offer a number of additional services that are in high demand among our customers.\",\"ua\":\"Ми також пропонуємо ряд додаткових послуг, що користуються високим попитом серед наших клієнтів.\"},\"option1\":{\"bg\":\"Филтриране и обработка на трафик\",\"en\":\"Traffic filtering and processing\",\"ua\":\"Фільтрація та обробка трафіку\"},\"option2\":{\"bg\":\"Защита с файъруол\",\"en\":\"Firewall protection\",\"ua\":\"Захист брандмауером\"},\"option3\":{\"bg\":\"Системи за резервни копия\",\"en\":\"Backup systems\",\"ua\":\"Систем резервного копіювання\"},\"option4\":{\"bg\":\"Техническа поддръжка\",\"en\":\"Technical support\",\"ua\":\"Технічна підтримка\"},\"option5\":{\"bg\":\"Актуализация на софтуер\",\"en\":\"Software updates\",\"ua\":\"Оновлення програмного забезпечення\"}},\"item5\":{\"text1\":{\"bg\":\"Събрали сте вече вашата конфигурация?\",\"en\":\"Have you completed your configuration?\",\"ua\":\"Зібрали свою конфігурацію?\"},\"text2\":{\"bg\":\"Изпратете вашата конфигурация и представител на нашата компания ще се свърже с вас в най-скоро време.\",\"en\":\"Send your configuration and a representative of our company will contact you shortly\",\"ua\":\"Надішліть вашу конфігурацію і представник нашої компанії зв'яжеться з вами найближчим часом\"}}},\"dedicatedHeaderText\":{\"caption\":{\"bg\":\"Наети сървъри\",\"en\":\"Dedicated servers\",\"ua\":\"Виділені сервери\"},\"h2\":{\"bg\":\"Предоставяне на наети сървъри\",\"en\":\"Providing dedicated servers\",\"ua\":\"Надання виділених серверів\"},\"title\":{\"bg\":\"Ние предлагаме наети сървъри с висока производителност, контрол и надеждност, които са идеални за взискателни задачи и големи проекти.\",\"en\":\"We offer dedicated servers with high performance, control, and reliability, ideal for demanding tasks and large projects.\",\"ua\":\"Ми пропонуємо виділені сервери з високою продуктивністю, контролем і надійністю, що ідеально підходять для вимогливих завдань та великих проєктів.\"}},\"dedicatedText\":{\"caption\":{\"bg\":\"Нашето предложение\",\"en\":\"Our offer\",\"ua\":\"Наша пропозиція\"},\"h2\":{\"bg\":\"Готови решения за специализирано обслужване\",\"en\":\"Turnkey managed services solutions\",\"ua\":\"Готові рішення спеціального обслуговування\"},\"title\":{\"bg\":\"Ние осигуряваме цялостен мониторинг на сървърите, бързо откриване и отстраняване на проблеми, за да гарантираме стабилна работа на вашата IT инфраструктура и да минимизираме риска от прекъсване.\",\"en\":\"We provide comprehensive server monitoring, prompt troubleshooting, and troubleshooting to ensure the stable operation of your IT infrastructure and minimize the risk of downtime.\",\"ua\":\"Ми забезпечуємо комплексний моніторинг серверів, оперативне виявлення та усунення несправностей, щоб гарантувати стабільну роботу вашої ІТ-інфраструктури та мінімізувати ризик простою.\"},\"title2\":{\"bg\":\"Вие можете <span>самостоятелно </span> да съставите и коригирате параметрите на необходимото оборудване.\",\"en\":\"You can independently create and adjust the parameters of the necessary equipment.\",\"ua\":\"Ви можете <span>самостійно</span> сформувати і відкоригувати параметри необхідного обладнання.\"}},\"dedicatedServersText\":{\"h3\":{\"bg\":\"За наетите сървъри\",\"en\":\"About dedicated servers\",\"ua\":\"Про виділені сервери\"},\"text\":{\"bg\":\"Подробно описание\",\"en\":\"Detailed description\",\"ua\":\"Детальний опис\"},\"caption\":{\"bg\":\"Компанията IT Soft Services предлага аутсорсинг на обслужването на системен и приложен софтуер, мрежово и сървърно оборудване, разположено в дейта центровете OST и NORD.\",\"en\":\"IT Soft Services offers outsourcing of system and application software, network and server equipment located in OST and NORD data centers.\",\"ua\":\"Компанія IT Soft Services пропонує аутсорсинг обслуговування системного і прикладного програмного забезпечення, мережевого і серверного обладнання, розташованого в дата-центрах OST і NORD.\"},\"caption2\":{\"bg\":\"Постоянен мониторинг на сървърите за бързо откриване и отстраняване на проблеми, осигуряващ безпроблемна работа на вашата инфраструктура.\",\"en\":\"Constant monitoring of servers to quickly identify and resolve malfunctions, ensuring the smooth operation of your infrastructure.\",\"ua\":\"Постійний моніторинг серверів для оперативного виявлення та усунення несправностей, забезпечення безперебійної роботи вашої інфраструктури.\"},\"item1\":{\"h3\":{\"bg\":\"Сървърно и мрежово оборудване\",\"en\":\"Server and network equipment\",\"ua\":\"Серверне та мережеве обладнання\"},\"text1\":{\"bg\":\"Сървъри, системи за съхранение на данни\",\"en\":\"Servers, data storage systems\",\"ua\":\"Сервери, системи зберігання даних\"},\"title1\":{\"bg\":\"DSS\",\"en\":\"DSS\",\"ua\":\"DSS\"},\"text2\":{\"bg\":\"Мрежово оборудване\",\"en\":\"Network equipment\",\"ua\":\"Мережеве обладнання\"},\"title2\":{\"bg\":\"маршрутизатори, суичове, файъруолове, разпределители на натоварването\",\"en\":\"Routers, switches, firewalls, load balancers\",\"ua\":\"маршрутизатори, комутатори, фаєрволи, розподілювачі навантаження\"}},\"item2\":{\"h3\":{\"bg\":\"Системен софтуер\",\"en\":\"System software\",\"ua\":\"Системне програмне забезпечення\"},\"text1\":{\"bg\":\"Операционни системи:\",\"en\":\"Operating systems\",\"ua\":\"Операційні системи\"},\"title1\":{\"bg\":\"Windows, Unix, Linux, Solaris, AIX\",\"en\":\"Windows, Unix, Linux, Solaris, AIX\",\"ua\":\"Windows, Unix, Linux, Solaris, AIX\"},\"text2\":{\"bg\":\"Active Directory\",\"en\":\"Active Directory\",\"ua\":\"Active Directory\"},\"text3\":{\"bg\":\"Сървъри за бази данни\",\"en\":\"Database servers\",\"ua\":\"Сервери баз даних\"},\"title2\":{\"bg\":\"MS SQL, MySQL, Oracle DB, Sybase ASE\",\"en\":\"MS SQL, MySQL, Oracle DB, Sybase ASE\",\"ua\":\"MS SQL, MySQL, Oracle DB, Sybase ASE\"},\"text4\":{\"bg\":\"Платформа за виртуализация VMware\",\"en\":\"VMware virtualization platform\",\"ua\":\"Платформа віртуалізації VMware\"}},\"item3\":{\"h3\":{\"bg\":\"Приложен софтуер\",\"en\":\"Application software\",\"ua\":\"Прикладне програмне забезпечення\"},\"text1\":{\"bg\":\"Microsoft Exchange\",\"en\":\"Microsoft Exchange\",\"ua\":\"Microsoft Exchange\"},\"text2\":{\"bg\":\"Microsoft Lync\",\"en\":\"Microsoft Lync\",\"ua\":\"Microsoft Lync\"},\"text3\":{\"bg\":\"Сървъри за отдалечени работни станции\",\"en\":\"Remote desktop services servers\",\"ua\":\"Сервери служб віддалених робочих столів\"},\"title1\":{\"bg\":\"RDS\",\"en\":\"RDS\",\"ua\":\"RDS\"}}},\"cloudHeaderText\":{\"caption\":{\"bg\":\"Облачен хостинг\",\"en\":\"Cloud hosting services\",\"ua\":\"Хмарний хостинг\"},\"h2\":{\"bg\":\"Услуги за облачен хостинг\",\"en\":\"Cloud hosting services\",\"ua\":\"Послуги хмарного хостингу\"},\"title\":{\"bg\":\"Облачният хостинг осигурява безопасно съхранение и обработка на данни с гъвкаво мащабиране на ресурсите, висока производителност, достъп 24/7 и минимални разходи за поддръжка на собствена инфраструктура.\",\"en\":\"Cloud hosting provides secure data storage and processing with flexible resource scaling, high performance, 24/7 access, and minimal costs for maintaining your own infrastructure.\",\"ua\":\"Хмарний хостинг забезпечує безпечне зберігання та обробку даних з гнучким масштабуванням ресурсів, високою продуктивністю, доступом 24/7 та мінімальними витратами на утримання власної інфраструктури.\"}},\"cloudText\":{\"caption\":{\"bg\":\"Нашето предложение\",\"en\":\"Our offer\",\"ua\":\"Наша пропозиція\"},\"h2\":{\"bg\":\"Готови решения за облачен хостинг\",\"en\":\"Ready-made cloud hosting solutions\",\"ua\":\"Готові рішення хмарного хостингу\"},\"title\":{\"bg\":\"Облачният сървър е вид хостинг, към който преминават всички големи интернет проекти, тъй като разходите за този тип хостинг са по-ниски отколкото за нает сървър и това е много по-удобно.\",\"en\":\"A cloud server is the type of hosting that all large Internet projects are gradually switching to, because the cost of this type of hosting is lower than a dedicated server and it is much more convenient.\",\"ua\":\"Хмарний сервер – це той вид хостингу, на який поступово переходять всі великі інтернет-проєкти, адже витрати на цей вид хостингу нижчі, ніж на виділений сервер і це набагато зручніше.\"},\"title2\":{\"bg\":\"Вие можете самостоятелно да съставите и коригирате параметрите на необходимото оборудване.\",\"en\":\"You can create and adjust the parameters of the necessary equipment yourself.\",\"ua\":\"Ви можете <span>самостійно</span> сформувати і відкоригувати параметри необхідного обладнання.\"},\"item1\":{\"h3\":{\"bg\":\"Какво е облачен хостинг?\",\"en\":\"What is cloud hosting?\",\"ua\":\"Що таке хмарний хостинг?\"},\"text\":{\"bg\":\"Облачният сървър е сървър, който предоставя възможност по всяко време да увеличите мощността му, ако проектът се развива и изисква повече ресурси. Можете да настроите сървъра както искате, да имате пълен root достъп до избраната от вас дистрибуция на Linux. Цената на такъв сървър зависи от неговата мощност, а цената на вашия хостинг ще зависи именно от количеството ресурси, които вашият сайт ще използва. Разликата между облачните и наетите сървъри е, че можете по всяко време да увеличите мощността на сървъра си, без да е необходимо да спирате сайта и да прехвърляте всички данни на нов сървър или да чакате, докато оборудването на вашия нает сървър бъде разширено.\",\"en\":\"A cloud server is a server that allows you to increase its capacity at any time if your project develops and requires more resources. You can configure the server the way you want, have full root access to the Linux distribution of your choice. The price of such a server depends on its capacity, and the price of your hosting will depend on the amount of resources your site will use. The difference between cloud and dedicated servers is that you can increase the capacity of your server at any time and you will not need to stop the site and transfer all the data to a new server, or wait until the hardware of your dedicated server is expanded.\",\"ua\":\"Хмарний сервер – це сервер, який дає можливість у будь-який момент збільшити його потужність, якщо проєкт розвивається та потребує більше ресурсів. Ви можете налаштувати сервер так, як вам заманеться, мати повний root-доступ до обраного вами дистрибутива Linux. Ціна такого сервера залежить від його потужності, а ціна вашого хостингу буде залежати саме від кількості ресурсів, які буде використовувати ваш сайт. Різниця між хмарними і виділеними серверами полягає в тому, що ви можете в будь-який момент збільшити потужність свого сервера і вам не потрібно буде зупиняти сайт і переносити всі дані на новий сервер, або чекати, поки обладнання вашого виділеного сервера буде розширено.\"},\"text2\":{\"bg\":\"Разликата между облачните и VPS сървъри е, че много от предложенията за VPS не гарантират ресурсите, които предлагат, тоест други потребители с по-големи проекти могат да забавят работата на вашия сайт. Но при облачния хостинг вие гарантирано ще получите ресурсите, за които плащате.\",\"en\":\"The difference between cloud and VPS servers is that many VPS offers do not guarantee you the resources they provide, meaning that other users with larger projects may slow down your site. But with the cloud, you are guaranteed to get the resources you pay for.\",\"ua\":\"Різниця між хмарними та VPS серверами полягає в тому, що багато пропозицій VPS не гарантують вам ресурсів, які вони надають, тобто інші користувачі з більшими проєктами можуть уповільнити роботу вашого сайту. Але з хмарою ви гарантовано отримаєте ресурси, за які платите.\"}}},\"cloudServersText\":{\"caption\":{\"bg\":\"Мониторинг\",\"en\":\"Monitoring\",\"ua\":\"Моніторинг\"},\"h2\":{\"bg\":\"Софтуерен и хардуерен мониторинг\",\"en\":\"Software and hardware monitoring\",\"ua\":\"Програмний та апаратний моніторинг\"},\"text1\":{\"bg\":\"Мониторингът на оборудването, софтуера и инфраструктурата на дейта центровете позволява поддържането на високо качество на услугата и предотвратяването на аварии. Всички показатели се проследяват внимателно с помощта на специализирани решения и се трансферират в „Моят профил“ и мобилното приложение DL Monitor.\",\"en\":\"Monitoring of data center hardware, software, and infrastructure allows you to maintain high quality of service and prevent accidents. All readings are carefully monitored using specialized solutions and transmitted to My Profile and the DL Monitor mobile application.\",\"ua\":\"Моніторинг обладнання, програмного забезпечення та інфраструктури дата-центрів дозволяє підтримувати високу якість сервісу та запобігати аваріям. Всі показання ретельно відстежуються за допомогою спеціалізованих рішень та транслюються в «Мій профіль» і мобільний додаток DL Monitor.\"},\"text2\":{\"bg\":\"Постоянният мониторинг на сървърите за бързо откриване и отстраняване на проблеми осигурява непрекъсната работа на вашата инфраструктура.\",\"en\":\"Constant monitoring of servers to quickly identify and resolve malfunctions, ensuring the smooth operation of your infrastructure.\",\"ua\":\"Постійний моніторинг серверів для оперативного виявлення та усунення несправностей, забезпечення безперебійної роботи вашої інфраструктури.\"},\"h3\":{\"bg\":\"Контролираните показатели включват:\",\"en\":\"The monitored indicators are:\",\"ua\":\"Показниками, що контролюються, є:\"},\"item1\":{\"text1\":{\"bg\":\"Показатели за енергийна консумация и системи за основно и резервно захранване\",\"en\":\"Power consumption and main and backup power systems\",\"ua\":\"Показники енергоспоживання та систем основного та резервного електроживлення\"},\"title1\":{\"bg\":\"силови ленти, UPS устройства, дизелови генератори\",\"en\":\"power beams, UPS, diesel generators\",\"ua\":\"силові балки, ДБЖ, дизельні генератори\"},\"text2\":{\"bg\":\"Климатични параметри\",\"en\":\"Climate parameters\",\"ua\":\"Кліматичні параметри\"},\"title2\":{\"bg\":\"температура и влажност в зоната на разположение на оборудването\",\"en\":\"temperature and humidity in the area where the equipment is located\",\"ua\":\"температура і вологість в зоні розташування обладнання\"},\"text3\":{\"bg\":\"Мрежа, комуникационни канали, сървърно оборудване\",\"en\":\"Network, communication channels, server equipment\",\"ua\":\"Мережа, канали зв'язку, серверне обладнання\"},\"text4\":{\"bg\":\"Софтуер, процеси, мрежови услуги\",\"en\":\"Software, processes, network services\",\"ua\":\"Програмне забезпечення, процеси, мережеві служби\"},\"title3\":{\"bg\":\"SMTP, POP3, HTTP, NNTP, ICMP, SNMP\",\"en\":\"SMTP, POP3, HTTP, NNTP, ICMP, SNMP\",\"ua\":\"SMTP, POP3, HTTP, NNTP, ICMP, SNMP\"},\"text5\":{\"bg\":\"Използване на процесора, използване на диска, системни регистрационни файлове\",\"en\":\"CPU load, disk usage, system logs\",\"ua\":\"Навантаження на процесор, використання диска, системні журнали\"}}},\"antiHeaderText\":{\"caption\":{\"bg\":\"Защита\",\"en\":\"Protection\",\"ua\":\"Захист\"},\"h2\":{\"bg\":\"Защита от DDoS атаки\",\"en\":\"Protection against DDoS attacks\",\"ua\":\"Захист від DDoS-атаки\"},\"title\":{\"bg\":\"Ние осигуряваме защита от DDoS атаки, използвайки съвременни технологии за филтриране на трафик и оперативно реагиране на заплахи, за да гарантираме безпроблемна работа на вашите системи.\",\"en\":\"We provide protection against DDOS attacks by using state-of-the-art traffic filtering technologies and responding quickly to threats to ensure that your systems are up and running.\",\"ua\":\"Ми забезпечуємо захист від DDOS-атак, використовуючи сучасні технології фільтрації трафіку та оперативно реагуючи на загрози, щоб гарантувати безперебійну роботу ваших систем.\"}},\"antiText\":{\"caption\":{\"bg\":\"Нашето предложение\",\"en\":\"Our offer\",\"ua\":\"Наша пропозиція\"},\"h2\":{\"bg\":\"Система за защита от DDoS атаки\",\"en\":\"DDoS protection system\",\"ua\":\"Система захисту від DDoS\"},\"title\":{\"bg\":\"Ние защитаваме вашата инфраструктура от DDoS атаки, осигурявайки стабилност на работата чрез съвременни методи за филтриране на трафика.\",\"en\":\"We protect your infrastructure from DDoS attacks, ensuring stability of operation through modern traffic filtering methods.\",\"ua\":\"Ми захищаємо вашу інфраструктуру від DDOS-атак, забезпечуючи стабільність роботи завдяки сучасним методам фільтрації трафіку.\"},\"title2\":{\"bg\":\"Можете самостоятелно да съставите и коригирате параметрите на необходимото оборудване.\",\"en\":\"You can independently create and adjust the parameters of the necessary equipment.\",\"ua\":\"Ви можете <span>самостійно</span> сформувати та відкоригувати параметри необхідного обладнання.\"}},\"antiServersText\":{\"item\":{\"caption\":{\"bg\":\"Защита\",\"en\":\"Protection\",\"ua\":\"Захист\"}},\"item1\":{\"h3\":{\"bg\":\"Защита от DDoS атаки\",\"en\":\"Protection against DDoS attacks\",\"ua\":\"Захист від DDoS-атаки\"},\"text1\":{\"bg\":\"Ние предоставяме професионални услуги за защита от DDoS атаки, осигурявайки стабилна работа на вашия ресурс дори по време на най-мащабните кибератаки. Нашият екип използва най-съвременните технологии за откриване и неутрализиране на заплахи в реално време.\",\"en\":\"We provide professional DDoS protection services, ensuring the stable operation of your resource even during the most large-scale cyberattacks. Our team uses advanced technologies to detect and neutralize threats in real time.\",\"ua\":\"Ми надаємо професійні послуги захисту від DDoS-атак, забезпечуючи стабільну роботу вашого ресурсу навіть під час наймасштабніших кібератак. Наша команда використовує передові технології для виявлення та нейтралізації загроз у режимі реального часу.\"},\"text2\":{\"bg\":\"Ние защитаваме вашата инфраструктура от претоварвания и гарантираме непрекъснатост на бизнес процесите.\",\"en\":\"We protect your infrastructure from overloads and guarantee the continuity of business processes.\",\"ua\":\"Ми захищаємо вашу інфраструктуру від перевантажень і гарантуємо безперервність бізнес-процесів.\"}},\"item2\":{\"h3\":{\"bg\":\"Отбранителна политика, базирана на услугата\",\"en\":\"Service-based defense policy\",\"ua\":\"Оборонна політика, заснована на сервісі\"},\"text\":{\"bg\":\"Решенията за защита от DDoS на IT Soft Services осигуряват непрекъснато обучение и анализ на трафика на услугите, определяйки нормалните контури на трафика за всяка зона. Това позволява създаването на диференцирана защита за различни услуги или за една услуга в различни времеви интервали, осигурявайки усъвършенствано ниво на сигурност.\",\"en\":\"IT Soft Services' anti-DDoS solution provides continuous training and analysis of service traffic, determining the usual traffic pattern for each zone. This allows you to create differentiated protection for different services or for the same service at different time intervals, providing an improved level of security.\",\"ua\":\"Анти-DDoS-рішення IT Soft Services забезпечує безперервне навчання та аналіз сервісного трафіку, визначаючи звичний контур трафіку для кожної зони. Це дозволяє створювати диференційований захист для різних служб або для однієї служби в різні часові інтервали, забезпечуючи вдосконалений рівень безпеки.\"}},\"item3\":{\"h3\":{\"bg\":\"Прецизно почистване на нестандартен трафик\",\"en\":\"Precise removal of abnormal traffic\",\"ua\":\"Точне прибирання позаштатного трафіку\"},\"text\":{\"bg\":\"Решенията за защита от DDoS на IT Soft Services използва технология за откриване на базата на пакети. Защитата се активира незабавно при атака. Това решение използва няколко технологии, включително филтриране за седем години назад, анализ на поведението и мониторинг на сесиите за прецизна защита срещу различни атаки като флууд атаки, атаки срещу уеб приложения, DNS атаки, SSL атаки, DoS/DDoS атаки и атаки срещу уязвимости в стека на протоколите. Така сървърите на приложенията са защитени.\",\"en\":\"IT Soft Services' anti-DDoS solution uses packet-based detection technology. Protection is triggered immediately by an attack. This solution uses several technologies, including seven-year filtering, behavioral analysis, and session monitoring, to accurately protect against various flood attacks, web application attacks, DNS attacks, SSL DoS/DDoS attacks, and protocol stack vulnerability attacks. Thus, application servers are protected.\",\"ua\":\"Анти-DDoS-рішення IT Soft Services використовує технологію попакетного детектування. Захист спрацьовує відразу ж нападом. Це рішення використовує кілька технологій, включаючи семирічну фільтрацію, аналіз поведінки та моніторинг сеансів, для точного захисту від різних атак флуду, атак веб-додатків, DNS-атак, SSL-атак DoS/DDoS-атак та атак на вразливість стека протоколів. Таким чином, сервери додатків захищені.\"}},\"item4\":{\"h3\":{\"bg\":\"Интелигентно кеширане на DNS трафик\",\"en\":\"Intelligent caching of DNS traffic\",\"ua\":\"Інтелектуальне кешування DNS-трафіку\"},\"text\":{\"bg\":\"Интелигентното кеширане на DNS трафик ви позволява значително да подобрите скоростта на достъп до уеб ресурси и да намалите натоварването на сървърите. Благодарение на това решение, често повтарящите се DNS заявки се кешират и се обслужват на потребителите много по-бързо, намалявайки времето за реакция и оптимизирайки използването на мрежовите ресурси.\",\"en\":\"Intelligent caching of DNS traffic can significantly improve the speed of access to web resources and reduce the load on servers. Thanks to this solution, frequently repeated DNS queries are stored in the cache and provided to users much faster, reducing response time and optimizing the use of network resources.\",\"ua\":\"Інтелектуальне кешування DNS-трафіку дозволяє значно покращити швидкість доступу до вебресурсів і зменшити навантаження на сервери. Завдяки цьому рішенню, DNS-запити, що часто повторюються, зберігаються в кеші та надаються користувачам набагато швидше, зменшуючи час відгуку та оптимізуючи використання мережевих ресурсів.\"}},\"item5\":{\"h3\":{\"bg\":\"Защита от повечето зомбита/троянски коне/червеи\",\"en\":\"Protection against most zombies/Trojan horses/worms\",\"ua\":\"Захист від більшості zombies/Trojan horses/worms\"},\"text\":{\"bg\":\"Нашите решения осигуряват надеждна защита от повечето видове злонамерени софтуери, като зомбита (zombies), троянски коне (Trojan horses) и червеи (worms). С усъвършенствани методи за откриване и блокиране на злонамерени атаки, ние предотвратяваме заразяването на вашите системи и мрежи, като намаляваме риска те да бъдат използвани за разпространение на вируси или извършване на атаки.\",\"en\":\"Our solutions provide reliable protection against most types of malware, such as zombies, Trojan horses, and worms. With advanced detection and blocking techniques, we prevent your systems and networks from becoming infected, reducing the risk of them being used to spread viruses or launch attacks.\",\"ua\":\"Наші рішення забезпечують надійний захист від більшості типів шкідливих програм, таких як зомбі-мережі (zombies), троянські коні (Trojan horses) та черв'яки (worms). Завдяки передовим методам виявлення і блокування шкідливих атак, ми запобігаємо зараженню ваших систем і мереж, знижуючи ризик їх використання для розповсюдження вірусів або проведення атак.\"}},\"item6\":{\"h3\":{\"bg\":\"Идеална защита за IPv4 и IPv6\",\"en\":\"Perfect IPv4-IPv6 protection\",\"ua\":\"Ідеальний захист IPv4-IPv6\"},\"text\":{\"bg\":\"Нашите специализирани инструменти гарантират защита както за традиционни IPv4 мрежи, така и за новите IPv6, което позволява минимизиране на рисковете от атаки, които могат да засегнат достъпността и производителността на вашите ресурси. Използваме адаптивни методи на реакция, които ни позволяват незабавно да неутрализираме дори най-мащабните атаки.\",\"en\":\"Our specialized tools provide protection for both traditional IPv4 networks and the latest IPv6 networks, minimizing the risk of attacks that could affect the availability and performance of your resources. We use adaptive response methods that allow us to instantly neutralize even the largest attacks.\",\"ua\":\"Наші спеціалізовані інструменти гарантують захист як для традиційних IPv4 мереж, так і для новітніх IPv6, що дозволяє мінімізувати ризики від атак, які можуть вплинути на доступність та продуктивність ваших ресурсів. Ми використовуємо адаптивні методи реагування, що дозволяють миттєво нейтралізувати навіть наймасштабніші атаки.\"}},\"item7\":{\"h3\":{\"bg\":\"Гъвкаво мрежово свързване\",\"en\":\"Flexible networking\",\"ua\":\"Гнучкий нетворкінг\"},\"text\":{\"bg\":\"Решението за защита от DDoS трябва да се адаптира към различни мрежови среди и да отговаря на различни нива на изисквания за обслужване. Въз основа на това, анти-DDoS решението на IT Soft Services предоставя множество вградени и самостоятелни внедрявания, позволявайки на клиентите гъвкавостта да избират според техните услуги и мрежи. Вградено внедряване: Серийно свързва модули за откриване и почистване към мрежата за защита за директно откриване и почистване на трафика. Използваната високопроизводителна и многоядрена хардуерна платформа не само гарантира точност на откриване и почистване, но също така минимизира забавянето на обработката.\",\"en\":\"A DDoS protection solution must adapt to different network environments and meet different levels of service requirements. With this in mind, IT Soft Services' anti-DDoS solution provides numerous embedded and standalone deployments, allowing customers the flexibility to choose according to their services and networks. Inline deployment: Seamlessly connects detection and scrubbing modules to the defense network to directly detect and scrub traffic. The high-performance and multi-core hardware platform used not only ensures the accuracy of detection and cleaning, but also minimizes processing latency.\",\"ua\":\"Рішення для захисту від DDoS-атак має адаптуватися до різних мережевих середовищ і відповідати різним рівням вимог до обслуговування. Виходячи з цього, анти-DDoS-рішення IT Soft Services забезпечує численні вбудовані та автономні розгортання, що дозволяє клієнтам гнучко вибирати за своїми послугами та мережами. Вбудоване розгортання: послідовно підключає модулі виявлення та очищення до мережі для захисту для безпосереднього виявлення та очищення трафіку. Високопродуктивна та багатоядерна апаратна платформа, що використовується, не тільки забезпечує точність виявлення та очищення, але й мінімізує затримку обробки.\"}}},\"adminHeaderText\":{\"caption\":{\"bg\":\"Системно администриране\",\"en\":\"System administration\",\"ua\":\"Системне адміністрування\"},\"h2\":{\"bg\":\"Системно администриране\",\"en\":\"System administration\",\"ua\":\"Системне адміністрування\"},\"title\":{\"bg\":\"Ние администрираме виртуални среди, осигурявайки стабилност на работата, оптимизация на ресурсите и сигурност, за да работи вашата IT инфраструктура с максимална ефективност.\",\"en\":\"We administer virtual environments, ensuring stability, resource optimization, and security to keep your IT infrastructure running as efficiently as possible.\",\"ua\":\"Ми адмініструємо віртуальні середовища, забезпечуючи стабільність роботи, оптимізацію ресурсів і безпеку, щоб ваша IT-інфраструктура працювала максимально ефективно.\"}},\"adminText\":{\"caption\":{\"bg\":\"Нашето предложение\",\"en\":\"Our offer\",\"ua\":\"Наша пропозиція\"},\"h2\":{\"bg\":\"Програмни и хардуерни средства за системно администриране\",\"en\":\"System administration software and hardware\",\"ua\":\"Програмні та апаратні засоби системного адміністрування\"},\"title1\":{\"bg\":\"Нашата услуга за системно администриране осигурява стабилна работа на вашата IT инфраструктура. Ние извършваме мониторинг, настройка на сървъри, осигуряваме сигурност, актуализираме и оптимизираме производителността.\",\"en\":\"Our system administration service ensures the stable operation of your IT infrastructure. We monitor and configure servers, ensure security, provide updates, and optimize performance.\",\"ua\":\"Наша послуга з адміністрування систем забезпечує стабільну роботу вашої IT-інфраструктури. Ми здійснюємо моніторинг, налаштування серверів, забезпечуємо безпеку, оновлення та оптимізуємо продуктивність.\"},\"title2\":{\"bg\":\"Доверете се на нашите професионалисти, за да управляват надеждно вашите системи и да поддържат бизнеса ви да работи гладко.\",\"en\":\"Trust our professionals to reliably manage your systems and keep your business running smoothly.\",\"ua\":\"Довіртеся нашим професіоналам для надійного управління вашими системами та безперебійної роботи бізнесу.\"}},\"adminServersText\":{\"item\":{\"caption\":{\"bg\":\"Повече подробности\",\"en\":\"Read more\",\"ua\":\"Детальніше\"}},\"item1\":{\"h3\":{\"bg\":\"Системно администриране\",\"en\":\"System administration\",\"ua\":\"Системне адміністрування\"},\"text\":{\"bg\":\"Нашата компания предоставя професионална поддръжка и администриране на IT системи, осигурявайки ефективна работа, сигурност и стабилност на вашата инфраструктура.\",\"en\":\"Our company provides professional support and administration of IT systems, ensuring the efficient operation, security and stability of your infrastructure.\",\"ua\":\"Наша компанія надає професійну підтримку та адміністрування IT-систем, забезпечуючи ефективну роботу, безпеку та стабільність вашої інфраструктури.\"}},\"item2\":{\"h3\":{\"bg\":\"Системно администриране на Linux\",\"en\":\"Linux system administration\",\"ua\":\"Системне адміністрування Linux\"},\"text\":{\"bg\":\"Професионално администриране, конфигуриране, наблюдение и оптимизиране на производителността на Linux сървъри, за да се гарантира стабилна работа и сигурност на вашата IT инфраструктура.\",\"en\":\"Professional Linux server administration, configuration, monitoring and performance optimization to ensure stable operation and security of your IT infrastructure.\",\"ua\":\"Професійне адміністрування серверів Linux, налаштування, моніторинг та оптимізація продуктивності для забезпечення стабільної роботи та безпеки вашої IT-інфраструктури.\"}},\"item3\":{\"h3\":{\"bg\":\"Обслужване на Active Directory\",\"en\":\"Active Directory maintenance\",\"ua\":\"Обслуговування Active Directory\"},\"text\":{\"bg\":\"Поддръжка и актуализиране на Active Directory за осигуряване на ефективно управление на потребителите, групи и политики за сигурност, което ви позволява да оптимизирате работата на вашата организация.\",\"en\":\"Maintain and update Active Directory to ensure effective management of users, groups, and security policies to optimize your organization's performance.\",\"ua\":\"Підтримка та оновлення Active Directory для забезпечення ефективного управління користувачами, групами та політиками безпеки, що дозволяє оптимізувати роботу вашої організації.\"}},\"item4\":{\"h3\":{\"bg\":\"Управление на Active Directory\",\"en\":\"Active Directory management\",\"ua\":\"Керування Active Directory\"},\"h4\":{\"bg\":\"до 250 потребители\",\"en\":\"Up to 250 users\",\"ua\":\"до 250 користувачів\"},\"text\":{\"bg\":\"Управление на Active Directory за компании с до 250 потребители, включително настройка на достъп, политики за сигурност и редовни актуализации за стабилна работа.\",\"en\":\"Manage Active Directory for companies with up to 250 users, including access settings, security policies, and regular updates to ensure a stable experience.\",\"ua\":\"Керування Active Directory для компаній з кількістю користувачів до 250 осіб, включаючи налаштування доступу, політики безпеки та регулярні оновлення для стабільної роботи.\"}},\"item5\":{\"h3\":{\"bg\":\"Exchange сървър\",\"en\":\"Exchange server\",\"ua\":\"Сервер Exchange\"},\"h4\":{\"bg\":\"до 250 потребители\",\"en\":\"Up to 250 users\",\"ua\":\"до 250 користувачів\"},\"text\":{\"bg\":\"Настройка и администриране на Microsoft Exchange Server за ефективна електронна поща и управление на контакти и календари за организации до 250 потребители.\",\"en\":\"Configure and administer Microsoft Exchange Server for efficient email exchange and contact and calendar management for organizations with up to 250 users.\",\"ua\":\"Налаштування та адміністрування Microsoft Exchange Server для ефективного обміну електронною поштою та управління контактами та календарем для організацій до 250 користувачів.\"}},\"item6\":{\"h3\":{\"bg\":\"Интернет поддръжка и управление\",\"en\":\"Internet support and management\",\"ua\":\"Інтернет-підтримка та управління\"},\"text\":{\"bg\":\"Осигуряване на стабилно и сигурно интернет свързване, мониторинг на трафика, управление на достъпа и оптимизация на работата за подобряване на производителността на мрежата.\",\"en\":\"Provide a stable and secure Internet connection, monitor traffic, manage access, and optimize performance to improve network performance.\",\"ua\":\"Забезпечення стабільного та безпечного підключення до Інтернету, моніторинг трафіку, управління доступом та оптимізація роботи для покращення продуктивності мережі.\"}},\"item7\":{\"h3\":{\"bg\":\"Сигурност и файъруол\",\"en\":\"Security and firewall\",\"ua\":\"Безпека та фаєрвол\"},\"text\":{\"bg\":\"Инсталиране и настройка на системи за сигурност и файъруоли за защита от външни заплахи, мониторинг на инфраструктурата и поддържане на високо ниво на защита на данните.\",\"en\":\"Installing and configuring security systems and firewalls to protect against external threats, monitoring the infrastructure, and maintaining a high level of data protection.\",\"ua\":\"Встановлення та налаштування систем безпеки та брандмауерів для захисту від зовнішніх загроз, моніторинг інфраструктури та підтримка високого рівня захисту даних.\"}},\"item8\":{\"h3\":{\"bg\":\"Локални и глобални мрежи\",\"en\":\"Local and wide area network\",\"ua\":\"Локальна та глобальна мережа\"},\"text\":{\"bg\":\"Проектиране, настройка и поддръжка на локални (LAN) и глобални (WAN) мрежи, осигуряване на тяхната стабилна работа и висока скорост на пренос на данни.\",\"en\":\"Designing, configuring, and maintaining local area networks (LAN) and wide area networks (WAN), ensuring their stable operation and high data transfer speed.\",\"ua\":\"Проєктування, налаштування та підтримка локальних (LAN) та глобальних (WAN) мереж, забезпечення їх стабільної роботи та високої швидкості передачі даних.\"}},\"item9\":{\"h3\":{\"bg\":\"Кластер и репликация MySQL\",\"en\":\"MySQL cluster and replication\",\"ua\":\"Кластер і реплікація MySQL\"},\"text\":{\"bg\":\"Настройка и управление на MySQL клъстери и репликация за осигуряване на висока наличност и устойчивост на бази данни, оптимизация на производителността и сигурността.\",\"en\":\"Setting up and managing MySQL clusters and replication to ensure high availability and fault tolerance of databases, optimize performance and security.\",\"ua\":\"Налаштування та управління MySQL кластерами та реплікацією для забезпечення високої доступності та відмовостійкості баз даних, оптимізації продуктивності та безпеки.\"}},\"item10\":{\"h3\":{\"bg\":\"Технология CentOS\",\"en\":\"CentOS technology\",\"ua\":\"Технологія CentOS\"},\"text\":{\"bg\":\"Администриране на операционна система CentOS, настройка на сървъри, актуализиране на системата и осигуряване на стабилната й работа за задоволяване на нуждите на вашия бизнес.\",\"en\":\"Administering the CentOS operating system, configuring servers, updating the system, and ensuring its stable operation to meet your business needs.\",\"ua\":\"Адміністрування операційної системи CentOS, налаштування серверів, оновлення системи та забезпечення її стабільної роботи для задоволення потреб вашого бізнесу.\"}},\"item11\":{\"h3\":{\"bg\":\"Debian\",\"en\":\"Debian\",\"ua\":\"Debian\"},\"text\":{\"bg\":\"Поддръжка и администриране на сървъри с Debian, настройка на сигурността, актуализиране на пакети и оптимизация на системата за постигане на най-висока производителност и надеждност.\",\"en\":\"Support and administration of Debian-based servers, security settings, package updates, and system optimization to achieve the highest performance and reliability.\",\"ua\":\"Підтримка та адміністрування серверів на базі Debian, налаштування безпеки, оновлення пакетів та оптимізація системи для досягнення найвищої продуктивності та надійності.\"}}},\"aboutServersText\":{\"item12\":{\"h3\":{\"bg\":\"SuSE\",\"en\":\"SuSE\",\"ua\":\"SuSE\"},\"text\":{\"bg\":\"Управление и администриране на сървъри на платформата SuSE Linux, настройка на инфраструктура, осигуряване на осигуряване на нейната сигурност и поддръжка на най-високо ниво на оперативна ефективност.\",\"en\":\"Manage and administer servers based on the SuSE Linux platform, configure the infrastructure, ensure its security, and keep it running at the highest level of efficiency.\",\"ua\":\"Управління та адміністрування серверів на платформі SuSE Linux, налаштування інфраструктури, забезпечення її безпеки та підтримка на найвищому рівні ефективності роботи.\"}}},\"faqHeaderText\":{\"title\":{\"bg\":\"FAQ\",\"en\":\"FAQ\",\"ua\":\"FAQ\"},\"text1\":{\"bg\":\"Подробна информация за мониторинг на сървъри, филтриране на трафик, резервно копиране, защита от DDoS, администриране на сървъри, техническа поддръжка 24/7, облачен хостинг и наети сървъри. Ясно, точно и достъпно!\",\"en\":\"Detailed information about server monitoring, traffic filtering, backup, DDOS protection, server administration, 24/7 technical support, cloud hosting, and dedicated servers. Clear, concise and accessible!\",\"ua\":\"Детальна інформація про моніторинг серверів, фільтрацію трафіку, резервне копіювання, захист від DDOS, адміністрування серверів, технічну підтримку 24/7, хмарний хостинг та виділені сервери. Зрозуміло, чітко й доступно!\"}},\"faqQuestionTextSearch\":{\"item1\":{\"h3\":{\"bg\":\"Търсене\",\"en\":\"Search\",\"ua\":\"Пошук\"}}},\"faqQuestionText\":{\"item1\":{\"h3\":{\"bg\":\"Какво включва услугата за мониторинг на сървъри?\",\"en\":\"What does the server monitoring service include?\",\"ua\":\"Що включає послуга моніторингу серверів?\"},\"text\":{\"bg\":\"Услугата включва 24/7 мониторинг на състоянието на сървъра, диагностика на неизправности и бързо отстраняване на неизправности, за да се осигури непрекъсната работа.\",\"en\":\"The service includes round-the-clock server monitoring, fault diagnostics, and prompt troubleshooting to ensure uninterrupted operation.\",\"ua\":\"Послуга включає цілодобове відстеження стану серверів, діагностику несправностей та оперативне усунення проблем для забезпечення безперебійної роботи.\"}},\"item2\":{\"h3\":{\"bg\":\"Колко бързо се решават проблемите, открити по време на мониторинга?\",\"en\":\"How quickly are problems detected during monitoring resolved?\",\"ua\":\"Як швидко вирішуються проблеми, виявлені під час моніторингу?\"},\"text\":{\"bg\":\"Времето за решение зависи от сложността на проблема. Средно, диагностиката се извършва за няколко минути, а отстраняването на проблемите отнема до няколко часа.\",\"en\":\"The resolution time depends on the complexity of the problem. On average, diagnostics are performed in a few minutes, and troubleshooting takes up to several hours.\",\"ua\":\"Час вирішення залежить від складності проблеми. У середньому діагностика виконується за кілька хвилин, а усунення проблем — до кількох годин.\"}},\"item3\":{\"h3\":{\"bg\":\"Как работи филтрирането на трафик?\",\"en\":\"How does traffic filtering work?\",\"ua\":\"Як працює фільтрація трафіку?\"},\"text\":{\"bg\":\"Анализираме мрежовия трафик, откриваме подозрителна активност, блокираме заплахи и осигуряваме чист и безопасен поток от данни.\",\"en\":\"We analyze network traffic, detect suspicious activity, block threats, and ensure a clean and secure data flow.\",\"ua\":\"Ми аналізуємо мережевий трафік, виявляємо підозрілу активність, блокуємо загрози та забезпечуємо чистий та безпечний потік даних.\"}},\"item4\":{\"h3\":{\"bg\":\"Може ли вашата система за филтриране да се интегрира с вече съществуваща инфраструктура?\",\"en\":\"Can I integrate your filtering system with my existing infrastructure?\",\"ua\":\"Чи можна інтегрувати вашу систему фільтрації з вже існуючою інфраструктурою?\"},\"text\":{\"bg\":\"Да, нашите решения лесно се интегрират във вашата IT инфраструктура с минимални промени.\",\"en\":\"Yes, our solutions can be easily integrated into your IT infrastructure with minimal changes.\",\"ua\":\"Так, наші рішення легко інтегруються у вашу IT-інфраструктуру з мінімальними змінами.\"}},\"item5\":{\"h3\":{\"bg\":\"Какви резервни копия се настройват?\",\"en\":\"What kind of backups are configured?\",\"ua\":\"Які резервні копії налаштовуються?\"},\"text\":{\"bg\":\"Ние конфигурираме пълни, диференциални или инкрементални резервни копия в зависимост от вашите нужди.\",\"en\":\"We customize full, differentiated, or incremental backups depending on your needs.\",\"ua\":\"Ми налаштовуємо повні, диференційовані або інкрементальні резервні копії залежно від ваших потреб.\"}},\"item6\":{\"h3\":{\"bg\":\"Можете ли да възстановите данни след атака или срив?\",\"en\":\"Can you restore data after an attack or failure?\",\"ua\":\"Чи можете ви відновити дані після атаки або збою?\"},\"text\":{\"bg\":\"Да, ние предлагаме пълно възстановяване на данни в най-кратки срокове.\",\"en\":\"Yes, we provide full data recovery services as soon as possible.\",\"ua\":\"Так, ми надаємо послуги з повного відновлення даних у найкоротші терміни.\"}},\"item7\":{\"h3\":{\"bg\":\"Какво включва услугата за настройка на виртуални сървъри?\",\"en\":\"What is included in the virtual server setup service?\",\"ua\":\"Що входить у послугу налаштування віртуальних серверів?\"},\"text\":{\"bg\":\"Услугата включва инсталация, конфигурация, оптимизация на работата и администриране на виртуални сървъри за вашите задачи.\",\"en\":\"The service includes the installation, configuration, optimization and administration of virtual servers for your tasks.\",\"ua\":\"Послуга включає встановлення, конфігурацію, оптимізацію роботи та адміністрування віртуальних серверів для ваших завдань.\"}},\"item8\":{\"h3\":{\"bg\":\"Подходящи ли са вашите виртуални сървъри за високо натоварени проекти?\",\"en\":\"Are your virtual servers suitable for high-load projects?\",\"ua\":\"Чи підходять ваші віртуальні сервери для високонавантажених проєктів?\"},\"text\":{\"bg\":\"Да, ние настройваме виртуални машини, които могат да издържат на високи натоварвания и да се мащабират според вашите нужди.\",\"en\":\"Yes, we set up virtual machines that can withstand high loads and scale to your needs.\",\"ua\":\"Так, ми налаштовуємо віртуальні машини, що витримують високі навантаження та масштабуються відповідно до ваших потреб.\"}},\"item9\":{\"h3\":{\"bg\":\"Включва ли услугата редовни актуализации на операционни системи?\",\"en\":\"Does the service include regular operating system updates?\",\"ua\":\"Чи входить у послугу регулярне оновлення операційних систем?\"},\"text\":{\"bg\":\"Да, ние осигуряваме редовни актуализации на ОС за подобряване на сигурността и производителността.\",\"en\":\"Yes, we provide regular OS updates to improve security and performance.\",\"ua\":\"Так, ми забезпечуємо регулярне оновлення ОС для підвищення безпеки та продуктивності.\"}},\"item10\":{\"h3\":{\"bg\":\"Проверява ли се работата на системата след актуализация?\",\"en\":\"Is the system tested after the update?\",\"ua\":\"Чи перевіряється робота системи після оновлення?\"},\"text\":{\"bg\":\"Да, след всяка актуализация ние тестваме системата, за да гарантираме стабилна работа.\",\"en\":\"Yes, we test the system after each update to ensure stable operation.\",\"ua\":\"Так, після кожного оновлення ми тестуємо систему, щоб переконатися у стабільній роботі.\"}},\"item11\":{\"h3\":{\"bg\":\"Какво включва услугата за техническа поддръжка?\",\"en\":\"What is included in the technical support service?\",\"ua\":\"Що входить у послугу технічної підтримки?\"},\"text\":{\"bg\":\"Ние осигуряваме 24/7 поддръжка за потребители, диагностика на проблеми и тяхното бързо решаване.\",\"en\":\"We provide round-the-clock support for users, diagnosing problems and resolving them promptly.\",\"ua\":\"Ми забезпечуємо цілодобову підтримку користувачів, діагностику проблем та їх оперативне вирішення.\"}},\"item12\":{\"h3\":{\"bg\":\"Колко бързо мога да получа помощ?\",\"en\":\"How quickly can I get help?\",\"ua\":\"Як швидко я можу отримати допомогу?\"},\"text\":{\"bg\":\"Средното време за отговор на запитване е до 10 минути.\",\"en\":\"The average response time to a request is up to 10 minutes.\",\"ua\":\"Середній час відповіді на запит — до 10 хвилин.\"}},\"item13\":{\"h3\":{\"bg\":\"Какво е облачен хостинг?\",\"en\":\"What is cloud hosting?\",\"ua\":\"Що таке хмарний хостинг?\"},\"text\":{\"bg\":\"Облачният хостинг е услуга за хостване на вашия проект на виртуални сървъри, които осигуряват висока производителност и достъпност.\",\"en\":\"Cloud hosting is a service of placing your project on virtual servers that provide high performance and availability.\",\"ua\":\"Хмарний хостинг — це послуга розміщення вашого проєкту на віртуальних серверах, що забезпечують високу продуктивність та доступність.\"}},\"item14\":{\"h3\":{\"bg\":\"Мога ли да мащабирам ресурсите на хостинга?\",\"en\":\"Can I scale my hosting resources?\",\"ua\":\"Чи можу я масштабувати ресурси хостингу?\"},\"text\":{\"bg\":\"Да, нашият облачен хостинг ви позволява да мащабирате ресурсите гъвкаво в зависимост от вашите нужди.\",\"en\":\"Yes, our cloud hosting allows you to flexibly scale resources depending on your needs.\",\"ua\":\"Так, наш хмарний хостинг дозволяє гнучко масштабувати ресурси залежно від ваших потреб.\"}},\"item15\":{\"h3\":{\"bg\":\"Как се защитавате от DDoS атаки?\",\"en\":\"How do you protect against DDOS attacks?\",\"ua\":\"Як ви захищаєте від DDOS-атак?\"},\"text\":{\"bg\":\"Използваме съвременни методи за анализ на трафика, автоматично блокиране на подозрителна активност и мрежови филтри за минимизиране на рисковете.\",\"en\":\"We use advanced traffic analysis techniques, automatic blocking of suspicious activity, and network filters to minimize risks.\",\"ua\":\"Ми використовуємо передові методи аналізу трафіку, автоматичне блокування підозрілої активності та мережеві фільтри для мінімізації ризиків.\"}},\"item16\":{\"h3\":{\"bg\":\"Може ли системата да работи без прекъсване по време на атака?\",\"en\":\"Can the system work without interruption during an attack?\",\"ua\":\"Чи може система працювати без перерви під час атаки?\"},\"text\":{\"bg\":\"Да, нашите решения позволяват системата да продължи да работи дори при големи атаки.\",\"en\":\"Yes, our solutions can keep systems running even in the event of large-scale attacks.\",\"ua\":\"Так, наші рішення дозволяють підтримувати роботу систем навіть у разі масштабних атак.\"}},\"item17\":{\"h3\":{\"bg\":\"Какво е нает сървър?\",\"en\":\"What is a dedicated server?\",\"ua\":\"Що таке виділений сервер?\"},\"text\":{\"bg\":\"Наетият сървър е физически сървър, който е напълно достъпен за използване само от вашия проект.\",\"en\":\"A dedicated server is a physical server that is fully available for use only by your project.\",\"ua\":\"Виділений сервер — це фізичний сервер, повністю доступний для використання тільки вашим проєктом.\"}},\"item18\":{\"h3\":{\"bg\":\"Мога ли да инсталирам собствен софтуер на наетия сървър?\",\"en\":\"Can I install my own software on a dedicated server?\",\"ua\":\"Чи можу я встановити власне ПЗ на виділений сервер?\"},\"text\":{\"bg\":\"Да, получавате пълен контрол върху сървъра, включително възможността да инсталирате всякакъв софтуер.\",\"en\":\"Yes, you get full control over the server, including the installation of any software.\",\"ua\":\"Так, ви отримуєте повний контроль над сервером, включаючи встановлення будь-якого програмного забезпечення.\"}},\"item19\":{\"h3\":{\"bg\":\"Как да избера между виртуален и нает сървър?\",\"en\":\"How to choose between a virtual server and a dedicated server?\",\"ua\":\"Як вибрати між віртуальним сервером і виділеним?\"},\"text\":{\"bg\":\"Виртуалният сървър е подходящ за средни натоварвания, докато наетият сървър е за проекти с високи изисквания към ресурсите.\",\"en\":\"A virtual server is suitable for medium workloads, while a dedicated server is suitable for projects with high resource requirements.\",\"ua\":\"Віртуальний сервер підходить для середніх навантажень, тоді як виділений — для проєктів із високими вимогами до ресурсів.\"}},\"item20\":{\"h3\":{\"bg\":\"Мога ли да получа консултация преди да избера услуга?\",\"en\":\"Can I get a consultation before choosing a service?\",\"ua\":\"Чи можу я отримати консультацію перед вибором послуги?\"},\"text\":{\"bg\":\"Да, ние предоставяме безплатна консултация, за да ви помогнем да изберете най-подходящото решение.\",\"en\":\"Yes, we provide a free consultation to help you choose the best solution.\",\"ua\":\"Так, ми надаємо безкоштовну консультацію, щоб допомогти вам обрати оптимальне рішення.\"}}},\"newsHeaderText\":{\"title\":{\"bg\":\"Новини\",\"en\":\"News\",\"ua\":\"Новини\"},\"text\":{\"bg\":\"Бъдете първи, които научават за най-новите тенденции в света на технологиите, нови разработки, успешни случаи, анализи и инсайти от ИТ индустрията. Това ще ви помогне да сте в крак с новостите и една крачка напред в света на цифровите промени.\",\"en\":\"Be the first to know about the latest trends in the world of technology, new developments, successful cases, analytics and insights of the IT industry. This will help you stay up-to-date and one step ahead in the world of digital change.\",\"ua\":\"Дізнавайтесь першими про останні тренди у світі технологій, нові розробки, успішні кейси, аналітику та інсайти ІТ-індустрії. Це допоможе бути в курсі подій та на крок попереду у світі цифрових змін.\"}},\"newsWidget\":{\"caption\":{\"bg\":\"Новини\",\"en\":\"Read more\",\"ua\":\"Новини\"}},\"newsWidgetText\":{\"h2\":{\"bg\":\"Последни новини\",\"en\":\"Latest news\",\"ua\":\"Останні новини\"}},\"contactsHeaderText\":{\"title\":{\"bg\":\"Нашите контакти\",\"en\":\"Our contacts\",\"ua\":\"Наші контакти\"},\"text1\":{\"bg\":\"Нашият екип винаги е готов да ви помогне да намерите оптималното решение.\",\"en\":\"Our team is always ready to help you find the best solution.\",\"ua\":\"Наша команда завжди готова допомогти вам знайти оптимальне рішення.\"}},\"contactsFormText\":{\"caption\":{\"bg\":\"Свържете се с нас\",\"en\":\"Contact us\",\"ua\":\"Зв'язатися з нами\"},\"h2\":{\"bg\":\"Контактна информация\",\"en\":\"Contact information\",\"ua\":\"Контактна інформація\"},\"item1\":{\"bg\":\"Техническа поддръжка\",\"en\":\"Technical support\",\"ua\":\"Технічна підтримка\"},\"item1s\":{\"bg\":\"support@itsoftservice.com\",\"en\":\"support@itsoftservice.com\",\"ua\":\"support@itsoftservice.com\"},\"item2\":{\"bg\":\"Отдел продажби\",\"en\":\"Sales department\",\"ua\":\"Відділ продажів\"},\"item2s\":{\"bg\":\"sales@itsoftservice.com\",\"en\":\"sales@itsoftservice.com\",\"ua\":\"sales@itsoftservice.com\"},\"item3\":{\"bg\":\"Имейл\",\"en\":\"Email\",\"ua\":\"Email\"},\"item3s\":{\"bg\":\"info@itsoftservice.com\",\"en\":\"info@itsoftservice.com\",\"ua\":\"info@itsoftservice.com\"},\"item4\":{\"bg\":\"Телефон\",\"en\":\"Phone.\",\"ua\":\"Телефон\"},\"item4s\":{\"bg\":\"+359 89 5078712\",\"en\":\"+359 89 5078712\",\"ua\":\"+359 89 5078712\"},\"item5\":{\"bg\":\"Адрес\",\"en\":\"Address.\",\"ua\":\"Адреса\"},\"item5s\":{\"bg\":\"1A, 1/2, ул. Рачо Димчев 8300, Средец, София, България\",\"en\":\"1A, 1/2, Racho Dimchev Str. 8300, Sredets, Sofia, Bulgaria\",\"ua\":\"1A, 1/2, Racho Dimchev Str. 8300, Sredets, Sofia, Bulgaria\"}},\"contactsForm\":{\"title2\":{\"bg\":\"Форма за обратна връзка\",\"en\":\"Contact form\",\"ua\":\"Форма зворотного зв'язку\"},\"item1\":{\"bg\":\"Име*\",\"en\":\"Name*\",\"ua\":\"Ім'я*\"},\"item2\":{\"bg\":\"Email*\",\"en\":\"Email*\",\"ua\":\"Email*\"},\"item3\":{\"bg\":\"Тема*\",\"en\":\"Subject*\",\"ua\":\"Тема*\"},\"item4\":{\"bg\":\"Съобщение\",\"en\":\"Message\",\"ua\":\"Повідомлення\"},\"item5\":{\"bg\":\"Съобщението трябва да бъде поне 15 символа\",\"en\":\"The message must be at least 15 characters\",\"ua\":\"Повідомлення повинно бути не менше 15 символів\"}},\"notText\":{\"title\":{\"bg\":\"404\",\"en\":\"404\",\"ua\":\"404\"},\"text1\":{\"bg\":\"Нещо се обърка...\",\"en\":\"Something went wrong...\",\"ua\":\"Щось пішло не так...\"},\"text2\":{\"bg\":\"Върнете се на началната страница\",\"en\":\"Back to main page\",\"ua\":\"Повернутись на головну\"}},\"Vacancy1HeaderText\":{\"title\":{\"bg\":\"Отворена позиция\",\"en\":\"Vacancy is open\",\"ua\":\"Відкрита вакансія\"},\"text\":{\"bg\":\"Търсим специалист\",\"en\":\"We are looking for a specialist\",\"ua\":\"Шукаємо спеціаліста\"}},\"Vacancy1Text\":{\"title\":{\"bg\":\"Системен администратор L3 (Windows)\",\"en\":\"System administrator L3 (Windows)\",\"ua\":\"System administrator L3 (Windows)\"},\"item1\":{\"h3\":{\"bg\":\"Кого търсим\",\"en\":\"Who we are looking for\",\"ua\":\"Кого шукаємо\"},\"text1\":{\"bg\":\"Търсим опитен и квалифициран Системен администратор ниво 3, който ще поддържа инфраструктурата на Vmware и среда Windows. Трябва да имате задълбочени познания за технологиите, посочени в описанието на позицията, да сте готови постоянно да се развивате и усъвършенствате, да можете да решавате проблеми при несигурност и да запазите спокойствие в стресови ситуации, което е от решаващо значение. Вашите умения за решаване на проблеми, способност за работа в екип и отлични комуникационни умения ще бъдат от решаващо значение за успеха на тази позиция.\",\"en\":\"We are looking for an experienced and qualified System administrator level 3 who will support Vmware infrastructure, support Windows environment. You should have in-depth knowledge of the technologies mentioned in the job description, be ready for continuous development and improvement, be able to solve problems in conditions of uncertainty and stay calm in stressful situations are critical. Your problem-solving skills, ability to work in a team and excellent communication skills will be crucial to the success of this role.\",\"ua\":\"Ми шукаємо досвідченого та кваліфікованого System administrator level 3 який буде підтримувати інфраструктуру Vmware, підтримувати середовище Windows. Ви повинні мати глибокі знання технологій зазначених у описі вакансії, бути готовими до постійного розвитку та вдосконалення, вміти вирішувати проблеми в умовах невизначеності та залишатися спокійним у стресових ситуаціях є критично важливими. Ваші навички у вирішенні проблем, здатність працювати в команді та відмінні комунікативні здібності будуть вирішальними для успішного виконання цієї ролі.\"}},\"item2\":{\"h3\":{\"bg\":\"Вашите задължения ще включват:\",\"en\":\"Your responsibilities will include:\",\"ua\":\"У ваші обов'язки буде входити:\"},\"text1\":{\"bg\":\"Поддръжка на хардуерната част на сървърите\",\"en\":\"Supporting server hardware.\",\"ua\":\"Підтримка апаратної частини серверів\"},\"text2\":{\"bg\":\"Поддръжка на средата за виртуализация Vmware\",\"en\":\"Support of Vmware virtualization environment\",\"ua\":\"Підтримка середовища віртуалізації Vmware\"},\"text3\":{\"bg\":\"Развитие, мащабиране, оразмеряване на физическата инфраструктура, работа в дейта центровете\",\"en\":\"Development, scaling, sizing of physical infrastructure, data center operations\",\"ua\":\"Розвиток, масштабування, сайзинг фізичної інфраструктури, роботи у ДЦ\"},\"text4\":{\"bg\":\"Поддръжка на инфраструктура Windows\",\"en\":\"Support of Windows infrastructure\",\"ua\":\"Підтримка інфраструктури Windows\"},\"texts\":{\"bg\":\"AD, RDS, файлови сървъри\",\"en\":\"AD, RDS, File servers\",\"ua\":\"AD, RDS, File servers\"},\"text5\":{\"bg\":\"Автоматизация на процесите и разгръщане с помощта на PowerShell\",\"en\":\"Automation of work and deployment processes using PowerShell\",\"ua\":\"Автоматизація процесів роботи та розгортання за допомогою PowerShell\"},\"text6\":{\"bg\":\"Настройка и поддръжка на мониторинг системата Zabbix\",\"en\":\"Configuration and support of the Zabbix monitoring system\",\"ua\":\"Налаштування та підтримка системи моніторингу Zabbix\"},\"text7\":{\"bg\":\"Внедряване на нови инфраструктурни решения\",\"en\":\"Implementation of new infrastructure solutions\",\"ua\":\"Впровадження нових рішень інфраструктури\"}},\"item3\":{\"h3\":{\"bg\":\"Изисквания към позицията:\",\"en\":\"Position requirements:\",\"ua\":\"Вимоги до посади:\"},\"text1\":{\"bg\":\"Опит в инсталирането и настройката на vmware esxi, vcenter\",\"en\":\"Experience in installing, configuring vmware esxi, vcenter\",\"ua\":\"Досвід встановлення, налаштування vmware esxi, vcenter\"},\"text2\":{\"bg\":\"Опит с ActiveDirectory, RDS farm, Exchange Servers\",\"en\":\"Experience with Active Directory, RDS farm, Exchange Servers\",\"ua\":\"Досвід роботи з ActiveDirectory, RDS farm, Exchange Servers\"},\"text3\":{\"bg\":\"Опит с автоматизирани системи като PowerShell, Ansible\",\"en\":\"Experience with PowerShell, Ansible automation systems\",\"ua\":\"Досвід роботи із системами автоматизації PowerShell, Ansible\"},\"text4\":{\"bg\":\"Опит с системи за мониторинг като Zabbix, Grafana\",\"en\":\"Experience with monitoring systems Zabbix, Grafana\",\"ua\":\"Досвід роботи із системами моніторингу Zabbix, Grafana\"},\"text5\":{\"bg\":\"Опит с активни мрежови устройства\",\"en\":\"Experience with active network equipment\",\"ua\":\"Досвід роботи з активним мережевим обладнанням\"},\"texts1\":{\"bg\":\"суичове, рутери\",\"en\":\"switches, routers\",\"ua\":\"комутатори, роутери\"},\"text6\":{\"bg\":\"Опит с Wi-Fi оборудване\",\"en\":\"Experience with Wi-Fi equipment\",\"ua\":\"Досвід роботи з Wi-Fi обладнання\"},\"texts2\":{\"bg\":\"UniFi, Mikrotik\",\"en\":\"UniFi, Mikrotik\",\"ua\":\"UniFi, Mikrotik\"},\"text7\":{\"bg\":\"Опит с документация, водене на техническа документация\",\"en\":\"Experience with documentation, maintenance of technical documentation\",\"ua\":\"Досвід роботи з документацією, ведення технічної документації\"}},\"item4\":{\"h3\":{\"bg\":\"Ние предлагаме:\",\"en\":\"We offer:\",\"ua\":\"Ми пропонуємо:\"},\"text1\":{\"bg\":\"Заплащане, което зависи от вашия опит\",\"en\":\"Salary, which depends on your level\",\"ua\":\"ЗП, яка залежить від вашого рівня\"},\"text2\":{\"bg\":\"Дистанционна работа\",\"en\":\"Remote work from any city of Ukraine\",\"ua\":\"Віддалену роботу, з будь-якого міста України\"},\"text3\":{\"bg\":\"8-часов работен ден с възможност за избор на начало и край на работния ден\",\"en\":\"8-hour working day with the ability to choose the start and end time of the working day\",\"ua\":\"8-годинний робочий день з можливістю обрати час початку та кінця робочого дня\"},\"text4\":{\"bg\":\"Вътрешнофирмено обучение\",\"en\":\"Training within the company\",\"ua\":\"Навчання всередині компанії\"},\"text5\":{\"bg\":\"Възможности за кариерно и професионално развитие\",\"en\":\"Opportunity for career and professional growth\",\"ua\":\"Можливість кар'єрного та професійного зростання\"}},\"item5\":{\"h3\":{\"bg\":\"Изпрати ни своето резюме, ако виждате себе си на тази позиция!\",\"en\":\"Send your resume if this sounds like you!\",\"ua\":\"Надсилай своє резюме, якщо це все про тебе!\"}}},\"Vacancy2HeaderText\":{\"title\":{\"bg\":\"Отворена позиция\",\"en\":\"Vacancy is open\",\"ua\":\"Відкрита вакансія\"},\"text\":{\"bg\":\"Търсим специалист\",\"en\":\"We are looking for a specialist\",\"ua\":\"Шукаємо спеціаліста\"}},\"Vacancy2Text\":{\"title\":{\"bg\":\"SOC инженер\",\"en\":\"SOC Engineer\",\"ua\":\"SOC Engineer\"},\"item1\":{\"h3\":{\"bg\":\"Кого търсим\",\"en\":\"Who we are looking for\",\"ua\":\"Кого шукаємо\"},\"text1\":{\"bg\":\"Търсим SOC инженер, който ще стане ключова част от осигуряването на безопасността на нашата инфраструктура. Това е идеалната роля за професионалист с дълбоки познания в сферата на киберсигурността, който иска да работи с най-съвременни инструменти за мониторинг и управление на инциденти.\",\"en\":\"We are looking for a SOC Engineer who will become a key link in ensuring the security of our infrastructure. This is an ideal role for a professional who has deep knowledge of cybersecurity and wants to work with advanced monitoring and incident management tools.\",\"ua\":\"Ми шукаємо SOC Engineer, який стане ключовою ланкою в забезпеченні безпеки нашої інфраструктури. Це ідеальна роль для професіонала, який володіє глибокими знаннями у сфері кібербезпеки та бажає працювати з передовими інструментами моніторингу та управління інцидентами.\"}},\"item2\":{\"h3\":{\"bg\":\"Вашите задължения ще включват:\",\"en\":\"Your responsibilities will include:\",\"ua\":\"У ваші обов'язки буде входити:\"},\"text1\":{\"bg\":\"Наблюдение на таблата за управление и обработка на известията от системата за управление на събития по сигурността (SIEM) с цел откриване на инциденти със странно поведение на потребители/хостове в мрежата\",\"en\":\"Monitoring dashboards and responding to Security Event Management System (SIEM) alerts to identify incidents of unusual network user/host behavior\",\"ua\":\"Спостереження дашбордів та відпрацювання оповіщень системи управління подіями безпеки (SIEM) з метою виявлення інцидентів незвичайної поведінки користувачів/хостів мережі\"},\"text2\":{\"bg\":\"Създаване на аналитични заявки в системата Splunk Enterprise за откриване на инциденти\",\"en\":\"Building analytical queries in Splunk Enterprise to detect incidents\",\"ua\":\"Побудова аналітичних запитів у системі Splunk Enterprise з метою виявлення інцидентів\"},\"text3\":{\"bg\":\"Документиране на инциденти, оценка на причинените щети и обхвата на въздействието\",\"en\":\"Documenting incidents, assessing the damage caused and the extent of the impact\",\"ua\":\"Документування інцидентів, оцінка заподіяної шкоди та масштабу впливу\"},\"text4\":{\"bg\":\"Администриране на услугата Microsoft Update\",\"en\":\"Administration of the Microsoft update system service\",\"ua\":\"Адміністрування сервісу системи оновлень Microsoft\"},\"texts\":{\"bg\":\"WSUS\",\"en\":\"WSUS SERVICE\",\"ua\":\"WSUS\"},\"text5\":{\"bg\":\"Елиминиране на технически дълг чрез показатели\",\"en\":\"Elimination of technical debt by metrics\",\"ua\":\"Усунення технічного боргу за метриками\"},\"text6\":{\"bg\":\"Осигуряване на внедряването и подобряването на процесите за мониторинг на инциденти\",\"en\":\"Ensuring the implementation and improvement of incident monitoring processes\",\"ua\":\"Забезпечення виконання та вдосконалення процесів моніторингу інцидентів\"},\"text7\":{\"bg\":\"Управление на инциденти и реагиране на инциденти\",\"en\":\"Incident management and incident response\",\"ua\":\"Управління інцидентами та реагування на інциденти\"}},\"item3\":{\"h3\":{\"bg\":\"Изисквания към позицията:\",\"en\":\"Position Requirements:\",\"ua\":\"Вимоги до посади:\"},\"text1\":{\"bg\":\"Опит в администрирането на операционни системи: Microsoft Windows/Linux\",\"en\":\"Experience in operating system administration: Microsoft Windows/Linux\",\"ua\":\"Досвід з адміністрування операційних систем: Microsoft Windows/Linux\"},\"text2\":{\"bg\":\"Способност за гъвкаво управление на приоритети\",\"en\":\"Ability to manage priorities flexibly\",\"ua\":\"Здатність гнучкого управління пріоритетами\"},\"text3\":{\"bg\":\"Опит: минимум 2 години като Системен администратор или на 2-ро ниво поддръжка\",\"en\":\"At least 2 years of experience as a system administrator or 2nd level support line\",\"ua\":\"Досвід роботи від 2 років як системний адміністратор або лінії підтримки 2-го рівня\"},\"text4\":{\"bg\":\"Висше образование в една от следните области: компютърни науки, математика или инженерни науки\",\"en\":\"University degree in one of the following fields: computer, math or engineering\",\"ua\":\"Вища освіта в одній із галузей: комп'ютерних, математичних або інженерних наук\"},\"text5\":{\"bg\":\"Познания за стандарти и добри практики в информационната сигурност\",\"en\":\"Knowledge of information security standards and best practices\",\"ua\":\"Знання стандартів та найкращих практик в галузі інформаційної безпеки\"},\"texts1\":{\"bg\":\"ISO27000, CIS контроли, SANS Top 20 Critical Security Controls и т.н., OWASP Top 10\",\"en\":\"ISO27000, CIS controls, SANS Top 20 Critical Security Controls, etc., OWASP Top 10\",\"ua\":\"ISO27000, CIS contrils, SANS Top 20 Critical Security Controls і т. д., OWASP Top 10\"},\"text6\":{\"bg\":\"Опит в управлението на услуги на операционни системи\",\"en\":\"Experience in managing operating system services\",\"ua\":\"Досвід управління сервісами операційних систем\"},\"texts2\":{\"bg\":\"AD, Exchange, DNS, DHCP, уеб сървъри и т.н.\",\"en\":\"AD, Exchange, DNS, DHCP, web-servers, etc.\",\"ua\":\"AD, Exchange, DNS, DHCP, web-servers і т.д\"},\"text7\":{\"bg\":\"Опит с едно от решенията за защита на крайни точки на водещите доставчици\",\"en\":\"Experience with one of the endpoint security solutions from leading vendors\",\"ua\":\"Досвід роботи з одним із рішень захисту кінцевих точок провідних вендорів\"}},\"item4\":{\"h3\":{\"bg\":\"Ние предлагаме:\",\"en\":\"We offer:\",\"ua\":\"Ми пропонуємо:\"},\"text1\":{\"bg\":\"Заплащане, което зависи от вашия опит\",\"en\":\"A salary that depends on your level\",\"ua\":\"ЗП, яка залежить від вашого рівня\"},\"text2\":{\"bg\":\"Дистанционна работа\",\"en\":\"Remote work, from any city of Ukraine\",\"ua\":\"Віддалену роботу, з будь-якого міста України\"},\"text3\":{\"bg\":\"8-часов работен ден с възможност за избор на начало и край на работния ден\",\"en\":\"8-hour working day with the ability to choose the start and end time of the working day\",\"ua\":\"8-годинний робочий день з можливістю обрати час початку та кінця робочого дня\"},\"text4\":{\"bg\":\"Вътрешнофирмено обучение\",\"en\":\"Training within the company\",\"ua\":\"Навчання всередині компанії\"},\"text5\":{\"bg\":\"Възможности за кариерно и професионално развитие\",\"en\":\"Opportunity for career and professional growth\",\"ua\":\"Можливість кар'єрного та професійного зростання\"}},\"item5\":{\"h3\":{\"bg\":\"Изпрати ни своето резюме, ако виждате себе си на тази позиция!\",\"en\":\"Send your resume if this sounds like you!\",\"ua\":\"Надсилай своє резюме, якщо це все про тебе!\"}}},\"Vacancy3HeaderText\":{\"title\":{\"bg\":\"Отворена позиция\",\"en\":\"Vacancy is open\",\"ua\":\"Відкрита вакансія\"},\"text\":{\"bg\":\"Търсим специалист\",\"en\":\"We are looking for a specialist\",\"ua\":\"Шукаємо спеціаліста\"}},\"Vacancy3Text\":{\"title\":{\"bg\":\"Penetration Tester\",\"en\":\"Penetration Tester\",\"ua\":\"Penetration Tester\"},\"item1\":{\"h3\":{\"bg\":\"Кого търсим\",\"en\":\"Who we are looking for\",\"ua\":\"Кого шукаємо\"},\"text1\":{\"bg\":\"Търсим тестер за проникване - експерт по киберсигурност, който е готов да се предизвика като етичен хакер и да помогне за подобряване на сигурността на нашата IT инфраструктура чрез идентифициране и анализиране на уязвимости.\",\"en\":\"We are seeking a Penetration Tester – a cybersecurity professional ready to take on the role of an ethical hacker. Your mission will be to enhance the security of our IT infrastructure by identifying and analyzing vulnerabilities.\",\"ua\":\"Ми шукаємо Penetration Tester – експерта з кібербезпеки, який готовий випробувати себе у ролі етичного хакера та допоможе покращити захищеність нашої ІТ-інфраструктури шляхом виявлення та аналізу вразливостей.\"}},\"item2\":{\"h3\":{\"bg\":\"Вашите задължения ще включват:\",\"en\":\"Your responsibilities will include:\",\"ua\":\"У ваші обов'язки буде входити:\"},\"text1\":{\"bg\":\"Според сценария за хакерски подход White Hat, търсене и опит за експлоатация на уязвимости в IT инфраструктурата, компоненти и услуги с цел подобряване на защитата\",\"en\":\"Following the White Hat hacking scenario, searching for and attempting to exploit vulnerabilities in IT infrastructure, components, and services to further improve the security posture\",\"ua\":\"За сценарієм хакерського підходу White Hat пошук та спроба експлуатації вразливостей в ІТ-інфраструктурі, компонентах і сервісах з метою подальшого покращення стану захищеності\"},\"text2\":{\"bg\":\"Създаване на аналитични заявки в системата Splunk Enterprise за откриване на инциденти\",\"en\":\"Building analytical queries in Splunk Enterprise to detect incidents\",\"ua\":\"Побудова аналітичних запитів у системі Splunk Enterprise з метою виявлення інцидентів\"},\"text3\":{\"bg\":\"Съставяне на доклади по резултати от сканиране и penetration тестове\",\"en\":\"Compiling reports on the results of scans and penetration tests.\",\"ua\":\"Складання звітів за результатами сканувань та тестувань на проникнення.\"},\"text4\":{\"bg\":\"Документиране на работата по модела на процеса \\\"Управление на уязвимости\\\"\",\"en\":\"Documentation of work according to the Vulnerability Management process model\",\"ua\":\"Документування роботи за моделлю процесу \\\"Керування вразливостями\\\"\"},\"texts\":{\"bg\":\"Документиране на работата по модела на процеса \\\"Управление на уязвимости\\\"\",\"en\":\"Documentation of work according to the Vulnerability Management process model\",\"ua\":\"Документування роботи за моделлю процесу \\\"Керування вразливостями\\\"\"},\"text5\":{\"bg\":\"Предоставяне на препоръки за IT и отдела за информационна сигурност \\\"BLUE TEAM\\\" за отстраняване на откритите уязвимости\",\"en\":\"Providing proposals for IT and the BLUE TEAM information security unit to eliminate the found vulnerabilities\",\"ua\":\"Надання пропозицій для IT та підрозділу \\\"BLUE TEAM\\\" інформаційної безпеки на усунення знайдених вразливостей\"}},\"item3\":{\"h3\":{\"bg\":\"Изисквания към позицията:\",\"en\":\"Position requirements:\",\"ua\":\"Вимоги до посади:\"},\"text1\":{\"bg\":\"Познания за принципите и организацията на информационната сигурност според стандартите ISO27000, CIS v7, v8, NIST, SANS, OWASP и др.\",\"en\":\"Knowledge of the principles and organization of information security according to ISO 27000, CIS v7, v8, NIST, SANS, OWASP, etc.\",\"ua\":\"Знання принципів та організації інформаційної безпеки за стандартами ISO27000, CIS v7, v8, NIST, SANS, OWASP etc.\"},\"text2\":{\"bg\":\"Познания в използването на инструмент WireShark\",\"en\":\"Knowledge of the WireShark tool.\",\"ua\":\"Знання інструменту WireShark.\"},\"text3\":{\"bg\":\"Познания за принципите на работа на компютърни мрежи на ниво CISCO CCNA или подобни\",\"en\":\"Knowledge of the principles of computer networks at the level of CISCO CCNA or similar\",\"ua\":\"Знання принципів роботи обчислювальних мереж на рівні CISCO CCNA або подібних\"},\"text4\":{\"bg\":\"Администриране на операционни системи от семейството UNIX/LINUX\",\"en\":\"Administration of UNIX/LINUX operating systems\",\"ua\":\"Адміністрування операційних систем сімейства UNIX/LINUX\"},\"text5\":{\"bg\":\"Познания по академични принципи на нападение/защита\",\"en\":\"Knowledge of academic principles of attack/defense\",\"ua\":\"Знання академічних принципів нападу/захисту\"},\"texts1\":{\"bg\":\"Kill Chain, MITRE ATTACK матрици\",\"en\":\"Kill Chain, MITRE ATTACK matrix\",\"ua\":\"Kill Chain, матриці MITRE ATTACK\"},\"text6\":{\"bg\":\"Познаване на инструментите Kali LINUX\",\"en\":\"Familiarity with Kali LINUX tools\",\"ua\":\"Знайомство з інструментами Kali LINUX\"},\"texts2\":{\"bg\":\"Network Defence Suit и др.\",\"en\":\"Network Defense Suit, etc.\",\"ua\":\"Network Defence Suit etc.\"},\"text7\":{\"bg\":\"Обучение/сертификати CEH, CPENT\",\"en\":\"CEH, CPENT training/certification\",\"ua\":\"Навчання/сертифікація CEH, CPENT\"}},\"item4\":{\"h3\":{\"bg\":\"Ние предлагаме:\",\"en\":\"We offer:\",\"ua\":\"Ми пропонуємо:\"},\"text1\":{\"bg\":\"Заплащане, което зависи от вашия опит\",\"en\":\"Salary, which depends on your level\",\"ua\":\"ЗП, яка залежить від вашого рівня\"},\"text2\":{\"bg\":\"Дистанционна работа\",\"en\":\"Remote work, from any city in Ukraine\",\"ua\":\"Віддалену роботу, з будь-якого міста України\"},\"text3\":{\"bg\":\"8-часов работен ден с възможност за избор на начало и край на работния ден\",\"en\":\"8-hour working day with the ability to choose the start and end time of the working day\",\"ua\":\"8-годинний робочий день з можливістю обрати час початку та кінця робочого дня\"},\"text4\":{\"bg\":\"Вътрешнофирмено обучение\",\"en\":\"Training within the company\",\"ua\":\"Навчання всередині компанії\"},\"text5\":{\"bg\":\"Възможности за кариерно и професионално развитие\",\"en\":\"Opportunity for career and professional growth\",\"ua\":\"Можливість кар'єрного та професійного зростання\"}},\"item5\":{\"h3\":{\"bg\":\"Изпрати ни своето резюме, ако виждате себе си на тази позиция!\",\"en\":\"Send your resume if this sounds like you!\",\"ua\":\"Надсилай своє резюме, якщо це все про тебе!\"}}},\"Vacancy4HeaderText\":{\"title\":{\"bg\":\"Отворена позиция\",\"en\":\"Vacancy is open\",\"ua\":\"Відкрита вакансія\"},\"text\":{\"bg\":\"Търсим специалист\",\"en\":\"We are looking for a specialist\",\"ua\":\"Шукаємо спеціаліста\"}},\"Vacancy4Text\":{\"title\":{\"bg\":\"Network Analyst\",\"en\":\"Network Analyst\",\"ua\":\"Network Analyst\"},\"item1\":{\"h3\":{\"bg\":\"Кого търсим\",\"en\":\"Who we are looking for\",\"ua\":\"Кого шукаємо\"},\"text1\":{\"bg\":\"Търсим опитен и квалифициран Network Analyst, който ще подобрява и решава проблеми с текущата инфраструктура. Трябва да имате задълбочени познания за мрежовите технологии, да сте готови постоянно да се развивате и подобрявате, да можете да решавате проблеми при несигурност и да запазвате спокойствие в стресови ситуации, което е от критично значение. Вашите умения за решаване на проблеми, способност за работа в екип и отлични комуникационни умения ще бъдат решаващи за успешното изпълнение на тази роля.\",\"en\":\"We are looking for an experienced and skilled Network Analyst who will improve and solve problems with the current infrastructure. You should have a deep knowledge of networking technologies, be ready for continuous development and improvement, be able to solve problems in conditions of uncertainty and stay calm in stressful situations are critical. Your problem-solving skills, ability to work in a team, and excellent communication skills will be crucial to the success of this role.\",\"ua\":\"Ми шукаємо досвідченого та кваліфікованого Network Analyst який буде покращувати та вирішувати проблем з поточною інфраструктурою. Ви повинні мати глибокі знання мережевих технологій, бути готовими до постійного розвитку та вдосконалення, вміти вирішувати проблеми в умовах невизначеності та залишатися спокійним у стресових ситуаціях є критично важливими. Ваші навички у вирішенні проблем, здатність працювати в команді та відмінні комунікативні здібності будуть вирішальними для успішного виконання цієї ролі.\"}},\"item2\":{\"h3\":{\"bg\":\"Вашите задължения ще включват:\",\"en\":\"Your responsibilities will include:\",\"ua\":\"У ваші обов'язки буде входити:\"},\"text1\":{\"bg\":\"Анализ и предоставяне на отчети за проблемите на съществуващата мрежова инфраструктура\",\"en\":\"Analyzing and reporting on existing network infrastructure issues\",\"ua\":\"Аналіз та надання звітів з проблем існуючої мережної інфраструктури\"},\"text2\":{\"bg\":\"Оптимизация на съществуващата инфраструктура, решаване на технически проблеми\",\"en\":\"Optimizing the existing infrastructure, solving technical problems\",\"ua\":\"Оптимізація існуючої інфраструктури, вирішення технічних проблем\"},\"text3\":{\"bg\":\"Споделяне на най-добрите практики в екипа\",\"en\":\"Disseminating best practices across the team\",\"ua\":\"Поширення найкращих практик у команді\"},\"text4\":{\"bg\":\"Анализ и предоставяне на отчети за проблемите и знанията на екипа\",\"en\":\"Analyzing and reporting on team's problems and knowledge\",\"ua\":\"Аналіз та надання звіту з проблем та знань команди\"},\"text5\":{\"bg\":\"Поддържане и подобряване на техническата документация\",\"en\":\"Maintaining and improving technical documentation\",\"ua\":\"Ведення та покращення технічної документації\"}},\"item3\":{\"h3\":{\"bg\":\"Изисквания към позицията:\",\"en\":\"Requirements for the position:\",\"ua\":\"Вимоги до посади:\"},\"text1\":{\"bg\":\"Опит на позицията Network Analyst - Мрежов инженер минимум 5 години\",\"en\":\"5 years of experience as a network engineer\",\"ua\":\"Досвід роботи на посаді мережевим інженером від 5 років\"},\"text2\":{\"bg\":\"Опит с маршрутизатори Fortinet/Mikrotik\",\"en\":\"Experience with Fortinet/Mikrotik routers\",\"ua\":\"Досвід роботи з маршрутизаторами Fortinet/Mikrotik\"},\"text3\":{\"bg\":\"Опит с комутатори HP/Cisco/Mikrotik\",\"en\":\"Experience with HP/Cisco/Mikrotik switches\",\"ua\":\"Досвід роботи з комутаторами HP/Cisco/Mikrotik\"},\"text4\":{\"bg\":\"Опит с изграждане на безпроблемни wifi мрежи на базата на оборудване Unifi\",\"en\":\"Experience in building seamless wifi based on unifi equipment\",\"ua\":\"Досвід побудова безшовного wifi на базі обладнання unifi\"},\"text5\":{\"bg\":\"Опит с протоколи за динамична маршрутизация\",\"en\":\"Experience with dynamic routing protocols\",\"ua\":\"Досвід роботи з протоколами динамічної маршрутизації\"},\"texts1\":{\"bg\":\"BGP/OSPF\",\"en\":\"BGP/OSPF PROTOCOLS\",\"ua\":\"BGP/OSPF\"},\"text6\":{\"bg\":\"Познания за настройка на VPN\",\"en\":\"Knowledge of VPN configuration\",\"ua\":\"Знання налаштування VPN\"},\"texts2\":{\"bg\":\"l2tp, ipsec, sstp, ip-ip, gre, eoip, ovpn, ssl vpn\",\"en\":\"L2TP, IPsec, SSTP, IP-IP, GRE, EoIP, OVPN, SSL VPN\",\"ua\":\"l2tp,ipsec,sstp,ip-ip,gre,eoip,ovpn,ssl vpn\"},\"text7\":{\"bg\":\"Познания за принципите на работа на PBR/SD-WAN/multi wan\",\"en\":\"Knowledge of the principles of PBR/SD-WAN/multi wan\",\"ua\":\"Знання принципів роботи PBR/SD-WAN/multi wan\"}},\"item4\":{\"h3\":{\"bg\":\"Ние предлагаме:\",\"en\":\"We offer:\",\"ua\":\"Ми пропонуємо:\"},\"text1\":{\"bg\":\"Заплащане, което зависи от вашия опит\",\"en\":\"Salary, which depends on your level\",\"ua\":\"ЗП, яка залежить від вашого рівня\"},\"text2\":{\"bg\":\"Дистанционна работа\",\"en\":\"Remote work, from any city of Ukraine\",\"ua\":\"Віддалену роботу, з будь-якого міста України\"},\"text3\":{\"bg\":\"8-часов работен ден с възможност за избор на начало и край на работния ден\",\"en\":\"8-hour working day with the ability to choose the start and end time of the working day\",\"ua\":\"8-годинний робочий день з можливістю обрати час початку та кінця робочого дня\"},\"text4\":{\"bg\":\"Вътрешнофирмено обучение\",\"en\":\"Training within the company\",\"ua\":\"Навчання всередині компанії\"},\"text5\":{\"bg\":\"Възможности за кариерно и професионално развитие\",\"en\":\"Opportunity for career and professional growth\",\"ua\":\"Можливість кар'єрного та професійного зростання\"}},\"item5\":{\"h3\":{\"bg\":\"Изпрати ни своето резюме, ако виждате себе си на тази позиция!\",\"en\":\"Send your resume if this sounds like you!\",\"ua\":\"Надсилай своє резюме, якщо це все про тебе!\"}}},\"termsHeaderText\":{\"title\":{\"bg\":\"Условия за използване\",\"en\":\"Terms of Use\",\"ua\":\"Умови використання\"},\"text\":{\"bg\":\"Политиката се преразглежда редовно годишно\",\"en\":\"The policy is reviewed on a regular annual basis\",\"ua\":\"Політика переглядається на регулярній щорічній основі\"}},\"termsText\":{\"title\":{\"bg\":\"Въведение\",\"en\":\"Introduction\",\"ua\":\"Вступ\"},\"item1\":{\"text1\":{\"bg\":\"Тези Условия за използване (\\\"Условия\\\") регулират използването на уебсайта и услугите на IT Soft Services (\\\"Услуги\\\"). Използвайки нашите Услуги, вие се съгласявате да спазвате тези Условия.\",\"en\":\"These Terms of Use (the “Terms”) govern your use of the IT Soft Services website and services (the “Services”). By using our Services, you agree to be bound by these Terms.\",\"ua\":\"Ці Умови використання (\\\"Умови\\\") регулюють використання вами веб-сайту та послуг IT Soft Services (\\\"Послуги\\\"). Використовуючи наші Послуги, ви погоджуєтеся дотримуватися цих Умов.\"}},\"item2\":{\"h3\":{\"bg\":\"Предоставени услуги\",\"en\":\"Services provided\",\"ua\":\"Надавані послуги\"},\"text1\":{\"bg\":\"IT Soft Services предлага следните услуги:\",\"en\":\"IT Soft Services offers the following services:\",\"ua\":\"IT Soft Services пропонує такі послуги:\"},\"text2\":{\"bg\":\"1. Наети сървъри - ексклузивен достъп до ресурси за висока производителност и сигурност.\",\"en\":\"1. Dedicated servers - exclusive access to resources for high performance and security.\",\"ua\":\"1. Виділені сервери - ексклюзивний доступ до ресурсів для високої продуктивності та безпеки.\"},\"text3\":{\"bg\":\"2. Защита на IT инфраструктура - защита срещу DDOS атаки и мониторинг в реално време.\",\"en\":\"2. IT infrastructure protection - protection against DDOS attacks and real-time monitoring.\",\"ua\":\"2. Захист IT-інфраструктури - захист від DDOS-атак і моніторинг у режимі реального часу.\"},\"text4\":{\"bg\":\"3. Облачен хостинг - гъвкави, мащабируеми и сигурни решения за съхранение на данни.\",\"en\":\"3. Cloud hosting - flexible, scalable, and secure data storage solutions.\",\"ua\":\"3. Хмарний хостинг - гнучкі, масштабовані та безпечні рішення для зберігання даних.\"},\"text5\":{\"bg\":\"4. Администриране на сървъри - професионално управление на виртуални среди.\",\"en\":\"4. Server administration - professional management of virtual environments.\",\"ua\":\"4. Адміністрування серверів - професійне управління віртуальними середовищами.\"}},\"item3\":{\"h3\":{\"bg\":\"Задължения на потребителя\",\"en\":\"User responsibilities\",\"ua\":\"Обов'язки користувача\"},\"text1\":{\"bg\":\"Използвайки нашите Услуги, вие се съгласявате да:\",\"en\":\"By using our Services, you agree to:\",\"ua\":\"Використовуючи наші Послуги, ви погоджуєтеся:\"},\"text2\":{\"bg\":\"1. Предоставяте точна и актуална информация.\",\"en\":\"1. Provide accurate and up-to-date information.\",\"ua\":\"1. Надавати точну та актуальну інформацію.\"},\"text3\":{\"bg\":\"2. Използвате нашите Услуги в съответствие с действащото законодателство и нормативни актове.\",\"en\":\"2. Use our Services in accordance with applicable laws and regulations.\",\"ua\":\"2. Використовувати наші Послуги відповідно до чинного законодавства та нормативних актів.\"},\"text4\":{\"bg\":\"3. Избягвате действия, които нарушават или причиняват щети на нашата инфраструктура.\",\"en\":\"3. Refrain from actions that disrupt or damage our infrastructure.\",\"ua\":\"3. Утримуватися від дій, які порушують або завдають шкоди нашій інфраструктурі.\"}},\"item4\":{\"h3\":{\"bg\":\"Условия за плащане\",\"en\":\"Payment terms\",\"ua\":\"Умови оплати\"},\"text1\":{\"bg\":\"Плащанията трябва да бъдат извършени в съответствие с вашия договор за обслужване.\",\"en\":\"Payments must be made in accordance with your service agreement.\",\"ua\":\"Платежі мають бути здійснені відповідно до вашого договору на обслуговування.\"},\"text2\":{\"bg\":\"Забавяне на плащания може да доведе до спиране или прекратяване на услугите.\",\"en\":\"Late payments may result in suspension or termination of services.\",\"ua\":\"Прострочення платежів може призвести до призупинення або припинення послуг.\"}},\"item5\":{\"h3\":{\"bg\":\"Интелектуална собственост\",\"en\":\"Intellectual property\",\"ua\":\"Інтелектуальна власність\"},\"text1\":{\"bg\":\"Цялото съдържание на нашия уебсайт и услуги, включително лога, текстове, графики и софтуер, е интелектуална собственост на IT Soft Services и е защитено от приложимото законодателство. Неразрешеното използване е строго забранено.\",\"en\":\"All content on our website and services, including logos, texts, graphics and software, is the intellectual property of IT Soft Services and is protected by applicable law. Unauthorized use is strictly prohibited.\",\"ua\":\"Увесь вміст нашого веб-сайту та послуг, включаючи логотипи, тексти, графіку та програмне забезпечення, є інтелектуальною власністю IT Soft Services і захищений чинним законодавством. Несанкціоноване використання суворо заборонено.\"}},\"item6\":{\"h3\":{\"bg\":\"Ограничения на отговорността\",\"en\":\"Limitation of liability\",\"ua\":\"Обмеження відповідальності\"},\"text1\":{\"bg\":\"IT Soft Services не носи отговорност за:\",\"en\":\"IT Soft Services is not responsible for:\",\"ua\":\"IT Soft Services не несе відповідальності за:\"},\"text2\":{\"bg\":\"1. Непряко, случайно или вторично възникнали щети от използването на нашите Услуги.\",\"en\":\"1. Indirect, incidental or consequential damages arising from the use of our Services.\",\"ua\":\"1. Непрямі, випадкові або побічні збитки, що виникають у результаті використання наших Послуг.\"},\"text3\":{\"bg\":\"2. Загуба на данни или прекъсвания в работата, причинени от технически проблеми.\",\"en\":\"2. Loss of data or business interruption caused by technical problems.\",\"ua\":\"2. Втрату даних або перерву в роботі, спричинену технічними проблемами.\"}},\"item7\":{\"h3\":{\"bg\":\"Прекратяване\",\"en\":\"Termination.\",\"ua\":\"Припинення\"},\"text1\":{\"bg\":\"Ние си запазваме правото да прекратим или спрем достъпа до нашите Услуги по наше усмотрение в случай на нарушение на тези Условия.\",\"en\":\"We reserve the right to terminate or suspend access to our Services at our sole discretion in the event of a breach of these Terms.\",\"ua\":\"Ми залишаємо за собою право припинити або призупинити доступ до наших Послуг на власний розсуд у разі порушення цих Умов.\"}},\"item8\":{\"h3\":{\"bg\":\"Законодателство\",\"en\":\"Governing Law\",\"ua\":\"Законодавство\"},\"text1\":{\"bg\":\"Тези Условия се регулират и тълкуват съгласно законодателството на Украйна.\",\"en\":\"These Terms shall be governed by and construed in accordance with the laws of Ukraine.\",\"ua\":\"Ці Умови регулюються та тлумачаться відповідно до законодавства України.\"}},\"item9\":{\"h3\":{\"bg\":\"Свържете се с нас\",\"en\":\"Contact us\",\"ua\":\"Зв'язатися з нами\"},\"text1\":{\"bg\":\"За въпроси относно тези Условия се свържете с нас на:\",\"en\":\"For questions regarding these Terms, please contact us at:\",\"ua\":\"Для запитань щодо цих Умов звертайтесь до нас за адресою:\"},\"text2\":{\"bg\":\"Email: info@itsoftservice.com\",\"en\":\"Email: info@itsoftservice.com\",\"ua\":\"Email: info@itsoftservice.com\"}}},\"privacyHeaderText\":{\"title\":{\"bg\":\"Политика за конфиденциалност\",\"en\":\"Privacy Policy\",\"ua\":\"Політика конфіденційності\"},\"text\":{\"bg\":\"Политиката се преразглежда на редовни годишни интервали\",\"en\":\"The policy is reviewed on a regular annual basis\",\"ua\":\"Політика переглядається на регулярній щорічній основі\"}},\"privacyText\":{\"title\":{\"bg\":\"Въведение\",\"en\":\"Introduction\",\"ua\":\"Вступ\"},\"item1\":{\"text1\":{\"bg\":\"IT Soft Services (\\\"ние\\\", \\\"наш\\\", \\\"нас\\\") се ангажира да защитава конфиденциалността на потребителите (\\\"вие\\\", \\\"ваш\\\"). Тази Политика за конфиденциалност описва как събираме, използваме и защитаваме вашата лична информация, когато взаимодействате с нашия уебсайт и услуги.\",\"en\":\"IT Soft Services (“we”, “our”, “us”) is committed to protecting the privacy of users (“you”, “your”). This Privacy Policy describes how we collect, use and protect your personal information when you interact with our website and services.\",\"ua\":\"IT Soft Services (\\\"ми\\\", \\\"наш\\\", \\\"нас\\\") зобов'язується захищати конфіденційність користувачів (\\\"ви\\\", \\\"ваш\\\"). Ця Політика конфіденційності описує як ми збираємо, використовуємо та захищаємо вашу особисту інформацію, коли ви взаємодієте з нашим веб-сайтом і послугами.\"}},\"item2\":{\"h3\":{\"bg\":\"Информация, която събираме\",\"en\":\"Information we collect\",\"ua\":\"Інформація, яку ми збираємо\"},\"text1\":{\"bg\":\"Ние можем да събираме следните видове информация:\",\"en\":\"We may collect the following types of information:\",\"ua\":\"Ми можемо збирати такі типи інформації:\"},\"text2\":{\"bg\":\"Лична информация:\",\"en\":\"Personal information:\",\"ua\":\"Особиста інформація:\"},\"text3\":{\"bg\":\"Име, имейл адрес, телефонен номер и други контактни данни.\",\"en\":\"Name, email address, phone number and other contact information.\",\"ua\":\"Ім'я, адреса електронної пошти, номер телефону та інші контактні дані.\"},\"text4\":{\"bg\":\"Платежна информация (например данни за кредитни карти), ако е приложимо.\",\"en\":\"Payment information (such as credit card information), if applicable\",\"ua\":\"Платіжна інформація (наприклад, дані кредитної картки), якщо це застосовується\"},\"text5\":{\"bg\":\"Не лична информация:\",\"en\":\"Non-personal information:\",\"ua\":\"Неособиста інформація:\"},\"text6\":{\"bg\":\"Не лична информация: IP адрес, тип браузър, операционна система и време на достъп.\",\"en\":\"IP address, browser type, operating system and time of access.\",\"ua\":\"IP-адреса, тип браузера, операційна система та час доступу.\"},\"text7\":{\"bg\":\"Данни за използване, включително посещавани страници и взаимодействия с нашите услуги.\",\"en\":\"Usage data, including pages visited and interactions with our services.\",\"ua\":\"Дані про використання, включаючи відвідані сторінки та взаємодії з нашими послугами.\"},\"text8\":{\"bg\":\"Бисквитки и технологии за проследяване:\",\"en\":\"Cookies and tracking technologies:\",\"ua\":\"Файли cookie та технології відстеження:\"},\"text9\":{\"bg\":\"Бисквитки, уеб маяци и подобни технологии за подобряване на вашето преживяване и анализиране на използването на уебсайта.\",\"en\":\"Cookies, web beacons, and similar technologies to improve your experience and analyze website usage.\",\"ua\":\"Файли cookie, веб-маяки та подібні технології для покращення вашого досвіду та аналізу використання веб-сайту.\"}},\"item3\":{\"h3\":{\"bg\":\"Как използваме вашата информация\",\"en\":\"How we use your information\",\"ua\":\"Як ми використовуємо вашу інформацію\"},\"text1\":{\"bg\":\"Вашата информация може да бъде използвана за следните цели:\",\"en\":\"Your information may be used for the following purposes:\",\"ua\":\"Ваша інформація може бути використана для таких цілей:\"},\"text2\":{\"bg\":\"За предоставяне, експлоатация и поддръжка на нашите услуги.\",\"en\":\"To provide, operate and maintain our services.\",\"ua\":\"Для надання, експлуатації та підтримки наших послуг.\"},\"text3\":{\"bg\":\"За комуникация с вас, включително изпращане на актуализации и рекламни материали.\",\"en\":\"To communicate with you, including sending you updates and promotional materials.\",\"ua\":\"Для зв'язку з вами, включаючи надсилання оновлень і рекламних матеріалів.\"},\"text4\":{\"bg\":\"За обработка на плащания и осигуряване на сигурни транзакции.\",\"en\":\"To process payments and ensure secure transactions.\",\"ua\":\"Для обробки платежів і забезпечення безпечних транзакцій.\"},\"text5\":{\"bg\":\"За мониторинг и подобряване на нашия уебсайт и услуги.\",\"en\":\"To monitor and improve our website and services.\",\"ua\":\"Для моніторингу та покращення нашого веб-сайту та послуг.\"},\"text6\":{\"bg\":\"За изпълнение на юридически и регулаторни задължения.\",\"en\":\"To comply with legal and regulatory obligations.\",\"ua\":\"Для виконання юридичних та регуляторних зобов'язань.\"}},\"item4\":{\"h3\":{\"bg\":\"Обмен на информация\",\"en\":\"Information sharing\",\"ua\":\"Обмін інформацією\"},\"text1\":{\"bg\":\"Ние не продаваме и не предоставяме вашата лична информация на трети страни, освен в случаите:\",\"en\":\"We do not sell or share your personal information with third parties, except to:\",\"ua\":\"Ми не продаємо та не передаємо вашу особисту інформацію третім сторонам, за винятком:\"},\"text2\":{\"bg\":\"Доставчици на услуги: За изпълнение на услуги от наше име (например обработка на плащания, хостинг).\",\"en\":\"Service providers: to perform services on our behalf (e.g. payment processing, hosting).\",\"ua\":\"Постачальники послуг: для виконання послуг від нашого імені (наприклад, обробка платежів, хостинг).\"},\"text3\":{\"bg\":\"Юридически задължения: За съответствие с приложимите закони, нормативни актове или правни процеси.\",\"en\":\"Legal obligations: to comply with applicable laws, regulations or legal process.\",\"ua\":\"Юридичні зобов'язання: для дотримання застосовних законів, нормативних актів або юридичних процесів.\"},\"text4\":{\"bg\":\"Бизнес операции: В случай на сливане, придобиване или продажба на активи.\",\"en\":\"Business transactions: in the event of a merger, acquisition or sale of assets.\",\"ua\":\"Бізнес-операції: у разі злиття, придбання або продажу активів.\"}},\"item5\":{\"h3\":{\"bg\":\"Сигурност\",\"en\":\"Security\",\"ua\":\"Безпека\"},\"text1\":{\"bg\":\"Ние прилагаме подходящи технически и организационни мерки, за да защитим вашата информация от неоторизиран достъп, промяна, разкриване или унищожаване.\",\"en\":\"We implement appropriate technical and organizational measures to protect your information from unauthorized access, alteration, disclosure or destruction.\",\"ua\":\"Ми впроваджуємо відповідні технічні та організаційні заходи для захисту вашої інформації від несанкціонованого доступу, зміни, розкриття або знищення.\"}},\"item6\":{\"h3\":{\"bg\":\"Вашите права\",\"en\":\"Your rights\",\"ua\":\"Ваші права\"},\"text1\":{\"bg\":\"Вие имате право да:\",\"en\":\"You have the right to:\",\"ua\":\"Ви маєте право:\"},\"text2\":{\"bg\":\"Получавате достъп, коригирате или изтривате личната си информация.\",\"en\":\"Access, correct or delete your personal information.\",\"ua\":\"Отримувати доступ, виправляти або видаляти свою особисту інформацію.\"},\"text3\":{\"bg\":\"Откажете от маркетингови съобщения.\",\"en\":\"Opt out of marketing communications.\",\"ua\":\"Відмовитися від маркетингових повідомлень.\"},\"text4\":{\"bg\":\"Ограничите или възразите срещу определени действия с обработка на данни.\",\"en\":\"Restrict or object to certain data processing activities.\",\"ua\":\"Обмежити або заперечити певні дії з обробки даних.\"},\"text5\":{\"bg\":\"За осъществяване на тези права се свържете с нас на info@itsoftservice.com.\",\"en\":\"To exercise these rights, please contact us at info@itsoftservice.com.\",\"ua\":\"Для реалізації цих прав звертайтесь до нас за адресою info@itsoftservice.com.\"}},\"item7\":{\"h3\":{\"bg\":\"Промени в тази Политика за конфиденциалност\",\"en\":\"Changes to this Privacy Policy\",\"ua\":\"Зміни до цієї Політики конфіденційності\"},\"text1\":{\"bg\":\"Ние си запазваме правото да обновяваме тази Политика за конфиденциалност по всяко време. Промените ще бъдат публикувани на тази страница с актуализираната дата \\\"Последна промяна\\\".\",\"en\":\"We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with an updated “Last modified” date.\",\"ua\":\"Ми залишаємо за собою право оновлювати цю Політику конфіденційності в будь-який час. Зміни будуть опубліковані на цій сторінці з оновленою датою \\\"Останні зміни\\\".\"}},\"item8\":{\"h3\":{\"bg\":\"Свържете се с нас\",\"en\":\"Contact us\",\"ua\":\"Зв'язатися з нами\"},\"text1\":{\"bg\":\"За въпроси относно тази Политика за конфиденциалност се свържете с нас на:\",\"en\":\"For questions about this Privacy Policy, please contact us at:\",\"ua\":\"Для запитань щодо цієї Політики конфіденційності звертайтесь до нас за адресою:\"},\"text2\":{\"bg\":\"Email: info@itsoftservice.com\",\"en\":\"Email: info@itsoftservice.com\",\"ua\":\"Email: info@itsoftservice.com\"}}},\"Cookies\":{\"text1\":{\"bg\":\"Този уебсайт използва бисквитки, които са строго необходими за функционирането на уебсайта, както и за производителността, функционалността и маркетинговите цели. Продължавайки разглеждането, вие се съгласявате с използването на бисквитки. За да научите повече за бисквитките, конфиденциалността и използването на този уебсайт, моля, прочетете нашата политика за конфиденциалност.\",\"en\":\"This website uses cookies that are necessary for the operation of the website, as well as for performance, functionality and marketing purposes. By continuing to browse, you agree to the use of cookies. To learn more about cookies, privacy and the use of this website, please read our privacy policy link.Privacy policy\",\"ua\":\"Цей веб-сайт використовує файли cookie, які суворо необхідні для роботи веб-сайту, а також для продуктивності, функціональності та маркетингових цілей. Продовжуючи перегляд, ви погоджуєтеся на використання файлів cookie. Щоб дізнатися більше про файли cookie, конфіденційність і використання цього веб-сайту, будь ласка, прочитайте наше посилання на політику конфіденційності.\"}},\"button\":{\"text1\":{\"bg\":\"Contact us\",\"en\":\"Contact us\",\"ua\":\"Зв'язатися з нами\"},\"text2\":{\"bg\":\"Find out more\",\"en\":\"Find out more\",\"ua\":\"Дізнатись більше\"},\"text3\":{\"bg\":\"Get started\",\"en\":\"Get started\",\"ua\":\"Розпочати\"},\"text4\":{\"bg\":\"Configurator\",\"en\":\"Configurator\",\"ua\":\"Конфігуратор\"},\"text5\":{\"bg\":\"Send a request\",\"en\":\"Send a request\",\"ua\":\"Надіслати запит\"},\"text6\":{\"bg\":\"Send a message\",\"en\":\"Send a message\",\"ua\":\"Надіслати повідомлення\"},\"text7\":{\"bg\":\"To the main page\",\"en\":\"To the main page\",\"ua\":\"На головну\"},\"text8\":{\"bg\":\"Apply for a vacancy\",\"en\":\"Apply for a vacancy\",\"ua\":\"Відгукнутись на вакансію\"},\"text9\":{\"bg\":\"Read more\",\"en\":\"Read more\",\"ua\":\"Детальніше\"}},\"navText\":{\"index\":{\"bg\":\"Home\",\"en\":\"Home\",\"ua\":\"Головна\"},\"about\":{\"bg\":\"Company\",\"en\":\"Company\",\"ua\":\"Компанія\"},\"servicespage\":{\"bg\":\"Solutions\",\"en\":\"Solutions\",\"ua\":\"Рішення\"},\"servicesdropdownitem\":{\"bg\":\"Services\",\"en\":\"Services\",\"ua\":\"Послуги\"},\"dedicated\":{\"bg\":\"Dedicated servers\",\"en\":\"Dedicated servers\",\"ua\":\"Виділені сервери\"},\"hosting\":{\"bg\":\"Cloud hosting\",\"en\":\"Cloud hosting\",\"ua\":\"Хмарний хостинг\"},\"ddos\":{\"bg\":\"Protection against DDoS attacks\",\"en\":\"Protection against DDoS attacks\",\"ua\":\"Захист від DDoS-атаки\"},\"administration\":{\"bg\":\"System administration\",\"en\":\"System administration\",\"ua\":\"Системне адміністрування\"},\"faq\":{\"bg\":\"FAQ\",\"en\":\"FAQ\",\"ua\":\"FAQ\"},\"news\":{\"bg\":\"News\",\"en\":\"News\",\"ua\":\"Новини\"},\"contacts\":{\"bg\":\"Contacts\",\"en\":\"Contacts\",\"ua\":\"Контакти\"}},\"titles\":{\"index\":{\"bg\":\"Home - IT Soft Services\",\"en\":\"Home - IT Soft Services\",\"ua\":\"Головна - ITsoftservice\"},\"about\":{\"bg\":\"Company - IT Soft Services\",\"en\":\"Company - IT Soft Services\",\"ua\":\"Компанія - ITsoftservice\"},\"services\":{\"bg\":\"Services - IT Soft Services\",\"en\":\"Services - IT Soft Services\",\"ua\":\"Послуги - ITsoftservice\"},\"dedicated\":{\"bg\":\"Dedicated servers - IT Soft Services\",\"en\":\"Dedicated servers - IT Soft Services\",\"ua\":\"Виділені сервери - ITsoftservice\"},\"hosting\":{\"bg\":\"Cloud hosting - IT Soft Services\",\"en\":\"Cloud hosting - IT Soft Services\",\"ua\":\"Хмарний хостинг - ITsoftservice\"},\"ddos\":{\"bg\":\"Protection against DDoS attacks - IT Soft Services\",\"en\":\"Protection against DDoS attacks - IT Soft Services\",\"ua\":\"Захист від DDoS-атаки - ITsoftservice\"},\"administration\":{\"bg\":\"System administration - IT Soft Services\",\"en\":\"System administration - IT Soft Services\",\"ua\":\"Системне адміністрування - ITsoftservice\"},\"faq\":{\"bg\":\"FAQ - IT Soft Services\",\"en\":\"FAQ - IT Soft Services\",\"ua\":\"FAQ - ITsoftservice\"},\"news\":{\"bg\":\"News - IT Soft Services\",\"en\":\"News - IT Soft Services\",\"ua\":\"Новини - ITsoftservice\"},\"contacts\":{\"bg\":\"Contacts - IT Soft Services\",\"en\":\"Contacts - IT Soft Services\",\"ua\":\"Контакти - ITsoftservice\"},\"notFound\":{\"bg\":\"404 - IT Soft Services\",\"en\":\"404 - IT Soft Services\",\"ua\":\"404 - ITsoftservice\"},\"vacancy\":{\"bg\":\"Vacancy - IT Soft Services\",\"en\":\"Vacancy - IT Soft Services\",\"ua\":\"Вакансія - ITsoftservice\"},\"policy\":{\"bg\":\"Privacy Policy - IT Soft Services\",\"en\":\"Privacy Policy - IT Soft Services\",\"ua\":\"Політика конфіденційності - ITsoftservice\"},\"condition\":{\"bg\":\"Terms of Service - IT Soft Services\",\"en\":\"Terms of Service - IT Soft Services\",\"ua\":\"Умови надання послуг - ITsoftservice\"}},\"additionalinf\":{\"text1\":{\"bg\":\"Order Information\",\"en\":\"Order Information\",\"ua\":\"Інформація про замовлення\"},\"text2\":{\"bg\":\"Enter your email to view the order details:\",\"en\":\"Enter your email to view the order details:\",\"ua\":\"Введіть свою електронну пошту для перегляду деталей замовлення:\"},\"text3\":{\"bg\":\"Details\",\"en\":\"Details\",\"ua\":\"Деталі\"}},\"popup\":{\"caption\":{\"bg\":\"Notification\",\"en\":\"Notification\",\"ua\":\"Повідомлення\"},\"title\":{\"bg\":\"Request sent successfully\",\"en\":\"Request sent successfully\",\"ua\":\"Запит був успішно надісланий\"},\"text\":{\"bg\":\"We will contact you shortly.\",\"en\":\"We will contact you shortly.\",\"ua\":\"Ми зв’яжемося з вами найближчим часом.\"}}}");

/***/ }),

/***/ "./site.config.json":
/*!**************************!*\
  !*** ./site.config.json ***!
  \**************************/
/*! exports provided: defaultLanguage, seo, php, waitplugin, iconplugin, spam, spamLicense, callbackSocialInputs, documents, companyData, brandlinks, javascript, build, imagerename, htmlrename, robotsfile, sitemapfile, seolocales, nonecompany, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"defaultLanguage\":\"ua\",\"seo\":false,\"php\":true,\"waitplugin\":true,\"iconplugin\":false,\"spam\":false,\"spamLicense\":false,\"callbackSocialInputs\":{\"telegram\":false,\"skype\":false,\"whatsup\":false},\"documents\":{\"user_agreement\":3,\"risk_disclosure_notice\":3,\"anti_money_laundering\":3,\"conflict_of_interest_policy_statement\":3,\"refund_cancellation_policy\":3},\"companyData\":{\"title\":\"IT Soft Services\",\"adres\":\"1A, 1/1, Racho Dimchev Str. 8300, Sredets, Sofia, Bulgaria\",\"phone\":\"+357 24 411682\",\"email\":\"info@itsoftservice.com\",\"url\":\"https://itsoftservice.com\",\"domain\":\"https://itsoftservice.com\",\"license\":{\"lls1\":\"\",\"lls2\":\"\"},\"loginpage\":\"login.html\",\"registratepage\":\"registration.html\"},\"brandlinks\":{\"logo\":\"assets/images/logo.svg\",\"altlogo\":\"assets/images/logo-dark.svg\",\"favicon\":\"assets/images/favicon.png\"},\"javascript\":{\"index_page\":{\"accounts\":{\"account_1\":{\"price\":\"0\",\"leverage\":\"1:100\"},\"account_2\":{\"price\":\"0\",\"leverage\":\"1:500\"},\"account_3\":{\"price\":\"0\",\"leverage\":\"1:500\"}}},\"navLangs\":{\"en\":true,\"ua\":true,\"bg\":true,\"de\":false,\"fr\":false,\"it\":false,\"pl\":false,\"zh\":false,\"tr\":false,\"hi\":false},\"table\":{\"reservserver\":\"https://trade.dtt-ma.com/history/quotesnapshot\",\"table_freq_update\":10000,\"instrument_leverage\":{\"stocks\":\"1:20\",\"metals\":\"1:100\",\"forex\":\"1:100\",\"commodities\":\"1:100\",\"indices\":\"1:500\",\"crypto\":\"1:10\",\"etf\":\"1:100\"}},\"aos\":{\"duration\":500},\"docs\":{\"user_agreement\":true,\"risk_disclosure_notice\":true,\"anti_money_laundering\":true,\"conflict_of_interest_policy_statement\":true,\"refund_cancellation_policy\":true,\"terms_of_use\":false,\"order_execution_policy\":false,\"privacy_policy\":false},\"news\":{\"number\":5,\"imgblock\":\"assets/images/news.svg\",\"linkrss\":\"https://www.itnews.com.au/RSS/rss.ashx?type=Category&ID=406\"},\"tradeview\":{\"instruments\":{\"forex\":\"EURUSD\",\"metals\":\"GOLD\",\"stocks\":\"NASDAQ:AMZN\",\"commodities\":\"OIL_BRENT\",\"index\":\"CURRENCYCOM:US500\",\"crypto\":\"BITSTAMP:BTCUSD\"}},\"about\":{\"duration\":1500},\"forms\":{\"sha\":\"0000\",\"methods\":{\"createacc\":\"CreateUserAndAccounts\",\"createtoken\":\"CreateToken\",\"createtokenGuest\":\"CreateGuestToken\",\"webAction\":\"WebAction\",\"reset\":\"ResetPassword\"}},\"ip_restrictions\":{\"ip_restrictions_flag\":true,\"ip_countries\":[\"bg\",\"ua\",\"il\"]}},\"build\":{\"contentfile\":\"content\",\"proxy\":\"localhost\",\"port\":\"3000\",\"links\":{\"source\":{\"core\":\"src\",\"php\":{\"windows\":{\"phpini\":\"src/php/php.ini\",\"phpbase\":\"src/php/php.exe\"},\"other\":{\"phpini\":\"php.ini\",\"phpbase\":\"php\"}},\"assets\":{\"scss\":\"src/assets/scss\",\"js\":\"src/assets/js\",\"img\":\"src/assets/images\",\"fonts\":\"src/assets/fonts\",\"icons\":\"src/assets/icons\",\"rss\":\"src/assets/js/blocks/env\"},\"csv\":\"src/csv\",\"pages\":\"src/pages\",\"pug\":\"src/pug\",\"icons\":{\"template\":\"src/templates/fonts.template.scss\",\"fontname\":\"iconfont\",\"formats\":[\"ttf\",\"eot\",\"woff\",\"svg\"]},\"sender\":{\"title\":\"sender.php\"},\"license\":{\"title\":\"license.php\"},\"wallets\":{\"title\":\"wallets.php\"},\"feedback\":{\"title\":\"feedback.php\"},\"rssrequest\":{\"title\":\"cw1mlq5ey0iu332v2u1u5xnw06y2a4.php\"},\"resources\":\"src/resources\"},\"build\":{\"core\":\"build\",\"assets\":{\"core\":\"build/assets/\",\"css\":\"build/assets/css\",\"js\":\"build/assets/js\",\"img\":\"build/assets/images\",\"fonts\":\"build/assets/fonts\",\"json\":\"build/assets/json\"},\"output\":{\"js\":{\"vendor\":\"vendor\",\"main\":\"main\"}},\"input\":{\"js\":{\"main\":\"construct\"}}}}},\"imagerename\":{\"numberletters\":30,\"possibles\":\"abcdefghijklmnopqrstuvwxyz0123456789\",\"formats\":[\"jpg\",\"png\",\"jpeg\",\"svg\",\"gif\",\"webp\"],\"nonerename\":[\"email/logo.png\"]},\"htmlrename\":{\"numberletters\":10,\"possibles\":\"abcdefghijklmnopqrstuvwxyz0123456789\",\"formats\":[\"html\"],\"nonerename\":[\"index.html\",\"en/index.html\",\"de/index.html\",\"bg/index.html\",\"fr/index.html\",\"it/index.html\",\"ru/index.html\",\"zh/index.html\",\"pl/index.html\",\"tr/index.html\",\"hi/index.html\",\"404.html\",\"en/404.html\",\"de/404.html\",\"bg/404.html\",\"fr/404.html\",\"it/404.html\",\"ru/404.html\",\"zh/404.html\",\"pl/404.html\",\"tr/404.html\",\"hi/404.html\"]},\"robotsfile\":{\"allow\":{\"false\":[],\"true\":[\"de/\",\"bg/\",\"fr/\",\"it/\",\"ru/\",\"zh/\",\"pl/\",\"tr/\",\"hi/\"]},\"disallow\":{\"false\":[\"/\",\"*?*\"],\"true\":[\"/*.json\",\"/*.php\",\"/*.htaccess\",\"/assets/\"]}},\"sitemapfile\":{\"rel\":\"sitemap\",\"freq\":\"monthly\",\"hidepage\":[\"404\",\"500\",\"503\",\"login\",\"recovery\",\"registration\"],\"langs\":[\"en\",\"ru\",\"fr\"]},\"seolocales\":{\"siteLocale\":{\"ru\":\"ru-RU\",\"en\":\"en-US\",\"bg\":\"bg-BG\",\"it\":\"it-IT\",\"de\":\"de-DE\",\"fr\":\"fr-FR\",\"zh\":\"zh-CN\",\"pl\":\"pl-PL\",\"tr\":\"tr-TR\",\"hi\":\"hi-HI\"},\"alternatives\":[\"ru\",\"en\",\"bg\",\"it\",\"de\",\"zh\",\"fr\",\"pl\",\"tr\",\"hi\"]},\"nonecompany\":{\"title\":\"Brocker Name\",\"email\":\"support@mail.com\",\"phone\":\"+0 0000 000 00 00\",\"adres\":\"BrockerName adress\",\"license\":{\"lls1\":\"000/00\",\"lls2\":\"00/00/00/00\",\"lls3\":\"000000000\"},\"url\":\"https://brokername.com\",\"domain\":\"brokername.com\"}}");

/***/ }),

/***/ "./src/assets/js/blocks/env/develop.js":
/*!*********************************************!*\
  !*** ./src/assets/js/blocks/env/develop.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

window.buildRelease = false;

/***/ }),

/***/ "./src/assets/js/blocks/footer.js":
/*!****************************************!*\
  !*** ./src/assets/js/blocks/footer.js ***!
  \****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _site_config_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../site.config.json */ "./site.config.json");
var _site_config_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t(/*! ../../../../site.config.json */ "./site.config.json", 1);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./global */ "./src/assets/js/blocks/global.js");
 // глобальный файл конфигурации сайта

(function () {
  var lang = Object(_global__WEBPACK_IMPORTED_MODULE_1__["definesLanguage"])(),
    // получение языка сайта
    blockid = '.footer-company-content',
    blockid_2 = '.footer-company-info',
    blockid_3 = '.footer-company-copy',
    baseDir = lang == _site_config_json__WEBPACK_IMPORTED_MODULE_0__.defaultLanguage ? '' : '../'; // определение корня сайта для ссылок

  let vars = {
    name: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.title,
    adr: '<b>' + _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.adres + '</b>',
    phoneNumber: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.phone,
    phone: "<a href='tel:" + _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.phone + "'>" + _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.phone + '</a>',
    mail: "<a href='mailto:" + _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.email + "'>" + _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.email + '</a>',
    lic: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.license.lls1,
    lic2: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.license.lls2,
    lic3: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.license.lls3,
    getCurrentYear() {
      let currentDate = new Date();
      return currentDate.getFullYear();
    }
  };
  let fDatas = {
    address: {
      ru: 'Юридический адрес: ' + vars.adr,
      en: 'Its registered office is at ' + vars.adr,
      es: 'Su oficina registrada se encuentra en ' + vars.adr,
      de: 'Sein eingetragenes Amt befindet sich bei' + vars.adr,
      fr: 'Son siège social se trouve à ' + vars.adr,
      it: 'La sua sede legale si trova a ' + vars.adr,
      pl: 'Jego zarejestrowane biuro znajduje się w ' + vars.adr,
      zh: '它的注册办事处位于塞浦路斯的 ' + vars.adr,
      tr: 'Yasal adres: ' + vars.adr + '.',
      hi: 'इसका पंजीकृत कार्यालय ' + vars.adr + '.'
    },
    info: {
      en: vars.name + ' - is a financial services company.' + '<br/>' + 'The company operates under regulation and supervision by two reputable authorities: the Dubai Financial Services Authority (DFSA) with investment dealer license number ' + vars.lic + ", and the Cyprus Securities and Exchange Commission (CySEC) with license number CIF " + vars.lic2 + '.',
      ru: vars.name + ' – компания, оказывающая финансовые услуги.' + '<br/>' + 'Управление компанией регламентировано и надзор за деятельностью осуществляется Управлением по финансовому регулированию и надзору Дубая (Dubai Financial Services Authority, DFSA) – номер лицензии инвестиционного дилера: ' + vars.lic + ". И также в соответствии с Кипрской комиссией по ценным бумагам и биржам (Cyprus Securities and Exchange Commission, CySEC) – номер лицензии: CIF " + vars.lic2 + '.',
      tr: vars.name + ' - Finansal hizmetler sunan şirket.' + '<br/>' + 'Şirketin yönetimi, Dubai Finansal Hizmetler Kurumu (DFSA) tarafından yönetilmekte ve denetlenmektedir – yatırım bayisinin lisans numarası: ' + vars.lic + '\'dir. Ayrıca Kıbrıs Menkul Kıymetler ve Borsa Komisyonu (Cyprus Securities and Exchange Commission, CySEC) uyarınca - lisans numarası: CIF ' + vars.lic2 + '.',
      de: vars.name + ' - ist ein Finanzdienstleistungsunternehmen.' + '<br/>' + 'Das Unternehmen unterliegt der Regulierung und Aufsicht zweier angesehener Behörden: der Dubai Financial Services Authority (DFSA) mit der Lizenznummer ' + vars.lic + ' für Investmenthändler und der Cyprus Securities and Exchange Commission (CySEC) mit der Lizenznummer CIF ' + vars.lic2 + '.',
      es: vars.name + ' - es una empresa de servicios financieros.' + '<br/>' + 'La empresa opera bajo la regulación y supervisión de dos autoridades acreditadas: la Autoridad de Servicios Financieros de Dubai (DFSA) con número de licencia de corredor de inversiones ' + vars.lic + ', y la Comisión de Bolsa y Valores de Chipre (CySEC) con número de licencia CIF ' + vars.lic2 + '.',
      fr: vars.name + ' - est une société de services financiers.' + '<br/>' + 'La société opère sous la réglementation et la supervision de deux autorités réputées : la Dubai Financial Services Authority (DFSA) avec le numéro de licence de courtier en investissements ' + vars.lic + ' et la Commission chypriote des valeurs mobilières et des changes (CySEC) avec le numéro de licence CIF ' + vars.lic2 + '.',
      it: vars.name + ' - è una società di servizi finanziari.' + '<br/>' + 'La società opera sotto la regolamentazione e la supervisione di due autorità rispettabili: la Dubai Financial Services Authority (DFSA) con numero di licenza per intermediari di investimenti ' + vars.lic + ' e la Cyprus Securities and Exchange Commission (CySEC) con numero di licenza CIF ' + vars.lic2 + '.',
      pl: vars.name + ' - to firma świadcząca usługi finansowe.' + '<br/>' + 'Firma działa pod nadzorem dwóch renomowanych organów: Dubai Financial Services Authority (DFSA) z licencją brokera inwestycyjnego o numerze ' + vars.lic + ' oraz Cypryjskiej Komisji Papierów Wartościowych i Giełd (CySEC) z licencją o numerze CIF ' + vars.lic2 + '.',
      zh: vars.name + ' - 是一家金融服务公司。' + '<br/>' + '该公司在两个信誉良好的机构的监管和监督下运营：迪拜金融服务管理局（DFSA）（投资交易商许可证号为' + vars.lic + '）和塞浦路斯证券交易委员会（CySEC）（许可证号为 CIF ' + vars.lic2 + '）。',
      hi: vars.name + ' - एक वित्तीय सेवा कंपनी है।' + '<br/>' + 'कंपनी दो प्रतिष्ठित अधिकारियों के विनियमन और पर्यवेक्षण के तहत काम करती है: निवेश डीलर लाइसेंस संख्या ' + vars.lic + 'के साथ दुबई वित्तीय सेवा प्राधिकरण (DFSA), और लाइसेंस संख्या CIF ' + vars.lic2 + ' के साथ साइप्रस सिक्योरिटीज एंड एक्सचेंज कमीशन (CySEC)।'
    },
    info2: {
      en: 'The company is regulated and supervised by the Dubai Financial Services Authority (DFSA). Investment Dealer License Number: ' + vars.lic + '. We are also regulated by the Cyprus Securities and Exchange Commission (CySEC) - investment license - CIF ' + vars.lic2 + '.',
      ru: 'Управление компанией регламентировано и надзор за деятельностью осуществляется Управлением по финансовому регулированию и надзору Дубая (Dubai Financial Services Authority, DFSA) – номер лицензии инвестиционного дилера: ' + vars.lic + '. А также в соответствии с Кипрской комиссией по ценным бумагам и биржам (Cyprus Securities and Exchange Commission, CySEC) – номер лицензии: CIF ' + vars.lic2 + '.',
      tr: 'Şirketin yönetimi, Dubai Finansal Hizmetler Kurumu (DFSA) tarafından yönetilmekte ve denetlenmektedir – yatırım bayisinin lisans numarası: ' + vars.lic + '\'dir. Ayrıca Kıbrıs Menkul Kıymetler ve Borsa Komisyonu (CySEC) uyarınca - yatırım bayisi lisans numarası: CIF ' + vars.lic2 + '.',
      de: 'Das Unternehmen wird von der Dubai Financial Services Authority (DFSA) reguliert und überwacht. Investmenthändler -Lizenznummer: ' + vars.lic + '. Wir werden auch von der Cyprus Securities and Exchange Commission (CySEC) - Investment Lizenz - CIF ' + vars.lic2 + ' reguliert.',
      es: 'La compañía está regulada y supervisada por la Autoridad de Servicios Financieros de Dubai (DFSA). Número de licencia del concesionario de inversión: ' + vars.lic + '. También estamos regulados por la Comisión de Bolsa y Valores de Chipre (CySEC) - Licencia de inversión - CIF ' + vars.lic2 + '.',
      fr: 'La société est réglementée et supervisée par la Dubai Financial Services Authority (DFSA). Numéro de licence du concessionnaire d\'investissement: ' + vars.lic + '. Nous sommes également réglementés par la Chypre Securities and Exchange Commission (CySEC) - Licence d\'investissement - CIF ' + vars.lic2 + '.',
      it: 'La Società è regolamentata e supervisionata dalla Dubai Financial Services Authority (DFSA). Numero di licenza del rivenditore di investimenti: ' + vars.lic + '. Siamo inoltre regolati dalla Cipro Securities and Exchange Commission (CySEC) - Licenza di investimento - CIF ' + vars.lic2 + '.',
      pl: 'Firma jest regulowana i nadzorowana przez Dubai Financial Services Authority (DFSA). Numer licencji dealera inwestycyjnego: ' + vars.lic + '. Jesteśmy również regulowani przez Cypr Papierów Wartościowych i Giełd (CySEC) - Licencja inwestycyjna - CIF ' + vars.lic2 + '.',
      zh: '公司受迪拜金融服务局（DFSA）的监管和监督。投资经销商许可证号：' + vars.lic + '。我们还受塞浦路斯证券交易委员会（CySEC）的监管 - 投资许可证-CIF ' + vars.lic2 + '。',
      hi: 'कंपनी को दुबई फाइनेंशियल सर्विसेज अथॉरिटी (DFSA) द्वारा विनियमित और पर्यवेक्षण किया जाता है। निवेश डीलर लाइसेंस संख्या: ' + vars.lic + '। हमें साइप्रस सिक्योरिटीज एंड एक्सचेंज कमीशन (CySEC) - निवेश लाइसेंस - CIF ' + vars.lic2 + ' द्वारा भी विनियमित किया जाता है।'
    },
    info3: {
      ru: 'Отказ от ответственности: продукты и услуги с контрактами на разницу («CFD») не предназначены для использования резидентами любых стран или юрисдикций, где такое распространение или использование противоречит местному законодательству.',
      en: 'Disclaimer: Contracts for Difference ("CFD") products and services are not intended for use by residents of any country or jurisdiction where such distribution or use is contrary to local law.',
      es: 'Descargo de responsabilidad: Los productos y servicios de Contratos por Diferencia ("CFD") no están destinados a ser utilizados por residentes de ningún país o jurisdicción donde dicha distribución o uso sea contrario a la ley local.',
      de: 'Haftungsausschluss: Produkte und Dienstleistungen von Contracts for Difference („CFD“) sind nicht für die Nutzung durch Einwohner eines Landes oder einer Gerichtsbarkeit bestimmt, in dem eine solche Verbreitung oder Nutzung gegen lokales Recht verstößt.',
      fr: 'Avertissement: Les produits et services Contracts for Difference ("CFD") ne sont pas destinés à être utilisés par des résidents de tout pays ou juridiction où une telle distribution ou utilisation est contraire à la loi locale.',
      it: 'Dichiarazione di non responsabilità: i prodotti e i servizi Contratti per differenza ("CFD") non sono destinati all\'uso da parte di residenti di qualsiasi paese o giurisdizione in cui tale distribuzione o utilizzo sia contrario alla legge locale.',
      pl: 'Zastrzeżenie: Produkty i usługi kontraktów różnicowych („CFD”) nie są przeznaczone do użytku przez mieszkańców jakiegokolwiek kraju lub jurysdykcji, gdzie taka dystrybucja lub wykorzystanie jest sprzeczne z lokalnym prawem.',
      zh: '免责声明：差价合约（“CFD”）产品和服务不适用于此类分发或使用违反当地法律的任何国家或司法管辖区的居民。',
      tr: 'Feragatname: Fark sözleşmeli ürünler ve hizmetler («CFD\'ler»), bu tür dağıtım veya kullanımın yerel yasalara aykırı olduğu herhangi bir ülkenin veya yargı bölgesinin sakinleri tarafından kullanılmak üzere tasarlanmamıştır.',
      hi: 'अस्वीकरण: अंतर के अनुबंध ("सीएफडी") उत्पाद और सेवाएं किसी भी देश या क्षेत्राधिकार के निवासियों द्वारा उपयोग के लिए नहीं हैं जहां ऐसा वितरण या उपयोग स्थानीय कानून के विपरीत है।'
    },
    copy: {
      ru: '<span class="footer-copyright">Все права защищены. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      en: '<span class="footer-copyright">All rights reserved. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      es: '<span class="footer-copyright">Reservados todos los derechos. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      de: '<span class="footer-copyright">Alle Rechte vorbehalten. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      fr: '<span class="footer-copyright">Tous droits réservés. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      it: '<span class="footer-copyright">Tutti i diritti riservati. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      pl: '<span class="footer-copyright">Wszelkie prawa zastrzeżone. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      zh: '<span class="footer-copyright">版权所有。 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      tr: '<span class="footer-copyright">Tüm hakları saklıdır. 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>',
      hi: '<span class="footer-copyright">सर्वाधिकार सुरक्षित। 2017 - ' + vars.getCurrentYear() + ' ' + vars.name + '</span>'
    }
  };
  var footer_info = "<p class='footer-info company'>" + fDatas.info[lang] + "</p>",
    footer = "<p class='footer-info bottom'>" + fDatas.info3[lang] + "</p>",
    footer_copy = "<p class='footer-copy'>" + fDatas.copy[lang] + "</p>",
    m = footer,
    m2 = footer_info,
    m3 = footer_copy,
    fs = blockid,
    fs2 = blockid_2,
    fs3 = blockid_3;
  if (typeof jQuery === 'function') {
    jQuery(function () {
      jQuery(fs).html(m).on('copy', function (e) {
        e.preventDefault();
        return !1;
      });
      jQuery(fs2).html(m2).on('copy', function (e) {
        e.preventDefault();
        return !1;
      });
      jQuery(fs3).html(m3).on('copy', function (e) {
        e.preventDefault();
        return !1;
      });
    });
  } else {
    var da = document.addEventListener,
      c = function () {
        if (da || window.event.type === 'load' || document.readyState === 'complete') {
          d();
          r();
        }
      };
    var n = function (e) {
      var a = e || window.event;
      a.preventDefault();
      return !1;
    };
    var r = function () {
      var e = document.querySelector(fs);
      if (e) {
        e.innerHTML = m;
        if (da) e.addEventListener('copy', n);else e.attachEvent('oncopy', n);
      }
    };
    var d = function () {
      if (da) {
        document.removeEventListener('DOMContentLoaded', c);
        window.removeEventListener('load', c);
      } else {
        document.detachEvent('onreadystatechange', c);
        window.detachEvent('onload', c);
      }
    };
    if (document.readyState === 'complete' || document.readyState !== 'loading' && !document.documentElement.doScroll) {
      window.setTimeout(r);
    } else if (da) {
      da('DOMContentLoaded', c);
      window.addEventListener('load', c);
    } else {
      document.attachEvent('onreadystatechange', c);
      window.attachEvent('onload', c);
    }
  }
})();

/***/ }),

/***/ "./src/assets/js/blocks/forms.js":
/*!***************************************!*\
  !*** ./src/assets/js/blocks/forms.js ***!
  \***************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _site_config_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../site.config.json */ "./site.config.json");
var _site_config_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t(/*! ../../../../site.config.json */ "./site.config.json", 1);
/* harmony import */ var _json_forms_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./json/forms.json */ "./src/assets/js/blocks/json/forms.json");
var _json_forms_json__WEBPACK_IMPORTED_MODULE_1___namespace = /*#__PURE__*/__webpack_require__.t(/*! ./json/forms.json */ "./src/assets/js/blocks/json/forms.json", 1);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./global */ "./src/assets/js/blocks/global.js");
/* harmony import */ var _construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../construct */ "./src/assets/js/construct.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_5__);
 // глобальный файл конфигурации сайта
 // статичные элементы для форм + переводы
 // хук для определения языка



(function buttonClosePopup() {
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('.mfp-close').on('click', function () {
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.close();
  });
})();

/**
 * Функция для открытия модального окна об успешной отправлении формы обратной связи
 */
function showSuccesText() {
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('form').find('input').val('');
  jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.close();
  jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.open({
    items: {
      src: '#information-popup'
    },
    type: 'inline',
    callbacks: {
      beforeOpen: function () {
        jquery__WEBPACK_IMPORTED_MODULE_5___default()('body').css('overflow', 'hidden');
      },
      beforeClose: function () {
        jquery__WEBPACK_IMPORTED_MODULE_5___default()('body').css('overflow', 'auto');
      }
    }
  }, 0);
}
;

/**
 * Валидация формы обратной связи
 */
if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('#callbackForm').length) {
  let formLang = Object(_global__WEBPACK_IMPORTED_MODULE_2__["definesLanguage"])();
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('#callbackForm').validate({
    rules: {
      first_name: {
        required: true,
        minlength: 2,
        maxlength: 30
      },
      second_name: {
        required: false,
        // minlength: 2,
        maxlength: 30
      },
      phone_number: {
        required: true,
        minlength: 7,
        maxlength: 50
      },
      email: {
        required: true,
        email: true,
        newEmailRules: true
      },
      language: {
        required: false
      },
      agreement: {
        required: false
      },
      submit_question: {
        required: false
      }
    },
    messages: {
      first_name: {
        required: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.requiredText[formLang],
        minlength: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.minlength_2[formLang],
        maxlength: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.maxlength_30[formLang]
      },
      second_name: {
        required: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.requiredText[formLang],
        minlength: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.minlength_2[formLang],
        maxlength: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.maxlength_30[formLang]
      },
      phone_number: {
        required: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.requiredText[formLang],
        minlength: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.minlength_7[formLang],
        maxlength: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.maxlength_50[formLang]
      },
      email: {
        required: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.requiredText[formLang],
        email: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.emailText[formLang],
        newEmailRules: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.emailText[formLang]
      },
      language: {
        required: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.requiredText[formLang]
      },
      agreement: {
        required: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.requiredText[formLang]
      },
      submit_question: {
        required: _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.callback.requiredText[formLang]
      }
    }
  });
}

/**
 * Объявление переменных для форм авторизаций
 */
if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js--form-wrapper').length) {
  // хосты для запросов
  var hosts = {
      web: {
        host: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.domain + '/web',
        type: 'dispatchregister'
      },
      createacc: {
        host: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.domain + '/api/'
      },
      auth2: {
        host: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.domain + '/#/?key=',
        endhost: '#/auth'
      },
      usercallback: {
        host: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.companyData.domain + '/api/'
      }
    },
    captchaImage = '',
    sendType = 'POST',
    contentType = 'application/json; charset=utf-8',
    // все возможные типы полей, которые принимает API (id - это уникальный идентификато id поля в форме!!!!)
    field = [{
      id: 'submit-name',
      name: 'FirstName',
      required: 'true',
      default: ''
    }, {
      id: 'submit-lastname',
      name: 'LastName',
      required: 'true',
      default: ''
    }, {
      id: 'submit-email',
      name: 'Email',
      required: 'true',
      default: ''
    }, {
      id: 'submit-pass-show',
      name: 'Password',
      required: 'true',
      default: ''
    }, {
      id: 'submit-phone',
      name: 'PhoneNumber',
      required: 'true',
      default: ''
    }, {
      id: 'submit-promo',
      name: 'PromoCode',
      required: 'false',
      default: ''
    }, {
      id: '',
      name: 'AffiliateCode',
      required: 'false',
      default: ''
    }, {
      id: '',
      name: 'PartnerLink',
      required: 'false',
      default: ''
    }, {
      id: '',
      name: 'Key',
      required: 'false',
      default: crypto_js__WEBPACK_IMPORTED_MODULE_4___default.a.SHA256(_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.forms.sha).toString()
    }, {
      id: 'select2-select-lang-container',
      name: 'language',
      required: 'false',
      default: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.defaultLanguage
    }, {
      id: 'submit-email',
      name: 'Login',
      required: 'false',
      default: ''
    }, {
      id: '',
      name: 'ConfirmUrl',
      required: 'false',
      default: ''
    }, {
      id: '',
      name: 'CreateAutoLoginUrl',
      required: 'false',
      default: true
    }, {
      id: '',
      name: 'SubscribeMails',
      required: 'false',
      default: 1
    }, {
      id: 'submit-name',
      name: 'MiddleName',
      required: 'false',
      default: ''
    }, {
      id: 'submit-question',
      name: 'question',
      required: 'false',
      default: ''
    }, {
      id: 'submit-skype',
      name: 'skype',
      required: 'false',
      default: ''
    }, {
      id: 'submit-telegram',
      name: 'telegram',
      required: 'false',
      default: ''
    }, {
      id: 'submit-whatsup',
      name: 'whatsup',
      required: 'false',
      default: ''
    }, {
      id: 'select-time-zone',
      name: 'timezone',
      required: 'false',
      default: ''
    }, {
      id: 'time-to-call',
      name: 'time',
      required: 'false',
      default: ''
    }, {
      id: 'date',
      name: 'date',
      required: 'false',
      default: ''
    }, {
      id: 'submit-captcha',
      name: 'Captcha',
      required: 'false',
      default: ''
    }],
    fieldAuth = [{
      id: 'auth-code',
      name: 'TwoFaCode',
      required: 'false',
      default: ''
    }, {
      id: 'auth-email-code',
      name: 'EmailCode',
      required: 'false',
      default: ''
    }, {
      id: '',
      name: 'Key',
      required: 'false',
      default: crypto_js__WEBPACK_IMPORTED_MODULE_4___default.a.SHA256(_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.forms.sha).toString()
    }, {
      id: 'submit-email',
      name: 'Login',
      required: 'true',
      default: ''
    }, {
      id: 'submit-pass-show',
      name: 'Password',
      required: 'true',
      default: ''
    }, {
      id: '',
      name: 'PasswordHashed',
      required: 'false',
      default: true
    }, {
      id: '',
      name: 'TwoFAToken',
      required: 'false',
      default: null
    }, {
      id: 'submit-captcha',
      name: 'Captcha',
      required: 'false',
      default: ''
    }],
    fieldResetPassword = [{
      id: '',
      name: 'Key',
      required: 'false',
      default: crypto_js__WEBPACK_IMPORTED_MODULE_4___default.a.SHA256(_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.forms.sha).toString()
    }, {
      id: 'submit-email',
      name: 'Login',
      required: 'true',
      default: ''
    }, {
      id: 'submit-captcha',
      name: 'Captcha',
      required: 'false',
      default: ''
    }],
    // используемые методы для регистрации, авторизации и восстановления пароля в глобальном файле конфигурации
    methods = _site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.forms.methods,
    mainHostMethods,
    submitData = {},
    authData = {},
    resetData = {},
    info = _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.info,
    currentLanguge = Object(_global__WEBPACK_IMPORTED_MODULE_2__["definesLanguage"])(),
    errorText = _json_forms_json__WEBPACK_IMPORTED_MODULE_1__.errorText,
    openTwoauthstepPopupFlag = false,
    openTwoauthstepEmailPopupFlag = false;

  /**
   * Валидация формы авторизации. Правила (rules) привязываются к значению атрибута "name"
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('#enter-form').validate({
    rules: {
      email: {
        required: true,
        email: true,
        newEmailRules: true
      },
      password: {
        required: true,
        minlength: 8
        // excludingRussian: true
      }
    },
    messages: {
      email: {
        email: errorText.emailText[currentLanguge],
        newEmailRules: errorText.emailText[currentLanguge]
      },
      password: {
        minlength: errorText.minlength_8[currentLanguge]
      }
    }
  });

  /**
   * Валидация формы восстановление пароля. Правила (rules) привязываются к значению атрибута "name"
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('#restore-form').validate({
    rules: {
      email: {
        required: true,
        email: true,
        newEmailRules: true
      }
    },
    messages: {
      email: {
        email: errorText.emailText[currentLanguge],
        newEmailRules: errorText.emailText[currentLanguge]
      }
    }
  });
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('#captcha-form').validate({
    rules: {
      captcha: {
        required: true,
        minlength: 2
      }
    },
    messages: {
      captcha: {
        minlength: errorText.minlength_2[currentLanguge]
      }
    }
  });

  /**
   * Валидация формы регистрации. Правила (rules) привязываются к значению атрибута "name"
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('#form-signup').validate({
    rules: {
      first_name: {
        required: true,
        excludingRussian: true,
        minlength: 2,
        maxlength: 30
      },
      last_name: {
        required: true,
        excludingRussian: true,
        minlength: 2,
        maxlength: 40
      },
      email: {
        required: true,
        email: true,
        newEmailRules: true
      },
      phone_number: {
        required: true,
        minlength: 7,
        maxlength: 50
      },
      password: {
        required: true,
        // excludingRussian: true,
        minlength: 8,
        newPasswordRules: true
      },
      confirm_password: {
        required: true,
        // excludingRussian: true,
        newPasswordRules: true,
        equalTo: '#submit-pass-show'
      },
      user_agreement: 'required',
      refund_cancellation: 'required'
    },
    messages: {
      first_name: {
        minlength: errorText.minlength_2[currentLanguge],
        maxlength: errorText.maxlength_30[currentLanguge]
      },
      last_name: {
        minlength: errorText.minlength_2[currentLanguge],
        maxlength: errorText.maxlength_40[currentLanguge]
      },
      email: {
        email: errorText.emailText[currentLanguge],
        newEmailRules: errorText.emailText[currentLanguge]
      },
      phone_number: {
        minlength: errorText.minlength_7[currentLanguge],
        maxlength: errorText.maxlength_50[currentLanguge]
      },
      password: {
        minlength: errorText.minlength_8[currentLanguge],
        equalTo: errorText.equalToText[currentLanguge]
      },
      confirm_password: {
        minlength: errorText.minlength_8[currentLanguge],
        equalTo: errorText.equalToText[currentLanguge]
      }
    }
  });

  /**
   * Валидация формы двухэтапной авторизации. Правила (rules) привязываются к значению атрибута "name"
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('#twoauthstep-form').validate({
    rules: {
      code: {
        required: true
      }
    }
  });

  /**
   * Событие на кнопке регистрации
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js--submit-form').unbind('click').click(function (e) {
    e.preventDefault();
    // если все поля валидированы, то отправляем запрос
    if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('#form-signup').valid()) {
      sumbitform(this);
    } else {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        // Якщо валідація не пройдена, знайти перший інпут з класом .error
        let firstErrorField = jquery__WEBPACK_IMPORTED_MODULE_5___default()('input.error').first();
        if (firstErrorField.length) {
          // Прокрутка до цього інпуту
          firstErrorField[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
  });
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js--captcha').unbind('click').click(function (e) {
    e.preventDefault();
    // если все поля валидированы, то отправляем запрос
    if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('#captcha-form').valid()) {
      if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('.reg-header').length === 1) {
        sumbitform(this);
      }
      ;
      if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('.login-header').length === 1) {
        loginform(this);
      }
      ;
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('input.error').focus();
    }
  });

  /**
   * Событие на кнопке двухэтапной авторизации
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js--send-authcode').unbind('click').click(function (e) {
    e.preventDefault();
    // если все поля валидированы, то отправляем запрос
    if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('#twoauthstep-form').valid()) {
      loginform(this);
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('input.error').focus();
    }
  });

  /**
   * Событие на кнопке авторизации
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js--login-form').unbind('click').click(function (e) {
    e.preventDefault();
    // если все поля валидированы, то отправляем запрос
    if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('#enter-form').valid()) {
      loginform(this);
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('input.error').focus();
    }
  });

  /**
   * Событие на кнопке восстановления пароля
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js--repass').unbind('click').click(function (e) {
    e.preventDefault();
    // если все поля валидированы, то отправляем запрос
    if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('#restore-form').valid()) {
      repass(this);
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('input.error').focus();
    }
  });

  /**
   * Основная фукнция восстановления пароля
   */
  function repass(el) {
    // массив для полуения токена
    for (var i = 0; i < fieldResetPassword.length; i++) {
      if (fieldResetPassword[i].id != '') {
        if (fieldResetPassword[i].required == 'true' && jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldResetPassword[i].id).val() == '') {
          // события ошибок, добавить классы к полям и уведомить пользователя
          jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldResetPassword[i].id).closest('.input').addClass('error');
          break;
        } else {
          resetData[fieldResetPassword[i].name] = jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldResetPassword[i].id).val();
        }
      } else {
        resetData[fieldResetPassword[i].name] = fieldResetPassword[i].default;
      }
    }
    mainHostMethods = hosts.createacc.host;
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.ajax({
      url: mainHostMethods + methods.reset,
      type: sendType,
      data: JSON.stringify(resetData),
      contentType: contentType,
      success: function (data) {
        if (data.Error != null) {
          if (data.Error == '1101') {
            infomessage('errorUserNotFound');
          } else if (data.Error == '1821') {
            hosts.captchaImage = data.Result.Captcha;
            resetData.captchaID = data.Result.CaptchaID;
            captchaPopup();
          } else if (data.Error == 'TooManyRequests') {
            infomessage('errorGlobal');
          } else {
            infomessage('errorGlobal');
          }
        } else {
          infomessageSuccess('successRepass', 'succesRepass');
          // чистим поля после восстановления
          fieldResetPassword.forEach(fieldreset => {
            jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldreset.id).val('');
          });
        }
      },
      error: function () {
        if (_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_restrictions_flag === true) {
          if (_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_countries.indexOf(localStorage.getItem('countryCode')) !== -1) {
            Object(_construct__WEBPACK_IMPORTED_MODULE_3__["countryErrorPopup"])(_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_countries, localStorage.getItem('countryCode'));
          } else {
            infomessage('errorGlobal');
          }
        } else {
          infomessage('errorGlobal');
        }
      }
    });
  }

  /**
   * Основная фукнция авторизации
   */
  function loginform(el) {
    // массив для полуения токена
    for (var i = 0; i < fieldAuth.length; i++) {
      if (fieldAuth[i].id != '') {
        if (fieldAuth[i].required == 'true' && jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldAuth[i].id).val() == '') {
          // события ошибок, добавить классы к полям и уведомить пользователя
          jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldAuth[i].id).closest('.input').addClass('error');
          break;
        } else {
          authData[fieldAuth[i].name] = jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldAuth[i].id).val();
        }
      } else {
        authData[fieldAuth[i].name] = fieldAuth[i].default;
      }
    }
    // md5 пароль пользователя для авторизации
    authData.Password = crypto_js__WEBPACK_IMPORTED_MODULE_4___default.a.MD5(authData.Password).toString();
    mainHostMethods = hosts.createacc.host;
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.ajax({
      url: mainHostMethods + methods.createtoken,
      type: sendType,
      data: JSON.stringify(authData),
      contentType: contentType,
      success: function (data) {
        try {
          if (data.Error != null) {
            // всплывающее окно о ошибке
            // коды ошибок?
            if (data.Error == '1816') {
              // TwoFaGoogleCodeIncorrect
              // двух этапная авторизация google
              // показываем диалоговое окно с полем #auth-code

              if (openTwoauthstepPopupFlag == true) {
                showTwoauthstepMessage();
              } else {
                openTwoauthstepPopup();
              }
              countupdateCapthaImage = 0;
            } else if (data.Error == '1812' || data.Error == '1815') {
              // 1812 - TwoFaEmailCodeRequired, 1815 - TwoFaEmailCodeIncorrect
              // двух этапная авторизация по email
              // показываем диалоговое окно с полем #auth-email-code
              if (openTwoauthstepEmailPopupFlag == true) {
                showTwoauthstepEmailMessage();
              } else {
                openTwoauthstepEmailPopup();
              }
              countupdateCapthaImage = 0;
            } else if (data.Error == '1101' || data.Error == '1800') {
              infomessage('errorPassword');
              countupdateCapthaImage = 0;
            } else if (data.Error == '1821') {
              hosts.captchaImage = data.Result.Captcha;
              authData.captchaID = data.Result.CaptchaID;
              captchaPopup();
            } else if (data.Error == 'TooManyRequests') {
              infomessage('errorGlobal');
              countupdateCapthaImage = 0;
            } else {
              // ошибка
              infomessage('errorGlobal');
              countupdateCapthaImage = 0;
            }
          } else {
            // чистим поля после восстановления
            fieldAuth.forEach(fieldauths => {
              if (fieldauths.id != '') {
                jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldauths.id).val('');
              }
            });
            // запускам редирект на платформу
            var two_fa_token = '';
            var email_code = '';
            countupdateCapthaImage = 0;
            if (data.Result.TwoFAToken) {
              two_fa_token = '&two_fa_token=' + data.Result.TwoFAToken.toString();
            }
            if (data.Result.EmailCode) {
              email_code = '&email_code=' + data.Result.EmailCode.toString();
            }
            window.location.href = hosts.auth2.host + data.Result.AccessToken.toString() + two_fa_token + email_code;
          }
        } catch (e) {
          // ошибка обработки ответа
          infomessage('errorGlobal');
          if (data.Result.Captcha) {
            hosts.captchaImage = data.Result.Captcha;
            authData.captchaID = data.Result.CaptchaID;
            captchaPopup();
          }
        }
      },
      error: function (xhr, errorCode, errorThrown) {
        if (_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_restrictions_flag === true && _site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_countries.indexOf(localStorage.getItem('countryCode')) !== -1) {
          Object(_construct__WEBPACK_IMPORTED_MODULE_3__["countryErrorPopup"])(_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_countries, localStorage.getItem('countryCode'));
        } else if (xhr.status === 401) {
          countupdateCapthaImage = 0;
          infomessage('errorPassword');
        } else {
          countupdateCapthaImage = 0;
          infomessage('errorGlobal');
        }
      }
    });
  }

  /**
   * Основная фукнция регистрации
   */
  function sumbitform(el) {
    for (var i = 0; i < field.length; i++) {
      if (field[i].id != '') {
        if (field[i].required == 'true' && jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + field[i].id).val() == '') {
          // события ошибок, добавить классы к полям и уведомить пользователя
          jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + field[i].id).closest('.input').addClass('error');
          infomessage('errorInput');
          break;
        } else {
          submitData[field[i].name] = jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + field[i].id).val();
        }
      } else {
        submitData[field[i].name] = field[i].default;
      }
    }
    // массив для полуения токена
    for (var i = 0; i < fieldAuth.length; i++) {
      if (fieldAuth[i].id != '') {
        if (fieldAuth[i].required == 'true' && jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldAuth[i].id).val() == '') {
          // события ошибок, добавить классы к полям и уведомить пользователя
          jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldAuth[i].id).closest('.input').addClass('error');
          break;
        } else {
          authData[fieldAuth[i].name] = jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + fieldAuth[i].id).val();
        }
      } else {
        authData[fieldAuth[i].name] = fieldAuth[i].default;
      }
    }
    // md5 пароль пользователя для авторизации
    authData.Password = crypto_js__WEBPACK_IMPORTED_MODULE_4___default.a.MD5(authData.Password).toString();
    mainHostMethods = hosts.createacc.host;
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.ajax({
      url: mainHostMethods + methods.createacc,
      type: sendType,
      data: JSON.stringify(submitData),
      contentType: contentType,
      success: function (data) {
        try {
          if (data.Error != null) {
            if (data.Error == '1102') {
              countupdateCapthaImage = 0;
              infomessage('errorUserExist');
            } else if (data.Error == '1821') {
              hosts.captchaImage = data.Result.Captcha;
              submitData.captchaID = data.Result.CaptchaID;
              captchaPopup();
            } else if (data.Error == '1105') {
              countupdateCapthaImage = 0;
              infomessage('errorPhoneExist');
            } else if (data.Error == 'TooManyRequests') {
              countupdateCapthaImage = 0;
              infomessage('errorGlobal');
            } else {
              // всплывающее окно о ошибке
              // коды ошибок?
              countupdateCapthaImage = 0;
              infomessage('errorGlobal');
            }
          } else {
            // успешная регистрация
            if (data.Result.RegistrationTime == 0) {
              // запуск авторизации
              // authData.Result.UserId - id пользователя
              // authData.Result.AutoLoginUrl - ссылка автологина
              jquery__WEBPACK_IMPORTED_MODULE_5___default.a.ajax({
                url: mainHostMethods + methods.createtoken,
                type: sendType,
                contentType: contentType,
                data: JSON.stringify(authData),
                success: function (data) {
                  try {
                    if (data.Error != null) {
                      // всплывающее окно о ошибке
                      // коды ошибок?
                      countupdateCapthaImage = 0;
                      infomessage('errorGlobal');
                    } else {
                      // запускам редирект на платформу
                      window.location.href = hosts.auth2.host + data.Result.AccessToken.toString() + hosts.auth2.endhost;
                    }
                  } catch (e) {
                    // ошибка обработки ответа
                    countupdateCapthaImage = 0;
                    infomessage('errorGlobal');
                  }
                },
                error: function () {
                  countupdateCapthaImage = 0;
                  infomessage('errorGlobal');
                }
              });
            } else {
              // сообщение о том что пользователь встал на очередь регистрации и скоро будет зарегестрирован, пусь подождет какое то время
              // authData.Result.RegistrationTime - указывает сколько времени надо ждать
              infomessage('errorSubmitTime');
            }
          }
        } catch (e) {
          // ошибка обработки ответа
          infomessage('errorGlobal');
          if (data.Result.Captcha) {
            hosts.captchaImage = data.Result.Captcha;
            submitData.captchaID = data.Result.CaptchaID;
            captchaPopup();
          }
        }
      },
      error: function () {
        if (_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_restrictions_flag === true) {
          if (_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_countries.indexOf(localStorage.getItem('countryCode')) !== -1) {
            Object(_construct__WEBPACK_IMPORTED_MODULE_3__["countryErrorPopup"])(_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_countries, localStorage.getItem('countryCode'));
          } else {
            countupdateCapthaImage = 0;
            infomessage('errorGlobal');
          }
        } else {
          countupdateCapthaImage = 0;
          infomessage('errorGlobal');
        }
      }
    });
  }

  /**
   * Основная фукнция открытия диологово окна о сообщение с упехом или не успехом выполнения выше указанных функций
   */
  function infomessage(mess, classAdditional) {
    var lang = Object(_global__WEBPACK_IMPORTED_MODULE_2__["definesLanguage"])();
    // $.magnificPopup.instance.st.focus = '#information-popup';
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.close();
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.open({
      items: {
        src: '#information-popup',
        type: 'inline'
      },
      type: 'inline',
      mainClass: classAdditional !== undefined ? classAdditional : '',
      callbacks: {
        open: function () {
          jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js-text').html(info[lang][mess]);
        }
      }
    }, 0);
  }
  function infomessageSuccess(mess, classAdditional) {
    var lang = Object(_global__WEBPACK_IMPORTED_MODULE_2__["definesLanguage"])();
    // $.magnificPopup.instance.st.focus = '#information-popup';
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.close();
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.open({
      items: {
        src: '#saccess-popup',
        type: 'inline'
      },
      type: 'inline',
      mainClass: classAdditional !== undefined ? classAdditional : '',
      callbacks: {
        open: function () {
          jquery__WEBPACK_IMPORTED_MODULE_5___default()('.info-text').html(info[lang][mess]);
        }
      }
    }, 0);
  }

  /**
   * Открытия формы двух этапной авторизации
   */
  function openTwoauthstepPopup() {
    openTwoauthstepPopupFlag = true;
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.close();
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.open({
      items: {
        src: '#twoauthstep-popup'
      },
      type: 'inline',
      callbacks: {
        close: function () {
          openTwoauthstepPopupFlag = false;
        }
      }
    });
    sendTwofaCode('.fa-input', "#auth-code", ".js--send-authcode.js--twofa");
  }

  /**
   * Открытия формы двух этапной авторизации для Email
   */
  function openTwoauthstepEmailPopup() {
    openTwoauthstepEmailPopupFlag = true;
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.close();
    jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.open({
      items: {
        src: '#twoauthstepEmail-popup'
      },
      type: 'inline',
      callbacks: {
        close: function () {
          openTwoauthstepEmailPopupFlag = false;
        }
      }
    });
    sendTwofaCode('.fa-input-2', "#auth-email-code", ".js--send-authcode.js--email-twofa");
  }

  /**
   * Открытия модального окна о двух этапной авторизации
   */
  function showTwoauthstepMessage() {
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('.fa-input').addClass('error');
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('.fa-input-container-error').append('<label class="error" id="auth-code-error" class="error" for="auth-code">' + errorText.openTwoauthstepPopupRules[currentLanguge] + '</label>');
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('.fa-input').each((i, el) => {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()(el).val('');
    });
  }

  /**
   * Открытия модального окна о двух этапной авторизации
   */
  function showTwoauthstepEmailMessage() {
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('.fa-input-2').addClass('error');
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('.fa-input-container-error-2').append('<label class="error" id="auth-code-error" class="error" for="auth-email-code" style="">' + errorText.openTwoauthstepPopupRules[currentLanguge] + '</label>');
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('.fa-input-2').each((i, el) => {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()(el).val('');
    });
  }

  /**
   * Переопределяем сообщение по умолчанию-
   */
  jquery__WEBPACK_IMPORTED_MODULE_5___default.a.extend(jquery__WEBPACK_IMPORTED_MODULE_5___default.a.validator.messages, {
    required: errorText.requiredText[currentLanguge],
    excludingRussian: errorText.excludingRussian[currentLanguge]
  });
  jquery__WEBPACK_IMPORTED_MODULE_5___default.a.extend(jquery__WEBPACK_IMPORTED_MODULE_5___default.a.validator.messages, {
    required: errorText.requiredText[currentLanguge],
    newPasswordRules: errorText.errorPasswordText[currentLanguge]
  });
}

/**
 * Новые правила для validation plagin
 */
jquery__WEBPACK_IMPORTED_MODULE_5___default.a.validator.addMethod('phoneMethod', function (value, element) {
  return this.optional(element) || /^[0-9\(\)\-\+\.\,\ ]+$/.test(value);
});
jquery__WEBPACK_IMPORTED_MODULE_5___default.a.validator.addMethod('excludingRussian', function (value, element) {
  return this.optional(element) || /^[a-zA-Z0-9\.\,\!\?\:\…\_\-\/\"\$\@\#\&\^\(\)\%\~\|]*$/.test(value);
});
jquery__WEBPACK_IMPORTED_MODULE_5___default.a.validator.addMethod('newEmailRules', function (value, element) {
  return this.optional(element) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
});
jquery__WEBPACK_IMPORTED_MODULE_5___default.a.validator.addMethod('newPasswordRules', function (value, element) {
  return this.optional(element) || /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?@[\]^_`{|}~]{8,}$/.test(value);
});

/**
 * Маски на почту
 */
if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('input[name="email"]').length) {
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('input[name="email"]').mask('AB', {
    translation: {
      A: {
        pattern: /[^\s\.\/]/
      },
      B: {
        pattern: /\S/,
        recursive: true
      }
    }
  });
}
/**
 * Маски на телефон
 */
if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('input[name="phone_number"]').length) {
  jquery__WEBPACK_IMPORTED_MODULE_5___default()('input[name="phone_number"]').mask('Z', {
    translation: {
      Z: {
        pattern: /^[0-9\(\)\-\+\ ]+$/,
        recursive: true
      }
    }
  });
}
const KEYCODES = {
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
  DELETE: 46,
  BACKSPACE: 8,
  CTRL: 17,
  V: 86
};
const KEYCODE_TO_NUMBER = {
  48: 0,
  96: 0,
  49: 1,
  50: 2,
  51: 3,
  52: 4,
  53: 5,
  54: 6,
  55: 7,
  56: 8,
  57: 9,
  97: 1,
  98: 2,
  99: 3,
  100: 4,
  101: 5,
  102: 6,
  103: 7,
  104: 8,
  105: 9
};
function sendTwofaCode(selector, input, button) {
  const codeInputs = document.querySelectorAll(selector);

  // Обработчик вставки текста в любой из инпутов
  codeInputs.forEach(function (input) {
    input.addEventListener('paste', function (e) {
      e.preventDefault();
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');
      distributeCode(pastedText);
    });
  });
  function distributeCode(code) {
    // Распределение кода по инпутам
    for (let i = 0; i < Math.min(code.length, codeInputs.length); i++) {
      codeInputs[i].value = code[i];
      if (i == 5) {
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(input).val(code);
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(button).trigger('click');
      }
    }
  }
  jquery__WEBPACK_IMPORTED_MODULE_5___default()(selector).on("keydown", function (e) {
    if (e.keyCode === KEYCODES.BACKSPACE || e.keyCode === KEYCODES.DELETE || e.keyCode === KEYCODES.UP_ARROW || e.keyCode === KEYCODES.DOWN_ARROW) {
      return false;
    }
  });
  jquery__WEBPACK_IMPORTED_MODULE_5___default()(selector).on("keyup", function (e) {
    const currentValue = jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).val();
    switch (e.keyCode) {
      case KEYCODES.LEFT_ARROW:
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).prev().focus();
        return;
      case KEYCODES.RIGHT_ARROW:
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).next().focus();
        return;
      case KEYCODES.DELETE:
        if (!currentValue) {
          jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).next().val("").focus();
          return;
        }
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).val("").next().focus();
        return;
      case KEYCODES.BACKSPACE:
        if (!currentValue) {
          jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).prev().val("").focus();
          return;
        }
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).val("").prev().focus();
        return;
      default:
        const value = KEYCODE_TO_NUMBER[e.keyCode];
        if (value === undefined) {
          return;
        }
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).val(`${value}`);
        jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).blur();
        if (!jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).is(":last-child")) {
          jquery__WEBPACK_IMPORTED_MODULE_5___default()(this).next().focus();
          return;
        } else {
          let code = "";
          jquery__WEBPACK_IMPORTED_MODULE_5___default()(selector).each((i, el) => {
            code = code + jquery__WEBPACK_IMPORTED_MODULE_5___default()(el).val();
          });
          jquery__WEBPACK_IMPORTED_MODULE_5___default()(input).val(code);
          jquery__WEBPACK_IMPORTED_MODULE_5___default()(button).trigger('click');
        }
        return;
    }
  });
}
jquery__WEBPACK_IMPORTED_MODULE_5___default()('.js--btn-contacts').unbind('click').click(function (e) {
  e.preventDefault();
  // если все поля валидированы, то отправляем запрос
  if (jquery__WEBPACK_IMPORTED_MODULE_5___default()('#callbackForm').valid()) {
    sumbitformCallback();
    jquery__WEBPACK_IMPORTED_MODULE_5___default()("#submit-question").val("");
  } else {
    if (window.matchMedia("(max-width: 1024px)").matches) {
      // Якщо валідація не пройдена, знайти перший інпут з класом .error
      let firstErrorField = jquery__WEBPACK_IMPORTED_MODULE_5___default()('input.error').first();
      if (firstErrorField.length) {
        // Прокрутка до цього інпуту
        firstErrorField[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }
});
function sumbitformCallback() {
  for (var i = 0; i < field.length; i++) {
    if (field[i].id == 'submit-pass-show') {
      field[i].required = 'false';
    }
    ;
    if (field[i].id == 'submit-lastname') {
      field[i].required = 'false';
    }
    ;
    if (field[i].id == 'submit-name') {
      field[i].name = 'name';
    }
    ;
    if (field[i].id == 'submit-phone') {
      field[i].name = 'phone';
    }
    ;
    if (field[i].id == 'submit-question') {
      field[i].name = 'comment';
    }
    ;
    if (field[i].required == 'true' || field[i].id == 'submit-question' || field[i].id == 'submit-skype' || field[i].id == 'submit-whatsup' || field[i].id == 'submit-telegram' || field[i].id == 'select-time-zone' || field[i].id == 'time-to-call' || field[i].id == 'date') {
      submitData[field[i].name] = jquery__WEBPACK_IMPORTED_MODULE_5___default()('#' + field[i].id).val();
    }
    ;
    if (field[i].id == 'select2-select-lang-container') {
      submitData[field[i].name] = jquery__WEBPACK_IMPORTED_MODULE_5___default()('#select2-select-lang-container')[0].title;
    }
  }
  ;
  mainHostMethods = hosts.usercallback.host;

  // Делаем POST запрос с телом запроса
  fetch(mainHostMethods + methods.createtokenGuest, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(submitData)
  }).then(response => {
    if (!response.ok) {
      throw new Error('Ошибка сети'); // Обрабатываем ошибку, если ответ не успешен
    }
    return response.json(); // Преобразуем ответ в JSON
  }).then(data => {
    // console.log('Успешный POST запрос:', data.Result); // Обрабатываем ответные данные

    let key = data.Result;

    // Используем результат первого запроса для второго
    return fetch(mainHostMethods + methods.webAction, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        Action: 'UserCallback',
        Data: JSON.stringify(submitData),
        Key: key,
        Login: submitData.Email
      })
    });
  }).then(response => {
    if (!response.ok) {
      throw new Error('Ошибка сети при втором запросе');
    }
    return response.json();
  }).then(data => {
    // console.log('Второй запрос выполнен успешно:', data);
    showSuccesText();
  }).catch(error => {
    // console.error('Произошла ошибка:', error);
    infomessage('errorGlobal');
  });
}
(function inputsForCallback() {
  let inputTimeCall = document.getElementById('time-to-call');
  if (inputTimeCall) {
    function addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    }
    const d = new Date();
    let h = addZero(d.getHours());
    let m = addZero(d.getMinutes());
    let userTime = h + ":" + m;
    inputTimeCall.value = userTime;
    inputTimeCall.addEventListener('input', function (e) {
      let value = e.target.value.replace(/[^0-9]/g, '');
      if (value.length === 1 && value > '2') {
        value = '';
      }
      ;
      if (value.length > 4) {
        value = value.slice(0, 4);
      }
      ;
      if (value.length > 2) {
        value = value.slice(0, 2) + ':' + value.slice(2);
      }
      ;

      // Проверяем корректность введённых значений
      const [hoursStr, minutesStr] = value.split(':');
      let isValid = true;
      if (hoursStr) {
        const hours = parseInt(hoursStr, 10);
        if (isNaN(hours) || hours < 0 || hours > 23) {
          isValid = false;
        }
        ;
      }
      ;
      if (minutesStr) {
        if (minutesStr.length > 0 && minutesStr[0] > '5') {
          isValid = false; // Первый символ минут не может быть больше 5
        }
        ;
        const minutes = parseInt(minutesStr, 10);
        if (isNaN(minutes) || minutes < 0 || minutes > 59) {
          isValid = false;
        }
        ;
      }
      ;

      // Если значение некорректное, удаляем последний символ
      if (!isValid) {
        e.target.value = e.target.value.slice(0, -1);
      } else {
        e.target.value = value;
      }
    });
    inputTimeCall.addEventListener('paste', function (e) {
      e.preventDefault();
    });
    const today = new Date().toISOString().split('T')[0];
    const datePicker = document.getElementById('date');
    if (datePicker) {
      datePicker.min = today;
      datePicker.value = today;
    }
    ;
  }
  ;
})();
function captchaPopup() {
  jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.close();
  jquery__WEBPACK_IMPORTED_MODULE_5___default.a.magnificPopup.open({
    items: {
      src: '#captcha-popup',
      type: 'inline'
    },
    type: 'inline',
    callbacks: {
      beforeOpen: updateCapthaImage(hosts.captchaImage)
    }
  }, 0);
}
let countupdateCapthaImage = 0;
function updateCapthaImage(image) {
  let captchaImage = document.querySelector('.js--captha-image');
  captchaImage.src = 'data:image/png;base64,' + image;
  countupdateCapthaImage++;
  if (countupdateCapthaImage >= 2) {
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('#submit-captcha').addClass('error-captcha');
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('label.captcha-error').html(info[currentLanguge].errorCaptchaImage);
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('label.captcha-error').css('display', 'block');
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('#submit-captcha').val('');
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('#submit-captcha').on('change', () => {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('#submit-captcha').removeClass('error-captcha');
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('label.captcha-error').css('display', 'none');
    });
    jquery__WEBPACK_IMPORTED_MODULE_5___default()('#submit-captcha').on('focus', () => {
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('#submit-captcha').removeClass('error-captcha');
      jquery__WEBPACK_IMPORTED_MODULE_5___default()('label.captcha-error').css('display', 'none');
    });
  }
}

/***/ }),

/***/ "./src/assets/js/blocks/global.js":
/*!****************************************!*\
  !*** ./src/assets/js/blocks/global.js ***!
  \****************************************/
/*! exports provided: definesLanguage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "definesLanguage", function() { return definesLanguage; });
/* harmony import */ var _site_config_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../site.config.json */ "./site.config.json");
var _site_config_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t(/*! ../../../../site.config.json */ "./site.config.json", 1);
 // глобальный файл конфигурации сайта

function definesLanguage() {
  var pageUrl = location.pathname.split('/'),
    // парсим строку чтобы получить все возможные языки
    curLanguage = _site_config_json__WEBPACK_IMPORTED_MODULE_0__.defaultLanguage; // получаем дефолтный язык
  // получаем все реальные языка сайта
  _site_config_json__WEBPACK_IMPORTED_MODULE_0__.seolocales.alternatives.forEach(item => {
    // перебираем все языки из конфига
    if (pageUrl.indexOf(item) !== -1) {
      // и ищем какой элемент из массива совпадает с элементов массива языков
      // если находим присваиваем язык и заканчиваем выполнение цикла
      curLanguage = item;
      // возвращаем найденный язык и останавливаем цикл
      return curLanguage;
    }
  });
  // если язык не был найден возвращаем дефолтный язык
  return curLanguage;
}

/***/ }),

/***/ "./src/assets/js/blocks/index.js":
/*!***************************************!*\
  !*** ./src/assets/js/blocks/index.js ***!
  \***************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./global */ "./src/assets/js/blocks/global.js");
/* harmony import */ var _site_config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../site.config.json */ "./site.config.json");
var _site_config_json__WEBPACK_IMPORTED_MODULE_1___namespace = /*#__PURE__*/__webpack_require__.t(/*! ../../../../site.config.json */ "./site.config.json", 1);
/* harmony import */ var _json_news_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./json/news.json */ "./src/assets/js/blocks/json/news.json");
var _json_news_json__WEBPACK_IMPORTED_MODULE_2___namespace = /*#__PURE__*/__webpack_require__.t(/*! ./json/news.json */ "./src/assets/js/blocks/json/news.json", 1);
/* harmony import */ var jquery_rss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! jquery-rss */ "./node_modules/jquery-rss/src/jquery.rss.js");
 // хук для определения языка
 // глобальный файл конфигурации сайта
 // подключение объекта со всеми статичными переводами для новостей
 // подключение плагина для подгрузки rss новостей

function isbeta(name) {
  let url = name; // путь к файлу - если у вас другой - то его и указываете
  let pathname = location.pathname.split('/');
  for (let i = 0; i < pathname.length; i++) {
    if (pathname[i] == 'beta') url = '/beta' + name; // если мы на бете, то добавляем подддомен 'beta' к пути
  }
  return url;
}

/***/ }),

/***/ "./src/assets/js/blocks/json/forms.json":
/*!**********************************************!*\
  !*** ./src/assets/js/blocks/json/forms.json ***!
  \**********************************************/
/*! exports provided: info, errorText, callback, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"info\":{\"ru\":{\"successmessage\":\"Ваше сообщение успешно отправлено! Ожидайте, наши менеджеры свяжутся с Вами.\",\"successSubmit\":\"Вы успешно зарегистрировались на платформе. На Ваш Email отправлено сообщение с дальнейшими инструкциями.\",\"successRepass\":\"На ваш email отправлен временный пароль.\",\"errorInput\":\"Вы не заполнили обязательные поля!\",\"errorSubmitTime\":\"Вы успешно зарегистрировались на платформе. Необходимо время, пока наши меджеры обработую Вашу заявку.\",\"errorGlobal\":\"Ошибка, попробуйте позже.\",\"errorUserExist\":\"Данная электронная почта уже используется\",\"errorUserNotFound\":\"Данного пользователя не существует\",\"errorPassword\":\"Неверный логин или пароль\",\"errorPhoneExist\":\"Аккаунт с этим номером телефона уже существует\",\"errorCaptchaImage\":\"Текст с картинки введен неверно. Убедитесь в правильности введенного текста и повторите попытку\"},\"en\":{\"successmessage\":\"Your message has been sent successfully! Expect our managers to contact you.\",\"successSubmit\":\"You have successfully registered on the platform. A message with further instructions has been sent to your Email.\",\"successRepass\":\"A temporary password has been sent to your email.\",\"errorInput\":\"You have not completed the required fields!\",\"errorSubmitTime\":\"You have successfully registered on the platform. It takes time until our managers process your application.\",\"errorGlobal\":\"Error, try again later.\",\"errorUserExist\":\"This email is already in use\",\"errorUserNotFound\":\"This user does not exist\",\"errorPassword\":\"Wrong login or password\",\"errorPhoneExist\":\"Account with this phone number already exist\",\"errorCaptchaImage\":\"Text from the image is entered incorrectly. Make sure the text is entered correctly and try again\"},\"pl\":{\"successmessage\":\"Twoja wiadomość została wysłana poprawnie! Oczekuj, że nasi menedżerowie skontaktują się z Tobą.\",\"successSubmit\":\"Pomyślnie zarejestrowałeś się na platformie. Wiadomość z dalszymi instrukcjami została wysłana na Twój adres e-mail.\",\"successRepass\":\"Tymczasowe hasło zostało wysłane na Twój adres e-mail.\",\"errorInput\":\"Nie wypełniłeś wymaganych pól!\",\"errorSubmitTime\":\"Pomyślnie zarejestrowałeś się na platformie. Rozpatrzenie wniosku przez naszych menedżerów zajmuje trochę czasu.\",\"errorGlobal\":\"Błąd, spróbuj ponownie później.\",\"errorUserExist\":\"Ten email jest już w użyciu\",\"errorUserNotFound\":\"Ten użytkownik nie istnieje\",\"errorPassword\":\"Zły login lub hasło\",\"errorPhoneExist\":\"Konto z tym numerem telefonu już istnieje\",\"errorCaptchaImage\":\"Tekst z obrazka został wpisany nieprawidłowo. Upewnij się, że tekst został wpisany poprawnie i spróbuj ponownie\"},\"fr\":{\"successmessage\":\"Votre message a été envoyé avec succès! Attendez-vous à ce que nos gestionnaires vous contactent.\",\"successSubmit\":\"Vous vous êtes inscrit avec succès sur la plateforme. Un message contenant des instructions supplémentaires a été envoyé à votre adresse e-mail.\",\"successRepass\":\"Un mot de passe temporaire a été envoyé à votre email.\",\"errorInput\":\"Vous n`avez pas rempli les champs obligatoires!\",\"errorSubmitTime\":\"Vous vous êtes inscrit avec succès sur la plateforme. Cela prend du temps jusqu`à ce que notre medzherov traite votre demande.\",\"errorGlobal\":\"Erreur, réessayez plus tard.\",\"errorUserExist\":\"Cet e-mail est déjà utilisée\",\"errorUserNotFound\":\"Cet utilisateur n`existe pas\",\"errorPassword\":\"Identifiant ou mot de passe incorrect\",\"errorPhoneExist\":\"Un compte avec ce numéro de téléphone existe déjà\",\"errorCaptchaImage\":\"Le texte de l'image n'est pas saisi correctement. Assurez-vous que le texte est saisi correctement et réessayez\"},\"it\":{\"successmessage\":\"Il tuo messaggio è stato inviato con successo! Aspettati che i nostri responsabili ti contattino.\",\"successSubmit\":\"Ti sei registrato correttamente sulla piattaforma. Un messaggio con ulteriori istruzioni è stato inviato alla tua email.\",\"successRepass\":\"Una password temporanea è stata inviata alla tua email.\",\"errorInput\":\"Non hai completato i campi richiesti!\",\"errorSubmitTime\":\"Ti sei registrato correttamente sulla piattaforma. Ci vuole tempo prima che il nostro medzherov elabori la tua richiesta.\",\"errorGlobal\":\"Errore, riprova più tardi.\",\"errorUserExist\":\"Questa e-mail è già in uso\",\"errorUserNotFound\":\"Questo utente non esiste\",\"errorPassword\":\"Nome utente o password errati\",\"errorPhoneExist\":\"Esiste già un account con questo numero di telefono\",\"errorCaptchaImage\":\"Il testo dell'immagine è stato inserito in modo errato. Assicurati che il testo sia stato inserito correttamente e riprova\"},\"zh\":{\"successmessage\":\"您的留言已成功發送！ 希望我們的經理與您聯繫\",\"successSubmit\":\"您已成功在平台上註冊。 包含更多說明的消息已發送到您的電子郵件。\",\"successRepass\":\"臨時密碼已發送到您的電子郵箱。\",\"errorInput\":\"您尚未填寫必填字段！\",\"errorSubmitTime\":\"您已成功在平台上註冊。 我們的medzherov處理您的應用程序需要花費時間。\",\"errorGlobal\":\"錯誤，請稍後再試。\",\"errorUserExist\":\"该电子邮件已被使用\",\"errorUserNotFound\":\"该用户不存在\",\"errorPassword\":\"错误的登录名或密码\",\"errorPhoneExist\":\"具有该电话号码的帐户已存在\",\"errorCaptchaImage\":\"图像中的文本输入不正确。确保文本输入正确，然后重试\"},\"es\":{\"successmessage\":\"¡Tu mensaje ha sido enviado exitosamente! Espere que nuestros gerentes se contacten con usted.\",\"successSubmit\":\"Te has registrado con éxito en la plataforma. Se ha enviado un mensaje con más instrucciones a su correo electrónico.\",\"successRepass\":\"Una contraseña temporal ha sido enviada a su correo electrónico.\",\"errorInput\":\"¡No ha completado los campos obligatorios!\",\"errorSubmitTime\":\"Te has registrado con éxito en la plataforma. Lleva tiempo hasta que nuestro medzherov procese su solicitud.\",\"errorGlobal\":\"Error, intente nuevamente más tarde.\",\"errorUserExist\":\"Este correo electrónico ya está en uso\",\"errorUserNotFound\":\"Este usuario no existe\",\"errorPassword\":\"Usuario o contraseña incorrectos\",\"errorPhoneExist\":\"Ya existe una cuenta con este número de teléfono\",\"errorCaptchaImage\":\"El texto de la imagen se ingresó incorrectamente. Asegúrate de que el texto esté ingresado correctamente y vuelve a intentarlo.\"},\"de\":{\"successmessage\":\"Ihre Nachricht wurde erfolgreich gesendet! Erwarten Sie von unseren Managern, dass sie Sie kontaktieren.\",\"successSubmit\":\"Sie haben sich erfolgreich auf der Plattform registriert. Eine Nachricht mit weiteren Anweisungen wurde an Ihre E-Mail gesendet.\",\"successRepass\":\"Ein temporäres Passwort wurde an Ihre E-Mail-Adresse gesendet.\",\"errorInput\":\"Sie haben die erforderlichen Felder nicht ausgefüllt!\",\"errorSubmitTime\":\"Sie haben sich erfolgreich auf der Plattform registriert. Es dauert einige Zeit, bis unser Medzherov Ihre Bewerbung bearbeitet.\",\"errorGlobal\":\"Fehler, versuchen Sie es später erneut.\",\"errorUserExist\":\"Diese E-Mail-Adresse wird schon verwendet\",\"errorUserNotFound\":\"Dieser Benutzer existiert nicht\",\"errorPassword\":\"Falsches Login oder Passwort\",\"errorPhoneExist\":\"Ein Konto mit dieser Telefonnummer ist bereits vorhanden\",\"errorCaptchaImage\":\"Text aus dem Bild ist falsch eingegeben. Stellen Sie sicher, dass der Text korrekt eingegeben wurde, und versuchen Sie es erneut\"},\"tr\":{\"successmessage\":\"Mesajınız başarıyla gönderilmiştir! Yöneticilerimizin sizinle iletişime geçmesini bekleyin.\",\"successSubmit\":\"Platforma başarıyla kayıt oldunuz. E-postanıza daha fazla talimat içeren bir mesaj gönderildi.\",\"successRepass\":\"E-postanıza geçici bir şifre gönderildi.\",\"errorInput\":\"Gerekli alanları doldurmadınız!\",\"errorSubmitTime\":\"Platforma başarıyla kayıt oldunuz. Yöneticilerimizin başvurunuzu işleme koyması zaman alır.\",\"errorGlobal\":\"Hata, daha sonra tekrar deneyin.\",\"errorUserExist\":\"Bu e-posta zaten kullanılmıştır\",\"errorUserNotFound\":\"Böyle bir kullanıcı yoktur\",\"errorPassword\":\"Hatalı kullanıcı ismi veya şifre\",\"errorPhoneExist\":\"Bu telefon numarasına sahip hesap zaten var\",\"errorCaptchaImage\":\"Resimdeki metin yanlış girildi. Girdiğiniz metnin doğru olduğundan emin olun ve tekrar deneyin\"},\"hi\":{\"successmessage\":\"आपका संदेश सफलतापूर्वक भेजा जा चुका है! हमारे प्रबंधकों से आपसे संपर्क करने की अपेक्षा करें।\",\"successSubmit\":\"आपने मंच पर सफलतापूर्वक पंजीकरण कर लिया है। आगे के निर्देशों के साथ एक संदेश आपके ईमेल पर भेज दिया गया है।\",\"successRepass\":\"आपके ईमेल पर एक अस्थायी पासवर्ड भेज दिया गया है।\",\"errorInput\":\"आपने आवश्यक फ़ील्ड को पूरा नहीं किया है!\",\"errorSubmitTime\":\"आपने मंच पर सफलतापूर्वक पंजीकरण कर लिया है। जब तक हमारा मेडज़ेरोव आपके आवेदन को संसाधित नहीं करता है, तब तक इसमें समय लगता है।\",\"errorGlobal\":\"त्रुटि, बाद में पुन: प्रयास करें।\",\"errorUserExist\":\"यह ईमेल पहले से प्रयोग में है\",\"errorUserNotFound\":\"यह उपभोक्ता मौजूद नहीं है\",\"errorPassword\":\"ग़लत लॉगिन या पासवर्ड\",\"errorPhoneExist\":\"इस फ़ोन नंबर वाला खाता पहले से मौजूद है\",\"errorCaptchaImage\":\"छवि से पाठ ग़लत दर्ज किया गया है. सुनिश्चित करें कि पाठ सही ढंग से दर्ज किया गया है और पुनः प्रयास करें\"}},\"errorText\":{\"nameText\":{\"en\":\"Invalid name\",\"pl\":\"Błędna nazwa\",\"ru\":\"Недопустимое имя\",\"es\":\"Nombre inválido\",\"de\":\"Ungültiger Name\",\"fr\":\"Nom incorrect\",\"it\":\"Nome non valido\",\"zh\":\"名称无效\",\"tr\":\"Geçersiz isim\",\"hi\":\"अमान्य नाम\"},\"lastNameText\":{\"en\":\"Invalid last name\",\"pl\":\"Nieprawidłowe nazwisko\",\"ru\":\"Недопустимая фамилия\",\"es\":\"Apellido inválido\",\"de\":\"Ungültiger Nachname\",\"fr\":\"Nom de famille invalide\",\"it\":\"Cognome non valido\",\"zh\":\"姓氏无效\",\"tr\":\"Geçersiz soyadı\",\"hi\":\"अमान्य उपनाम\"},\"excludingRussian\":{\"en\":\"Only Latin letters, symbols and numbers are allowed\",\"pl\":\"Dozwolone są tylko łacińskie litery, symbole i cyfry\",\"ru\":\"Допустимы только латинские буквы, символы и цифры\",\"es\":\"Solo se permiten letras, símbolos y números en latinas.\",\"de\":\"Es sind nur lateinische Buchstaben, Symbole und Zahlen erlaubt\",\"fr\":\"Seules les lettres, symboles et chiffres latins sont autorisés\",\"it\":\"Sono ammessi solo lettere, simboli e numeri latini\",\"zh\":\"只允许使用拉丁字母、符号和数字\",\"tr\":\"Yalnızca Latin harflerine, sembollerine ve sayılarına izin verilir\",\"hi\":\"केवल लैटिन अक्षरों, प्रतीकों और संख्याओं की अनुमति है\"},\"requiredText\":{\"en\":\"This field is required\",\"pl\":\"To pole jest wymagane\",\"ru\":\"Это поле обязательно для заполнения\",\"es\":\"Este campo es requerido\",\"de\":\"Dieses Feld wird benötigt\",\"fr\":\"Ce champ est requis\",\"it\":\"Questo campo è obbligatorio\",\"zh\":\"这是必填栏\",\"tr\":\"Bu alanın doldurulması zorunludur\",\"hi\":\"यह फ़ील्ड आवश्यक है\"},\"minlength_2\":{\"en\":\"Please enter at least 2 characters\",\"pl\":\"Proszę wpisać co najmniej 2 znaki\",\"ru\":\"Введите не менее 2 символов\",\"es\":\"Por favor ingrese al menos 2 caracteres\",\"de\":\"Bitte geben Sie mindestens 2 Zeichen ein\",\"fr\":\"Veuillez saisir au moins 2 caractères\",\"it\":\"Inserisci almeno 2 caratteri\",\"zh\":\"请输入至少2个字符\",\"tr\":\"Lütfen en az 2 karakter giriniz\",\"hi\":\"कृपया कम से कम 2 अक्षर दर्ज करें\"},\"minlength_7\":{\"en\":\"Please enter at least 7 characters\",\"pl\":\"Proszę wpisać co najmniej 7 znaków\",\"ru\":\"Введите не менее 7 символов\",\"es\":\"Por favor ingrese al menos 7 caracteres\",\"de\":\"Bitte geben Sie mindestens 7 Zeichen ein\",\"fr\":\"Veuillez saisir au moins 7 caractères\",\"it\":\"Inserisci almeno 7 caratteri\",\"zh\":\"请输入至少7个字符\",\"tr\":\"Lütfen en az 7 karakter giriniz\",\"hi\":\"कृपया कम से कम 7 वर्ण दर्ज करें\"},\"maxlength_30\":{\"en\":\"Enter up to 30 characters\",\"pl\":\"Wpisz do 30 znaków\",\"ru\":\"Введите не более 30 символов\",\"es\":\"Ingrese hasta 30 caracteres\",\"de\":\"Geben Sie bis zu 30 Zeichen ein\",\"fr\":\"Entrez jusqu'à 30 caractères\",\"it\":\"Inserisci fino a 30 caratteri\",\"zh\":\"输入最多30个字符\",\"tr\":\"30 karaktere kadar giriniz\",\"hi\":\"अधिकतम 30 वर्ण दर्ज करें\"},\"maxlength_40\":{\"en\":\"Enter up to 40 characters\",\"pl\":\"Wpisz do 40 znaków\",\"ru\":\"Введите не более 40 символов\",\"es\":\"Ingrese hasta 40 caracteres\",\"de\":\"Geben Sie bis zu 40 Zeichen ein\",\"fr\":\"Entrez jusqu'à 40 caractères\",\"it\":\"Inserisci fino a 40 caratteri\",\"zh\":\"输入最多40个字符\",\"tr\":\"40 karaktere kadar giriniz\",\"hi\":\"40 वर्ण तक दर्ज करें\"},\"maxlength_50\":{\"en\":\"Enter up to 50 characters\",\"pl\":\"Wpisz do 60 znaków\",\"ru\":\"Введите не более 50 символов\",\"es\":\"Ingrese hasta 50 caracteres\",\"de\":\"Geben Sie bis zu 50 Zeichen ein\",\"fr\":\"Entrez jusqu'à 50 caractères\",\"it\":\"Inserisci fino a 50 caratteri\",\"zh\":\"输入最多50个字符\",\"tr\":\"50 karaktere kadar giriniz\",\"hi\":\"50 वर्ण तक दर्ज करें\"},\"emailText\":{\"en\":\"Invalid email address\",\"pl\":\"Niepoprawny adres email\",\"ru\":\"Недопустимый электронный адрес\",\"es\":\"Dirección de correo electrónico no válida\",\"de\":\"Ungültige E-Mail-Adresse\",\"fr\":\"Adresse e-mail invalide\",\"it\":\"indirizzo email non valido\",\"zh\":\"无效的邮件地址\",\"tr\":\"Geçersiz e-posta adresi\",\"hi\":\"अमान्य ईमेल पता\"},\"minlength_8\":{\"en\":\"Minimum 8 characters. Latin letters (uppercase and lowercase) and one number.\",\"pl\":\"Hasło musi zawierać co najmniej 8 znaków. Litery łacińskie (duże i małe) oraz jedna cyfra.\",\"ru\":\"Минимум 8 символов. Латинские буквы (заглавные и строчные) и одна цифра.\",\"es\":\"La contraseña debe tener al menos 8 caracteres. Letras latinas (mayúsculas y minúsculas) y un número.\",\"de\":\"Das Passwort muss mindestens 8 Zeichen lang sein. Lateinische Buchstaben (Groß - und Kleinbuchstaben) und eine Zahl.\",\"fr\":\"Mot de passe doit être d'au moins 8 caractères. Lettres latines (majuscules et minuscules) et un chiffre.\",\"it\":\"La password deve essere di almeno 8 caratteri. Lettere latine (maiuscole e minuscole) e un numero.\",\"zh\":\"密碼必須至少8個字符. 拉丁字母（大写和小写）和一个数字。\",\"tr\":\"Şifre 8 karakterden uzun olmalıdır. Latin harfleri (büyük ve küçük harf) ve bir rakam.\",\"hi\":\"पासवर्ड कम से कम 8 वर्णों का होना चाहिए. लैटिन अक्षर (अपरकेस और लोअरकेस) और एक संख्या\"},\"equalToText\":{\"en\":\"Password mismatch\",\"pl\":\"Hasło różni się\",\"ru\":\"Пароли не совпадают\",\"es\":\"Contraseña no coincide\",\"de\":\"Die Passwörter stimmen nicht überein\",\"fr\":\"Non concordance des mots de passe\",\"it\":\"Mancata corrispondenza della password\",\"zh\":\"密码不符合\",\"tr\":\"Şifreler eşleşmiyor\",\"hi\":\"पासवर्ड का मेल नहीं हुआ\"},\"errorPasswordText\":{\"en\":\"Password does not meet requirements\",\"pl\":\"Hasło Nie spełnia wymagań\",\"ru\":\"Пароль не соответствует требованиям\",\"es\":\"La contraseña no cumple los requisitos\",\"de\":\"Passwort entspricht nicht der Anforderungen\",\"fr\":\"Le mot de passe ne répond pas aux exigences\",\"it\":\"La password non soddisfa i requisiti\",\"zh\":\"密码不符合要求\",\"tr\":\"Şifre taleplere uymuyor\",\"hi\":\"पासवर्ड आवश्यकताओं को पूरा नहीं करता है\"},\"openTwoauthstepPopupRules\":{\"en\":\"Code is incorrect. Please try again.\",\"pl\":\"Kod jest nieprawidłowy. Proszę spróbuj ponownie.\",\"ru\":\"Код указан неверно. Пожалуйста, попробуйте еще раз.\",\"es\":\"El codigo esta mal. Inténtalo de nuevo.\",\"de\":\"Der Code ist falsch. Bitte versuche es erneut.\",\"fr\":\"Le code est faux. Veuillez réessayer.\",\"it\":\"Il codice è sbagliato. Per favore riprova.\",\"zh\":\"代码错误。 请再试一次。\",\"tr\":\"Kod yanlış. Lütfen tekrar deneyin.\",\"hi\":\"कोड गलत है। कृपया पुन: प्रयास करें।\"}},\"callback\":{\"requiredText\":{\"en\":\"This field is required\",\"pl\":\"To pole jest wymagane\",\"ru\":\"Это поле обязательно для заполнения\",\"es\":\"Este campo es requerido\",\"de\":\"Dieses Feld wird benötigt\",\"fr\":\"Ce champ est requis\",\"it\":\"Questo campo è obbligatorio\",\"zh\":\"这是必填栏\",\"tr\":\"Bu alanın doldurulması zorunludur\",\"hi\":\"यह फ़ील्ड आवश्यक है\"},\"minlength_2\":{\"en\":\"Please enter at least 2 characters\",\"pl\":\"Proszę wpisać co najmniej 2 znaki\",\"ru\":\"Введите не менее 2 символов\",\"es\":\"Por favor ingrese al menos 2 caracteres\",\"de\":\"Bitte geben Sie mindestens 2 Zeichen ein\",\"fr\":\"Veuillez saisir au moins 2 caractères\",\"it\":\"Inserisci almeno 2 caratteri\",\"zh\":\"请输入至少2个字符\",\"tr\":\"Lütfen en az 2 karakter giriniz\",\"hi\":\"कृपया कम से कम 2 अक्षर दर्ज करें\"},\"minlength_7\":{\"en\":\"Please enter at least 7 characters\",\"pl\":\"Proszę wpisać co najmniej 7 znaki\",\"ru\":\"Введите не менее 7 символов\",\"es\":\"Por favor ingrese al menos 7 caracteres\",\"de\":\"Bitte geben Sie mindestens 7 Zeichen ein\",\"fr\":\"Veuillez saisir au moins 7 caractères\",\"it\":\"Inserisci almeno 7 caratteri\",\"zh\":\"请输入至少7个字符\",\"tr\":\"Lütfen en az 7 karakter giriniz\",\"hi\":\"कृपया कम से कम 7 वर्ण दर्ज करें\"},\"maxlength_30\":{\"en\":\"Enter up to 30 characters\",\"pl\":\"Wpisz do 30 znaków\",\"ru\":\"Введите не более 30 символов\",\"es\":\"Ingrese hasta 30 caracteres\",\"de\":\"Geben Sie bis zu 30 Zeichen ein\",\"fr\":\"Entrez jusqu'à 30 caractères\",\"it\":\"Inserisci fino a 30 caratteri\",\"zh\":\"输入最多30个字符\",\"tr\":\"30 karaktere kadar giriniz\",\"hi\":\"अधिकतम 30 वर्ण दर्ज करें\"},\"emailText\":{\"en\":\"Invalid email address\",\"pl\":\"Niepoprawny adres email\",\"ru\":\"Недопустимый электронный адрес\",\"es\":\"Dirección de correo electrónico no válida\",\"de\":\"Ungültige E-Mail-Adresse\",\"fr\":\"Adresse e-mail invalide\",\"it\":\"indirizzo email non valido\",\"zh\":\"无效的邮件地址\",\"tr\":\"Geçersiz e-posta adresi\",\"hi\":\"अमान्य ईमेल पता\"},\"maxlength_50\":{\"en\":\"Enter up to 50 characters\",\"pl\":\"Wpisz do 50 znaków\",\"ru\":\"Введите не более 50 символов\",\"es\":\"Ingrese hasta 50 caracteres\",\"de\":\"Geben Sie bis zu 50 Zeichen ein\",\"fr\":\"Entrez jusqu'à 50 caractères\",\"it\":\"Inserisci fino a 50 caratteri\",\"zh\":\"输入最多50个字符\",\"tr\":\"50 karaktere kadar giriniz\",\"hi\":\"50 वर्ण तक दर्ज करें\"}}}");

/***/ }),

/***/ "./src/assets/js/blocks/json/news.json":
/*!*********************************************!*\
  !*** ./src/assets/js/blocks/json/news.json ***!
  \*********************************************/
/*! exports provided: ru, en, es, de, fr, it, pl, cn, tr, hi, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"ru\":{\"authors\":\"Источник\",\"date\":\"Дата публикации\",\"more\":\"Подробнее\"},\"en\":{\"authors\":\"Source\",\"date\":\"Publication Date\",\"more\":\"More\"},\"es\":{\"authors\":\"El autor\",\"date\":\"Fecha de publicación\",\"more\":\"Más detalles\"},\"de\":{\"authors\":\"Der Autor\",\"date\":\"Veröffentlichungsdatum\",\"more\":\"Weitere Details\"},\"fr\":{\"authors\":\"L`auteur\",\"date\":\"Date de publication\",\"more\":\"Plus de détails\"},\"it\":{\"authors\":\"L`autore\",\"date\":\"Data di pubblicazione\",\"more\":\"Maggiori dettagli\"},\"pl\":{\"authors\":\"Źródło\",\"date\":\"Data publikacji\",\"more\":\"Więcej\"},\"cn\":{\"authors\":\"作者\",\"date\":\"出版日期\",\"more\":\"更多細節\"},\"tr\":{\"authors\":\"Kaynak\",\"date\":\"Yayın tarihi\",\"more\":\"Daha\"},\"hi\":{\"authors\":\"स्रोत\",\"date\":\"प्रकाशन तिथि\",\"more\":\"अधिक\"}}");

/***/ }),

/***/ "./src/assets/js/blocks/json/select.json":
/*!***********************************************!*\
  !*** ./src/assets/js/blocks/json/select.json ***!
  \***********************************************/
/*! exports provided: 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, default */
/***/ (function(module) {

module.exports = JSON.parse("[{\"id\":\"utc+14\",\"text\":\"UTC+14\"},{\"id\":\"utc+13:45\",\"text\":\"UTC+13:45\"},{\"id\":\"utc+13\",\"text\":\"UTC+13\"},{\"id\":\"utc+12:45\",\"text\":\"UTC+12:45\"},{\"id\":\"utc+12\",\"text\":\"UTC+12\"},{\"id\":\"utc+11\",\"text\":\"UTC+11\"},{\"id\":\"utc+10:30\",\"text\":\"UTC+10:30\"},{\"id\":\"utc+10\",\"text\":\"UTC+10\"},{\"id\":\"utc+9:30\",\"text\":\"UTC+9:30\"},{\"id\":\"utc+9\",\"text\":\"UTC+9\"},{\"id\":\"utc+8:45\",\"text\":\"UTC+8:45\"},{\"id\":\"utc+8\",\"text\":\"UTC+8\"},{\"id\":\"utc+7\",\"text\":\"UTC+7\"},{\"id\":\"utc+6:30\",\"text\":\"UTC+6:30\"},{\"id\":\"utc+6\",\"text\":\"UTC+6\"},{\"id\":\"utc+5:45\",\"text\":\"UTC+5:45\"},{\"id\":\"utc+5:30\",\"text\":\"UTC+5:30\"},{\"id\":\"utc+5\",\"text\":\"UTC+5\"},{\"id\":\"utc+4:30\",\"text\":\"UTC+4:30\"},{\"id\":\"utc+4\",\"text\":\"UTC+4\"},{\"id\":\"utc+3:30\",\"text\":\"UTC+3:30\"},{\"id\":\"utc+3\",\"text\":\"UTC+3\"},{\"id\":\"utc+2\",\"text\":\"UTC+2\"},{\"id\":\"utc+1\",\"text\":\"UTC+1\"},{\"id\":\"utc+0\",\"text\":\"UTC+0\",\"selected\":true},{\"id\":\"utc-1\",\"text\":\"UTC-1\"},{\"id\":\"utc-2\",\"text\":\"UTC-2\"},{\"id\":\"utc-2:30\",\"text\":\"UTC-2:30\"},{\"id\":\"utc-3\",\"text\":\"UTC-3\"},{\"id\":\"utc-3:30\",\"text\":\"UTC-3:30\"},{\"id\":\"utc-4\",\"text\":\"UTC-4\"},{\"id\":\"utc-4:30\",\"text\":\"UTC-4:30\"},{\"id\":\"utc-5\",\"text\":\"UTC-5\"},{\"id\":\"utc-6\",\"text\":\"UTC-6\"},{\"id\":\"utc-7\",\"text\":\"UTC-7\"},{\"id\":\"utc-8\",\"text\":\"UTC-8\"},{\"id\":\"utc-9\",\"text\":\"UTC-9\"},{\"id\":\"utc-9:30\",\"text\":\"UTC-9:30\"},{\"id\":\"utc-10\",\"text\":\"UTC-10\"},{\"id\":\"utc-11\",\"text\":\"UTC-11\"},{\"id\":\"utc-12\",\"text\":\"UTC-12\"}]");

/***/ }),

/***/ "./src/assets/js/blocks/select.js":
/*!****************************************!*\
  !*** ./src/assets/js/blocks/select.js ***!
  \****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _json_select_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./json/select.json */ "./src/assets/js/blocks/json/select.json");
var _json_select_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t(/*! ./json/select.json */ "./src/assets/js/blocks/json/select.json", 1);
/* harmony import */ var _site_config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../site.config.json */ "./site.config.json");
var _site_config_json__WEBPACK_IMPORTED_MODULE_1___namespace = /*#__PURE__*/__webpack_require__.t(/*! ../../../../site.config.json */ "./site.config.json", 1);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./global */ "./src/assets/js/blocks/global.js");
 // подключение объекта со всеми странами
 // глобальный файл конфигурации сайта

 // хук для определения языка

let langs = Object(_global__WEBPACK_IMPORTED_MODULE_2__["definesLanguage"])();

/**
 * Функция для создания списка стран в модальном окне обратной связи с помощью плагина select2
 */
(function addCustomSelectCountry() {
  if ($('.custom-select-wrapper').length) {
    $('#select-time-zone').select2({
      data: _json_select_json__WEBPACK_IMPORTED_MODULE_0__,
      dropdownParent: '.select-wrapper-time-zone',
      tags: false,
      minimumResultsForSearch: Infinity
    });
  }
})();

/**
 * Функция для создания списка языков в модальном окне обратной связи с помощью плагина select2
 */
(function addCustomSelectLang() {
  if ($('.custom-select-wrapper').length) {
    function formatOption(option) {
      if (!option.id) {
        return option.text;
      }
      let optionWithImage = $('<span class="select-lang-item"><img src="' + option.id + '" class="select-lang-icon"/>' + '<span class="select-lang-item__text">' + option.text + '</span>' + '</span>');
      return optionWithImage;
    }
    let options;
    if (_site_config_json__WEBPACK_IMPORTED_MODULE_1__.spam === true) {
      if (langs == 'ru') {
        options = [{
          id: '/assets/images/ru-lang.svg',
          text: 'Русский'
        }, {
          id: '/assets/images/en-lang.svg',
          text: 'English'
        }, {
          id: '/assets/images/tr-lang.svg',
          text: 'Turkish'
        }];
      } else if (langs == 'tr') {
        options = [{
          id: '/assets/images/tr-lang.svg',
          text: 'Turkish'
        }, {
          id: '/assets/images/en-lang.svg',
          text: 'English'
        }, {
          id: '/assets/images/ru-lang.svg',
          text: 'Русский'
        }];
      } else {
        options = [{
          id: '/assets/images/en-lang.svg',
          text: 'English'
        }, {
          id: '/assets/images/ru-lang.svg',
          text: 'Русский'
        }, {
          id: '/assets/images/tr-lang.svg',
          text: 'Turkish'
        }];
      }
    } else {
      if (langs == 'ru') {
        options = [{
          id: '/assets/images/ru-lang.svg',
          text: 'Русский'
        }, {
          id: '/assets/images/en-lang.svg',
          text: 'English'
        }];
      } else {
        options = [{
          id: '/assets/images/en-lang.svg',
          text: 'English'
        }, {
          id: '/assets/images/ru-lang.svg',
          text: 'Русский'
        }];
      }
    }
    $('#select-lang').select2({
      templateResult: formatOption,
      templateSelection: formatOption,
      data: options,
      minimumResultsForSearch: Infinity,
      dropdownParent: '.select-wrapper-lang'
    });
  }
})();

/***/ }),

/***/ "./src/assets/js/construct.js":
/*!************************************!*\
  !*** ./src/assets/js/construct.js ***!
  \************************************/
/*! exports provided: countryErrorPopup */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countryErrorPopup", function() { return countryErrorPopup; });
/* harmony import */ var _site_config_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../site.config.json */ "./site.config.json");
var _site_config_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t(/*! ../../../site.config.json */ "./site.config.json", 1);
/* harmony import */ var _build_content_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../build/content.json */ "./build/content.json");
var _build_content_json__WEBPACK_IMPORTED_MODULE_1___namespace = /*#__PURE__*/__webpack_require__.t(/*! ../../../build/content.json */ "./build/content.json", 1);
/* harmony import */ var _babel_polyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/polyfill */ "./node_modules/@babel/polyfill/lib/index.js");
/* harmony import */ var _babel_polyfill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_polyfill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! aos */ "./node_modules/aos/dist/aos.js");
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(aos__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var jquery_validation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! jquery-validation */ "./node_modules/jquery-validation/dist/jquery.validate.js");
/* harmony import */ var jquery_validation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(jquery_validation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var jquery_mask_plugin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! jquery-mask-plugin */ "./node_modules/jquery-mask-plugin/dist/jquery.mask.js");
/* harmony import */ var jquery_mask_plugin__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(jquery_mask_plugin__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var magnific_popup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! magnific-popup */ "./node_modules/magnific-popup/dist/jquery.magnific-popup.js");
/* harmony import */ var magnific_popup__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(magnific_popup__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _blocks_global__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./blocks/global */ "./src/assets/js/blocks/global.js");
 // глобальный файл конфигурации сайта
 // весь сгенерированный контент



window.$ = jquery__WEBPACK_IMPORTED_MODULE_3___default.a;
window.jQuery = jquery__WEBPACK_IMPORTED_MODULE_3___default.a;


// import 'select2'



 // хук для определения языка
var lang = Object(_blocks_global__WEBPACK_IMPORTED_MODULE_9__["definesLanguage"])();
__webpack_require__(/*! ./vendor/jquery-ui.min */ "./src/assets/js/vendor/jquery-ui.min.js");
__webpack_require__(/*! ./vendor/jquery.animateNumber.min */ "./src/assets/js/vendor/jquery.animateNumber.min.js");
__webpack_require__(/*! ./vendor/jquery.viewportchecker.min */ "./src/assets/js/vendor/jquery.viewportchecker.min.js");
__webpack_require__(/*! ./blocks/forms */ "./src/assets/js/blocks/forms.js");
// require('./blocks/news')
__webpack_require__(/*! ./blocks/footer */ "./src/assets/js/blocks/footer.js");
__webpack_require__(/*! ./blocks/select */ "./src/assets/js/blocks/select.js");
__webpack_require__(/*! ./blocks/index */ "./src/assets/js/blocks/index.js");
__webpack_require__(/*! ./main */ "./src/assets/js/main.js")
// require('./vendor/simple-rss')
// window.buildRelease - переменная имеет true или false - означает сборка build:release или любая другая
// true - значит build:release сборка
// false - значит любая другая

// getCountry()

// SPAM
;
(function cookieOff() {
  if (_site_config_json__WEBPACK_IMPORTED_MODULE_0__.spam) {
    function getCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    getCookie('PHPSESSID');
    getCookie('_ga');
    getCookie('twk_uuid_628b53467b967b117990be5a');
    getCookie('twk_idm_key');
    getCookie('_ga_Q6220QR4VG');
    getCookie('__cf_bm');
    getCookie('_ga_J63P164LSP');
    getCookie('TawkConnectionTime');
    getCookie('_ga_4N7W8RN2S7');
    function deleteCookie(name, options = {}) {
      const {
        path = '/',
        domain = '',
        secure = true,
        sameSite = 'Strict'
      } = options;
      if (getCookie(name)) {
        const cookieOptions = [`path=${path}`, domain ? `domain=${domain}` : '', secure ? 'secure' : '', sameSite ? `sameSite=${sameSite}` : '', 'expires=Thu, 01 Jan 1970 00:00:01 GMT'].filter(Boolean).join(';');
        // .filter(Boolean).join(';') is used to remove empty values, ensuring there are no extra semicolons in the cookie string.
        document.cookie = `${name}=; ${cookieOptions}`;
      }
    }
    deleteCookie('PHPSESSID');
    deleteCookie('_ga');
    deleteCookie('twk_uuid_628b53467b967b117990be5a');
    deleteCookie('twk_idm_key');
    deleteCookie('_ga_Q6220QR4VG');
    deleteCookie('__cf_bm');
    deleteCookie('_ga_J63P164LSP');
    deleteCookie('TawkConnectionTime');
    deleteCookie('_ga_4N7W8RN2S7');
  }
})();
jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).on('click', '.js-btn-close', function (e) {
  e.preventDefault();
  jquery__WEBPACK_IMPORTED_MODULE_3___default.a.magnificPopup.close();
})

/**
 * Инициализация AOS
 */;
(function addedAosPlagin() {
  aos__WEBPACK_IMPORTED_MODULE_4___default.a.init({
    duration: _site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.aos.duration
  });
})()

/**
 * Показать пароль функция
 */;
(function showPassword() {
  if (jquery__WEBPACK_IMPORTED_MODULE_3___default()('.form-input_password').length) {
    jquery__WEBPACK_IMPORTED_MODULE_3___default()('.show-icon').on('click', function () {
      var thisInput = jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).parent().find('.form-input_password');
      if (!thisInput.hasClass('show')) {
        thisInput.addClass('show');
        thisInput.attr('type', 'text');
      } else {
        thisInput.removeClass('show');
        thisInput.attr('type', 'password');
      }
    });
  }
})();

/**
 * Кнопка для открытия меню
 */
jquery__WEBPACK_IMPORTED_MODULE_3___default()('#navBar').click(function () {
  jquery__WEBPACK_IMPORTED_MODULE_3___default()('#mainNav').toggleClass('responsive');
  jquery__WEBPACK_IMPORTED_MODULE_3___default()('.navbar-burger').toggleClass('active');
  jquery__WEBPACK_IMPORTED_MODULE_3___default()('body').toggleClass('lock');
})

/**
 * Берет доменное имя с адресной строки и вставляет в почту на странице Контакты
 */

/**
 * По клику на вопрос открывает/закрывает аккордеон в FAQ
 */;
(function faqToggle() {
  jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).on('click', '.js--faq-header', function () {
    jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).children('.faq-item__ask').toggleClass('opened');
    jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).siblings('.js--faq-answer').toggleClass('opened');
    jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).children('.js--faq-toggle').toggleClass('opened');
    if (jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).siblings('.js--faq-answer').hasClass('opened')) {
      jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).siblings('.js--faq-answer').slideDown(400);
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).siblings('.js--faq-answer').slideUp(400, function () {
        jquery__WEBPACK_IMPORTED_MODULE_3___default()(this).siblings('.js--faq-answer').removeClass('opened');
      });
    }
  });
})();
function getCountry() {
  var black_list_conutry = _site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_countries;
  if (_site_config_json__WEBPACK_IMPORTED_MODULE_0__.javascript.ip_restrictions.ip_restrictions_flag === true) {
    if (localStorage.getItem('countryCode') === null) {
      jquery__WEBPACK_IMPORTED_MODULE_3___default.a.get('https://api.ipstack.com/check?access_key=9ac3ab92ce4396c8da8c45f1d3c524e6', function (data) {
        localStorage.setItem('countryCode', data.country_code.toLowerCase());
      }).done(function (data) {
        countryErrorPopup(black_list_conutry, data.country_code.toLowerCase());
      });
    } else {
      countryErrorPopup(black_list_conutry, localStorage.getItem('countryCode'));
    }
  }
}
function countryErrorPopup(blackList, currentCountryCode) {
  if (blackList.indexOf(currentCountryCode) !== -1) {
    setTimeout(function () {
      jquery__WEBPACK_IMPORTED_MODULE_3___default.a.magnificPopup.open({
        items: {
          src: '#countryorder'
        },
        type: 'inline',
        callbacks: {
          beforeOpen: function () {
            jquery__WEBPACK_IMPORTED_MODULE_3___default()('body').css('overflow', 'hidden');
          },
          beforeClose: function () {
            jquery__WEBPACK_IMPORTED_MODULE_3___default()('body').css('overflow', 'auto');
          }
        }
      });
    });
  } else {
    if (jquery__WEBPACK_IMPORTED_MODULE_3___default()('#licenses-popup').length) {
      // licensesPopup();
    }
  }
}
;
function callcookie(name, value, days) {
  if (days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + d.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}
function getCookie() {
  let myCookie = 'emaill';
  var matches = document.cookie.match(new RegExp("(?:^|; )" + myCookie.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}
function licensesPopup() {
  jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).ready(function () {
    if (jquery__WEBPACK_IMPORTED_MODULE_3___default()('#licenses-popup').length) {
      let checkCookie = getCookie();
      if (checkCookie === undefined) {
        jquery__WEBPACK_IMPORTED_MODULE_3___default.a.magnificPopup.open({
          items: {
            src: '#licenses-popup',
            type: 'inline'
          },
          focus: '#email',
          closeOnBgClick: false,
          enableEscapeKey: false,
          showCloseBtn: false,
          callbacks: {
            beforeOpen: function () {
              jquery__WEBPACK_IMPORTED_MODULE_3___default()('body').css('overflow', 'hidden');
            },
            beforeClose: function () {
              jquery__WEBPACK_IMPORTED_MODULE_3___default()('body').css('overflow', 'auto');
            }
          }
        });
      }
    }
  });
}
;
(function showSuccesTextAndSaveCookie() {
  jquery__WEBPACK_IMPORTED_MODULE_3___default()('.js--callback-licenses').on("click", function () {
    jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).on('form_submitted', function (e, data) {
      callcookie('emaill', 'emaill', 1);
      jquery__WEBPACK_IMPORTED_MODULE_3___default()('form').find('input').val('');
      jquery__WEBPACK_IMPORTED_MODULE_3___default.a.magnificPopup.close();
    });
    jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).on('form_error', function (e, data) {
      // в data хранится ответ
    });
  });
})();
jquery__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  //Change the class name, if it has to be applied for more SVG elements
  jQuery('img.svg').each(function () {
    var $img = jQuery(this); // The image
    var imgID = $img.attr('id'); // ID attribute
    var imgClass = $img.attr('class'); // Class Name
    var imgURL = $img.attr('src'); // URL of the SVG image

    jQuery.get(imgURL, function (data) {
      //The data param contains the XML data of the SVG image
      //alert(new XMLSerializer().serializeToString(data));

      // Get the SVG tag, ignore the rest
      var $svg = jQuery(data).find('svg');

      // Give the image's ID to the SVG
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }

      // Give the image's class to the SVG
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Check if the viewport is set, else we gonna set it if we can.
      if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
      }

      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml'); //Returns as XML
  });
});
(function anchorLinks() {
  // headers anchors
  document.addEventListener("DOMContentLoaded", () => {
    jquery__WEBPACK_IMPORTED_MODULE_3___default()('.services-tab').each(function (index, elem) {
      elem.addEventListener('click', function (event) {
        event.preventDefault();
        jquery__WEBPACK_IMPORTED_MODULE_3___default()('html, body').animate({
          scrollTop: jquery__WEBPACK_IMPORTED_MODULE_3___default()(this.hash).offset().top - 95
        }, 1000);
      });
    });
    jquery__WEBPACK_IMPORTED_MODULE_3___default()('.js--scroll-down2').each(function (index, elem) {
      elem.addEventListener('click', function (event) {
        event.preventDefault();
        jquery__WEBPACK_IMPORTED_MODULE_3___default()('html, body').animate({
          scrollTop: jquery__WEBPACK_IMPORTED_MODULE_3___default()(this.hash).offset().top - 190
        }, 1000);
      });
    });
  });

  // footer link with anchor
  let myHash = location.hash;
  location.hash = '';
  if (myHash[1] != undefined) {
    jquery__WEBPACK_IMPORTED_MODULE_3___default()('html, body').animate({
      scrollTop: jquery__WEBPACK_IMPORTED_MODULE_3___default()(myHash).offset().top - 80
    }, 500);
  }
  ;
})();

//
//
// import __INDEX_IMG1 from "./blocks/json/animation-1.json"
// import __INDEX_IMG2 from "./blocks/json/animation-2.json"
// import __INDEX_IMG3 from "./blocks/json/animation-3.json"
// ;
// import animation from "lottie-web";
// import animation1 from "lottie-web";
// import animation2 from "lottie-web";
// import animation3 from "lottie-web";
//
// (function addedAnim1() {
//     let animation1 = require('lottie-web')
//     const dropdownItem1 = document.getElementById('animation-1');
//
//     let elements = [
//         { elementID: 'lottie-box-1', animationData: __INDEX_IMG1 }
//     ]
//
//     function loadAnimation(elementID, animationData) {
//         let element = document.getElementById(elementID)
//         if (!element) return
//
//         const navAnim1 = animation1.loadAnimation({
//             container: document.getElementById("lottie-box-1"),
//             renderer: 'svg',
//             loop: false,
//             autoplay: false,
//             animationData: __INDEX_IMG1
//         });
//
//         dropdownItem1.addEventListener('mouseenter', function() {
//             fEnter(navAnim1);
//         });
//
//         dropdownItem1.addEventListener('mouseleave', function() {
//             fLeave(navAnim1);
//         });
//
//         function fEnter(animation1) {
//             animation1.setDirection(1);
//             animation1.play();
//         }
//
//         function fLeave(animation1) {
//             animation1.setDirection(-1);
//             animation1.play();
//         }
//     }
//
//     elements.forEach(({ elementID, animationData }) =>
//         loadAnimation(elementID, animationData)
//     )
// })();
//
// (function addedAnim2() {
//     let animation2 = require('lottie-web')
//     const dropdownItem2 = document.getElementById('animation-2');
//
//     const elements = [
//         { elementID: 'lottie-box-2', animationData: __INDEX_IMG2 }
//     ]
//
//     function loadAnimation(elementID, animationData) {
//         let element = document.getElementById(elementID)
//         if (!element) return
//
//         const navAnim2 = animation2.loadAnimation({
//             container: document.getElementById("lottie-box-2"),
//             renderer: 'svg',
//             loop: false,
//             autoplay: false,
//             animationData: __INDEX_IMG2
//         });
//
//         dropdownItem2.addEventListener('mouseenter', function() {
//             fEnter(navAnim2);
//         });
//
//         dropdownItem2.addEventListener('mouseleave', function() {
//             fLeave(navAnim2);
//         });
//
//         function fEnter(animation2) {
//             animation2.setDirection(1);
//             animation2.setSpeed(0.6);
//             animation2.play();
//         }
//
//         function fLeave(animation2) {
//             animation2.setDirection(-1);
//             animation2.setSpeed(1);
//             animation2.play();
//         }
//     }
//
//     elements.forEach(({ elementID, animationData }) =>
//         loadAnimation(elementID, animationData)
//     )
// })();
//
// (function addedAnim3() {
//     let animation3 = require('lottie-web')
//     const dropdownItem3 = document.getElementById('animation-3');
//
//     let elements = [
//         { elementID: 'lottie-box-3', animationData: __INDEX_IMG3 }
//     ]
//
//     function loadAnimation(elementID, animationData) {
//         let element = document.getElementById(elementID)
//         if (!element) return
//
//         const navAnim3 = animation3.loadAnimation({
//             container: document.getElementById("lottie-box-3"),
//             renderer: 'svg',
//             loop: true,
//             autoplay: false,
//             animationData: __INDEX_IMG3
//         });
//
//         dropdownItem3.addEventListener('mouseenter', function() {
//             fEnter(navAnim3);
//         });
//
//         dropdownItem3.addEventListener('mouseleave', function() {
//             fLeave(navAnim3);
//         });
//
//         function fEnter(animation3) {
//             animation3.setSpeed(0.3);
//             animation3.setDirection(1);
//             animation3.play();
//         }
//
//         function fLeave(animation3) {
//             animation3.pause();
//         }
//     }
//
//     elements.forEach(({ elementID, animationData }) =>
//         loadAnimation(elementID, animationData)
//     )
// })();

jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).ready(function () {
  jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).on("scroll", onScroll);
  function onScroll(event) {
    var scrollPos = jquery__WEBPACK_IMPORTED_MODULE_3___default()(document).scrollTop();
    jquery__WEBPACK_IMPORTED_MODULE_3___default()('a.js--scroll-down').each(function () {
      var currLink = jquery__WEBPACK_IMPORTED_MODULE_3___default()(this);
      var refElement = jquery__WEBPACK_IMPORTED_MODULE_3___default()(currLink.attr("href"));
      if (refElement.length) {
        if (refElement.position().top + 600 <= scrollPos && refElement.position().top + refElement.height() + 660 > scrollPos) {
          jquery__WEBPACK_IMPORTED_MODULE_3___default()('a').removeClass("active");
          currLink.addClass("active");
        } else {
          currLink.removeClass("active");
        }
      }
    });
  }
});
jquery__WEBPACK_IMPORTED_MODULE_3___default()('.team-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  autoplay: false,
  loop: false,
  infinite: true,
  autoplaySpeed: 0,
  speed: 600,
  cssEase: "linear",
  // pauseOnHover: true,
  // pauseOnFocus: true,
  // swipeToSlide: true,
  prevArrow: jquery__WEBPACK_IMPORTED_MODULE_3___default()('.prev-team'),
  nextArrow: jquery__WEBPACK_IMPORTED_MODULE_3___default()('.next-team'),
  responsive: [{
    breakpoint: 1025,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 769,
    settings: {
      slidesToShow: 1
    }
  }]
});

/***/ }),

/***/ "./src/assets/js/main.js":
/*!*******************************!*\
  !*** ./src/assets/js/main.js ***!
  \*******************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _blocks_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./blocks/global */ "./src/assets/js/blocks/global.js");
 // хук для определения языка

let lang = Object(_blocks_global__WEBPACK_IMPORTED_MODULE_0__["definesLanguage"])();
let panels = document.querySelectorAll('.panels .panel');
panels.forEach(panel => {
  panel.addEventListener('click', e => {
    removeActiveClasses();
    panel.classList.add('active');
    const el = e.target.closest('.panel');
    console.log(el);
  });
});
function removeActiveClasses() {
  panels.forEach(panel => {
    panel.classList.remove('active');
  });
}
function tabs() {
  const showTab = elTabBtn => {
    const elTab = elTabBtn.closest('.tab-content');
    if (elTabBtn.classList.contains('tab-btn-active')) {
      return;
    }
    const targetId = elTabBtn.dataset.targetId;
    console.log(targetId);
    const elTabPane = elTab.querySelector(`.panel[data-id="${targetId}"]`);
    if (elTabPane) {
      const elTabBtnActive = elTab.querySelector('.tab-btn-active');
      elTabBtnActive.classList.remove('tab-btn-active');
      const elTabPaneShow = elTab.querySelector('.active');
      elTabPaneShow.classList.remove('active');
      elTabBtn.classList.add('tab-btn-active');
      elTabPane.classList.add('active');
    }
  };
  document.addEventListener('click', e => {
    if (e.target && !e.target.closest('.tab-btn')) {
      return;
    }
    const elTabBtn = e.target.closest('.tab-btn');
    showTab(elTabBtn);
  });
}
tabs();
(function fixedMenu() {
  var coordinateMenu = $('.nav').offset().top;
  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      $('.nav').addClass('sticky');
    } else {
      $('.nav').removeClass('sticky');
    }
  });
})();
$('.counter-tab-content').hide();
$('.counter-tab-content:first').show();
$('.counter-tab-nav-item').click(function (e) {
  $(this).addClass('active').siblings().removeClass('active');
  $($(this).attr('tab')).fadeIn().siblings().hide();
});
$(function () {
  $('#scrollToTop').click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
    return false;
  });
});
function initSlick() {
  $('.clients-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    margin: 0,
    speed: 400,
    cssEase: 'linear',
    infinite: true,
    prevArrow: $('.prev-client'),
    nextArrow: $('.next-client'),
    responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 540,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $('#dedicated-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: 'linear',
    dots: false,
    arrows: true,
    speed: 400,
    infinite: true,
    fade: false,
    prevArrow: $('.prev-dedicated'),
    nextArrow: $('.next-dedicated'),
    responsive: [{
      breakpoint: 1025,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 540,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $('.slider-docs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    margin: 0,
    speed: 400,
    infinite: true,
    prevArrow: $('.prev-docs'),
    nextArrow: $('.next-docs'),
    responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 540,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $(function () {
    let mouseX = 0,
      mouseY = 0;
    let currentX = 0,
      currentY = 0;
    const speed = 0.05; // Скорость анимации, чем меньше значение, тем медленнее движение

    $(document).on('mousemove', 'body', function (event) {
      let bodyX = $(this).width();
      let bodyY = $(this).height();
      let centerX = bodyX / 2;
      let centerY = bodyY / 2;
      mouseX = (event.screenX - centerX) * 100 / bodyX;
      mouseY = (event.screenY - centerY) * 200 / bodyY;
    });
    function updateParallax() {
      currentX += (mouseX - currentX) * speed;
      currentY += (mouseY - currentY) * speed;
      $('.parallax').each(function (index, element) {
        let depth = $(element).data('depth');
        let invert = $(element).data('invert');
        if (invert) {
          depth = -depth;
        }
        let translateX = depth * currentX;
        let translateY = depth * currentY;
        $(element).css({
          'transform': 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0px)',
          'transform-style': "preserve-3d"
        });
      });
      requestAnimationFrame(updateParallax);
    }
    updateParallax();
  });
  if (window.matchMedia("(max-width: 1024px)").matches) {
    $(".panels").hide(0);
    $('.index-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      margin: 0,
      // autoPlay: true,
      // autoplaySpeed: 4000,
      speed: 500,
      cssEase: "linear",
      // pauseOnHover: true,
      // pauseOnFocus: true,
      // swipeToSlide: true,
      infinite: true
    });
    $('.cloud-list').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      cssEase: 'linear',
      dots: false,
      arrows: true,
      speed: 400,
      infinite: true,
      fade: false,
      prevArrow: $('.prev-dedicated'),
      nextArrow: $('.next-dedicated'),
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }, {
        breakpoint: 540,
        settings: {
          slidesToShow: 1
        }
      }]
    });
    $('.hexagon-mob-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      speed: 400,
      infinite: true,
      fade: true,
      cssEase: 'linear',
      prevArrow: $('.prev-hex'),
      nextArrow: $('.next-hex')
    });
    $('#js--accounts-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: 'linear',
      dots: false,
      arrows: true,
      speed: 400,
      initialSlide: 1,
      infinite: true,
      fade: true,
      prevArrow: $('.prev-acc'),
      nextArrow: $('.next-acc')
    });
    $('.counter-list-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: 'linear',
      dots: false,
      arrows: true,
      speed: 400,
      infinite: true,
      fade: true,
      prevArrow: $('.prev-count'),
      nextArrow: $('.next-count')
    });
  }
}
initSlick();

// Accordion
$(function () {
  $('.faq-title').on('click', function (e) {
    e.preventDefault();
    $(".faq-item").removeClass('active');
    var $this = $(this);
    if (!$this.hasClass('active')) {
      $(this).closest(".faq-item").addClass("active");
      $('.faq-content').slideUp(400);
      $('.faq-title').removeClass('active');
    }
    $this.toggleClass('active');
    $this.next().slideToggle();
  });
});

//Mobile menu dropdrown
// $(function () {
// 	$('.respons-title').on('click', function (e) {
// 		e.preventDefault()
// 		$(".respons-block").removeClass('active')
// 		var $this = $(this)
// 		if (!$this.hasClass('active')) {
// 			$(this).closest(".respons-block").addClass("active")
// 			$('.respons-block').slideUp(400)
// 			$('.respons-title').removeClass('active')
// 		}
// 		$this.toggleClass('active')
// 		$this.next().slideToggle()
// 	})
// })
//
// var simpleRSSPlugin = (function() {
//     // get all the feed containers
//     var feedsNodes = document.querySelectorAll('[data-rss-feed]');
//     // Convert to array
//     var feeds = [].slice.call(feedsNodes);
//     for (var i = 0; i < feeds.length; i++) {
//         var container = feedsNodes[i];
//
//         // get feed URL
//         var url = container.getAttribute('data-rss-feed');
//         // get whether to link titles
//         var addLink = container.getAttribute('data-rss-link-titles') || 'true';
//
//         // get title wrapper element
//         var titleWrapper = container.getAttribute('data-rss-title-wrapper') || 'h2';
//         // Max outputs
//         var max = container.getAttribute('data-rss-max') || 10;
//         // Get data - append as script with callback to avoid CORS
//         var script = document.createElement('script');
//         script.src = document.location.protocol + '//api.rss2json.com/v1/api.json?callback=simpleRSSPlugin.handleJSON&rss_url=' + encodeURIComponent(url);
//         document.querySelector('head').appendChild(script);
//
//         // Remove script
//         script.parentNode.removeChild(script);
//     }
//     // Callback function
//     var loops = 0;
//     function handleJSON(data) {
//         if (data.feed && data.items) {
//
//             var docFrag = document.createDocumentFragment();
//             for (var i = 0; i < data.items.length; i++) {
//                 var e = data.items[i];
//                 var tempNode = document.createElement('div');
//                 var template = '<' + titleWrapper + '><a href="' + e.link + '">' + e.title + '</a></' + titleWrapper + '>' + e.content;
//                 if (addLink === 'false') {
//                     template = '<' + titleWrapper + '>' + e.title + '</' + titleWrapper + '>' + e.content;
//                 }
//                 if (i < max) {
//
//                     tempNode.innerHTML = template;
//
//                     docFrag.appendChild(tempNode);
//                 }
//             }
//             container = feedsNodes[loops];
//             container.appendChild(docFrag);
//             loops++;
//         }
//     }
//     // Return function for use in global scope
//     return {
//         handleJSON:handleJSON
//     }
// })();

/***/ }),

/***/ "./src/assets/js/vendor/jquery-ui.min.js":
/*!***********************************************!*\
  !*** ./src/assets/js/vendor/jquery-ui.min.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery UI - v1.13.1 - 2022-01-20
 * http://jqueryui.com
 * Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-patch.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
 * Copyright jQuery Foundation and other contributors; Licensed MIT */

!function (t) {
  'use strict';

   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : undefined;
}(function (V) {
  'use strict';

  V.ui = V.ui || {};
  V.ui.version = '1.13.1';
  var n,
    i = 0,
    a = Array.prototype.hasOwnProperty,
    r = Array.prototype.slice;
  V.cleanData = (n = V.cleanData, function (t) {
    for (var e, i, s = 0; null != (i = t[s]); s++) (e = V._data(i, 'events')) && e.remove && V(i).triggerHandler('remove');
    n(t);
  }), V.widget = function (t, i, e) {
    var s,
      n,
      o,
      a = {},
      r = t.split('.')[0],
      l = r + '-' + (t = t.split('.')[1]);
    return e || (e = i, i = V.Widget), Array.isArray(e) && (e = V.extend.apply(null, [{}].concat(e))), V.expr.pseudos[l.toLowerCase()] = function (t) {
      return !!V.data(t, l);
    }, V[r] = V[r] || {}, s = V[r][t], n = V[r][t] = function (t, e) {
      if (!this || !this._createWidget) return new n(t, e);
      arguments.length && this._createWidget(t, e);
    }, V.extend(n, s, {
      version: e.version,
      _proto: V.extend({}, e),
      _childConstructors: []
    }), (o = new i()).options = V.widget.extend({}, o.options), V.each(e, function (e, s) {
      function n() {
        return i.prototype[e].apply(this, arguments);
      }
      function o(t) {
        return i.prototype[e].apply(this, t);
      }
      a[e] = 'function' == typeof s ? function () {
        var t,
          e = this._super,
          i = this._superApply;
        return this._super = n, this._superApply = o, t = s.apply(this, arguments), this._super = e, this._superApply = i, t;
      } : s;
    }), n.prototype = V.widget.extend(o, {
      widgetEventPrefix: s && o.widgetEventPrefix || t
    }, a, {
      constructor: n,
      namespace: r,
      widgetName: t,
      widgetFullName: l
    }), s ? (V.each(s._childConstructors, function (t, e) {
      var i = e.prototype;
      V.widget(i.namespace + '.' + i.widgetName, n, e._proto);
    }), delete s._childConstructors) : i._childConstructors.push(n), V.widget.bridge(t, n), n;
  }, V.widget.extend = function (t) {
    for (var e, i, s = r.call(arguments, 1), n = 0, o = s.length; n < o; n++) for (e in s[n]) i = s[n][e], a.call(s[n], e) && void 0 !== i && (V.isPlainObject(i) ? t[e] = V.isPlainObject(t[e]) ? V.widget.extend({}, t[e], i) : V.widget.extend({}, i) : t[e] = i);
    return t;
  }, V.widget.bridge = function (o, e) {
    var a = e.prototype.widgetFullName || o;
    V.fn[o] = function (i) {
      var t = 'string' == typeof i,
        s = r.call(arguments, 1),
        n = this;
      return t ? this.length || 'instance' !== i ? this.each(function () {
        var t,
          e = V.data(this, a);
        return 'instance' === i ? (n = e, !1) : e ? 'function' != typeof e[i] || '_' === i.charAt(0) ? V.error("no such method '" + i + "' for " + o + ' widget instance') : (t = e[i].apply(e, s)) !== e && void 0 !== t ? (n = t && t.jquery ? n.pushStack(t.get()) : t, !1) : void 0 : V.error('cannot call methods on ' + o + " prior to initialization; attempted to call method '" + i + "'");
      }) : n = void 0 : (s.length && (i = V.widget.extend.apply(null, [i].concat(s))), this.each(function () {
        var t = V.data(this, a);
        t ? (t.option(i || {}), t._init && t._init()) : V.data(this, a, new e(i, this));
      })), n;
    };
  }, V.Widget = function () {}, V.Widget._childConstructors = [], V.Widget.prototype = {
    widgetName: 'widget',
    widgetEventPrefix: '',
    defaultElement: '<div>',
    options: {
      classes: {},
      disabled: !1,
      create: null
    },
    _createWidget: function (t, e) {
      ;
      e = V(e || this.defaultElement || this)[0], this.element = V(e), this.uuid = i++, this.eventNamespace = '.' + this.widgetName + this.uuid, this.bindings = V(), this.hoverable = V(), this.focusable = V(), this.classesElementLookup = {}, e !== this && (V.data(e, this.widgetFullName, this), this._on(!0, this.element, {
        remove: function (t) {
          t.target === e && this.destroy();
        }
      }), this.document = V(e.style ? e.ownerDocument : e.document || e), this.window = V(this.document[0].defaultView || this.document[0].parentWindow)), this.options = V.widget.extend({}, this.options, this._getCreateOptions(), t), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger('create', null, this._getCreateEventData()), this._init();
    },
    _getCreateOptions: function () {
      return {};
    },
    _getCreateEventData: V.noop,
    _create: V.noop,
    _init: V.noop,
    destroy: function () {
      var i = this;
      this._destroy(), V.each(this.classesElementLookup, function (t, e) {
        i._removeClass(e, t);
      }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr('aria-disabled'), this.bindings.off(this.eventNamespace);
    },
    _destroy: V.noop,
    widget: function () {
      return this.element;
    },
    option: function (t, e) {
      var i,
        s,
        n,
        o = t;
      if (0 === arguments.length) return V.widget.extend({}, this.options);
      if ('string' == typeof t) if (o = {}, t = (i = t.split('.')).shift(), i.length) {
        for (s = o[t] = V.widget.extend({}, this.options[t]), n = 0; n < i.length - 1; n++) s[i[n]] = s[i[n]] || {}, s = s[i[n]];
        if (t = i.pop(), 1 === arguments.length) return void 0 === s[t] ? null : s[t];
        s[t] = e;
      } else {
        if (1 === arguments.length) return void 0 === this.options[t] ? null : this.options[t];
        o[t] = e;
      }
      return this._setOptions(o), this;
    },
    _setOptions: function (t) {
      for (var e in t) this._setOption(e, t[e]);
      return this;
    },
    _setOption: function (t, e) {
      return 'classes' === t && this._setOptionClasses(e), this.options[t] = e, 'disabled' === t && this._setOptionDisabled(e), this;
    },
    _setOptionClasses: function (t) {
      var e, i, s;
      for (e in t) s = this.classesElementLookup[e], t[e] !== this.options.classes[e] && s && s.length && (i = V(s.get()), this._removeClass(s, e), i.addClass(this._classes({
        element: i,
        keys: e,
        classes: t,
        add: !0
      })));
    },
    _setOptionDisabled: function (t) {
      this._toggleClass(this.widget(), this.widgetFullName + '-disabled', null, !!t), t && (this._removeClass(this.hoverable, null, 'ui-state-hover'), this._removeClass(this.focusable, null, 'ui-state-focus'));
    },
    enable: function () {
      return this._setOptions({
        disabled: !1
      });
    },
    disable: function () {
      return this._setOptions({
        disabled: !0
      });
    },
    _classes: function (n) {
      var o = [],
        a = this;
      function t(t, e) {
        for (var i, s = 0; s < t.length; s++) i = a.classesElementLookup[t[s]] || V(), i = n.add ? (function () {
          var i = [];
          n.element.each(function (t, e) {
            V.map(a.classesElementLookup, function (t) {
              return t;
            }).some(function (t) {
              return t.is(e);
            }) || i.push(e);
          }), a._on(V(i), {
            remove: '_untrackClassesElement'
          });
        }(), V(V.uniqueSort(i.get().concat(n.element.get())))) : V(i.not(n.element).get()), a.classesElementLookup[t[s]] = i, o.push(t[s]), e && n.classes[t[s]] && o.push(n.classes[t[s]]);
      }
      return (n = V.extend({
        element: this.element,
        classes: this.options.classes || {}
      }, n)).keys && t(n.keys.match(/\S+/g) || [], !0), n.extra && t(n.extra.match(/\S+/g) || []), o.join(' ');
    },
    _untrackClassesElement: function (i) {
      var s = this;
      V.each(s.classesElementLookup, function (t, e) {
        ;
        -1 !== V.inArray(i.target, e) && (s.classesElementLookup[t] = V(e.not(i.target).get()));
      }), this._off(V(i.target));
    },
    _removeClass: function (t, e, i) {
      return this._toggleClass(t, e, i, !1);
    },
    _addClass: function (t, e, i) {
      return this._toggleClass(t, e, i, !0);
    },
    _toggleClass: function (t, e, i, s) {
      var n = 'string' == typeof t || null === t,
        i = {
          extra: n ? e : i,
          keys: n ? t : e,
          element: n ? this.element : t,
          add: s = 'boolean' == typeof s ? s : i
        };
      return i.element.toggleClass(this._classes(i), s), this;
    },
    _on: function (n, o, t) {
      var a,
        r = this;
      'boolean' != typeof n && (t = o, o = n, n = !1), t ? (o = a = V(o), this.bindings = this.bindings.add(o)) : (t = o, o = this.element, a = this.widget()), V.each(t, function (t, e) {
        function i() {
          if (n || !0 !== r.options.disabled && !V(this).hasClass('ui-state-disabled')) return ('string' == typeof e ? r[e] : e).apply(r, arguments);
        }
        'string' != typeof e && (i.guid = e.guid = e.guid || i.guid || V.guid++);
        var s = t.match(/^([\w:-]*)\s*(.*)$/),
          t = s[1] + r.eventNamespace,
          s = s[2];
        s ? a.on(t, s, i) : o.on(t, i);
      });
    },
    _off: function (t, e) {
      ;
      e = (e || '').split(' ').join(this.eventNamespace + ' ') + this.eventNamespace, t.off(e), this.bindings = V(this.bindings.not(t).get()), this.focusable = V(this.focusable.not(t).get()), this.hoverable = V(this.hoverable.not(t).get());
    },
    _delay: function (t, e) {
      var i = this;
      return setTimeout(function () {
        return ('string' == typeof t ? i[t] : t).apply(i, arguments);
      }, e || 0);
    },
    _hoverable: function (t) {
      ;
      this.hoverable = this.hoverable.add(t), this._on(t, {
        mouseenter: function (t) {
          this._addClass(V(t.currentTarget), null, 'ui-state-hover');
        },
        mouseleave: function (t) {
          this._removeClass(V(t.currentTarget), null, 'ui-state-hover');
        }
      });
    },
    _focusable: function (t) {
      ;
      this.focusable = this.focusable.add(t), this._on(t, {
        focusin: function (t) {
          this._addClass(V(t.currentTarget), null, 'ui-state-focus');
        },
        focusout: function (t) {
          this._removeClass(V(t.currentTarget), null, 'ui-state-focus');
        }
      });
    },
    _trigger: function (t, e, i) {
      var s,
        n,
        o = this.options[t];
      if (i = i || {}, (e = V.Event(e)).type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), e.target = this.element[0], n = e.originalEvent) for (s in n) s in e || (e[s] = n[s]);
      return this.element.trigger(e, i), !('function' == typeof o && !1 === o.apply(this.element[0], [e].concat(i)) || e.isDefaultPrevented());
    }
  }, V.each({
    show: 'fadeIn',
    hide: 'fadeOut'
  }, function (o, a) {
    V.Widget.prototype['_' + o] = function (e, t, i) {
      var s,
        n = (t = 'string' == typeof t ? {
          effect: t
        } : t) ? !0 !== t && 'number' != typeof t && t.effect || a : o;
      'number' == typeof (t = t || {}) ? t = {
        duration: t
      } : !0 === t && (t = {}), s = !V.isEmptyObject(t), t.complete = i, t.delay && e.delay(t.delay), s && V.effects && V.effects.effect[n] ? e[o](t) : n !== o && e[n] ? e[n](t.duration, t.easing, i) : e.queue(function (t) {
        V(this)[o](), i && i.call(e[0]), t();
      });
    };
  });
  var s, x, k, o, l, h, c, u, C;
  V.widget;
  function D(t, e, i) {
    return [parseFloat(t[0]) * (u.test(t[0]) ? e / 100 : 1), parseFloat(t[1]) * (u.test(t[1]) ? i / 100 : 1)];
  }
  function I(t, e) {
    return parseInt(V.css(t, e), 10) || 0;
  }
  function T(t) {
    return null != t && t === t.window;
  }
  ;
  x = Math.max, k = Math.abs, o = /left|center|right/, l = /top|center|bottom/, h = /[\+\-]\d+(\.[\d]+)?%?/, c = /^\w+/, u = /%$/, C = V.fn.position, V.position = {
    scrollbarWidth: function () {
      if (void 0 !== s) return s;
      var t,
        e = V("<div style='display:block;position:absolute;width:200px;height:200px;overflow:hidden;'><div style='height:300px;width:auto;'></div></div>"),
        i = e.children()[0];
      return V('body').append(e), t = i.offsetWidth, e.css('overflow', 'scroll'), t === (i = i.offsetWidth) && (i = e[0].clientWidth), e.remove(), s = t - i;
    },
    getScrollInfo: function (t) {
      var e = t.isWindow || t.isDocument ? '' : t.element.css('overflow-x'),
        i = t.isWindow || t.isDocument ? '' : t.element.css('overflow-y'),
        e = 'scroll' === e || 'auto' === e && t.width < t.element[0].scrollWidth;
      return {
        width: 'scroll' === i || 'auto' === i && t.height < t.element[0].scrollHeight ? V.position.scrollbarWidth() : 0,
        height: e ? V.position.scrollbarWidth() : 0
      };
    },
    getWithinInfo: function (t) {
      var e = V(t || window),
        i = T(e[0]),
        s = !!e[0] && 9 === e[0].nodeType;
      return {
        element: e,
        isWindow: i,
        isDocument: s,
        offset: !i && !s ? V(t).offset() : {
          left: 0,
          top: 0
        },
        scrollLeft: e.scrollLeft(),
        scrollTop: e.scrollTop(),
        width: e.outerWidth(),
        height: e.outerHeight()
      };
    }
  }, V.fn.position = function (u) {
    if (!u || !u.of) return C.apply(this, arguments);
    var d,
      p,
      f,
      g,
      m,
      t,
      _ = 'string' == typeof (u = V.extend({}, u)).of ? V(document).find(u.of) : V(u.of),
      v = V.position.getWithinInfo(u.within),
      b = V.position.getScrollInfo(v),
      y = (u.collision || 'flip').split(' '),
      w = {},
      e = 9 === (t = (e = _)[0]).nodeType ? {
        width: e.width(),
        height: e.height(),
        offset: {
          top: 0,
          left: 0
        }
      } : T(t) ? {
        width: e.width(),
        height: e.height(),
        offset: {
          top: e.scrollTop(),
          left: e.scrollLeft()
        }
      } : t.preventDefault ? {
        width: 0,
        height: 0,
        offset: {
          top: t.pageY,
          left: t.pageX
        }
      } : {
        width: e.outerWidth(),
        height: e.outerHeight(),
        offset: e.offset()
      };
    return _[0].preventDefault && (u.at = 'left top'), p = e.width, f = e.height, m = V.extend({}, g = e.offset), V.each(['my', 'at'], function () {
      var t,
        e,
        i = (u[this] || '').split(' ');
      (i = 1 === i.length ? o.test(i[0]) ? i.concat(['center']) : l.test(i[0]) ? ['center'].concat(i) : ['center', 'center'] : i)[0] = o.test(i[0]) ? i[0] : 'center', i[1] = l.test(i[1]) ? i[1] : 'center', t = h.exec(i[0]), e = h.exec(i[1]), w[this] = [t ? t[0] : 0, e ? e[0] : 0], u[this] = [c.exec(i[0])[0], c.exec(i[1])[0]];
    }), 1 === y.length && (y[1] = y[0]), 'right' === u.at[0] ? m.left += p : 'center' === u.at[0] && (m.left += p / 2), 'bottom' === u.at[1] ? m.top += f : 'center' === u.at[1] && (m.top += f / 2), d = D(w.at, p, f), m.left += d[0], m.top += d[1], this.each(function () {
      var i,
        t,
        a = V(this),
        r = a.outerWidth(),
        l = a.outerHeight(),
        e = I(this, 'marginLeft'),
        s = I(this, 'marginTop'),
        n = r + e + I(this, 'marginRight') + b.width,
        o = l + s + I(this, 'marginBottom') + b.height,
        h = V.extend({}, m),
        c = D(w.my, a.outerWidth(), a.outerHeight());
      'right' === u.my[0] ? h.left -= r : 'center' === u.my[0] && (h.left -= r / 2), 'bottom' === u.my[1] ? h.top -= l : 'center' === u.my[1] && (h.top -= l / 2), h.left += c[0], h.top += c[1], i = {
        marginLeft: e,
        marginTop: s
      }, V.each(['left', 'top'], function (t, e) {
        V.ui.position[y[t]] && V.ui.position[y[t]][e](h, {
          targetWidth: p,
          targetHeight: f,
          elemWidth: r,
          elemHeight: l,
          collisionPosition: i,
          collisionWidth: n,
          collisionHeight: o,
          offset: [d[0] + c[0], d[1] + c[1]],
          my: u.my,
          at: u.at,
          within: v,
          elem: a
        });
      }), u.using && (t = function (t) {
        var e = g.left - h.left,
          i = e + p - r,
          s = g.top - h.top,
          n = s + f - l,
          o = {
            target: {
              element: _,
              left: g.left,
              top: g.top,
              width: p,
              height: f
            },
            element: {
              element: a,
              left: h.left,
              top: h.top,
              width: r,
              height: l
            },
            horizontal: i < 0 ? 'left' : 0 < e ? 'right' : 'center',
            vertical: n < 0 ? 'top' : 0 < s ? 'bottom' : 'middle'
          };
        p < r && k(e + i) < p && (o.horizontal = 'center'), f < l && k(s + n) < f && (o.vertical = 'middle'), x(k(e), k(i)) > x(k(s), k(n)) ? o.important = 'horizontal' : o.important = 'vertical', u.using.call(this, t, o);
      }), a.offset(V.extend(h, {
        using: t
      }));
    });
  }, V.ui.position = {
    fit: {
      left: function (t, e) {
        var i = e.within,
          s = i.isWindow ? i.scrollLeft : i.offset.left,
          n = i.width,
          o = t.left - e.collisionPosition.marginLeft,
          a = s - o,
          r = o + e.collisionWidth - n - s;
        e.collisionWidth > n ? 0 < a && r <= 0 ? (i = t.left + a + e.collisionWidth - n - s, t.left += a - i) : t.left = !(0 < r && a <= 0) && r < a ? s + n - e.collisionWidth : s : 0 < a ? t.left += a : 0 < r ? t.left -= r : t.left = x(t.left - o, t.left);
      },
      top: function (t, e) {
        var i = e.within,
          s = i.isWindow ? i.scrollTop : i.offset.top,
          n = e.within.height,
          o = t.top - e.collisionPosition.marginTop,
          a = s - o,
          r = o + e.collisionHeight - n - s;
        e.collisionHeight > n ? 0 < a && r <= 0 ? (i = t.top + a + e.collisionHeight - n - s, t.top += a - i) : t.top = !(0 < r && a <= 0) && r < a ? s + n - e.collisionHeight : s : 0 < a ? t.top += a : 0 < r ? t.top -= r : t.top = x(t.top - o, t.top);
      }
    },
    flip: {
      left: function (t, e) {
        var i = e.within,
          s = i.offset.left + i.scrollLeft,
          n = i.width,
          o = i.isWindow ? i.scrollLeft : i.offset.left,
          a = t.left - e.collisionPosition.marginLeft,
          r = a - o,
          l = a + e.collisionWidth - n - o,
          h = 'left' === e.my[0] ? -e.elemWidth : 'right' === e.my[0] ? e.elemWidth : 0,
          i = 'left' === e.at[0] ? e.targetWidth : 'right' === e.at[0] ? -e.targetWidth : 0,
          a = -2 * e.offset[0];
        r < 0 ? ((s = t.left + h + i + a + e.collisionWidth - n - s) < 0 || s < k(r)) && (t.left += h + i + a) : 0 < l && (0 < (o = t.left - e.collisionPosition.marginLeft + h + i + a - o) || k(o) < l) && (t.left += h + i + a);
      },
      top: function (t, e) {
        var i = e.within,
          s = i.offset.top + i.scrollTop,
          n = i.height,
          o = i.isWindow ? i.scrollTop : i.offset.top,
          a = t.top - e.collisionPosition.marginTop,
          r = a - o,
          l = a + e.collisionHeight - n - o,
          h = 'top' === e.my[1] ? -e.elemHeight : 'bottom' === e.my[1] ? e.elemHeight : 0,
          i = 'top' === e.at[1] ? e.targetHeight : 'bottom' === e.at[1] ? -e.targetHeight : 0,
          a = -2 * e.offset[1];
        r < 0 ? ((s = t.top + h + i + a + e.collisionHeight - n - s) < 0 || s < k(r)) && (t.top += h + i + a) : 0 < l && (0 < (o = t.top - e.collisionPosition.marginTop + h + i + a - o) || k(o) < l) && (t.top += h + i + a);
      }
    },
    flipfit: {
      left: function () {
        V.ui.position.flip.left.apply(this, arguments), V.ui.position.fit.left.apply(this, arguments);
      },
      top: function () {
        V.ui.position.flip.top.apply(this, arguments), V.ui.position.fit.top.apply(this, arguments);
      }
    }
  };
  V.ui.position, V.extend(V.expr.pseudos, {
    data: V.expr.createPseudo ? V.expr.createPseudo(function (e) {
      return function (t) {
        return !!V.data(t, e);
      };
    }) : function (t, e, i) {
      return !!V.data(t, i[3]);
    }
  }), V.fn.extend({
    disableSelection: (t = 'onselectstart' in document.createElement('div') ? 'selectstart' : 'mousedown', function () {
      return this.on(t + '.ui-disableSelection', function (t) {
        t.preventDefault();
      });
    }),
    enableSelection: function () {
      return this.off('.ui-disableSelection');
    }
  });
  var t,
    d = V,
    p = {},
    e = p.toString,
    f = /^([\-+])=\s*(\d+\.?\d*)/,
    g = [{
      re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
      parse: function (t) {
        return [t[1], t[2], t[3], t[4]];
      }
    }, {
      re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
      parse: function (t) {
        return [2.55 * t[1], 2.55 * t[2], 2.55 * t[3], t[4]];
      }
    }, {
      re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?/,
      parse: function (t) {
        return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16), t[4] ? (parseInt(t[4], 16) / 255).toFixed(2) : 1];
      }
    }, {
      re: /#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?/,
      parse: function (t) {
        return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16), t[4] ? (parseInt(t[4] + t[4], 16) / 255).toFixed(2) : 1];
      }
    }, {
      re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
      space: 'hsla',
      parse: function (t) {
        return [t[1], t[2] / 100, t[3] / 100, t[4]];
      }
    }],
    m = d.Color = function (t, e, i, s) {
      return new d.Color.fn.parse(t, e, i, s);
    },
    _ = {
      rgba: {
        props: {
          red: {
            idx: 0,
            type: 'byte'
          },
          green: {
            idx: 1,
            type: 'byte'
          },
          blue: {
            idx: 2,
            type: 'byte'
          }
        }
      },
      hsla: {
        props: {
          hue: {
            idx: 0,
            type: 'degrees'
          },
          saturation: {
            idx: 1,
            type: 'percent'
          },
          lightness: {
            idx: 2,
            type: 'percent'
          }
        }
      }
    },
    v = {
      byte: {
        floor: !0,
        max: 255
      },
      percent: {
        max: 1
      },
      degrees: {
        mod: 360,
        floor: !0
      }
    },
    b = m.support = {},
    y = d('<p>')[0],
    w = d.each;
  function P(t) {
    return null == t ? t + '' : 'object' == typeof t ? p[e.call(t)] || 'object' : typeof t;
  }
  function M(t, e, i) {
    var s = v[e.type] || {};
    return null == t ? i || !e.def ? null : e.def : (t = s.floor ? ~~t : parseFloat(t), isNaN(t) ? e.def : s.mod ? (t + s.mod) % s.mod : Math.min(s.max, Math.max(0, t)));
  }
  function S(s) {
    var n = m(),
      o = n._rgba = [];
    return s = s.toLowerCase(), w(g, function (t, e) {
      var i = e.re.exec(s),
        i = i && e.parse(i),
        e = e.space || 'rgba';
      if (i) return i = n[e](i), n[_[e].cache] = i[_[e].cache], o = n._rgba = i._rgba, !1;
    }), o.length ? ('0,0,0,0' === o.join() && d.extend(o, B.transparent), n) : B[s];
  }
  function H(t, e, i) {
    return 6 * (i = (i + 1) % 1) < 1 ? t + (e - t) * i * 6 : 2 * i < 1 ? e : 3 * i < 2 ? t + (e - t) * (2 / 3 - i) * 6 : t;
  }
  ;
  y.style.cssText = 'background-color:rgba(1,1,1,.5)', b.rgba = -1 < y.style.backgroundColor.indexOf('rgba'), w(_, function (t, e) {
    ;
    e.cache = '_' + t, e.props.alpha = {
      idx: 3,
      type: 'percent',
      def: 1
    };
  }), d.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '), function (t, e) {
    p['[object ' + e + ']'] = e.toLowerCase();
  }), (m.fn = d.extend(m.prototype, {
    parse: function (n, t, e, i) {
      if (void 0 === n) return this._rgba = [null, null, null, null], this;
      (n.jquery || n.nodeType) && (n = d(n).css(t), t = void 0);
      var o = this,
        s = P(n),
        a = this._rgba = [];
      return void 0 !== t && (n = [n, t, e, i], s = 'array'), 'string' === s ? this.parse(S(n) || B._default) : 'array' === s ? (w(_.rgba.props, function (t, e) {
        a[e.idx] = M(n[e.idx], e);
      }), this) : 'object' === s ? (w(_, n instanceof m ? function (t, e) {
        n[e.cache] && (o[e.cache] = n[e.cache].slice());
      } : function (t, i) {
        var s = i.cache;
        w(i.props, function (t, e) {
          if (!o[s] && i.to) {
            if ('alpha' === t || null == n[t]) return;
            o[s] = i.to(o._rgba);
          }
          o[s][e.idx] = M(n[t], e, !0);
        }), o[s] && d.inArray(null, o[s].slice(0, 3)) < 0 && (null == o[s][3] && (o[s][3] = 1), i.from && (o._rgba = i.from(o[s])));
      }), this) : void 0;
    },
    is: function (t) {
      var n = m(t),
        o = !0,
        a = this;
      return w(_, function (t, e) {
        var i,
          s = n[e.cache];
        return s && (i = a[e.cache] || e.to && e.to(a._rgba) || [], w(e.props, function (t, e) {
          if (null != s[e.idx]) return o = s[e.idx] === i[e.idx];
        })), o;
      }), o;
    },
    _space: function () {
      var i = [],
        s = this;
      return w(_, function (t, e) {
        s[e.cache] && i.push(t);
      }), i.pop();
    },
    transition: function (t, a) {
      var e = (h = m(t))._space(),
        i = _[e],
        t = 0 === this.alpha() ? m('transparent') : this,
        r = t[i.cache] || i.to(t._rgba),
        l = r.slice(),
        h = h[i.cache];
      return w(i.props, function (t, e) {
        var i = e.idx,
          s = r[i],
          n = h[i],
          o = v[e.type] || {};
        null !== n && (null === s ? l[i] = n : (o.mod && (n - s > o.mod / 2 ? s += o.mod : s - n > o.mod / 2 && (s -= o.mod)), l[i] = M((n - s) * a + s, e)));
      }), this[e](l);
    },
    blend: function (t) {
      if (1 === this._rgba[3]) return this;
      var e = this._rgba.slice(),
        i = e.pop(),
        s = m(t)._rgba;
      return m(d.map(e, function (t, e) {
        return (1 - i) * s[e] + i * t;
      }));
    },
    toRgbaString: function () {
      var t = 'rgba(',
        e = d.map(this._rgba, function (t, e) {
          return null != t ? t : 2 < e ? 1 : 0;
        });
      return 1 === e[3] && (e.pop(), t = 'rgb('), t + e.join() + ')';
    },
    toHslaString: function () {
      var t = 'hsla(',
        e = d.map(this.hsla(), function (t, e) {
          return null == t && (t = 2 < e ? 1 : 0), t = e && e < 3 ? Math.round(100 * t) + '%' : t;
        });
      return 1 === e[3] && (e.pop(), t = 'hsl('), t + e.join() + ')';
    },
    toHexString: function (t) {
      var e = this._rgba.slice(),
        i = e.pop();
      return t && e.push(~~(255 * i)), '#' + d.map(e, function (t) {
        return 1 === (t = (t || 0).toString(16)).length ? '0' + t : t;
      }).join('');
    },
    toString: function () {
      return 0 === this._rgba[3] ? 'transparent' : this.toRgbaString();
    }
  })).parse.prototype = m.fn, _.hsla.to = function (t) {
    if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];
    var e = t[0] / 255,
      i = t[1] / 255,
      s = t[2] / 255,
      n = t[3],
      o = Math.max(e, i, s),
      a = Math.min(e, i, s),
      r = o - a,
      l = o + a,
      t = 0.5 * l,
      i = a === o ? 0 : e === o ? 60 * (i - s) / r + 360 : i === o ? 60 * (s - e) / r + 120 : 60 * (e - i) / r + 240,
      l = 0 == r ? 0 : t <= 0.5 ? r / l : r / (2 - l);
    return [Math.round(i) % 360, l, t, null == n ? 1 : n];
  }, _.hsla.from = function (t) {
    if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];
    var e = t[0] / 360,
      i = t[1],
      s = t[2],
      t = t[3],
      i = s <= 0.5 ? s * (1 + i) : s + i - s * i,
      s = 2 * s - i;
    return [Math.round(255 * H(s, i, e + 1 / 3)), Math.round(255 * H(s, i, e)), Math.round(255 * H(s, i, e - 1 / 3)), t];
  }, w(_, function (l, t) {
    var e = t.props,
      o = t.cache,
      a = t.to,
      r = t.from;
    m.fn[l] = function (t) {
      if (a && !this[o] && (this[o] = a(this._rgba)), void 0 === t) return this[o].slice();
      var i = P(t),
        s = 'array' === i || 'object' === i ? t : arguments,
        n = this[o].slice();
      return w(e, function (t, e) {
        t = s['object' === i ? t : e.idx];
        null == t && (t = n[e.idx]), n[e.idx] = M(t, e);
      }), r ? ((t = m(r(n)))[o] = n, t) : m(n);
    }, w(e, function (a, r) {
      m.fn[a] || (m.fn[a] = function (t) {
        var e,
          i = P(t),
          s = 'alpha' === a ? this._hsla ? 'hsla' : 'rgba' : l,
          n = this[s](),
          o = n[r.idx];
        return 'undefined' === i ? o : ('function' === i && (i = P(t = t.call(this, o))), null == t && r.empty ? this : ('string' === i && (e = f.exec(t)) && (t = o + parseFloat(e[2]) * ('+' === e[1] ? 1 : -1)), n[r.idx] = t, this[s](n)));
      });
    });
  }), (m.hook = function (t) {
    t = t.split(' ');
    w(t, function (t, o) {
      ;
      d.cssHooks[o] = {
        set: function (t, e) {
          var i,
            s,
            n = '';
          if ('transparent' !== e && ('string' !== P(e) || (i = S(e)))) {
            if (e = m(i || e), !b.rgba && 1 !== e._rgba[3]) {
              for (s = 'backgroundColor' === o ? t.parentNode : t; ('' === n || 'transparent' === n) && s && s.style;) try {
                ;
                n = d.css(s, 'backgroundColor'), s = s.parentNode;
              } catch (t) {}
              e = e.blend(n && 'transparent' !== n ? n : '_default');
            }
            e = e.toRgbaString();
          }
          try {
            t.style[o] = e;
          } catch (t) {}
        }
      }, d.fx.step[o] = function (t) {
        t.colorInit || (t.start = m(t.elem, o), t.end = m(t.end), t.colorInit = !0), d.cssHooks[o].set(t.elem, t.start.transition(t.end, t.pos));
      };
    });
  })('backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor'), d.cssHooks.borderColor = {
    expand: function (i) {
      var s = {};
      return w(['Top', 'Right', 'Bottom', 'Left'], function (t, e) {
        s['border' + e + 'Color'] = i;
      }), s;
    }
  };
  var z,
    A,
    O,
    N,
    E,
    W,
    F,
    L,
    R,
    Y,
    B = d.Color.names = {
      aqua: '#00ffff',
      black: '#000000',
      blue: '#0000ff',
      fuchsia: '#ff00ff',
      gray: '#808080',
      green: '#008000',
      lime: '#00ff00',
      maroon: '#800000',
      navy: '#000080',
      olive: '#808000',
      purple: '#800080',
      red: '#ff0000',
      silver: '#c0c0c0',
      teal: '#008080',
      white: '#ffffff',
      yellow: '#ffff00',
      transparent: [null, null, null, 0],
      _default: '#ffffff'
    },
    j = 'ui-effects-',
    q = 'ui-effects-style',
    K = 'ui-effects-animated';
  function U(t) {
    var e,
      i,
      s = t.ownerDocument.defaultView ? t.ownerDocument.defaultView.getComputedStyle(t, null) : t.currentStyle,
      n = {};
    if (s && s.length && s[0] && s[s[0]]) for (i = s.length; i--;) 'string' == typeof s[e = s[i]] && (n[e.replace(/-([\da-z])/gi, function (t, e) {
      return e.toUpperCase();
    })] = s[e]);else for (e in s) 'string' == typeof s[e] && (n[e] = s[e]);
    return n;
  }
  function X(t, e, i, s) {
    return t = {
      effect: t = V.isPlainObject(t) ? (e = t).effect : t
    }, 'function' == typeof (e = null == e ? {} : e) && (s = e, i = null, e = {}), 'number' != typeof e && !V.fx.speeds[e] || (s = i, i = e, e = {}), 'function' == typeof i && (s = i, i = null), e && V.extend(t, e), i = i || e.duration, t.duration = V.fx.off ? 0 : 'number' == typeof i ? i : i in V.fx.speeds ? V.fx.speeds[i] : V.fx.speeds._default, t.complete = s || e.complete, t;
  }
  function $(t) {
    return !t || 'number' == typeof t || V.fx.speeds[t] || 'string' == typeof t && !V.effects.effect[t] || 'function' == typeof t || 'object' == typeof t && !t.effect;
  }
  function G(t, e) {
    var i = e.outerWidth(),
      e = e.outerHeight(),
      t = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/.exec(t) || ['', 0, i, e, 0];
    return {
      top: parseFloat(t[1]) || 0,
      right: 'auto' === t[2] ? i : parseFloat(t[2]),
      bottom: 'auto' === t[3] ? e : parseFloat(t[3]),
      left: parseFloat(t[4]) || 0
    };
  }
  ;
  V.effects = {
    effect: {}
  }, N = ['add', 'remove', 'toggle'], E = {
    border: 1,
    borderBottom: 1,
    borderColor: 1,
    borderLeft: 1,
    borderRight: 1,
    borderTop: 1,
    borderWidth: 1,
    margin: 1,
    padding: 1
  }, V.each(['borderLeftStyle', 'borderRightStyle', 'borderBottomStyle', 'borderTopStyle'], function (t, e) {
    V.fx.step[e] = function (t) {
      ;
      ('none' !== t.end && !t.setAttr || 1 === t.pos && !t.setAttr) && (d.style(t.elem, e, t.end), t.setAttr = !0);
    };
  }), V.fn.addBack || (V.fn.addBack = function (t) {
    return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
  }), V.effects.animateClass = function (n, t, e, i) {
    var o = V.speed(t, e, i);
    return this.queue(function () {
      var i = V(this),
        t = i.attr('class') || '',
        e = (e = o.children ? i.find('*').addBack() : i).map(function () {
          return {
            el: V(this),
            start: U(this)
          };
        }),
        s = function () {
          V.each(N, function (t, e) {
            n[e] && i[e + 'Class'](n[e]);
          });
        };
      s(), e = e.map(function () {
        return this.end = U(this.el[0]), this.diff = function (t, e) {
          var i,
            s,
            n = {};
          for (i in e) s = e[i], t[i] !== s && (E[i] || !V.fx.step[i] && isNaN(parseFloat(s)) || (n[i] = s));
          return n;
        }(this.start, this.end), this;
      }), i.attr('class', t), e = e.map(function () {
        var t = this,
          e = V.Deferred(),
          i = V.extend({}, o, {
            queue: !1,
            complete: function () {
              e.resolve(t);
            }
          });
        return this.el.animate(this.diff, i), e.promise();
      }), V.when.apply(V, e.get()).done(function () {
        s(), V.each(arguments, function () {
          var e = this.el;
          V.each(this.diff, function (t) {
            e.css(t, '');
          });
        }), o.complete.call(i[0]);
      });
    });
  }, V.fn.extend({
    addClass: (O = V.fn.addClass, function (t, e, i, s) {
      return e ? V.effects.animateClass.call(this, {
        add: t
      }, e, i, s) : O.apply(this, arguments);
    }),
    removeClass: (A = V.fn.removeClass, function (t, e, i, s) {
      return 1 < arguments.length ? V.effects.animateClass.call(this, {
        remove: t
      }, e, i, s) : A.apply(this, arguments);
    }),
    toggleClass: (z = V.fn.toggleClass, function (t, e, i, s, n) {
      return 'boolean' == typeof e || void 0 === e ? i ? V.effects.animateClass.call(this, e ? {
        add: t
      } : {
        remove: t
      }, i, s, n) : z.apply(this, arguments) : V.effects.animateClass.call(this, {
        toggle: t
      }, e, i, s);
    }),
    switchClass: function (t, e, i, s, n) {
      return V.effects.animateClass.call(this, {
        add: e,
        remove: t
      }, i, s, n);
    }
  }), V.expr && V.expr.pseudos && V.expr.pseudos.animated && (V.expr.pseudos.animated = (W = V.expr.pseudos.animated, function (t) {
    return !!V(t).data(K) || W(t);
  })), !1 !== V.uiBackCompat && V.extend(V.effects, {
    save: function (t, e) {
      for (var i = 0, s = e.length; i < s; i++) null !== e[i] && t.data(j + e[i], t[0].style[e[i]]);
    },
    restore: function (t, e) {
      for (var i, s = 0, n = e.length; s < n; s++) null !== e[s] && (i = t.data(j + e[s]), t.css(e[s], i));
    },
    setMode: function (t, e) {
      return e = 'toggle' === e ? t.is(':hidden') ? 'show' : 'hide' : e;
    },
    createWrapper: function (i) {
      if (i.parent().is('.ui-effects-wrapper')) return i.parent();
      var s = {
          width: i.outerWidth(!0),
          height: i.outerHeight(!0),
          float: i.css('float')
        },
        t = V('<div></div>').addClass('ui-effects-wrapper').css({
          fontSize: '100%',
          background: 'transparent',
          border: 'none',
          margin: 0,
          padding: 0
        }),
        e = {
          width: i.width(),
          height: i.height()
        },
        n = document.activeElement;
      try {
        n.id;
      } catch (t) {
        n = document.body;
      }
      return i.wrap(t), i[0] !== n && !V.contains(i[0], n) || V(n).trigger('focus'), t = i.parent(), 'static' === i.css('position') ? (t.css({
        position: 'relative'
      }), i.css({
        position: 'relative'
      })) : (V.extend(s, {
        position: i.css('position'),
        zIndex: i.css('z-index')
      }), V.each(['top', 'left', 'bottom', 'right'], function (t, e) {
        ;
        s[e] = i.css(e), isNaN(parseInt(s[e], 10)) && (s[e] = 'auto');
      }), i.css({
        position: 'relative',
        top: 0,
        left: 0,
        right: 'auto',
        bottom: 'auto'
      })), i.css(e), t.css(s).show();
    },
    removeWrapper: function (t) {
      var e = document.activeElement;
      return t.parent().is('.ui-effects-wrapper') && (t.parent().replaceWith(t), t[0] !== e && !V.contains(t[0], e) || V(e).trigger('focus')), t;
    }
  }), V.extend(V.effects, {
    version: '1.13.1',
    define: function (t, e, i) {
      return i || (i = e, e = 'effect'), V.effects.effect[t] = i, V.effects.effect[t].mode = e, i;
    },
    scaledDimensions: function (t, e, i) {
      if (0 === e) return {
        height: 0,
        width: 0,
        outerHeight: 0,
        outerWidth: 0
      };
      var s = 'horizontal' !== i ? (e || 100) / 100 : 1,
        e = 'vertical' !== i ? (e || 100) / 100 : 1;
      return {
        height: t.height() * e,
        width: t.width() * s,
        outerHeight: t.outerHeight() * e,
        outerWidth: t.outerWidth() * s
      };
    },
    clipToBox: function (t) {
      return {
        width: t.clip.right - t.clip.left,
        height: t.clip.bottom - t.clip.top,
        left: t.clip.left,
        top: t.clip.top
      };
    },
    unshift: function (t, e, i) {
      var s = t.queue();
      1 < e && s.splice.apply(s, [1, 0].concat(s.splice(e, i))), t.dequeue();
    },
    saveStyle: function (t) {
      t.data(q, t[0].style.cssText);
    },
    restoreStyle: function (t) {
      ;
      t[0].style.cssText = t.data(q) || '', t.removeData(q);
    },
    mode: function (t, e) {
      t = t.is(':hidden');
      return 'toggle' === e && (e = t ? 'show' : 'hide'), e = (t ? 'hide' === e : 'show' === e) ? 'none' : e;
    },
    getBaseline: function (t, e) {
      var i, s;
      switch (t[0]) {
        case 'top':
          i = 0;
          break;
        case 'middle':
          i = 0.5;
          break;
        case 'bottom':
          i = 1;
          break;
        default:
          i = t[0] / e.height;
      }
      switch (t[1]) {
        case 'left':
          s = 0;
          break;
        case 'center':
          s = 0.5;
          break;
        case 'right':
          s = 1;
          break;
        default:
          s = t[1] / e.width;
      }
      return {
        x: s,
        y: i
      };
    },
    createPlaceholder: function (t) {
      var e,
        i = t.css('position'),
        s = t.position();
      return t.css({
        marginTop: t.css('marginTop'),
        marginBottom: t.css('marginBottom'),
        marginLeft: t.css('marginLeft'),
        marginRight: t.css('marginRight')
      }).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()), /^(static|relative)/.test(i) && (i = 'absolute', e = V('<' + t[0].nodeName + '>').insertAfter(t).css({
        display: /^(inline|ruby)/.test(t.css('display')) ? 'inline-block' : 'block',
        visibility: 'hidden',
        marginTop: t.css('marginTop'),
        marginBottom: t.css('marginBottom'),
        marginLeft: t.css('marginLeft'),
        marginRight: t.css('marginRight'),
        float: t.css('float')
      }).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).addClass('ui-effects-placeholder'), t.data(j + 'placeholder', e)), t.css({
        position: i,
        left: s.left,
        top: s.top
      }), e;
    },
    removePlaceholder: function (t) {
      var e = j + 'placeholder',
        i = t.data(e);
      i && (i.remove(), t.removeData(e));
    },
    cleanUp: function (t) {
      V.effects.restoreStyle(t), V.effects.removePlaceholder(t);
    },
    setTransition: function (s, t, n, o) {
      return o = o || {}, V.each(t, function (t, e) {
        var i = s.cssUnit(e);
        0 < i[0] && (o[e] = i[0] * n + i[1]);
      }), o;
    }
  }), V.fn.extend({
    effect: function () {
      function t(t) {
        var e = V(this),
          i = V.effects.mode(e, r) || o;
        e.data(K, !0), l.push(i), o && ('show' === i || i === o && 'hide' === i) && e.show(), o && 'none' === i || V.effects.saveStyle(e), 'function' == typeof t && t();
      }
      var s = X.apply(this, arguments),
        n = V.effects.effect[s.effect],
        o = n.mode,
        e = s.queue,
        i = e || 'fx',
        a = s.complete,
        r = s.mode,
        l = [];
      return V.fx.off || !n ? r ? this[r](s.duration, a) : this.each(function () {
        a && a.call(this);
      }) : !1 === e ? this.each(t).each(h) : this.queue(i, t).queue(i, h);
      function h(t) {
        var e = V(this);
        function i() {
          'function' == typeof a && a.call(e[0]), 'function' == typeof t && t();
        }
        ;
        s.mode = l.shift(), !1 === V.uiBackCompat || o ? 'none' === s.mode ? (e[r](), i()) : n.call(e[0], s, function () {
          e.removeData(K), V.effects.cleanUp(e), 'hide' === s.mode && e.hide(), i();
        }) : (e.is(':hidden') ? 'hide' === r : 'show' === r) ? (e[r](), i()) : n.call(e[0], s, i);
      }
    },
    show: (R = V.fn.show, function (t) {
      if ($(t)) return R.apply(this, arguments);
      t = X.apply(this, arguments);
      return t.mode = 'show', this.effect.call(this, t);
    }),
    hide: (L = V.fn.hide, function (t) {
      if ($(t)) return L.apply(this, arguments);
      t = X.apply(this, arguments);
      return t.mode = 'hide', this.effect.call(this, t);
    }),
    toggle: (F = V.fn.toggle, function (t) {
      if ($(t) || 'boolean' == typeof t) return F.apply(this, arguments);
      t = X.apply(this, arguments);
      return t.mode = 'toggle', this.effect.call(this, t);
    }),
    cssUnit: function (t) {
      var i = this.css(t),
        s = [];
      return V.each(['em', 'px', '%', 'pt'], function (t, e) {
        0 < i.indexOf(e) && (s = [parseFloat(i), e]);
      }), s;
    },
    cssClip: function (t) {
      return t ? this.css('clip', 'rect(' + t.top + 'px ' + t.right + 'px ' + t.bottom + 'px ' + t.left + 'px)') : G(this.css('clip'), this);
    },
    transfer: function (t, e) {
      var i = V(this),
        s = V(t.to),
        n = 'fixed' === s.css('position'),
        o = V('body'),
        a = n ? o.scrollTop() : 0,
        r = n ? o.scrollLeft() : 0,
        o = s.offset(),
        o = {
          top: o.top - a,
          left: o.left - r,
          height: s.innerHeight(),
          width: s.innerWidth()
        },
        s = i.offset(),
        l = V("<div class='ui-effects-transfer'></div>");
      l.appendTo('body').addClass(t.className).css({
        top: s.top - a,
        left: s.left - r,
        height: i.innerHeight(),
        width: i.innerWidth(),
        position: n ? 'fixed' : 'absolute'
      }).animate(o, t.duration, t.easing, function () {
        l.remove(), 'function' == typeof e && e();
      });
    }
  }), V.fx.step.clip = function (t) {
    t.clipInit || (t.start = V(t.elem).cssClip(), 'string' == typeof t.end && (t.end = G(t.end, t.elem)), t.clipInit = !0), V(t.elem).cssClip({
      top: t.pos * (t.end.top - t.start.top) + t.start.top,
      right: t.pos * (t.end.right - t.start.right) + t.start.right,
      bottom: t.pos * (t.end.bottom - t.start.bottom) + t.start.bottom,
      left: t.pos * (t.end.left - t.start.left) + t.start.left
    });
  }, Y = {}, V.each(['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'], function (e, t) {
    Y[t] = function (t) {
      return Math.pow(t, e + 2);
    };
  }), V.extend(Y, {
    Sine: function (t) {
      return 1 - Math.cos(t * Math.PI / 2);
    },
    Circ: function (t) {
      return 1 - Math.sqrt(1 - t * t);
    },
    Elastic: function (t) {
      return 0 === t || 1 === t ? t : -Math.pow(2, 8 * (t - 1)) * Math.sin((80 * (t - 1) - 7.5) * Math.PI / 15);
    },
    Back: function (t) {
      return t * t * (3 * t - 2);
    },
    Bounce: function (t) {
      for (var e, i = 4; t < ((e = Math.pow(2, --i)) - 1) / 11;);
      return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2);
    }
  }), V.each(Y, function (t, e) {
    ;
    V.easing['easeIn' + t] = e, V.easing['easeOut' + t] = function (t) {
      return 1 - e(1 - t);
    }, V.easing['easeInOut' + t] = function (t) {
      return t < 0.5 ? e(2 * t) / 2 : 1 - e(-2 * t + 2) / 2;
    };
  });
  y = V.effects, V.effects.define('blind', 'hide', function (t, e) {
    var i = {
        up: ['bottom', 'top'],
        vertical: ['bottom', 'top'],
        down: ['top', 'bottom'],
        left: ['right', 'left'],
        horizontal: ['right', 'left'],
        right: ['left', 'right']
      },
      s = V(this),
      n = t.direction || 'up',
      o = s.cssClip(),
      a = {
        clip: V.extend({}, o)
      },
      r = V.effects.createPlaceholder(s);
    a.clip[i[n][0]] = a.clip[i[n][1]], 'show' === t.mode && (s.cssClip(a.clip), r && r.css(V.effects.clipToBox(a)), a.clip = o), r && r.animate(V.effects.clipToBox(a), t.duration, t.easing), s.animate(a, {
      queue: !1,
      duration: t.duration,
      easing: t.easing,
      complete: e
    });
  }), V.effects.define('bounce', function (t, e) {
    var i,
      s,
      n = V(this),
      o = t.mode,
      a = 'hide' === o,
      r = 'show' === o,
      l = t.direction || 'up',
      h = t.distance,
      c = t.times || 5,
      o = 2 * c + (r || a ? 1 : 0),
      u = t.duration / o,
      d = t.easing,
      p = 'up' === l || 'down' === l ? 'top' : 'left',
      f = 'up' === l || 'left' === l,
      g = 0,
      t = n.queue().length;
    for (V.effects.createPlaceholder(n), l = n.css(p), h = h || n['top' == p ? 'outerHeight' : 'outerWidth']() / 3, r && ((s = {
      opacity: 1
    })[p] = l, n.css('opacity', 0).css(p, f ? 2 * -h : 2 * h).animate(s, u, d)), a && (h /= Math.pow(2, c - 1)), (s = {})[p] = l; g < c; g++) (i = {})[p] = (f ? '-=' : '+=') + h, n.animate(i, u, d).animate(s, u, d), h = a ? 2 * h : h / 2;
    a && ((i = {
      opacity: 0
    })[p] = (f ? '-=' : '+=') + h, n.animate(i, u, d)), n.queue(e), V.effects.unshift(n, t, 1 + o);
  }), V.effects.define('clip', 'hide', function (t, e) {
    var i = {},
      s = V(this),
      n = t.direction || 'vertical',
      o = 'both' === n,
      a = o || 'horizontal' === n,
      o = o || 'vertical' === n,
      n = s.cssClip();
    i.clip = {
      top: o ? (n.bottom - n.top) / 2 : n.top,
      right: a ? (n.right - n.left) / 2 : n.right,
      bottom: o ? (n.bottom - n.top) / 2 : n.bottom,
      left: a ? (n.right - n.left) / 2 : n.left
    }, V.effects.createPlaceholder(s), 'show' === t.mode && (s.cssClip(i.clip), i.clip = n), s.animate(i, {
      queue: !1,
      duration: t.duration,
      easing: t.easing,
      complete: e
    });
  }), V.effects.define('drop', 'hide', function (t, e) {
    var i = V(this),
      s = 'show' === t.mode,
      n = t.direction || 'left',
      o = 'up' === n || 'down' === n ? 'top' : 'left',
      a = 'up' === n || 'left' === n ? '-=' : '+=',
      r = '+=' == a ? '-=' : '+=',
      l = {
        opacity: 0
      };
    V.effects.createPlaceholder(i), n = t.distance || i['top' == o ? 'outerHeight' : 'outerWidth'](!0) / 2, l[o] = a + n, s && (i.css(l), l[o] = r + n, l.opacity = 1), i.animate(l, {
      queue: !1,
      duration: t.duration,
      easing: t.easing,
      complete: e
    });
  }), V.effects.define('explode', 'hide', function (t, e) {
    var i,
      s,
      n,
      o,
      a,
      r,
      l = t.pieces ? Math.round(Math.sqrt(t.pieces)) : 3,
      h = l,
      c = V(this),
      u = 'show' === t.mode,
      d = c.show().css('visibility', 'hidden').offset(),
      p = Math.ceil(c.outerWidth() / h),
      f = Math.ceil(c.outerHeight() / l),
      g = [];
    function m() {
      g.push(this), g.length === l * h && (c.css({
        visibility: 'visible'
      }), V(g).remove(), e());
    }
    for (i = 0; i < l; i++) for (o = d.top + i * f, r = i - (l - 1) / 2, s = 0; s < h; s++) n = d.left + s * p, a = s - (h - 1) / 2, c.clone().appendTo('body').wrap('<div></div>').css({
      position: 'absolute',
      visibility: 'visible',
      left: -s * p,
      top: -i * f
    }).parent().addClass('ui-effects-explode').css({
      position: 'absolute',
      overflow: 'hidden',
      width: p,
      height: f,
      left: n + (u ? a * p : 0),
      top: o + (u ? r * f : 0),
      opacity: u ? 0 : 1
    }).animate({
      left: n + (u ? 0 : a * p),
      top: o + (u ? 0 : r * f),
      opacity: u ? 1 : 0
    }, t.duration || 500, t.easing, m);
  }), V.effects.define('fade', 'toggle', function (t, e) {
    var i = 'show' === t.mode;
    V(this).css('opacity', i ? 0 : 1).animate({
      opacity: i ? 1 : 0
    }, {
      queue: !1,
      duration: t.duration,
      easing: t.easing,
      complete: e
    });
  }), V.effects.define('fold', 'hide', function (e, t) {
    var i = V(this),
      s = e.mode,
      n = 'show' === s,
      o = 'hide' === s,
      a = e.size || 15,
      r = /([0-9]+)%/.exec(a),
      l = !!e.horizFirst ? ['right', 'bottom'] : ['bottom', 'right'],
      h = e.duration / 2,
      c = V.effects.createPlaceholder(i),
      u = i.cssClip(),
      d = {
        clip: V.extend({}, u)
      },
      p = {
        clip: V.extend({}, u)
      },
      f = [u[l[0]], u[l[1]]],
      s = i.queue().length;
    r && (a = parseInt(r[1], 10) / 100 * f[o ? 0 : 1]), d.clip[l[0]] = a, p.clip[l[0]] = a, p.clip[l[1]] = 0, n && (i.cssClip(p.clip), c && c.css(V.effects.clipToBox(p)), p.clip = u), i.queue(function (t) {
      c && c.animate(V.effects.clipToBox(d), h, e.easing).animate(V.effects.clipToBox(p), h, e.easing), t();
    }).animate(d, h, e.easing).animate(p, h, e.easing).queue(t), V.effects.unshift(i, s, 4);
  }), V.effects.define('highlight', 'show', function (t, e) {
    var i = V(this),
      s = {
        backgroundColor: i.css('backgroundColor')
      };
    'hide' === t.mode && (s.opacity = 0), V.effects.saveStyle(i), i.css({
      backgroundImage: 'none',
      backgroundColor: t.color || '#ffff99'
    }).animate(s, {
      queue: !1,
      duration: t.duration,
      easing: t.easing,
      complete: e
    });
  }), V.effects.define('size', function (s, e) {
    var n,
      i = V(this),
      t = ['fontSize'],
      o = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom'],
      a = ['borderLeftWidth', 'borderRightWidth', 'paddingLeft', 'paddingRight'],
      r = s.mode,
      l = 'effect' !== r,
      h = s.scale || 'both',
      c = s.origin || ['middle', 'center'],
      u = i.css('position'),
      d = i.position(),
      p = V.effects.scaledDimensions(i),
      f = s.from || p,
      g = s.to || V.effects.scaledDimensions(i, 0);
    V.effects.createPlaceholder(i), 'show' === r && (r = f, f = g, g = r), n = {
      from: {
        y: f.height / p.height,
        x: f.width / p.width
      },
      to: {
        y: g.height / p.height,
        x: g.width / p.width
      }
    }, 'box' !== h && 'both' !== h || (n.from.y !== n.to.y && (f = V.effects.setTransition(i, o, n.from.y, f), g = V.effects.setTransition(i, o, n.to.y, g)), n.from.x !== n.to.x && (f = V.effects.setTransition(i, a, n.from.x, f), g = V.effects.setTransition(i, a, n.to.x, g))), 'content' !== h && 'both' !== h || n.from.y !== n.to.y && (f = V.effects.setTransition(i, t, n.from.y, f), g = V.effects.setTransition(i, t, n.to.y, g)), c && (c = V.effects.getBaseline(c, p), f.top = (p.outerHeight - f.outerHeight) * c.y + d.top, f.left = (p.outerWidth - f.outerWidth) * c.x + d.left, g.top = (p.outerHeight - g.outerHeight) * c.y + d.top, g.left = (p.outerWidth - g.outerWidth) * c.x + d.left), delete f.outerHeight, delete f.outerWidth, i.css(f), 'content' !== h && 'both' !== h || (o = o.concat(['marginTop', 'marginBottom']).concat(t), a = a.concat(['marginLeft', 'marginRight']), i.find('*[width]').each(function () {
      var t = V(this),
        e = V.effects.scaledDimensions(t),
        i = {
          height: e.height * n.from.y,
          width: e.width * n.from.x,
          outerHeight: e.outerHeight * n.from.y,
          outerWidth: e.outerWidth * n.from.x
        },
        e = {
          height: e.height * n.to.y,
          width: e.width * n.to.x,
          outerHeight: e.height * n.to.y,
          outerWidth: e.width * n.to.x
        };
      n.from.y !== n.to.y && (i = V.effects.setTransition(t, o, n.from.y, i), e = V.effects.setTransition(t, o, n.to.y, e)), n.from.x !== n.to.x && (i = V.effects.setTransition(t, a, n.from.x, i), e = V.effects.setTransition(t, a, n.to.x, e)), l && V.effects.saveStyle(t), t.css(i), t.animate(e, s.duration, s.easing, function () {
        l && V.effects.restoreStyle(t);
      });
    })), i.animate(g, {
      queue: !1,
      duration: s.duration,
      easing: s.easing,
      complete: function () {
        var t = i.offset();
        0 === g.opacity && i.css('opacity', f.opacity), l || (i.css('position', 'static' === u ? 'relative' : u).offset(t), V.effects.saveStyle(i)), e();
      }
    });
  }), V.effects.define('scale', function (t, e) {
    var i = V(this),
      s = t.mode,
      s = parseInt(t.percent, 10) || (0 === parseInt(t.percent, 10) || 'effect' !== s ? 0 : 100),
      s = V.extend(!0, {
        from: V.effects.scaledDimensions(i),
        to: V.effects.scaledDimensions(i, s, t.direction || 'both'),
        origin: t.origin || ['middle', 'center']
      }, t);
    t.fade && (s.from.opacity = 1, s.to.opacity = 0), V.effects.effect.size.call(this, s, e);
  }), V.effects.define('puff', 'hide', function (t, e) {
    t = V.extend(!0, {}, t, {
      fade: !0,
      percent: parseInt(t.percent, 10) || 150
    });
    V.effects.effect.scale.call(this, t, e);
  }), V.effects.define('pulsate', 'show', function (t, e) {
    var i = V(this),
      s = t.mode,
      n = 'show' === s,
      o = 2 * (t.times || 5) + (n || 'hide' === s ? 1 : 0),
      a = t.duration / o,
      r = 0,
      l = 1,
      s = i.queue().length;
    for (!n && i.is(':visible') || (i.css('opacity', 0).show(), r = 1); l < o; l++) i.animate({
      opacity: r
    }, a, t.easing), r = 1 - r;
    i.animate({
      opacity: r
    }, a, t.easing), i.queue(e), V.effects.unshift(i, s, 1 + o);
  }), V.effects.define('shake', function (t, e) {
    var i = 1,
      s = V(this),
      n = t.direction || 'left',
      o = t.distance || 20,
      a = t.times || 3,
      r = 2 * a + 1,
      l = Math.round(t.duration / r),
      h = 'up' === n || 'down' === n ? 'top' : 'left',
      c = 'up' === n || 'left' === n,
      u = {},
      d = {},
      p = {},
      n = s.queue().length;
    for (V.effects.createPlaceholder(s), u[h] = (c ? '-=' : '+=') + o, d[h] = (c ? '+=' : '-=') + 2 * o, p[h] = (c ? '-=' : '+=') + 2 * o, s.animate(u, l, t.easing); i < a; i++) s.animate(d, l, t.easing).animate(p, l, t.easing);
    s.animate(d, l, t.easing).animate(u, l / 2, t.easing).queue(e), V.effects.unshift(s, n, 1 + r);
  }), V.effects.define('slide', 'show', function (t, e) {
    var i,
      s,
      n = V(this),
      o = {
        up: ['bottom', 'top'],
        down: ['top', 'bottom'],
        left: ['right', 'left'],
        right: ['left', 'right']
      },
      a = t.mode,
      r = t.direction || 'left',
      l = 'up' === r || 'down' === r ? 'top' : 'left',
      h = 'up' === r || 'left' === r,
      c = t.distance || n['top' == l ? 'outerHeight' : 'outerWidth'](!0),
      u = {};
    V.effects.createPlaceholder(n), i = n.cssClip(), s = n.position()[l], u[l] = (h ? -1 : 1) * c + s, u.clip = n.cssClip(), u.clip[o[r][1]] = u.clip[o[r][0]], 'show' === a && (n.cssClip(u.clip), n.css(l, u[l]), u.clip = i, u[l] = s), n.animate(u, {
      queue: !1,
      duration: t.duration,
      easing: t.easing,
      complete: e
    });
  }), y = !1 !== V.uiBackCompat ? V.effects.define('transfer', function (t, e) {
    V(this).transfer(t, e);
  }) : y;
  V.ui.focusable = function (t, e) {
    var i,
      s,
      n,
      o,
      a = t.nodeName.toLowerCase();
    return 'area' === a ? (s = (i = t.parentNode).name, !(!t.href || !s || 'map' !== i.nodeName.toLowerCase()) && 0 < (s = V("img[usemap='#" + s + "']")).length && s.is(':visible')) : (/^(input|select|textarea|button|object)$/.test(a) ? (n = !t.disabled) && (o = V(t).closest('fieldset')[0]) && (n = !o.disabled) : n = 'a' === a && t.href || e, n && V(t).is(':visible') && function (t) {
      var e = t.css('visibility');
      for (; 'inherit' === e;) t = t.parent(), e = t.css('visibility');
      return 'visible' === e;
    }(V(t)));
  }, V.extend(V.expr.pseudos, {
    focusable: function (t) {
      return V.ui.focusable(t, null != V.attr(t, 'tabindex'));
    }
  });
  var Q, J;
  V.ui.focusable, V.fn._form = function () {
    return 'string' == typeof this[0].form ? this.closest('form') : V(this[0].form);
  }, V.ui.formResetMixin = {
    _formResetHandler: function () {
      var e = V(this);
      setTimeout(function () {
        var t = e.data('ui-form-reset-instances');
        V.each(t, function () {
          this.refresh();
        });
      });
    },
    _bindFormResetHandler: function () {
      var t;
      this.form = this.element._form(), this.form.length && ((t = this.form.data('ui-form-reset-instances') || []).length || this.form.on('reset.ui-form-reset', this._formResetHandler), t.push(this), this.form.data('ui-form-reset-instances', t));
    },
    _unbindFormResetHandler: function () {
      var t;
      this.form.length && ((t = this.form.data('ui-form-reset-instances')).splice(V.inArray(this, t), 1), t.length ? this.form.data('ui-form-reset-instances', t) : this.form.removeData('ui-form-reset-instances').off('reset.ui-form-reset'));
    }
  };
  V.expr.pseudos || (V.expr.pseudos = V.expr[':']), V.uniqueSort || (V.uniqueSort = V.unique), V.escapeSelector || (Q = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, J = function (t, e) {
    return e ? '\0' === t ? '�' : t.slice(0, -1) + '\\' + t.charCodeAt(t.length - 1).toString(16) + ' ' : '\\' + t;
  }, V.escapeSelector = function (t) {
    return (t + '').replace(Q, J);
  }), V.fn.even && V.fn.odd || V.fn.extend({
    even: function () {
      return this.filter(function (t) {
        return t % 2 == 0;
      });
    },
    odd: function () {
      return this.filter(function (t) {
        return t % 2 == 1;
      });
    }
  });
  var Z;
  V.ui.keyCode = {
    BACKSPACE: 8,
    COMMA: 188,
    DELETE: 46,
    DOWN: 40,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    HOME: 36,
    LEFT: 37,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    PERIOD: 190,
    RIGHT: 39,
    SPACE: 32,
    TAB: 9,
    UP: 38
  }, V.fn.labels = function () {
    var t, e, i;
    return this.length ? this[0].labels && this[0].labels.length ? this.pushStack(this[0].labels) : (e = this.eq(0).parents('label'), (t = this.attr('id')) && (i = (i = this.eq(0).parents().last()).add((i.length ? i : this).siblings()), t = "label[for='" + V.escapeSelector(t) + "']", e = e.add(i.find(t).addBack(t))), this.pushStack(e)) : this.pushStack([]);
  }, V.fn.scrollParent = function (t) {
    var e = this.css('position'),
      i = 'absolute' === e,
      s = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
      t = this.parents().filter(function () {
        var t = V(this);
        return (!i || 'static' !== t.css('position')) && s.test(t.css('overflow') + t.css('overflow-y') + t.css('overflow-x'));
      }).eq(0);
    return 'fixed' !== e && t.length ? t : V(this[0].ownerDocument || document);
  }, V.extend(V.expr.pseudos, {
    tabbable: function (t) {
      var e = V.attr(t, 'tabindex'),
        i = null != e;
      return (!i || 0 <= e) && V.ui.focusable(t, i);
    }
  }), V.fn.extend({
    uniqueId: (Z = 0, function () {
      return this.each(function () {
        this.id || (this.id = 'ui-id-' + ++Z);
      });
    }),
    removeUniqueId: function () {
      return this.each(function () {
        ;
        /^ui-id-\d+$/.test(this.id) && V(this).removeAttr('id');
      });
    }
  }), V.widget('ui.accordion', {
    version: '1.13.1',
    options: {
      active: 0,
      animate: {},
      classes: {
        'ui-accordion-header': 'ui-corner-top',
        'ui-accordion-header-collapsed': 'ui-corner-all',
        'ui-accordion-content': 'ui-corner-bottom'
      },
      collapsible: !1,
      event: 'click',
      header: function (t) {
        return t.find('> li > :first-child').add(t.find('> :not(li)').even());
      },
      heightStyle: 'auto',
      icons: {
        activeHeader: 'ui-icon-triangle-1-s',
        header: 'ui-icon-triangle-1-e'
      },
      activate: null,
      beforeActivate: null
    },
    hideProps: {
      borderTopWidth: 'hide',
      borderBottomWidth: 'hide',
      paddingTop: 'hide',
      paddingBottom: 'hide',
      height: 'hide'
    },
    showProps: {
      borderTopWidth: 'show',
      borderBottomWidth: 'show',
      paddingTop: 'show',
      paddingBottom: 'show',
      height: 'show'
    },
    _create: function () {
      var t = this.options;
      this.prevShow = this.prevHide = V(), this._addClass('ui-accordion', 'ui-widget ui-helper-reset'), this.element.attr('role', 'tablist'), t.collapsible || !1 !== t.active && null != t.active || (t.active = 0), this._processPanels(), t.active < 0 && (t.active += this.headers.length), this._refresh();
    },
    _getCreateEventData: function () {
      return {
        header: this.active,
        panel: this.active.length ? this.active.next() : V()
      };
    },
    _createIcons: function () {
      var t,
        e = this.options.icons;
      e && (t = V('<span>'), this._addClass(t, 'ui-accordion-header-icon', 'ui-icon ' + e.header), t.prependTo(this.headers), t = this.active.children('.ui-accordion-header-icon'), this._removeClass(t, e.header)._addClass(t, null, e.activeHeader)._addClass(this.headers, 'ui-accordion-icons'));
    },
    _destroyIcons: function () {
      this._removeClass(this.headers, 'ui-accordion-icons'), this.headers.children('.ui-accordion-header-icon').remove();
    },
    _destroy: function () {
      var t;
      this.element.removeAttr('role'), this.headers.removeAttr('role aria-expanded aria-selected aria-controls tabIndex').removeUniqueId(), this._destroyIcons(), t = this.headers.next().css('display', '').removeAttr('role aria-hidden aria-labelledby').removeUniqueId(), 'content' !== this.options.heightStyle && t.css('height', '');
    },
    _setOption: function (t, e) {
      'active' !== t ? ('event' === t && (this.options.event && this._off(this.headers, this.options.event), this._setupEvents(e)), this._super(t, e), 'collapsible' !== t || e || !1 !== this.options.active || this._activate(0), 'icons' === t && (this._destroyIcons(), e && this._createIcons())) : this._activate(e);
    },
    _setOptionDisabled: function (t) {
      this._super(t), this.element.attr('aria-disabled', t), this._toggleClass(null, 'ui-state-disabled', !!t), this._toggleClass(this.headers.add(this.headers.next()), null, 'ui-state-disabled', !!t);
    },
    _keydown: function (t) {
      if (!t.altKey && !t.ctrlKey) {
        var e = V.ui.keyCode,
          i = this.headers.length,
          s = this.headers.index(t.target),
          n = !1;
        switch (t.keyCode) {
          case e.RIGHT:
          case e.DOWN:
            n = this.headers[(s + 1) % i];
            break;
          case e.LEFT:
          case e.UP:
            n = this.headers[(s - 1 + i) % i];
            break;
          case e.SPACE:
          case e.ENTER:
            this._eventHandler(t);
            break;
          case e.HOME:
            n = this.headers[0];
            break;
          case e.END:
            n = this.headers[i - 1];
        }
        n && (V(t.target).attr('tabIndex', -1), V(n).attr('tabIndex', 0), V(n).trigger('focus'), t.preventDefault());
      }
    },
    _panelKeyDown: function (t) {
      t.keyCode === V.ui.keyCode.UP && t.ctrlKey && V(t.currentTarget).prev().trigger('focus');
    },
    refresh: function () {
      var t = this.options;
      this._processPanels(), !1 === t.active && !0 === t.collapsible || !this.headers.length ? (t.active = !1, this.active = V()) : !1 === t.active ? this._activate(0) : this.active.length && !V.contains(this.element[0], this.active[0]) ? this.headers.length === this.headers.find('.ui-state-disabled').length ? (t.active = !1, this.active = V()) : this._activate(Math.max(0, t.active - 1)) : t.active = this.headers.index(this.active), this._destroyIcons(), this._refresh();
    },
    _processPanels: function () {
      var t = this.headers,
        e = this.panels;
      'function' == typeof this.options.header ? this.headers = this.options.header(this.element) : this.headers = this.element.find(this.options.header), this._addClass(this.headers, 'ui-accordion-header ui-accordion-header-collapsed', 'ui-state-default'), this.panels = this.headers.next().filter(':not(.ui-accordion-content-active)').hide(), this._addClass(this.panels, 'ui-accordion-content', 'ui-helper-reset ui-widget-content'), e && (this._off(t.not(this.headers)), this._off(e.not(this.panels)));
    },
    _refresh: function () {
      var i,
        t = this.options,
        e = t.heightStyle,
        s = this.element.parent();
      this.active = this._findActive(t.active), this._addClass(this.active, 'ui-accordion-header-active', 'ui-state-active')._removeClass(this.active, 'ui-accordion-header-collapsed'), this._addClass(this.active.next(), 'ui-accordion-content-active'), this.active.next().show(), this.headers.attr('role', 'tab').each(function () {
        var t = V(this),
          e = t.uniqueId().attr('id'),
          i = t.next(),
          s = i.uniqueId().attr('id');
        t.attr('aria-controls', s), i.attr('aria-labelledby', e);
      }).next().attr('role', 'tabpanel'), this.headers.not(this.active).attr({
        'aria-selected': 'false',
        'aria-expanded': 'false',
        tabIndex: -1
      }).next().attr({
        'aria-hidden': 'true'
      }).hide(), this.active.length ? this.active.attr({
        'aria-selected': 'true',
        'aria-expanded': 'true',
        tabIndex: 0
      }).next().attr({
        'aria-hidden': 'false'
      }) : this.headers.eq(0).attr('tabIndex', 0), this._createIcons(), this._setupEvents(t.event), 'fill' === e ? (i = s.height(), this.element.siblings(':visible').each(function () {
        var t = V(this),
          e = t.css('position');
        'absolute' !== e && 'fixed' !== e && (i -= t.outerHeight(!0));
      }), this.headers.each(function () {
        i -= V(this).outerHeight(!0);
      }), this.headers.next().each(function () {
        V(this).height(Math.max(0, i - V(this).innerHeight() + V(this).height()));
      }).css('overflow', 'auto')) : 'auto' === e && (i = 0, this.headers.next().each(function () {
        var t = V(this).is(':visible');
        t || V(this).show(), i = Math.max(i, V(this).css('height', '').height()), t || V(this).hide();
      }).height(i));
    },
    _activate: function (t) {
      t = this._findActive(t)[0];
      t !== this.active[0] && (t = t || this.active[0], this._eventHandler({
        target: t,
        currentTarget: t,
        preventDefault: V.noop
      }));
    },
    _findActive: function (t) {
      return 'number' == typeof t ? this.headers.eq(t) : V();
    },
    _setupEvents: function (t) {
      var i = {
        keydown: '_keydown'
      };
      t && V.each(t.split(' '), function (t, e) {
        i[e] = '_eventHandler';
      }), this._off(this.headers.add(this.headers.next())), this._on(this.headers, i), this._on(this.headers.next(), {
        keydown: '_panelKeyDown'
      }), this._hoverable(this.headers), this._focusable(this.headers);
    },
    _eventHandler: function (t) {
      var e = this.options,
        i = this.active,
        s = V(t.currentTarget),
        n = s[0] === i[0],
        o = n && e.collapsible,
        a = o ? V() : s.next(),
        r = i.next(),
        a = {
          oldHeader: i,
          oldPanel: r,
          newHeader: o ? V() : s,
          newPanel: a
        };
      t.preventDefault(), n && !e.collapsible || !1 === this._trigger('beforeActivate', t, a) || (e.active = !o && this.headers.index(s), this.active = n ? V() : s, this._toggle(a), this._removeClass(i, 'ui-accordion-header-active', 'ui-state-active'), e.icons && (i = i.children('.ui-accordion-header-icon'), this._removeClass(i, null, e.icons.activeHeader)._addClass(i, null, e.icons.header)), n || (this._removeClass(s, 'ui-accordion-header-collapsed')._addClass(s, 'ui-accordion-header-active', 'ui-state-active'), e.icons && (n = s.children('.ui-accordion-header-icon'), this._removeClass(n, null, e.icons.header)._addClass(n, null, e.icons.activeHeader)), this._addClass(s.next(), 'ui-accordion-content-active')));
    },
    _toggle: function (t) {
      var e = t.newPanel,
        i = this.prevShow.length ? this.prevShow : t.oldPanel;
      this.prevShow.add(this.prevHide).stop(!0, !0), this.prevShow = e, this.prevHide = i, this.options.animate ? this._animate(e, i, t) : (i.hide(), e.show(), this._toggleComplete(t)), i.attr({
        'aria-hidden': 'true'
      }), i.prev().attr({
        'aria-selected': 'false',
        'aria-expanded': 'false'
      }), e.length && i.length ? i.prev().attr({
        tabIndex: -1,
        'aria-expanded': 'false'
      }) : e.length && this.headers.filter(function () {
        return 0 === parseInt(V(this).attr('tabIndex'), 10);
      }).attr('tabIndex', -1), e.attr('aria-hidden', 'false').prev().attr({
        'aria-selected': 'true',
        'aria-expanded': 'true',
        tabIndex: 0
      });
    },
    _animate: function (t, i, e) {
      var s,
        n,
        o,
        a = this,
        r = 0,
        l = t.css('box-sizing'),
        h = t.length && (!i.length || t.index() < i.index()),
        c = this.options.animate || {},
        u = h && c.down || c,
        h = function () {
          a._toggleComplete(e);
        };
      return n = (n = 'string' == typeof u ? u : n) || u.easing || c.easing, o = (o = 'number' == typeof u ? u : o) || u.duration || c.duration, i.length ? t.length ? (s = t.show().outerHeight(), i.animate(this.hideProps, {
        duration: o,
        easing: n,
        step: function (t, e) {
          e.now = Math.round(t);
        }
      }), void t.hide().animate(this.showProps, {
        duration: o,
        easing: n,
        complete: h,
        step: function (t, e) {
          ;
          e.now = Math.round(t), 'height' !== e.prop ? 'content-box' === l && (r += e.now) : 'content' !== a.options.heightStyle && (e.now = Math.round(s - i.outerHeight() - r), r = 0);
        }
      })) : i.animate(this.hideProps, o, n, h) : t.animate(this.showProps, o, n, h);
    },
    _toggleComplete: function (t) {
      var e = t.oldPanel,
        i = e.prev();
      this._removeClass(e, 'ui-accordion-content-active'), this._removeClass(i, 'ui-accordion-header-active')._addClass(i, 'ui-accordion-header-collapsed'), e.length && (e.parent()[0].className = e.parent()[0].className), this._trigger('activate', null, t);
    }
  }), V.ui.safeActiveElement = function (e) {
    var i;
    try {
      i = e.activeElement;
    } catch (t) {
      i = e.body;
    }
    return i = !(i = i || e.body).nodeName ? e.body : i;
  }, V.widget('ui.menu', {
    version: '1.13.1',
    defaultElement: '<ul>',
    delay: 300,
    options: {
      icons: {
        submenu: 'ui-icon-caret-1-e'
      },
      items: '> *',
      menus: 'ul',
      position: {
        my: 'left top',
        at: 'right top'
      },
      role: 'menu',
      blur: null,
      focus: null,
      select: null
    },
    _create: function () {
      ;
      this.activeMenu = this.element, this.mouseHandled = !1, this.lastMousePosition = {
        x: null,
        y: null
      }, this.element.uniqueId().attr({
        role: this.options.role,
        tabIndex: 0
      }), this._addClass('ui-menu', 'ui-widget ui-widget-content'), this._on({
        'mousedown .ui-menu-item': function (t) {
          t.preventDefault(), this._activateItem(t);
        },
        'click .ui-menu-item': function (t) {
          var e = V(t.target),
            i = V(V.ui.safeActiveElement(this.document[0]));
          !this.mouseHandled && e.not('.ui-state-disabled').length && (this.select(t), t.isPropagationStopped() || (this.mouseHandled = !0), e.has('.ui-menu').length ? this.expand(t) : !this.element.is(':focus') && i.closest('.ui-menu').length && (this.element.trigger('focus', [!0]), this.active && 1 === this.active.parents('.ui-menu').length && clearTimeout(this.timer)));
        },
        'mouseenter .ui-menu-item': '_activateItem',
        'mousemove .ui-menu-item': '_activateItem',
        mouseleave: 'collapseAll',
        'mouseleave .ui-menu': 'collapseAll',
        focus: function (t, e) {
          var i = this.active || this._menuItems().first();
          e || this.focus(t, i);
        },
        blur: function (t) {
          this._delay(function () {
            V.contains(this.element[0], V.ui.safeActiveElement(this.document[0])) || this.collapseAll(t);
          });
        },
        keydown: '_keydown'
      }), this.refresh(), this._on(this.document, {
        click: function (t) {
          this._closeOnDocumentClick(t) && this.collapseAll(t, !0), this.mouseHandled = !1;
        }
      });
    },
    _activateItem: function (t) {
      var e, i;
      this.previousFilter || t.clientX === this.lastMousePosition.x && t.clientY === this.lastMousePosition.y || (this.lastMousePosition = {
        x: t.clientX,
        y: t.clientY
      }, e = V(t.target).closest('.ui-menu-item'), i = V(t.currentTarget), e[0] === i[0] && (i.is('.ui-state-active') || (this._removeClass(i.siblings().children('.ui-state-active'), null, 'ui-state-active'), this.focus(t, i))));
    },
    _destroy: function () {
      var t = this.element.find('.ui-menu-item').removeAttr('role aria-disabled').children('.ui-menu-item-wrapper').removeUniqueId().removeAttr('tabIndex role aria-haspopup');
      this.element.removeAttr('aria-activedescendant').find('.ui-menu').addBack().removeAttr('role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex').removeUniqueId().show(), t.children().each(function () {
        var t = V(this);
        t.data('ui-menu-submenu-caret') && t.remove();
      });
    },
    _keydown: function (t) {
      var e,
        i,
        s,
        n = !0;
      switch (t.keyCode) {
        case V.ui.keyCode.PAGE_UP:
          this.previousPage(t);
          break;
        case V.ui.keyCode.PAGE_DOWN:
          this.nextPage(t);
          break;
        case V.ui.keyCode.HOME:
          this._move('first', 'first', t);
          break;
        case V.ui.keyCode.END:
          this._move('last', 'last', t);
          break;
        case V.ui.keyCode.UP:
          this.previous(t);
          break;
        case V.ui.keyCode.DOWN:
          this.next(t);
          break;
        case V.ui.keyCode.LEFT:
          this.collapse(t);
          break;
        case V.ui.keyCode.RIGHT:
          this.active && !this.active.is('.ui-state-disabled') && this.expand(t);
          break;
        case V.ui.keyCode.ENTER:
        case V.ui.keyCode.SPACE:
          this._activate(t);
          break;
        case V.ui.keyCode.ESCAPE:
          this.collapse(t);
          break;
        default:
          ;
          e = this.previousFilter || '', s = n = !1, i = 96 <= t.keyCode && t.keyCode <= 105 ? (t.keyCode - 96).toString() : String.fromCharCode(t.keyCode), clearTimeout(this.filterTimer), i === e ? s = !0 : i = e + i, e = this._filterMenuItems(i), (e = s && -1 !== e.index(this.active.next()) ? this.active.nextAll('.ui-menu-item') : e).length || (i = String.fromCharCode(t.keyCode), e = this._filterMenuItems(i)), e.length ? (this.focus(t, e), this.previousFilter = i, this.filterTimer = this._delay(function () {
            delete this.previousFilter;
          }, 1e3)) : delete this.previousFilter;
      }
      n && t.preventDefault();
    },
    _activate: function (t) {
      this.active && !this.active.is('.ui-state-disabled') && (this.active.children("[aria-haspopup='true']").length ? this.expand(t) : this.select(t));
    },
    refresh: function () {
      var t,
        e,
        s = this,
        n = this.options.icons.submenu,
        i = this.element.find(this.options.menus);
      this._toggleClass('ui-menu-icons', null, !!this.element.find('.ui-icon').length), e = i.filter(':not(.ui-menu)').hide().attr({
        role: this.options.role,
        'aria-hidden': 'true',
        'aria-expanded': 'false'
      }).each(function () {
        var t = V(this),
          e = t.prev(),
          i = V('<span>').data('ui-menu-submenu-caret', !0);
        s._addClass(i, 'ui-menu-icon', 'ui-icon ' + n), e.attr('aria-haspopup', 'true').prepend(i), t.attr('aria-labelledby', e.attr('id'));
      }), this._addClass(e, 'ui-menu', 'ui-widget ui-widget-content ui-front'), (t = i.add(this.element).find(this.options.items)).not('.ui-menu-item').each(function () {
        var t = V(this);
        s._isDivider(t) && s._addClass(t, 'ui-menu-divider', 'ui-widget-content');
      }), i = (e = t.not('.ui-menu-item, .ui-menu-divider')).children().not('.ui-menu').uniqueId().attr({
        tabIndex: -1,
        role: this._itemRole()
      }), this._addClass(e, 'ui-menu-item')._addClass(i, 'ui-menu-item-wrapper'), t.filter('.ui-state-disabled').attr('aria-disabled', 'true'), this.active && !V.contains(this.element[0], this.active[0]) && this.blur();
    },
    _itemRole: function () {
      return {
        menu: 'menuitem',
        listbox: 'option'
      }[this.options.role];
    },
    _setOption: function (t, e) {
      var i;
      'icons' === t && (i = this.element.find('.ui-menu-icon'), this._removeClass(i, null, this.options.icons.submenu)._addClass(i, null, e.submenu)), this._super(t, e);
    },
    _setOptionDisabled: function (t) {
      this._super(t), this.element.attr('aria-disabled', String(t)), this._toggleClass(null, 'ui-state-disabled', !!t);
    },
    focus: function (t, e) {
      var i;
      this.blur(t, t && 'focus' === t.type), this._scrollIntoView(e), this.active = e.first(), i = this.active.children('.ui-menu-item-wrapper'), this._addClass(i, null, 'ui-state-active'), this.options.role && this.element.attr('aria-activedescendant', i.attr('id')), i = this.active.parent().closest('.ui-menu-item').children('.ui-menu-item-wrapper'), this._addClass(i, null, 'ui-state-active'), t && 'keydown' === t.type ? this._close() : this.timer = this._delay(function () {
        this._close();
      }, this.delay), (i = e.children('.ui-menu')).length && t && /^mouse/.test(t.type) && this._startOpening(i), this.activeMenu = e.parent(), this._trigger('focus', t, {
        item: e
      });
    },
    _scrollIntoView: function (t) {
      var e, i, s;
      this._hasScroll() && (i = parseFloat(V.css(this.activeMenu[0], 'borderTopWidth')) || 0, s = parseFloat(V.css(this.activeMenu[0], 'paddingTop')) || 0, e = t.offset().top - this.activeMenu.offset().top - i - s, i = this.activeMenu.scrollTop(), s = this.activeMenu.height(), t = t.outerHeight(), e < 0 ? this.activeMenu.scrollTop(i + e) : s < e + t && this.activeMenu.scrollTop(i + e - s + t));
    },
    blur: function (t, e) {
      e || clearTimeout(this.timer), this.active && (this._removeClass(this.active.children('.ui-menu-item-wrapper'), null, 'ui-state-active'), this._trigger('blur', t, {
        item: this.active
      }), this.active = null);
    },
    _startOpening: function (t) {
      clearTimeout(this.timer), 'true' === t.attr('aria-hidden') && (this.timer = this._delay(function () {
        this._close(), this._open(t);
      }, this.delay));
    },
    _open: function (t) {
      var e = V.extend({
        of: this.active
      }, this.options.position);
      clearTimeout(this.timer), this.element.find('.ui-menu').not(t.parents('.ui-menu')).hide().attr('aria-hidden', 'true'), t.show().removeAttr('aria-hidden').attr('aria-expanded', 'true').position(e);
    },
    collapseAll: function (e, i) {
      clearTimeout(this.timer), this.timer = this._delay(function () {
        var t = i ? this.element : V(e && e.target).closest(this.element.find('.ui-menu'));
        t.length || (t = this.element), this._close(t), this.blur(e), this._removeClass(t.find('.ui-state-active'), null, 'ui-state-active'), this.activeMenu = t;
      }, i ? 0 : this.delay);
    },
    _close: function (t) {
      ;
      (t = t || (this.active ? this.active.parent() : this.element)).find('.ui-menu').hide().attr('aria-hidden', 'true').attr('aria-expanded', 'false');
    },
    _closeOnDocumentClick: function (t) {
      return !V(t.target).closest('.ui-menu').length;
    },
    _isDivider: function (t) {
      return !/[^\-\u2014\u2013\s]/.test(t.text());
    },
    collapse: function (t) {
      var e = this.active && this.active.parent().closest('.ui-menu-item', this.element);
      e && e.length && (this._close(), this.focus(t, e));
    },
    expand: function (t) {
      var e = this.active && this._menuItems(this.active.children('.ui-menu')).first();
      e && e.length && (this._open(e.parent()), this._delay(function () {
        this.focus(t, e);
      }));
    },
    next: function (t) {
      this._move('next', 'first', t);
    },
    previous: function (t) {
      this._move('prev', 'last', t);
    },
    isFirstItem: function () {
      return this.active && !this.active.prevAll('.ui-menu-item').length;
    },
    isLastItem: function () {
      return this.active && !this.active.nextAll('.ui-menu-item').length;
    },
    _menuItems: function (t) {
      return (t || this.element).find(this.options.items).filter('.ui-menu-item');
    },
    _move: function (t, e, i) {
      var s;
      (s = this.active ? 'first' === t || 'last' === t ? this.active['first' === t ? 'prevAll' : 'nextAll']('.ui-menu-item').last() : this.active[t + 'All']('.ui-menu-item').first() : s) && s.length && this.active || (s = this._menuItems(this.activeMenu)[e]()), this.focus(i, s);
    },
    nextPage: function (t) {
      var e, i, s;
      this.active ? this.isLastItem() || (this._hasScroll() ? (i = this.active.offset().top, s = this.element.innerHeight(), 0 === V.fn.jquery.indexOf('3.2.') && (s += this.element[0].offsetHeight - this.element.outerHeight()), this.active.nextAll('.ui-menu-item').each(function () {
        return (e = V(this)).offset().top - i - s < 0;
      }), this.focus(t, e)) : this.focus(t, this._menuItems(this.activeMenu)[this.active ? 'last' : 'first']())) : this.next(t);
    },
    previousPage: function (t) {
      var e, i, s;
      this.active ? this.isFirstItem() || (this._hasScroll() ? (i = this.active.offset().top, s = this.element.innerHeight(), 0 === V.fn.jquery.indexOf('3.2.') && (s += this.element[0].offsetHeight - this.element.outerHeight()), this.active.prevAll('.ui-menu-item').each(function () {
        return 0 < (e = V(this)).offset().top - i + s;
      }), this.focus(t, e)) : this.focus(t, this._menuItems(this.activeMenu).first())) : this.next(t);
    },
    _hasScroll: function () {
      return this.element.outerHeight() < this.element.prop('scrollHeight');
    },
    select: function (t) {
      this.active = this.active || V(t.target).closest('.ui-menu-item');
      var e = {
        item: this.active
      };
      this.active.has('.ui-menu').length || this.collapseAll(t, !0), this._trigger('select', t, e);
    },
    _filterMenuItems: function (t) {
      var t = t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'),
        e = new RegExp('^' + t, 'i');
      return this.activeMenu.find(this.options.items).filter('.ui-menu-item').filter(function () {
        return e.test(String.prototype.trim.call(V(this).children('.ui-menu-item-wrapper').text()));
      });
    }
  });
  V.widget('ui.autocomplete', {
    version: '1.13.1',
    defaultElement: '<input>',
    options: {
      appendTo: null,
      autoFocus: !1,
      delay: 300,
      minLength: 1,
      position: {
        my: 'left top',
        at: 'left bottom',
        collision: 'none'
      },
      source: null,
      change: null,
      close: null,
      focus: null,
      open: null,
      response: null,
      search: null,
      select: null
    },
    requestIndex: 0,
    pending: 0,
    liveRegionTimer: null,
    _create: function () {
      var i,
        s,
        n,
        t = this.element[0].nodeName.toLowerCase(),
        e = 'textarea' === t,
        t = 'input' === t;
      this.isMultiLine = e || !t && this._isContentEditable(this.element), this.valueMethod = this.element[e || t ? 'val' : 'text'], this.isNewMenu = !0, this._addClass('ui-autocomplete-input'), this.element.attr('autocomplete', 'off'), this._on(this.element, {
        keydown: function (t) {
          if (this.element.prop('readOnly')) s = n = i = !0;else {
            s = n = i = !1;
            var e = V.ui.keyCode;
            switch (t.keyCode) {
              case e.PAGE_UP:
                ;
                i = !0, this._move('previousPage', t);
                break;
              case e.PAGE_DOWN:
                ;
                i = !0, this._move('nextPage', t);
                break;
              case e.UP:
                ;
                i = !0, this._keyEvent('previous', t);
                break;
              case e.DOWN:
                ;
                i = !0, this._keyEvent('next', t);
                break;
              case e.ENTER:
                this.menu.active && (i = !0, t.preventDefault(), this.menu.select(t));
                break;
              case e.TAB:
                this.menu.active && this.menu.select(t);
                break;
              case e.ESCAPE:
                this.menu.element.is(':visible') && (this.isMultiLine || this._value(this.term), this.close(t), t.preventDefault());
                break;
              default:
                ;
                s = !0, this._searchTimeout(t);
            }
          }
        },
        keypress: function (t) {
          if (i) return i = !1, void (this.isMultiLine && !this.menu.element.is(':visible') || t.preventDefault());
          if (!s) {
            var e = V.ui.keyCode;
            switch (t.keyCode) {
              case e.PAGE_UP:
                this._move('previousPage', t);
                break;
              case e.PAGE_DOWN:
                this._move('nextPage', t);
                break;
              case e.UP:
                this._keyEvent('previous', t);
                break;
              case e.DOWN:
                this._keyEvent('next', t);
            }
          }
        },
        input: function (t) {
          if (n) return n = !1, void t.preventDefault();
          this._searchTimeout(t);
        },
        focus: function () {
          ;
          this.selectedItem = null, this.previous = this._value();
        },
        blur: function (t) {
          clearTimeout(this.searching), this.close(t), this._change(t);
        }
      }), this._initSource(), this.menu = V('<ul>').appendTo(this._appendTo()).menu({
        role: null
      }).hide().attr({
        unselectable: 'on'
      }).menu('instance'), this._addClass(this.menu.element, 'ui-autocomplete', 'ui-front'), this._on(this.menu.element, {
        mousedown: function (t) {
          t.preventDefault();
        },
        menufocus: function (t, e) {
          var i, s;
          if (this.isNewMenu && (this.isNewMenu = !1, t.originalEvent && /^mouse/.test(t.originalEvent.type))) return this.menu.blur(), void this.document.one('mousemove', function () {
            V(t.target).trigger(t.originalEvent);
          });
          s = e.item.data('ui-autocomplete-item'), !1 !== this._trigger('focus', t, {
            item: s
          }) && t.originalEvent && /^key/.test(t.originalEvent.type) && this._value(s.value), (i = e.item.attr('aria-label') || s.value) && String.prototype.trim.call(i).length && (clearTimeout(this.liveRegionTimer), this.liveRegionTimer = this._delay(function () {
            this.liveRegion.html(V('<div>').text(i));
          }, 100));
        },
        menuselect: function (t, e) {
          var i = e.item.data('ui-autocomplete-item'),
            s = this.previous;
          this.element[0] !== V.ui.safeActiveElement(this.document[0]) && (this.element.trigger('focus'), this.previous = s, this._delay(function () {
            ;
            this.previous = s, this.selectedItem = i;
          })), !1 !== this._trigger('select', t, {
            item: i
          }) && this._value(i.value), this.term = this._value(), this.close(t), this.selectedItem = i;
        }
      }), this.liveRegion = V('<div>', {
        role: 'status',
        'aria-live': 'assertive',
        'aria-relevant': 'additions'
      }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, 'ui-helper-hidden-accessible'), this._on(this.window, {
        beforeunload: function () {
          this.element.removeAttr('autocomplete');
        }
      });
    },
    _destroy: function () {
      clearTimeout(this.searching), this.element.removeAttr('autocomplete'), this.menu.element.remove(), this.liveRegion.remove();
    },
    _setOption: function (t, e) {
      this._super(t, e), 'source' === t && this._initSource(), 'appendTo' === t && this.menu.element.appendTo(this._appendTo()), 'disabled' === t && e && this.xhr && this.xhr.abort();
    },
    _isEventTargetInWidget: function (t) {
      var e = this.menu.element[0];
      return t.target === this.element[0] || t.target === e || V.contains(e, t.target);
    },
    _closeOnClickOutside: function (t) {
      this._isEventTargetInWidget(t) || this.close();
    },
    _appendTo: function () {
      var t = this.options.appendTo;
      return t = !(t = !(t = t && (t.jquery || t.nodeType ? V(t) : this.document.find(t).eq(0))) || !t[0] ? this.element.closest('.ui-front, dialog') : t).length ? this.document[0].body : t;
    },
    _initSource: function () {
      var i,
        s,
        n = this;
      Array.isArray(this.options.source) ? (i = this.options.source, this.source = function (t, e) {
        e(V.ui.autocomplete.filter(i, t.term));
      }) : 'string' == typeof this.options.source ? (s = this.options.source, this.source = function (t, e) {
        n.xhr && n.xhr.abort(), n.xhr = V.ajax({
          url: s,
          data: t,
          dataType: 'json',
          success: function (t) {
            e(t);
          },
          error: function () {
            e([]);
          }
        });
      }) : this.source = this.options.source;
    },
    _searchTimeout: function (s) {
      clearTimeout(this.searching), this.searching = this._delay(function () {
        var t = this.term === this._value(),
          e = this.menu.element.is(':visible'),
          i = s.altKey || s.ctrlKey || s.metaKey || s.shiftKey;
        t && (e || i) || (this.selectedItem = null, this.search(null, s));
      }, this.options.delay);
    },
    search: function (t, e) {
      return t = null != t ? t : this._value(), this.term = this._value(), t.length < this.options.minLength ? this.close(e) : !1 !== this._trigger('search', e) ? this._search(t) : void 0;
    },
    _search: function (t) {
      this.pending++, this._addClass('ui-autocomplete-loading'), this.cancelSearch = !1, this.source({
        term: t
      }, this._response());
    },
    _response: function () {
      var e = ++this.requestIndex;
      return function (t) {
        e === this.requestIndex && this.__response(t), this.pending--, this.pending || this._removeClass('ui-autocomplete-loading');
      }.bind(this);
    },
    __response: function (t) {
      ;
      t = t && this._normalize(t), this._trigger('response', null, {
        content: t
      }), !this.options.disabled && t && t.length && !this.cancelSearch ? (this._suggest(t), this._trigger('open')) : this._close();
    },
    close: function (t) {
      ;
      this.cancelSearch = !0, this._close(t);
    },
    _close: function (t) {
      this._off(this.document, 'mousedown'), this.menu.element.is(':visible') && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger('close', t));
    },
    _change: function (t) {
      this.previous !== this._value() && this._trigger('change', t, {
        item: this.selectedItem
      });
    },
    _normalize: function (t) {
      return t.length && t[0].label && t[0].value ? t : V.map(t, function (t) {
        return 'string' == typeof t ? {
          label: t,
          value: t
        } : V.extend({}, t, {
          label: t.label || t.value,
          value: t.value || t.label
        });
      });
    },
    _suggest: function (t) {
      var e = this.menu.element.empty();
      this._renderMenu(e, t), this.isNewMenu = !0, this.menu.refresh(), e.show(), this._resizeMenu(), e.position(V.extend({
        of: this.element
      }, this.options.position)), this.options.autoFocus && this.menu.next(), this._on(this.document, {
        mousedown: '_closeOnClickOutside'
      });
    },
    _resizeMenu: function () {
      var t = this.menu.element;
      t.outerWidth(Math.max(t.width('').outerWidth() + 1, this.element.outerWidth()));
    },
    _renderMenu: function (i, t) {
      var s = this;
      V.each(t, function (t, e) {
        s._renderItemData(i, e);
      });
    },
    _renderItemData: function (t, e) {
      return this._renderItem(t, e).data('ui-autocomplete-item', e);
    },
    _renderItem: function (t, e) {
      return V('<li>').append(V('<div>').text(e.label)).appendTo(t);
    },
    _move: function (t, e) {
      if (this.menu.element.is(':visible')) return this.menu.isFirstItem() && /^previous/.test(t) || this.menu.isLastItem() && /^next/.test(t) ? (this.isMultiLine || this._value(this.term), void this.menu.blur()) : void this.menu[t](e);
      this.search(null, e);
    },
    widget: function () {
      return this.menu.element;
    },
    _value: function () {
      return this.valueMethod.apply(this.element, arguments);
    },
    _keyEvent: function (t, e) {
      ;
      this.isMultiLine && !this.menu.element.is(':visible') || (this._move(t, e), e.preventDefault());
    },
    _isContentEditable: function (t) {
      if (!t.length) return !1;
      var e = t.prop('contentEditable');
      return 'inherit' === e ? this._isContentEditable(t.parent()) : 'true' === e;
    }
  }), V.extend(V.ui.autocomplete, {
    escapeRegex: function (t) {
      return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    },
    filter: function (t, e) {
      var i = new RegExp(V.ui.autocomplete.escapeRegex(e), 'i');
      return V.grep(t, function (t) {
        return i.test(t.label || t.value || t);
      });
    }
  }), V.widget('ui.autocomplete', V.ui.autocomplete, {
    options: {
      messages: {
        noResults: 'No search results.',
        results: function (t) {
          return t + (1 < t ? ' results are' : ' result is') + ' available, use up and down arrow keys to navigate.';
        }
      }
    },
    __response: function (t) {
      var e;
      this._superApply(arguments), this.options.disabled || this.cancelSearch || (e = t && t.length ? this.options.messages.results(t.length) : this.options.messages.noResults, clearTimeout(this.liveRegionTimer), this.liveRegionTimer = this._delay(function () {
        this.liveRegion.html(V('<div>').text(e));
      }, 100));
    }
  });
  V.ui.autocomplete;
  var tt = /ui-corner-([a-z]){2,6}/g;
  V.widget('ui.controlgroup', {
    version: '1.13.1',
    defaultElement: '<div>',
    options: {
      direction: 'horizontal',
      disabled: null,
      onlyVisible: !0,
      items: {
        button: 'input[type=button], input[type=submit], input[type=reset], button, a',
        controlgroupLabel: '.ui-controlgroup-label',
        checkboxradio: "input[type='checkbox'], input[type='radio']",
        selectmenu: 'select',
        spinner: '.ui-spinner-input'
      }
    },
    _create: function () {
      this._enhance();
    },
    _enhance: function () {
      this.element.attr('role', 'toolbar'), this.refresh();
    },
    _destroy: function () {
      this._callChildMethod('destroy'), this.childWidgets.removeData('ui-controlgroup-data'), this.element.removeAttr('role'), this.options.items.controlgroupLabel && this.element.find(this.options.items.controlgroupLabel).find('.ui-controlgroup-label-contents').contents().unwrap();
    },
    _initWidgets: function () {
      var o = this,
        a = [];
      V.each(this.options.items, function (s, t) {
        var e,
          n = {};
        if (t) return 'controlgroupLabel' === s ? ((e = o.element.find(t)).each(function () {
          var t = V(this);
          t.children('.ui-controlgroup-label-contents').length || t.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>");
        }), o._addClass(e, null, 'ui-widget ui-widget-content ui-state-default'), void (a = a.concat(e.get()))) : void (V.fn[s] && (n = o['_' + s + 'Options'] ? o['_' + s + 'Options']('middle') : {
          classes: {}
        }, o.element.find(t).each(function () {
          var t = V(this),
            e = t[s]('instance'),
            i = V.widget.extend({}, n);
          'button' === s && t.parent('.ui-spinner').length || ((e = e || t[s]()[s]('instance')) && (i.classes = o._resolveClassesValues(i.classes, e)), t[s](i), i = t[s]('widget'), V.data(i[0], 'ui-controlgroup-data', e || t[s]('instance')), a.push(i[0]));
        })));
      }), this.childWidgets = V(V.uniqueSort(a)), this._addClass(this.childWidgets, 'ui-controlgroup-item');
    },
    _callChildMethod: function (e) {
      this.childWidgets.each(function () {
        var t = V(this).data('ui-controlgroup-data');
        t && t[e] && t[e]();
      });
    },
    _updateCornerClass: function (t, e) {
      e = this._buildSimpleOptions(e, 'label').classes.label;
      this._removeClass(t, null, 'ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all'), this._addClass(t, null, e);
    },
    _buildSimpleOptions: function (t, e) {
      var i = 'vertical' === this.options.direction,
        s = {
          classes: {}
        };
      return s.classes[e] = {
        middle: '',
        first: 'ui-corner-' + (i ? 'top' : 'left'),
        last: 'ui-corner-' + (i ? 'bottom' : 'right'),
        only: 'ui-corner-all'
      }[t], s;
    },
    _spinnerOptions: function (t) {
      t = this._buildSimpleOptions(t, 'ui-spinner');
      return t.classes['ui-spinner-up'] = '', t.classes['ui-spinner-down'] = '', t;
    },
    _buttonOptions: function (t) {
      return this._buildSimpleOptions(t, 'ui-button');
    },
    _checkboxradioOptions: function (t) {
      return this._buildSimpleOptions(t, 'ui-checkboxradio-label');
    },
    _selectmenuOptions: function (t) {
      var e = 'vertical' === this.options.direction;
      return {
        width: e && 'auto',
        classes: {
          middle: {
            'ui-selectmenu-button-open': '',
            'ui-selectmenu-button-closed': ''
          },
          first: {
            'ui-selectmenu-button-open': 'ui-corner-' + (e ? 'top' : 'tl'),
            'ui-selectmenu-button-closed': 'ui-corner-' + (e ? 'top' : 'left')
          },
          last: {
            'ui-selectmenu-button-open': e ? '' : 'ui-corner-tr',
            'ui-selectmenu-button-closed': 'ui-corner-' + (e ? 'bottom' : 'right')
          },
          only: {
            'ui-selectmenu-button-open': 'ui-corner-top',
            'ui-selectmenu-button-closed': 'ui-corner-all'
          }
        }[t]
      };
    },
    _resolveClassesValues: function (i, s) {
      var n = {};
      return V.each(i, function (t) {
        var e = s.options.classes[t] || '',
          e = String.prototype.trim.call(e.replace(tt, ''));
        n[t] = (e + ' ' + i[t]).replace(/\s+/g, ' ');
      }), n;
    },
    _setOption: function (t, e) {
      'direction' === t && this._removeClass('ui-controlgroup-' + this.options.direction), this._super(t, e), 'disabled' !== t ? this.refresh() : this._callChildMethod(e ? 'disable' : 'enable');
    },
    refresh: function () {
      var n,
        o = this;
      this._addClass('ui-controlgroup ui-controlgroup-' + this.options.direction), 'horizontal' === this.options.direction && this._addClass(null, 'ui-helper-clearfix'), this._initWidgets(), n = this.childWidgets, (n = this.options.onlyVisible ? n.filter(':visible') : n).length && (V.each(['first', 'last'], function (t, e) {
        var i,
          s = n[e]().data('ui-controlgroup-data');
        s && o['_' + s.widgetName + 'Options'] ? ((i = o['_' + s.widgetName + 'Options'](1 === n.length ? 'only' : e)).classes = o._resolveClassesValues(i.classes, s), s.element[s.widgetName](i)) : o._updateCornerClass(n[e](), e);
      }), this._callChildMethod('refresh'));
    }
  });
  V.widget('ui.checkboxradio', [V.ui.formResetMixin, {
    version: '1.13.1',
    options: {
      disabled: null,
      label: null,
      icon: !0,
      classes: {
        'ui-checkboxradio-label': 'ui-corner-all',
        'ui-checkboxradio-icon': 'ui-corner-all'
      }
    },
    _getCreateOptions: function () {
      var t,
        e = this,
        i = this._super() || {};
      return this._readType(), t = this.element.labels(), this.label = V(t[t.length - 1]), this.label.length || V.error('No label found for checkboxradio widget'), this.originalLabel = '', this.label.contents().not(this.element[0]).each(function () {
        e.originalLabel += 3 === this.nodeType ? V(this).text() : this.outerHTML;
      }), this.originalLabel && (i.label = this.originalLabel), null != (t = this.element[0].disabled) && (i.disabled = t), i;
    },
    _create: function () {
      var t = this.element[0].checked;
      this._bindFormResetHandler(), null == this.options.disabled && (this.options.disabled = this.element[0].disabled), this._setOption('disabled', this.options.disabled), this._addClass('ui-checkboxradio', 'ui-helper-hidden-accessible'), this._addClass(this.label, 'ui-checkboxradio-label', 'ui-button ui-widget'), 'radio' === this.type && this._addClass(this.label, 'ui-checkboxradio-radio-label'), this.options.label && this.options.label !== this.originalLabel ? this._updateLabel() : this.originalLabel && (this.options.label = this.originalLabel), this._enhance(), t && this._addClass(this.label, 'ui-checkboxradio-checked', 'ui-state-active'), this._on({
        change: '_toggleClasses',
        focus: function () {
          this._addClass(this.label, null, 'ui-state-focus ui-visual-focus');
        },
        blur: function () {
          this._removeClass(this.label, null, 'ui-state-focus ui-visual-focus');
        }
      });
    },
    _readType: function () {
      var t = this.element[0].nodeName.toLowerCase();
      this.type = this.element[0].type, 'input' === t && /radio|checkbox/.test(this.type) || V.error("Can't create checkboxradio on element.nodeName=" + t + ' and element.type=' + this.type);
    },
    _enhance: function () {
      this._updateIcon(this.element[0].checked);
    },
    widget: function () {
      return this.label;
    },
    _getRadioGroup: function () {
      var t = this.element[0].name,
        e = "input[name='" + V.escapeSelector(t) + "']";
      return t ? (this.form.length ? V(this.form[0].elements).filter(e) : V(e).filter(function () {
        return 0 === V(this)._form().length;
      })).not(this.element) : V([]);
    },
    _toggleClasses: function () {
      var t = this.element[0].checked;
      this._toggleClass(this.label, 'ui-checkboxradio-checked', 'ui-state-active', t), this.options.icon && 'checkbox' === this.type && this._toggleClass(this.icon, null, 'ui-icon-check ui-state-checked', t)._toggleClass(this.icon, null, 'ui-icon-blank', !t), 'radio' === this.type && this._getRadioGroup().each(function () {
        var t = V(this).checkboxradio('instance');
        t && t._removeClass(t.label, 'ui-checkboxradio-checked', 'ui-state-active');
      });
    },
    _destroy: function () {
      this._unbindFormResetHandler(), this.icon && (this.icon.remove(), this.iconSpace.remove());
    },
    _setOption: function (t, e) {
      if ('label' !== t || e) {
        if (this._super(t, e), 'disabled' === t) return this._toggleClass(this.label, null, 'ui-state-disabled', e), void (this.element[0].disabled = e);
        this.refresh();
      }
    },
    _updateIcon: function (t) {
      var e = 'ui-icon ui-icon-background ';
      this.options.icon ? (this.icon || (this.icon = V('<span>'), this.iconSpace = V('<span> </span>'), this._addClass(this.iconSpace, 'ui-checkboxradio-icon-space')), 'checkbox' === this.type ? (e += t ? 'ui-icon-check ui-state-checked' : 'ui-icon-blank', this._removeClass(this.icon, null, t ? 'ui-icon-blank' : 'ui-icon-check')) : e += 'ui-icon-blank', this._addClass(this.icon, 'ui-checkboxradio-icon', e), t || this._removeClass(this.icon, null, 'ui-icon-check ui-state-checked'), this.icon.prependTo(this.label).after(this.iconSpace)) : void 0 !== this.icon && (this.icon.remove(), this.iconSpace.remove(), delete this.icon);
    },
    _updateLabel: function () {
      var t = this.label.contents().not(this.element[0]);
      this.icon && (t = t.not(this.icon[0])), (t = this.iconSpace ? t.not(this.iconSpace[0]) : t).remove(), this.label.append(this.options.label);
    },
    refresh: function () {
      var t = this.element[0].checked,
        e = this.element[0].disabled;
      this._updateIcon(t), this._toggleClass(this.label, 'ui-checkboxradio-checked', 'ui-state-active', t), null !== this.options.label && this._updateLabel(), e !== this.options.disabled && this._setOptions({
        disabled: e
      });
    }
  }]);
  var et;
  V.ui.checkboxradio;
  V.widget('ui.button', {
    version: '1.13.1',
    defaultElement: '<button>',
    options: {
      classes: {
        'ui-button': 'ui-corner-all'
      },
      disabled: null,
      icon: null,
      iconPosition: 'beginning',
      label: null,
      showLabel: !0
    },
    _getCreateOptions: function () {
      var t,
        e = this._super() || {};
      return this.isInput = this.element.is('input'), null != (t = this.element[0].disabled) && (e.disabled = t), this.originalLabel = this.isInput ? this.element.val() : this.element.html(), this.originalLabel && (e.label = this.originalLabel), e;
    },
    _create: function () {
      !this.option.showLabel & !this.options.icon && (this.options.showLabel = !0), null == this.options.disabled && (this.options.disabled = this.element[0].disabled || !1), this.hasTitle = !!this.element.attr('title'), this.options.label && this.options.label !== this.originalLabel && (this.isInput ? this.element.val(this.options.label) : this.element.html(this.options.label)), this._addClass('ui-button', 'ui-widget'), this._setOption('disabled', this.options.disabled), this._enhance(), this.element.is('a') && this._on({
        keyup: function (t) {
          t.keyCode === V.ui.keyCode.SPACE && (t.preventDefault(), this.element[0].click ? this.element[0].click() : this.element.trigger('click'));
        }
      });
    },
    _enhance: function () {
      this.element.is('button') || this.element.attr('role', 'button'), this.options.icon && (this._updateIcon('icon', this.options.icon), this._updateTooltip());
    },
    _updateTooltip: function () {
      ;
      this.title = this.element.attr('title'), this.options.showLabel || this.title || this.element.attr('title', this.options.label);
    },
    _updateIcon: function (t, e) {
      var i = 'iconPosition' !== t,
        s = i ? this.options.iconPosition : e,
        t = 'top' === s || 'bottom' === s;
      this.icon ? i && this._removeClass(this.icon, null, this.options.icon) : (this.icon = V('<span>'), this._addClass(this.icon, 'ui-button-icon', 'ui-icon'), this.options.showLabel || this._addClass('ui-button-icon-only')), i && this._addClass(this.icon, null, e), this._attachIcon(s), t ? (this._addClass(this.icon, null, 'ui-widget-icon-block'), this.iconSpace && this.iconSpace.remove()) : (this.iconSpace || (this.iconSpace = V('<span> </span>'), this._addClass(this.iconSpace, 'ui-button-icon-space')), this._removeClass(this.icon, null, 'ui-wiget-icon-block'), this._attachIconSpace(s));
    },
    _destroy: function () {
      this.element.removeAttr('role'), this.icon && this.icon.remove(), this.iconSpace && this.iconSpace.remove(), this.hasTitle || this.element.removeAttr('title');
    },
    _attachIconSpace: function (t) {
      this.icon[/^(?:end|bottom)/.test(t) ? 'before' : 'after'](this.iconSpace);
    },
    _attachIcon: function (t) {
      this.element[/^(?:end|bottom)/.test(t) ? 'append' : 'prepend'](this.icon);
    },
    _setOptions: function (t) {
      var e = (void 0 === t.showLabel ? this.options : t).showLabel,
        i = (void 0 === t.icon ? this.options : t).icon;
      e || i || (t.showLabel = !0), this._super(t);
    },
    _setOption: function (t, e) {
      'icon' === t && (e ? this._updateIcon(t, e) : this.icon && (this.icon.remove(), this.iconSpace && this.iconSpace.remove())), 'iconPosition' === t && this._updateIcon(t, e), 'showLabel' === t && (this._toggleClass('ui-button-icon-only', null, !e), this._updateTooltip()), 'label' === t && (this.isInput ? this.element.val(e) : (this.element.html(e), this.icon && (this._attachIcon(this.options.iconPosition), this._attachIconSpace(this.options.iconPosition)))), this._super(t, e), 'disabled' === t && (this._toggleClass(null, 'ui-state-disabled', e), (this.element[0].disabled = e) && this.element.trigger('blur'));
    },
    refresh: function () {
      var t = this.element.is('input, button') ? this.element[0].disabled : this.element.hasClass('ui-button-disabled');
      t !== this.options.disabled && this._setOptions({
        disabled: t
      }), this._updateTooltip();
    }
  }), !1 !== V.uiBackCompat && (V.widget('ui.button', V.ui.button, {
    options: {
      text: !0,
      icons: {
        primary: null,
        secondary: null
      }
    },
    _create: function () {
      this.options.showLabel && !this.options.text && (this.options.showLabel = this.options.text), !this.options.showLabel && this.options.text && (this.options.text = this.options.showLabel), this.options.icon || !this.options.icons.primary && !this.options.icons.secondary ? this.options.icon && (this.options.icons.primary = this.options.icon) : this.options.icons.primary ? this.options.icon = this.options.icons.primary : (this.options.icon = this.options.icons.secondary, this.options.iconPosition = 'end'), this._super();
    },
    _setOption: function (t, e) {
      'text' !== t ? ('showLabel' === t && (this.options.text = e), 'icon' === t && (this.options.icons.primary = e), 'icons' === t && (e.primary ? (this._super('icon', e.primary), this._super('iconPosition', 'beginning')) : e.secondary && (this._super('icon', e.secondary), this._super('iconPosition', 'end'))), this._superApply(arguments)) : this._super('showLabel', e);
    }
  }), V.fn.button = (et = V.fn.button, function (i) {
    var t = 'string' == typeof i,
      s = Array.prototype.slice.call(arguments, 1),
      n = this;
    return t ? this.length || 'instance' !== i ? this.each(function () {
      var t = V(this).attr('type'),
        e = V.data(this, 'ui-' + ('checkbox' !== t && 'radio' !== t ? 'button' : 'checkboxradio'));
      return 'instance' === i ? (n = e, !1) : e ? 'function' != typeof e[i] || '_' === i.charAt(0) ? V.error("no such method '" + i + "' for button widget instance") : (t = e[i].apply(e, s)) !== e && void 0 !== t ? (n = t && t.jquery ? n.pushStack(t.get()) : t, !1) : void 0 : V.error("cannot call methods on button prior to initialization; attempted to call method '" + i + "'");
    }) : n = void 0 : (s.length && (i = V.widget.extend.apply(null, [i].concat(s))), this.each(function () {
      var t = V(this).attr('type'),
        e = 'checkbox' !== t && 'radio' !== t ? 'button' : 'checkboxradio',
        t = V.data(this, 'ui-' + e);
      t ? (t.option(i || {}), t._init && t._init()) : 'button' != e ? V(this).checkboxradio(V.extend({
        icon: !1
      }, i)) : et.call(V(this), i);
    })), n;
  }), V.fn.buttonset = function () {
    return V.ui.controlgroup || V.error('Controlgroup widget missing'), 'option' === arguments[0] && 'items' === arguments[1] && arguments[2] ? this.controlgroup.apply(this, [arguments[0], 'items.button', arguments[2]]) : 'option' === arguments[0] && 'items' === arguments[1] ? this.controlgroup.apply(this, [arguments[0], 'items.button']) : ('object' == typeof arguments[0] && arguments[0].items && (arguments[0].items = {
      button: arguments[0].items
    }), this.controlgroup.apply(this, arguments));
  });
  var it;
  V.ui.button;
  function st() {
    ;
    this._curInst = null, this._keyEvent = !1, this._disabledInputs = [], this._datepickerShowing = !1, this._inDialog = !1, this._mainDivId = 'ui-datepicker-div', this._inlineClass = 'ui-datepicker-inline', this._appendClass = 'ui-datepicker-append', this._triggerClass = 'ui-datepicker-trigger', this._dialogClass = 'ui-datepicker-dialog', this._disableClass = 'ui-datepicker-disabled', this._unselectableClass = 'ui-datepicker-unselectable', this._currentClass = 'ui-datepicker-current-day', this._dayOverClass = 'ui-datepicker-days-cell-over', this.regional = [], this.regional[''] = {
      closeText: 'Done',
      prevText: 'Prev',
      nextText: 'Next',
      currentText: 'Today',
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      weekHeader: 'Wk',
      dateFormat: 'mm/dd/yy',
      firstDay: 0,
      isRTL: !1,
      showMonthAfterYear: !1,
      yearSuffix: '',
      selectMonthLabel: 'Select month',
      selectYearLabel: 'Select year'
    }, this._defaults = {
      showOn: 'focus',
      showAnim: 'fadeIn',
      showOptions: {},
      defaultDate: null,
      appendText: '',
      buttonText: '...',
      buttonImage: '',
      buttonImageOnly: !1,
      hideIfNoPrevNext: !1,
      navigationAsDateFormat: !1,
      gotoCurrent: !1,
      changeMonth: !1,
      changeYear: !1,
      yearRange: 'c-10:c+10',
      showOtherMonths: !1,
      selectOtherMonths: !1,
      showWeek: !1,
      calculateWeek: this.iso8601Week,
      shortYearCutoff: '+10',
      minDate: null,
      maxDate: null,
      duration: 'fast',
      beforeShowDay: null,
      beforeShow: null,
      onSelect: null,
      onChangeMonthYear: null,
      onClose: null,
      onUpdateDatepicker: null,
      numberOfMonths: 1,
      showCurrentAtPos: 0,
      stepMonths: 1,
      stepBigMonths: 12,
      altField: '',
      altFormat: '',
      constrainInput: !0,
      showButtonPanel: !1,
      autoSize: !1,
      disabled: !1
    }, V.extend(this._defaults, this.regional['']), this.regional.en = V.extend(!0, {}, this.regional['']), this.regional['en-US'] = V.extend(!0, {}, this.regional.en), this.dpDiv = nt(V("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
  }
  function nt(t) {
    var e = 'button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a';
    return t.on('mouseout', e, function () {
      V(this).removeClass('ui-state-hover'), -1 !== this.className.indexOf('ui-datepicker-prev') && V(this).removeClass('ui-datepicker-prev-hover'), -1 !== this.className.indexOf('ui-datepicker-next') && V(this).removeClass('ui-datepicker-next-hover');
    }).on('mouseover', e, ot);
  }
  function ot() {
    V.datepicker._isDisabledDatepicker((it.inline ? it.dpDiv.parent() : it.input)[0]) || (V(this).parents('.ui-datepicker-calendar').find('a').removeClass('ui-state-hover'), V(this).addClass('ui-state-hover'), -1 !== this.className.indexOf('ui-datepicker-prev') && V(this).addClass('ui-datepicker-prev-hover'), -1 !== this.className.indexOf('ui-datepicker-next') && V(this).addClass('ui-datepicker-next-hover'));
  }
  function at(t, e) {
    for (var i in V.extend(t, e), e) null == e[i] && (t[i] = e[i]);
    return t;
  }
  V.extend(V.ui, {
    datepicker: {
      version: '1.13.1'
    }
  }), V.extend(st.prototype, {
    markerClassName: 'hasDatepicker',
    maxRows: 4,
    _widgetDatepicker: function () {
      return this.dpDiv;
    },
    setDefaults: function (t) {
      return at(this._defaults, t || {}), this;
    },
    _attachDatepicker: function (t, e) {
      var i,
        s = t.nodeName.toLowerCase(),
        n = 'div' === s || 'span' === s;
      t.id || (this.uuid += 1, t.id = 'dp' + this.uuid), (i = this._newInst(V(t), n)).settings = V.extend({}, e || {}), 'input' === s ? this._connectDatepicker(t, i) : n && this._inlineDatepicker(t, i);
    },
    _newInst: function (t, e) {
      return {
        id: t[0].id.replace(/([^A-Za-z0-9_\-])/g, '\\\\$1'),
        input: t,
        selectedDay: 0,
        selectedMonth: 0,
        selectedYear: 0,
        drawMonth: 0,
        drawYear: 0,
        inline: e,
        dpDiv: e ? nt(V("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")) : this.dpDiv
      };
    },
    _connectDatepicker: function (t, e) {
      var i = V(t);
      e.append = V([]), e.trigger = V([]), i.hasClass(this.markerClassName) || (this._attachments(i, e), i.addClass(this.markerClassName).on('keydown', this._doKeyDown).on('keypress', this._doKeyPress).on('keyup', this._doKeyUp), this._autoSize(e), V.data(t, 'datepicker', e), e.settings.disabled && this._disableDatepicker(t));
    },
    _attachments: function (t, e) {
      var i,
        s = this._get(e, 'appendText'),
        n = this._get(e, 'isRTL');
      e.append && e.append.remove(), s && (e.append = V('<span>').addClass(this._appendClass).text(s), t[n ? 'before' : 'after'](e.append)), t.off('focus', this._showDatepicker), e.trigger && e.trigger.remove(), 'focus' !== (i = this._get(e, 'showOn')) && 'both' !== i || t.on('focus', this._showDatepicker), 'button' !== i && 'both' !== i || (s = this._get(e, 'buttonText'), i = this._get(e, 'buttonImage'), this._get(e, 'buttonImageOnly') ? e.trigger = V('<img>').addClass(this._triggerClass).attr({
        src: i,
        alt: s,
        title: s
      }) : (e.trigger = V("<button type='button'>").addClass(this._triggerClass), i ? e.trigger.html(V('<img>').attr({
        src: i,
        alt: s,
        title: s
      })) : e.trigger.text(s)), t[n ? 'before' : 'after'](e.trigger), e.trigger.on('click', function () {
        return V.datepicker._datepickerShowing && V.datepicker._lastInput === t[0] ? V.datepicker._hideDatepicker() : (V.datepicker._datepickerShowing && V.datepicker._lastInput !== t[0] && V.datepicker._hideDatepicker(), V.datepicker._showDatepicker(t[0])), !1;
      }));
    },
    _autoSize: function (t) {
      var e, i, s, n, o, a;
      this._get(t, 'autoSize') && !t.inline && (o = new Date(2009, 11, 20), (a = this._get(t, 'dateFormat')).match(/[DM]/) && (e = function (t) {
        for (n = s = i = 0; n < t.length; n++) t[n].length > i && (i = t[n].length, s = n);
        return s;
      }, o.setMonth(e(this._get(t, a.match(/MM/) ? 'monthNames' : 'monthNamesShort'))), o.setDate(e(this._get(t, a.match(/DD/) ? 'dayNames' : 'dayNamesShort')) + 20 - o.getDay())), t.input.attr('size', this._formatDate(t, o).length));
    },
    _inlineDatepicker: function (t, e) {
      var i = V(t);
      i.hasClass(this.markerClassName) || (i.addClass(this.markerClassName).append(e.dpDiv), V.data(t, 'datepicker', e), this._setDate(e, this._getDefaultDate(e), !0), this._updateDatepicker(e), this._updateAlternate(e), e.settings.disabled && this._disableDatepicker(t), e.dpDiv.css('display', 'block'));
    },
    _dialogDatepicker: function (t, e, i, s, n) {
      var o,
        a = this._dialogInst;
      return a || (this.uuid += 1, o = 'dp' + this.uuid, this._dialogInput = V("<input type='text' id='" + o + "' style='position: absolute; top: -100px; width: 0px;'/>"), this._dialogInput.on('keydown', this._doKeyDown), V('body').append(this._dialogInput), (a = this._dialogInst = this._newInst(this._dialogInput, !1)).settings = {}, V.data(this._dialogInput[0], 'datepicker', a)), at(a.settings, s || {}), e = e && e.constructor === Date ? this._formatDate(a, e) : e, this._dialogInput.val(e), this._pos = n ? n.length ? n : [n.pageX, n.pageY] : null, this._pos || (o = document.documentElement.clientWidth, s = document.documentElement.clientHeight, e = document.documentElement.scrollLeft || document.body.scrollLeft, n = document.documentElement.scrollTop || document.body.scrollTop, this._pos = [o / 2 - 100 + e, s / 2 - 150 + n]), this._dialogInput.css('left', this._pos[0] + 20 + 'px').css('top', this._pos[1] + 'px'), a.settings.onSelect = i, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), V.blockUI && V.blockUI(this.dpDiv), V.data(this._dialogInput[0], 'datepicker', a), this;
    },
    _destroyDatepicker: function (t) {
      var e,
        i = V(t),
        s = V.data(t, 'datepicker');
      i.hasClass(this.markerClassName) && (e = t.nodeName.toLowerCase(), V.removeData(t, 'datepicker'), 'input' === e ? (s.append.remove(), s.trigger.remove(), i.removeClass(this.markerClassName).off('focus', this._showDatepicker).off('keydown', this._doKeyDown).off('keypress', this._doKeyPress).off('keyup', this._doKeyUp)) : 'div' !== e && 'span' !== e || i.removeClass(this.markerClassName).empty(), it === s && (it = null, this._curInst = null));
    },
    _enableDatepicker: function (e) {
      var t,
        i = V(e),
        s = V.data(e, 'datepicker');
      i.hasClass(this.markerClassName) && ('input' === (t = e.nodeName.toLowerCase()) ? (e.disabled = !1, s.trigger.filter('button').each(function () {
        this.disabled = !1;
      }).end().filter('img').css({
        opacity: '1.0',
        cursor: ''
      })) : 'div' !== t && 'span' !== t || ((i = i.children('.' + this._inlineClass)).children().removeClass('ui-state-disabled'), i.find('select.ui-datepicker-month, select.ui-datepicker-year').prop('disabled', !1)), this._disabledInputs = V.map(this._disabledInputs, function (t) {
        return t === e ? null : t;
      }));
    },
    _disableDatepicker: function (e) {
      var t,
        i = V(e),
        s = V.data(e, 'datepicker');
      i.hasClass(this.markerClassName) && ('input' === (t = e.nodeName.toLowerCase()) ? (e.disabled = !0, s.trigger.filter('button').each(function () {
        this.disabled = !0;
      }).end().filter('img').css({
        opacity: '0.5',
        cursor: 'default'
      })) : 'div' !== t && 'span' !== t || ((i = i.children('.' + this._inlineClass)).children().addClass('ui-state-disabled'), i.find('select.ui-datepicker-month, select.ui-datepicker-year').prop('disabled', !0)), this._disabledInputs = V.map(this._disabledInputs, function (t) {
        return t === e ? null : t;
      }), this._disabledInputs[this._disabledInputs.length] = e);
    },
    _isDisabledDatepicker: function (t) {
      if (!t) return !1;
      for (var e = 0; e < this._disabledInputs.length; e++) if (this._disabledInputs[e] === t) return !0;
      return !1;
    },
    _getInst: function (t) {
      try {
        return V.data(t, 'datepicker');
      } catch (t) {
        throw 'Missing instance data for this datepicker';
      }
    },
    _optionDatepicker: function (t, e, i) {
      var s,
        n,
        o = this._getInst(t);
      if (2 === arguments.length && 'string' == typeof e) return 'defaults' === e ? V.extend({}, V.datepicker._defaults) : o ? 'all' === e ? V.extend({}, o.settings) : this._get(o, e) : null;
      s = e || {}, 'string' == typeof e && ((s = {})[e] = i), o && (this._curInst === o && this._hideDatepicker(), n = this._getDateDatepicker(t, !0), e = this._getMinMaxDate(o, 'min'), i = this._getMinMaxDate(o, 'max'), at(o.settings, s), null !== e && void 0 !== s.dateFormat && void 0 === s.minDate && (o.settings.minDate = this._formatDate(o, e)), null !== i && void 0 !== s.dateFormat && void 0 === s.maxDate && (o.settings.maxDate = this._formatDate(o, i)), 'disabled' in s && (s.disabled ? this._disableDatepicker(t) : this._enableDatepicker(t)), this._attachments(V(t), o), this._autoSize(o), this._setDate(o, n), this._updateAlternate(o), this._updateDatepicker(o));
    },
    _changeDatepicker: function (t, e, i) {
      this._optionDatepicker(t, e, i);
    },
    _refreshDatepicker: function (t) {
      t = this._getInst(t);
      t && this._updateDatepicker(t);
    },
    _setDateDatepicker: function (t, e) {
      t = this._getInst(t);
      t && (this._setDate(t, e), this._updateDatepicker(t), this._updateAlternate(t));
    },
    _getDateDatepicker: function (t, e) {
      t = this._getInst(t);
      return t && !t.inline && this._setDateFromField(t, e), t ? this._getDate(t) : null;
    },
    _doKeyDown: function (t) {
      var e,
        i,
        s = V.datepicker._getInst(t.target),
        n = !0,
        o = s.dpDiv.is('.ui-datepicker-rtl');
      if (s._keyEvent = !0, V.datepicker._datepickerShowing) switch (t.keyCode) {
        case 9:
          V.datepicker._hideDatepicker(), n = !1;
          break;
        case 13:
          return (i = V('td.' + V.datepicker._dayOverClass + ':not(.' + V.datepicker._currentClass + ')', s.dpDiv))[0] && V.datepicker._selectDay(t.target, s.selectedMonth, s.selectedYear, i[0]), (e = V.datepicker._get(s, 'onSelect')) ? (i = V.datepicker._formatDate(s), e.apply(s.input ? s.input[0] : null, [i, s])) : V.datepicker._hideDatepicker(), !1;
        case 27:
          V.datepicker._hideDatepicker();
          break;
        case 33:
          V.datepicker._adjustDate(t.target, t.ctrlKey ? -V.datepicker._get(s, 'stepBigMonths') : -V.datepicker._get(s, 'stepMonths'), 'M');
          break;
        case 34:
          V.datepicker._adjustDate(t.target, t.ctrlKey ? +V.datepicker._get(s, 'stepBigMonths') : +V.datepicker._get(s, 'stepMonths'), 'M');
          break;
        case 35:
          ;
          (t.ctrlKey || t.metaKey) && V.datepicker._clearDate(t.target), n = t.ctrlKey || t.metaKey;
          break;
        case 36:
          ;
          (t.ctrlKey || t.metaKey) && V.datepicker._gotoToday(t.target), n = t.ctrlKey || t.metaKey;
          break;
        case 37:
          ;
          (t.ctrlKey || t.metaKey) && V.datepicker._adjustDate(t.target, o ? 1 : -1, 'D'), n = t.ctrlKey || t.metaKey, t.originalEvent.altKey && V.datepicker._adjustDate(t.target, t.ctrlKey ? -V.datepicker._get(s, 'stepBigMonths') : -V.datepicker._get(s, 'stepMonths'), 'M');
          break;
        case 38:
          ;
          (t.ctrlKey || t.metaKey) && V.datepicker._adjustDate(t.target, -7, 'D'), n = t.ctrlKey || t.metaKey;
          break;
        case 39:
          ;
          (t.ctrlKey || t.metaKey) && V.datepicker._adjustDate(t.target, o ? -1 : 1, 'D'), n = t.ctrlKey || t.metaKey, t.originalEvent.altKey && V.datepicker._adjustDate(t.target, t.ctrlKey ? +V.datepicker._get(s, 'stepBigMonths') : +V.datepicker._get(s, 'stepMonths'), 'M');
          break;
        case 40:
          ;
          (t.ctrlKey || t.metaKey) && V.datepicker._adjustDate(t.target, 7, 'D'), n = t.ctrlKey || t.metaKey;
          break;
        default:
          n = !1;
      } else 36 === t.keyCode && t.ctrlKey ? V.datepicker._showDatepicker(this) : n = !1;
      n && (t.preventDefault(), t.stopPropagation());
    },
    _doKeyPress: function (t) {
      var e,
        i = V.datepicker._getInst(t.target);
      if (V.datepicker._get(i, 'constrainInput')) return e = V.datepicker._possibleChars(V.datepicker._get(i, 'dateFormat')), i = String.fromCharCode(null == t.charCode ? t.keyCode : t.charCode), t.ctrlKey || t.metaKey || i < ' ' || !e || -1 < e.indexOf(i);
    },
    _doKeyUp: function (t) {
      t = V.datepicker._getInst(t.target);
      if (t.input.val() !== t.lastVal) try {
        V.datepicker.parseDate(V.datepicker._get(t, 'dateFormat'), t.input ? t.input.val() : null, V.datepicker._getFormatConfig(t)) && (V.datepicker._setDateFromField(t), V.datepicker._updateAlternate(t), V.datepicker._updateDatepicker(t));
      } catch (t) {}
      return !0;
    },
    _showDatepicker: function (t) {
      var e, i, s, n;
      'input' !== (t = t.target || t).nodeName.toLowerCase() && (t = V('input', t.parentNode)[0]), V.datepicker._isDisabledDatepicker(t) || V.datepicker._lastInput === t || (n = V.datepicker._getInst(t), V.datepicker._curInst && V.datepicker._curInst !== n && (V.datepicker._curInst.dpDiv.stop(!0, !0), n && V.datepicker._datepickerShowing && V.datepicker._hideDatepicker(V.datepicker._curInst.input[0])), !1 !== (i = (s = V.datepicker._get(n, 'beforeShow')) ? s.apply(t, [t, n]) : {}) && (at(n.settings, i), n.lastVal = null, V.datepicker._lastInput = t, V.datepicker._setDateFromField(n), V.datepicker._inDialog && (t.value = ''), V.datepicker._pos || (V.datepicker._pos = V.datepicker._findPos(t), V.datepicker._pos[1] += t.offsetHeight), e = !1, V(t).parents().each(function () {
        return !(e |= 'fixed' === V(this).css('position'));
      }), s = {
        left: V.datepicker._pos[0],
        top: V.datepicker._pos[1]
      }, V.datepicker._pos = null, n.dpDiv.empty(), n.dpDiv.css({
        position: 'absolute',
        display: 'block',
        top: '-1000px'
      }), V.datepicker._updateDatepicker(n), s = V.datepicker._checkOffset(n, s, e), n.dpDiv.css({
        position: V.datepicker._inDialog && V.blockUI ? 'static' : e ? 'fixed' : 'absolute',
        display: 'none',
        left: s.left + 'px',
        top: s.top + 'px'
      }), n.inline || (i = V.datepicker._get(n, 'showAnim'), s = V.datepicker._get(n, 'duration'), n.dpDiv.css('z-index', function (t) {
        for (var e, i; t.length && t[0] !== document;) {
          if (('absolute' === (e = t.css('position')) || 'relative' === e || 'fixed' === e) && (i = parseInt(t.css('zIndex'), 10), !isNaN(i) && 0 !== i)) return i;
          t = t.parent();
        }
        return 0;
      }(V(t)) + 1), V.datepicker._datepickerShowing = !0, V.effects && V.effects.effect[i] ? n.dpDiv.show(i, V.datepicker._get(n, 'showOptions'), s) : n.dpDiv[i || 'show'](i ? s : null), V.datepicker._shouldFocusInput(n) && n.input.trigger('focus'), V.datepicker._curInst = n)));
    },
    _updateDatepicker: function (t) {
      ;
      this.maxRows = 4, (it = t).dpDiv.empty().append(this._generateHTML(t)), this._attachHandlers(t);
      var e,
        i = this._getNumberOfMonths(t),
        s = i[1],
        n = t.dpDiv.find('.' + this._dayOverClass + ' a'),
        o = V.datepicker._get(t, 'onUpdateDatepicker');
      0 < n.length && ot.apply(n.get(0)), t.dpDiv.removeClass('ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4').width(''), 1 < s && t.dpDiv.addClass('ui-datepicker-multi-' + s).css('width', 17 * s + 'em'), t.dpDiv[(1 !== i[0] || 1 !== i[1] ? 'add' : 'remove') + 'Class']('ui-datepicker-multi'), t.dpDiv[(this._get(t, 'isRTL') ? 'add' : 'remove') + 'Class']('ui-datepicker-rtl'), t === V.datepicker._curInst && V.datepicker._datepickerShowing && V.datepicker._shouldFocusInput(t) && t.input.trigger('focus'), t.yearshtml && (e = t.yearshtml, setTimeout(function () {
        e === t.yearshtml && t.yearshtml && t.dpDiv.find('select.ui-datepicker-year').first().replaceWith(t.yearshtml), e = t.yearshtml = null;
      }, 0)), o && o.apply(t.input ? t.input[0] : null, [t]);
    },
    _shouldFocusInput: function (t) {
      return t.input && t.input.is(':visible') && !t.input.is(':disabled') && !t.input.is(':focus');
    },
    _checkOffset: function (t, e, i) {
      var s = t.dpDiv.outerWidth(),
        n = t.dpDiv.outerHeight(),
        o = t.input ? t.input.outerWidth() : 0,
        a = t.input ? t.input.outerHeight() : 0,
        r = document.documentElement.clientWidth + (i ? 0 : V(document).scrollLeft()),
        l = document.documentElement.clientHeight + (i ? 0 : V(document).scrollTop());
      return e.left -= this._get(t, 'isRTL') ? s - o : 0, e.left -= i && e.left === t.input.offset().left ? V(document).scrollLeft() : 0, e.top -= i && e.top === t.input.offset().top + a ? V(document).scrollTop() : 0, e.left -= Math.min(e.left, e.left + s > r && s < r ? Math.abs(e.left + s - r) : 0), e.top -= Math.min(e.top, e.top + n > l && n < l ? Math.abs(n + a) : 0), e;
    },
    _findPos: function (t) {
      for (var e = this._getInst(t), i = this._get(e, 'isRTL'); t && ('hidden' === t.type || 1 !== t.nodeType || V.expr.pseudos.hidden(t));) t = t[i ? 'previousSibling' : 'nextSibling'];
      return [(e = V(t).offset()).left, e.top];
    },
    _hideDatepicker: function (t) {
      var e,
        i,
        s = this._curInst;
      !s || t && s !== V.data(t, 'datepicker') || this._datepickerShowing && (e = this._get(s, 'showAnim'), i = this._get(s, 'duration'), t = function () {
        V.datepicker._tidyDialog(s);
      }, V.effects && (V.effects.effect[e] || V.effects[e]) ? s.dpDiv.hide(e, V.datepicker._get(s, 'showOptions'), i, t) : s.dpDiv['slideDown' === e ? 'slideUp' : 'fadeIn' === e ? 'fadeOut' : 'hide'](e ? i : null, t), e || t(), this._datepickerShowing = !1, (t = this._get(s, 'onClose')) && t.apply(s.input ? s.input[0] : null, [s.input ? s.input.val() : '', s]), this._lastInput = null, this._inDialog && (this._dialogInput.css({
        position: 'absolute',
        left: '0',
        top: '-100px'
      }), V.blockUI && (V.unblockUI(), V('body').append(this.dpDiv))), this._inDialog = !1);
    },
    _tidyDialog: function (t) {
      t.dpDiv.removeClass(this._dialogClass).off('.ui-datepicker-calendar');
    },
    _checkExternalClick: function (t) {
      var e;
      V.datepicker._curInst && (e = V(t.target), t = V.datepicker._getInst(e[0]), (e[0].id === V.datepicker._mainDivId || 0 !== e.parents('#' + V.datepicker._mainDivId).length || e.hasClass(V.datepicker.markerClassName) || e.closest('.' + V.datepicker._triggerClass).length || !V.datepicker._datepickerShowing || V.datepicker._inDialog && V.blockUI) && (!e.hasClass(V.datepicker.markerClassName) || V.datepicker._curInst === t) || V.datepicker._hideDatepicker());
    },
    _adjustDate: function (t, e, i) {
      var s = V(t),
        t = this._getInst(s[0]);
      this._isDisabledDatepicker(s[0]) || (this._adjustInstDate(t, e, i), this._updateDatepicker(t));
    },
    _gotoToday: function (t) {
      var e = V(t),
        i = this._getInst(e[0]);
      this._get(i, 'gotoCurrent') && i.currentDay ? (i.selectedDay = i.currentDay, i.drawMonth = i.selectedMonth = i.currentMonth, i.drawYear = i.selectedYear = i.currentYear) : (t = new Date(), i.selectedDay = t.getDate(), i.drawMonth = i.selectedMonth = t.getMonth(), i.drawYear = i.selectedYear = t.getFullYear()), this._notifyChange(i), this._adjustDate(e);
    },
    _selectMonthYear: function (t, e, i) {
      var s = V(t),
        t = this._getInst(s[0]);
      t['selected' + ('M' === i ? 'Month' : 'Year')] = t['draw' + ('M' === i ? 'Month' : 'Year')] = parseInt(e.options[e.selectedIndex].value, 10), this._notifyChange(t), this._adjustDate(s);
    },
    _selectDay: function (t, e, i, s) {
      var n = V(t);
      V(s).hasClass(this._unselectableClass) || this._isDisabledDatepicker(n[0]) || ((n = this._getInst(n[0])).selectedDay = n.currentDay = parseInt(V('a', s).attr('data-date')), n.selectedMonth = n.currentMonth = e, n.selectedYear = n.currentYear = i, this._selectDate(t, this._formatDate(n, n.currentDay, n.currentMonth, n.currentYear)));
    },
    _clearDate: function (t) {
      t = V(t);
      this._selectDate(t, '');
    },
    _selectDate: function (t, e) {
      var i = V(t),
        t = this._getInst(i[0]);
      e = null != e ? e : this._formatDate(t), t.input && t.input.val(e), this._updateAlternate(t), (i = this._get(t, 'onSelect')) ? i.apply(t.input ? t.input[0] : null, [e, t]) : t.input && t.input.trigger('change'), t.inline ? this._updateDatepicker(t) : (this._hideDatepicker(), this._lastInput = t.input[0], 'object' != typeof t.input[0] && t.input.trigger('focus'), this._lastInput = null);
    },
    _updateAlternate: function (t) {
      var e,
        i,
        s = this._get(t, 'altField');
      s && (e = this._get(t, 'altFormat') || this._get(t, 'dateFormat'), i = this._getDate(t), t = this.formatDate(e, i, this._getFormatConfig(t)), V(document).find(s).val(t));
    },
    noWeekends: function (t) {
      t = t.getDay();
      return [0 < t && t < 6, ''];
    },
    iso8601Week: function (t) {
      var e = new Date(t.getTime());
      return e.setDate(e.getDate() + 4 - (e.getDay() || 7)), t = e.getTime(), e.setMonth(0), e.setDate(1), Math.floor(Math.round((t - e) / 864e5) / 7) + 1;
    },
    parseDate: function (e, n, t) {
      if (null == e || null == n) throw 'Invalid arguments';
      if ('' === (n = 'object' == typeof n ? n.toString() : n + '')) return null;
      for (var i, s, o, a = 0, r = (t ? t.shortYearCutoff : null) || this._defaults.shortYearCutoff, r = 'string' != typeof r ? r : new Date().getFullYear() % 100 + parseInt(r, 10), l = (t ? t.dayNamesShort : null) || this._defaults.dayNamesShort, h = (t ? t.dayNames : null) || this._defaults.dayNames, c = (t ? t.monthNamesShort : null) || this._defaults.monthNamesShort, u = (t ? t.monthNames : null) || this._defaults.monthNames, d = -1, p = -1, f = -1, g = -1, m = !1, _ = function (t) {
          t = w + 1 < e.length && e.charAt(w + 1) === t;
          return t && w++, t;
        }, v = function (t) {
          var e = _(t),
            e = '@' === t ? 14 : '!' === t ? 20 : 'y' === t && e ? 4 : 'o' === t ? 3 : 2,
            e = new RegExp('^\\d{' + ('y' === t ? e : 1) + ',' + e + '}'),
            e = n.substring(a).match(e);
          if (!e) throw 'Missing number at position ' + a;
          return a += e[0].length, parseInt(e[0], 10);
        }, b = function (t, e, i) {
          var s = -1,
            e = V.map(_(t) ? i : e, function (t, e) {
              return [[e, t]];
            }).sort(function (t, e) {
              return -(t[1].length - e[1].length);
            });
          if (V.each(e, function (t, e) {
            var i = e[1];
            if (n.substr(a, i.length).toLowerCase() === i.toLowerCase()) return s = e[0], a += i.length, !1;
          }), -1 !== s) return s + 1;
          throw 'Unknown name at position ' + a;
        }, y = function () {
          if (n.charAt(a) !== e.charAt(w)) throw 'Unexpected literal at position ' + a;
          a++;
        }, w = 0; w < e.length; w++) if (m) "'" !== e.charAt(w) || _("'") ? y() : m = !1;else switch (e.charAt(w)) {
        case 'd':
          f = v('d');
          break;
        case 'D':
          b('D', l, h);
          break;
        case 'o':
          g = v('o');
          break;
        case 'm':
          p = v('m');
          break;
        case 'M':
          p = b('M', c, u);
          break;
        case 'y':
          d = v('y');
          break;
        case '@':
          ;
          d = (o = new Date(v('@'))).getFullYear(), p = o.getMonth() + 1, f = o.getDate();
          break;
        case '!':
          ;
          d = (o = new Date((v('!') - this._ticksTo1970) / 1e4)).getFullYear(), p = o.getMonth() + 1, f = o.getDate();
          break;
        case "'":
          _("'") ? y() : m = !0;
          break;
        default:
          y();
      }
      if (a < n.length && (s = n.substr(a), !/^\s+/.test(s))) throw 'Extra/unparsed characters found in date: ' + s;
      if (-1 === d ? d = new Date().getFullYear() : d < 100 && (d += new Date().getFullYear() - new Date().getFullYear() % 100 + (d <= r ? 0 : -100)), -1 < g) for (p = 1, f = g;;) {
        if (f <= (i = this._getDaysInMonth(d, p - 1))) break;
        p++, f -= i;
      }
      if ((o = this._daylightSavingAdjust(new Date(d, p - 1, f))).getFullYear() !== d || o.getMonth() + 1 !== p || o.getDate() !== f) throw 'Invalid date';
      return o;
    },
    ATOM: 'yy-mm-dd',
    COOKIE: 'D, dd M yy',
    ISO_8601: 'yy-mm-dd',
    RFC_822: 'D, d M y',
    RFC_850: 'DD, dd-M-y',
    RFC_1036: 'D, d M y',
    RFC_1123: 'D, d M yy',
    RFC_2822: 'D, d M yy',
    RSS: 'D, d M y',
    TICKS: '!',
    TIMESTAMP: '@',
    W3C: 'yy-mm-dd',
    _ticksTo1970: 24 * (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) * 60 * 60 * 1e7,
    formatDate: function (e, t, i) {
      if (!t) return '';
      function s(t, e, i) {
        var s = '' + e;
        if (c(t)) for (; s.length < i;) s = '0' + s;
        return s;
      }
      function n(t, e, i, s) {
        return (c(t) ? s : i)[e];
      }
      var o,
        a = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort,
        r = (i ? i.dayNames : null) || this._defaults.dayNames,
        l = (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort,
        h = (i ? i.monthNames : null) || this._defaults.monthNames,
        c = function (t) {
          t = o + 1 < e.length && e.charAt(o + 1) === t;
          return t && o++, t;
        },
        u = '',
        d = !1;
      if (t) for (o = 0; o < e.length; o++) if (d) "'" !== e.charAt(o) || c("'") ? u += e.charAt(o) : d = !1;else switch (e.charAt(o)) {
        case 'd':
          u += s('d', t.getDate(), 2);
          break;
        case 'D':
          u += n('D', t.getDay(), a, r);
          break;
        case 'o':
          u += s('o', Math.round((new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5), 3);
          break;
        case 'm':
          u += s('m', t.getMonth() + 1, 2);
          break;
        case 'M':
          u += n('M', t.getMonth(), l, h);
          break;
        case 'y':
          u += c('y') ? t.getFullYear() : (t.getFullYear() % 100 < 10 ? '0' : '') + t.getFullYear() % 100;
          break;
        case '@':
          u += t.getTime();
          break;
        case '!':
          u += 1e4 * t.getTime() + this._ticksTo1970;
          break;
        case "'":
          c("'") ? u += "'" : d = !0;
          break;
        default:
          u += e.charAt(o);
      }
      return u;
    },
    _possibleChars: function (e) {
      for (var t = '', i = !1, s = function (t) {
          t = n + 1 < e.length && e.charAt(n + 1) === t;
          return t && n++, t;
        }, n = 0; n < e.length; n++) if (i) "'" !== e.charAt(n) || s("'") ? t += e.charAt(n) : i = !1;else switch (e.charAt(n)) {
        case 'd':
        case 'm':
        case 'y':
        case '@':
          t += '0123456789';
          break;
        case 'D':
        case 'M':
          return null;
        case "'":
          s("'") ? t += "'" : i = !0;
          break;
        default:
          t += e.charAt(n);
      }
      return t;
    },
    _get: function (t, e) {
      return (void 0 !== t.settings[e] ? t.settings : this._defaults)[e];
    },
    _setDateFromField: function (t, e) {
      if (t.input.val() !== t.lastVal) {
        var i = this._get(t, 'dateFormat'),
          s = t.lastVal = t.input ? t.input.val() : null,
          n = this._getDefaultDate(t),
          o = n,
          a = this._getFormatConfig(t);
        try {
          o = this.parseDate(i, s, a) || n;
        } catch (t) {
          s = e ? '' : s;
        }
        ;
        t.selectedDay = o.getDate(), t.drawMonth = t.selectedMonth = o.getMonth(), t.drawYear = t.selectedYear = o.getFullYear(), t.currentDay = s ? o.getDate() : 0, t.currentMonth = s ? o.getMonth() : 0, t.currentYear = s ? o.getFullYear() : 0, this._adjustInstDate(t);
      }
    },
    _getDefaultDate: function (t) {
      return this._restrictMinMax(t, this._determineDate(t, this._get(t, 'defaultDate'), new Date()));
    },
    _determineDate: function (r, t, e) {
      var i,
        s,
        t = null == t || '' === t ? e : 'string' == typeof t ? function (t) {
          try {
            return V.datepicker.parseDate(V.datepicker._get(r, 'dateFormat'), t, V.datepicker._getFormatConfig(r));
          } catch (t) {}
          for (var e = (t.toLowerCase().match(/^c/) ? V.datepicker._getDate(r) : null) || new Date(), i = e.getFullYear(), s = e.getMonth(), n = e.getDate(), o = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, a = o.exec(t); a;) {
            switch (a[2] || 'd') {
              case 'd':
              case 'D':
                n += parseInt(a[1], 10);
                break;
              case 'w':
              case 'W':
                n += 7 * parseInt(a[1], 10);
                break;
              case 'm':
              case 'M':
                ;
                s += parseInt(a[1], 10), n = Math.min(n, V.datepicker._getDaysInMonth(i, s));
                break;
              case 'y':
              case 'Y':
                ;
                i += parseInt(a[1], 10), n = Math.min(n, V.datepicker._getDaysInMonth(i, s));
            }
            a = o.exec(t);
          }
          return new Date(i, s, n);
        }(t) : 'number' == typeof t ? isNaN(t) ? e : (i = t, (s = new Date()).setDate(s.getDate() + i), s) : new Date(t.getTime());
      return (t = t && 'Invalid Date' === t.toString() ? e : t) && (t.setHours(0), t.setMinutes(0), t.setSeconds(0), t.setMilliseconds(0)), this._daylightSavingAdjust(t);
    },
    _daylightSavingAdjust: function (t) {
      return t ? (t.setHours(12 < t.getHours() ? t.getHours() + 2 : 0), t) : null;
    },
    _setDate: function (t, e, i) {
      var s = !e,
        n = t.selectedMonth,
        o = t.selectedYear,
        e = this._restrictMinMax(t, this._determineDate(t, e, new Date()));
      t.selectedDay = t.currentDay = e.getDate(), t.drawMonth = t.selectedMonth = t.currentMonth = e.getMonth(), t.drawYear = t.selectedYear = t.currentYear = e.getFullYear(), n === t.selectedMonth && o === t.selectedYear || i || this._notifyChange(t), this._adjustInstDate(t), t.input && t.input.val(s ? '' : this._formatDate(t));
    },
    _getDate: function (t) {
      return !t.currentYear || t.input && '' === t.input.val() ? null : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));
    },
    _attachHandlers: function (t) {
      var e = this._get(t, 'stepMonths'),
        i = '#' + t.id.replace(/\\\\/g, '\\');
      t.dpDiv.find('[data-handler]').map(function () {
        var t = {
          prev: function () {
            V.datepicker._adjustDate(i, -e, 'M');
          },
          next: function () {
            V.datepicker._adjustDate(i, +e, 'M');
          },
          hide: function () {
            V.datepicker._hideDatepicker();
          },
          today: function () {
            V.datepicker._gotoToday(i);
          },
          selectDay: function () {
            return V.datepicker._selectDay(i, +this.getAttribute('data-month'), +this.getAttribute('data-year'), this), !1;
          },
          selectMonth: function () {
            return V.datepicker._selectMonthYear(i, this, 'M'), !1;
          },
          selectYear: function () {
            return V.datepicker._selectMonthYear(i, this, 'Y'), !1;
          }
        };
        V(this).on(this.getAttribute('data-event'), t[this.getAttribute('data-handler')]);
      });
    },
    _generateHTML: function (t) {
      var e,
        i,
        s,
        n,
        o,
        a,
        r,
        l,
        h,
        c,
        u,
        d,
        p,
        f,
        g,
        m,
        _,
        v,
        b,
        y,
        w,
        x,
        k,
        C,
        D,
        I,
        T,
        P,
        M,
        S,
        H,
        z,
        A = new Date(),
        O = this._daylightSavingAdjust(new Date(A.getFullYear(), A.getMonth(), A.getDate())),
        N = this._get(t, 'isRTL'),
        E = this._get(t, 'showButtonPanel'),
        W = this._get(t, 'hideIfNoPrevNext'),
        F = this._get(t, 'navigationAsDateFormat'),
        L = this._getNumberOfMonths(t),
        R = this._get(t, 'showCurrentAtPos'),
        A = this._get(t, 'stepMonths'),
        Y = 1 !== L[0] || 1 !== L[1],
        B = this._daylightSavingAdjust(t.currentDay ? new Date(t.currentYear, t.currentMonth, t.currentDay) : new Date(9999, 9, 9)),
        j = this._getMinMaxDate(t, 'min'),
        q = this._getMinMaxDate(t, 'max'),
        K = t.drawMonth - R,
        U = t.drawYear;
      if (K < 0 && (K += 12, U--), q) for (e = this._daylightSavingAdjust(new Date(q.getFullYear(), q.getMonth() - L[0] * L[1] + 1, q.getDate())), e = j && e < j ? j : e; this._daylightSavingAdjust(new Date(U, K, 1)) > e;) --K < 0 && (K = 11, U--);
      for (t.drawMonth = K, t.drawYear = U, R = this._get(t, 'prevText'), R = F ? this.formatDate(R, this._daylightSavingAdjust(new Date(U, K - A, 1)), this._getFormatConfig(t)) : R, i = this._canAdjustMonth(t, -1, U, K) ? V('<a>').attr({
        class: 'ui-datepicker-prev ui-corner-all',
        'data-handler': 'prev',
        'data-event': 'click',
        title: R
      }).append(V('<span>').addClass('ui-icon ui-icon-circle-triangle-' + (N ? 'e' : 'w')).text(R))[0].outerHTML : W ? '' : V('<a>').attr({
        class: 'ui-datepicker-prev ui-corner-all ui-state-disabled',
        title: R
      }).append(V('<span>').addClass('ui-icon ui-icon-circle-triangle-' + (N ? 'e' : 'w')).text(R))[0].outerHTML, R = this._get(t, 'nextText'), R = F ? this.formatDate(R, this._daylightSavingAdjust(new Date(U, K + A, 1)), this._getFormatConfig(t)) : R, s = this._canAdjustMonth(t, 1, U, K) ? V('<a>').attr({
        class: 'ui-datepicker-next ui-corner-all',
        'data-handler': 'next',
        'data-event': 'click',
        title: R
      }).append(V('<span>').addClass('ui-icon ui-icon-circle-triangle-' + (N ? 'w' : 'e')).text(R))[0].outerHTML : W ? '' : V('<a>').attr({
        class: 'ui-datepicker-next ui-corner-all ui-state-disabled',
        title: R
      }).append(V('<span>').attr('class', 'ui-icon ui-icon-circle-triangle-' + (N ? 'w' : 'e')).text(R))[0].outerHTML, A = this._get(t, 'currentText'), W = this._get(t, 'gotoCurrent') && t.currentDay ? B : O, A = F ? this.formatDate(A, W, this._getFormatConfig(t)) : A, R = '', t.inline || (R = V('<button>').attr({
        type: 'button',
        class: 'ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all',
        'data-handler': 'hide',
        'data-event': 'click'
      }).text(this._get(t, 'closeText'))[0].outerHTML), F = '', E && (F = V("<div class='ui-datepicker-buttonpane ui-widget-content'>").append(N ? R : '').append(this._isInRange(t, W) ? V('<button>').attr({
        type: 'button',
        class: 'ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all',
        'data-handler': 'today',
        'data-event': 'click'
      }).text(A) : '').append(N ? '' : R)[0].outerHTML), n = parseInt(this._get(t, 'firstDay'), 10), n = isNaN(n) ? 0 : n, o = this._get(t, 'showWeek'), a = this._get(t, 'dayNames'), r = this._get(t, 'dayNamesMin'), l = this._get(t, 'monthNames'), h = this._get(t, 'monthNamesShort'), c = this._get(t, 'beforeShowDay'), u = this._get(t, 'showOtherMonths'), d = this._get(t, 'selectOtherMonths'), p = this._getDefaultDate(t), f = '', m = 0; m < L[0]; m++) {
        for (_ = '', this.maxRows = 4, v = 0; v < L[1]; v++) {
          if (b = this._daylightSavingAdjust(new Date(U, K, t.selectedDay)), y = ' ui-corner-all', w = '', Y) {
            if (w += "<div class='ui-datepicker-group", 1 < L[1]) switch (v) {
              case 0:
                ;
                w += ' ui-datepicker-group-first', y = ' ui-corner-' + (N ? 'right' : 'left');
                break;
              case L[1] - 1:
                ;
                w += ' ui-datepicker-group-last', y = ' ui-corner-' + (N ? 'left' : 'right');
                break;
              default:
                ;
                w += ' ui-datepicker-group-middle', y = '';
            }
            w += "'>";
          }
          for (w += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + y + "'>" + (/all|left/.test(y) && 0 === m ? N ? s : i : '') + (/all|right/.test(y) && 0 === m ? N ? i : s : '') + this._generateMonthYearHeader(t, K, U, j, q, 0 < m || 0 < v, l, h) + "</div><table class='ui-datepicker-calendar'><thead><tr>", x = o ? "<th class='ui-datepicker-week-col'>" + this._get(t, 'weekHeader') + '</th>' : '', g = 0; g < 7; g++) x += "<th scope='col'" + (5 <= (g + n + 6) % 7 ? " class='ui-datepicker-week-end'" : '') + "><span title='" + a[k = (g + n) % 7] + "'>" + r[k] + '</span></th>';
          for (w += x + '</tr></thead><tbody>', D = this._getDaysInMonth(U, K), U === t.selectedYear && K === t.selectedMonth && (t.selectedDay = Math.min(t.selectedDay, D)), C = (this._getFirstDayOfMonth(U, K) - n + 7) % 7, D = Math.ceil((C + D) / 7), I = Y && this.maxRows > D ? this.maxRows : D, this.maxRows = I, T = this._daylightSavingAdjust(new Date(U, K, 1 - C)), P = 0; P < I; P++) {
            for (w += '<tr>', M = o ? "<td class='ui-datepicker-week-col'>" + this._get(t, 'calculateWeek')(T) + '</td>' : '', g = 0; g < 7; g++) S = c ? c.apply(t.input ? t.input[0] : null, [T]) : [!0, ''], z = (H = T.getMonth() !== K) && !d || !S[0] || j && T < j || q && q < T, M += "<td class='" + (5 <= (g + n + 6) % 7 ? ' ui-datepicker-week-end' : '') + (H ? ' ui-datepicker-other-month' : '') + (T.getTime() === b.getTime() && K === t.selectedMonth && t._keyEvent || p.getTime() === T.getTime() && p.getTime() === b.getTime() ? ' ' + this._dayOverClass : '') + (z ? ' ' + this._unselectableClass + ' ui-state-disabled' : '') + (H && !u ? '' : ' ' + S[1] + (T.getTime() === B.getTime() ? ' ' + this._currentClass : '') + (T.getTime() === O.getTime() ? ' ui-datepicker-today' : '')) + "'" + (H && !u || !S[2] ? '' : " title='" + S[2].replace(/'/g, '&#39;') + "'") + (z ? '' : " data-handler='selectDay' data-event='click' data-month='" + T.getMonth() + "' data-year='" + T.getFullYear() + "'") + '>' + (H && !u ? '&#xa0;' : z ? "<span class='ui-state-default'>" + T.getDate() + '</span>' : "<a class='ui-state-default" + (T.getTime() === O.getTime() ? ' ui-state-highlight' : '') + (T.getTime() === B.getTime() ? ' ui-state-active' : '') + (H ? ' ui-priority-secondary' : '') + "' href='#' aria-current='" + (T.getTime() === B.getTime() ? 'true' : 'false') + "' data-date='" + T.getDate() + "'>" + T.getDate() + '</a>') + '</td>', T.setDate(T.getDate() + 1), T = this._daylightSavingAdjust(T);
            w += M + '</tr>';
          }
          11 < ++K && (K = 0, U++), _ += w += '</tbody></table>' + (Y ? '</div>' + (0 < L[0] && v === L[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : '') : '');
        }
        f += _;
      }
      return f += F, t._keyEvent = !1, f;
    },
    _generateMonthYearHeader: function (t, e, i, s, n, o, a, r) {
      var l,
        h,
        c,
        u,
        d,
        p,
        f = this._get(t, 'changeMonth'),
        g = this._get(t, 'changeYear'),
        m = this._get(t, 'showMonthAfterYear'),
        _ = this._get(t, 'selectMonthLabel'),
        v = this._get(t, 'selectYearLabel'),
        b = "<div class='ui-datepicker-title'>",
        y = '';
      if (o || !f) y += "<span class='ui-datepicker-month'>" + a[e] + '</span>';else {
        for (l = s && s.getFullYear() === i, h = n && n.getFullYear() === i, y += "<select class='ui-datepicker-month' aria-label='" + _ + "' data-handler='selectMonth' data-event='change'>", c = 0; c < 12; c++) (!l || c >= s.getMonth()) && (!h || c <= n.getMonth()) && (y += "<option value='" + c + "'" + (c === e ? " selected='selected'" : '') + '>' + r[c] + '</option>');
        y += '</select>';
      }
      if (m || (b += y + (!o && f && g ? '' : '&#xa0;')), !t.yearshtml) if (t.yearshtml = '', o || !g) b += "<span class='ui-datepicker-year'>" + i + '</span>';else {
        for (a = this._get(t, 'yearRange').split(':'), u = new Date().getFullYear(), d = (_ = function (t) {
          t = t.match(/c[+\-].*/) ? i + parseInt(t.substring(1), 10) : t.match(/[+\-].*/) ? u + parseInt(t, 10) : parseInt(t, 10);
          return isNaN(t) ? u : t;
        })(a[0]), p = Math.max(d, _(a[1] || '')), d = s ? Math.max(d, s.getFullYear()) : d, p = n ? Math.min(p, n.getFullYear()) : p, t.yearshtml += "<select class='ui-datepicker-year' aria-label='" + v + "' data-handler='selectYear' data-event='change'>"; d <= p; d++) t.yearshtml += "<option value='" + d + "'" + (d === i ? " selected='selected'" : '') + '>' + d + '</option>';
        t.yearshtml += '</select>', b += t.yearshtml, t.yearshtml = null;
      }
      return b += this._get(t, 'yearSuffix'), m && (b += (!o && f && g ? '' : '&#xa0;') + y), b += '</div>';
    },
    _adjustInstDate: function (t, e, i) {
      var s = t.selectedYear + ('Y' === i ? e : 0),
        n = t.selectedMonth + ('M' === i ? e : 0),
        e = Math.min(t.selectedDay, this._getDaysInMonth(s, n)) + ('D' === i ? e : 0),
        e = this._restrictMinMax(t, this._daylightSavingAdjust(new Date(s, n, e)));
      t.selectedDay = e.getDate(), t.drawMonth = t.selectedMonth = e.getMonth(), t.drawYear = t.selectedYear = e.getFullYear(), 'M' !== i && 'Y' !== i || this._notifyChange(t);
    },
    _restrictMinMax: function (t, e) {
      var i = this._getMinMaxDate(t, 'min'),
        t = this._getMinMaxDate(t, 'max'),
        e = i && e < i ? i : e;
      return t && t < e ? t : e;
    },
    _notifyChange: function (t) {
      var e = this._get(t, 'onChangeMonthYear');
      e && e.apply(t.input ? t.input[0] : null, [t.selectedYear, t.selectedMonth + 1, t]);
    },
    _getNumberOfMonths: function (t) {
      t = this._get(t, 'numberOfMonths');
      return null == t ? [1, 1] : 'number' == typeof t ? [1, t] : t;
    },
    _getMinMaxDate: function (t, e) {
      return this._determineDate(t, this._get(t, e + 'Date'), null);
    },
    _getDaysInMonth: function (t, e) {
      return 32 - this._daylightSavingAdjust(new Date(t, e, 32)).getDate();
    },
    _getFirstDayOfMonth: function (t, e) {
      return new Date(t, e, 1).getDay();
    },
    _canAdjustMonth: function (t, e, i, s) {
      var n = this._getNumberOfMonths(t),
        n = this._daylightSavingAdjust(new Date(i, s + (e < 0 ? e : n[0] * n[1]), 1));
      return e < 0 && n.setDate(this._getDaysInMonth(n.getFullYear(), n.getMonth())), this._isInRange(t, n);
    },
    _isInRange: function (t, e) {
      var i = this._getMinMaxDate(t, 'min'),
        s = this._getMinMaxDate(t, 'max'),
        n = null,
        o = null,
        a = this._get(t, 'yearRange');
      return a && (t = a.split(':'), a = new Date().getFullYear(), n = parseInt(t[0], 10), o = parseInt(t[1], 10), t[0].match(/[+\-].*/) && (n += a), t[1].match(/[+\-].*/) && (o += a)), (!i || e.getTime() >= i.getTime()) && (!s || e.getTime() <= s.getTime()) && (!n || e.getFullYear() >= n) && (!o || e.getFullYear() <= o);
    },
    _getFormatConfig: function (t) {
      var e = this._get(t, 'shortYearCutoff');
      return {
        shortYearCutoff: e = 'string' != typeof e ? e : new Date().getFullYear() % 100 + parseInt(e, 10),
        dayNamesShort: this._get(t, 'dayNamesShort'),
        dayNames: this._get(t, 'dayNames'),
        monthNamesShort: this._get(t, 'monthNamesShort'),
        monthNames: this._get(t, 'monthNames')
      };
    },
    _formatDate: function (t, e, i, s) {
      e || (t.currentDay = t.selectedDay, t.currentMonth = t.selectedMonth, t.currentYear = t.selectedYear);
      e = e ? 'object' == typeof e ? e : this._daylightSavingAdjust(new Date(s, i, e)) : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));
      return this.formatDate(this._get(t, 'dateFormat'), e, this._getFormatConfig(t));
    }
  }), V.fn.datepicker = function (t) {
    if (!this.length) return this;
    V.datepicker.initialized || (V(document).on('mousedown', V.datepicker._checkExternalClick), V.datepicker.initialized = !0), 0 === V('#' + V.datepicker._mainDivId).length && V('body').append(V.datepicker.dpDiv);
    var e = Array.prototype.slice.call(arguments, 1);
    return 'string' == typeof t && ('isDisabled' === t || 'getDate' === t || 'widget' === t) || 'option' === t && 2 === arguments.length && 'string' == typeof arguments[1] ? V.datepicker['_' + t + 'Datepicker'].apply(V.datepicker, [this[0]].concat(e)) : this.each(function () {
      'string' == typeof t ? V.datepicker['_' + t + 'Datepicker'].apply(V.datepicker, [this].concat(e)) : V.datepicker._attachDatepicker(this, t);
    });
  }, V.datepicker = new st(), V.datepicker.initialized = !1, V.datepicker.uuid = new Date().getTime(), V.datepicker.version = '1.13.1';
  V.datepicker, V.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());
  var rt = !1;
  V(document).on('mouseup', function () {
    rt = !1;
  });
  V.widget('ui.mouse', {
    version: '1.13.1',
    options: {
      cancel: 'input, textarea, button, select, option',
      distance: 1,
      delay: 0
    },
    _mouseInit: function () {
      var e = this;
      this.element.on('mousedown.' + this.widgetName, function (t) {
        return e._mouseDown(t);
      }).on('click.' + this.widgetName, function (t) {
        if (!0 === V.data(t.target, e.widgetName + '.preventClickEvent')) return V.removeData(t.target, e.widgetName + '.preventClickEvent'), t.stopImmediatePropagation(), !1;
      }), this.started = !1;
    },
    _mouseDestroy: function () {
      this.element.off('.' + this.widgetName), this._mouseMoveDelegate && this.document.off('mousemove.' + this.widgetName, this._mouseMoveDelegate).off('mouseup.' + this.widgetName, this._mouseUpDelegate);
    },
    _mouseDown: function (t) {
      if (!rt) {
        ;
        this._mouseMoved = !1, this._mouseStarted && this._mouseUp(t), this._mouseDownEvent = t;
        var e = this,
          i = 1 === t.which,
          s = !('string' != typeof this.options.cancel || !t.target.nodeName) && V(t.target).closest(this.options.cancel).length;
        return i && !s && this._mouseCapture(t) ? (this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {
          e.mouseDelayMet = !0;
        }, this.options.delay)), this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = !1 !== this._mouseStart(t), !this._mouseStarted) ? (t.preventDefault(), !0) : (!0 === V.data(t.target, this.widgetName + '.preventClickEvent') && V.removeData(t.target, this.widgetName + '.preventClickEvent'), this._mouseMoveDelegate = function (t) {
          return e._mouseMove(t);
        }, this._mouseUpDelegate = function (t) {
          return e._mouseUp(t);
        }, this.document.on('mousemove.' + this.widgetName, this._mouseMoveDelegate).on('mouseup.' + this.widgetName, this._mouseUpDelegate), t.preventDefault(), rt = !0)) : !0;
      }
    },
    _mouseMove: function (t) {
      if (this._mouseMoved) {
        if (V.ui.ie && (!document.documentMode || document.documentMode < 9) && !t.button) return this._mouseUp(t);
        if (!t.which) if (t.originalEvent.altKey || t.originalEvent.ctrlKey || t.originalEvent.metaKey || t.originalEvent.shiftKey) this.ignoreMissingWhich = !0;else if (!this.ignoreMissingWhich) return this._mouseUp(t);
      }
      return (t.which || t.button) && (this._mouseMoved = !0), this._mouseStarted ? (this._mouseDrag(t), t.preventDefault()) : (this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = !1 !== this._mouseStart(this._mouseDownEvent, t), this._mouseStarted ? this._mouseDrag(t) : this._mouseUp(t)), !this._mouseStarted);
    },
    _mouseUp: function (t) {
      this.document.off('mousemove.' + this.widgetName, this._mouseMoveDelegate).off('mouseup.' + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, t.target === this._mouseDownEvent.target && V.data(t.target, this.widgetName + '.preventClickEvent', !0), this._mouseStop(t)), this._mouseDelayTimer && (clearTimeout(this._mouseDelayTimer), delete this._mouseDelayTimer), this.ignoreMissingWhich = !1, rt = !1, t.preventDefault();
    },
    _mouseDistanceMet: function (t) {
      return Math.max(Math.abs(this._mouseDownEvent.pageX - t.pageX), Math.abs(this._mouseDownEvent.pageY - t.pageY)) >= this.options.distance;
    },
    _mouseDelayMet: function () {
      return this.mouseDelayMet;
    },
    _mouseStart: function () {},
    _mouseDrag: function () {},
    _mouseStop: function () {},
    _mouseCapture: function () {
      return !0;
    }
  }), V.ui.plugin = {
    add: function (t, e, i) {
      var s,
        n = V.ui[t].prototype;
      for (s in i) n.plugins[s] = n.plugins[s] || [], n.plugins[s].push([e, i[s]]);
    },
    call: function (t, e, i, s) {
      var n,
        o = t.plugins[e];
      if (o && (s || t.element[0].parentNode && 11 !== t.element[0].parentNode.nodeType)) for (n = 0; n < o.length; n++) t.options[o[n][0]] && o[n][1].apply(t.element, i);
    }
  }, V.ui.safeBlur = function (t) {
    t && 'body' !== t.nodeName.toLowerCase() && V(t).trigger('blur');
  };
  V.widget('ui.draggable', V.ui.mouse, {
    version: '1.13.1',
    widgetEventPrefix: 'drag',
    options: {
      addClasses: !0,
      appendTo: 'parent',
      axis: !1,
      connectToSortable: !1,
      containment: !1,
      cursor: 'auto',
      cursorAt: !1,
      grid: !1,
      handle: !1,
      helper: 'original',
      iframeFix: !1,
      opacity: !1,
      refreshPositions: !1,
      revert: !1,
      revertDuration: 500,
      scope: 'default',
      scroll: !0,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      snap: !1,
      snapMode: 'both',
      snapTolerance: 20,
      stack: !1,
      zIndex: !1,
      drag: null,
      start: null,
      stop: null
    },
    _create: function () {
      'original' === this.options.helper && this._setPositionRelative(), this.options.addClasses && this._addClass('ui-draggable'), this._setHandleClassName(), this._mouseInit();
    },
    _setOption: function (t, e) {
      this._super(t, e), 'handle' === t && (this._removeHandleClassName(), this._setHandleClassName());
    },
    _destroy: function () {
      ;
      (this.helper || this.element).is('.ui-draggable-dragging') ? this.destroyOnClear = !0 : (this._removeHandleClassName(), this._mouseDestroy());
    },
    _mouseCapture: function (t) {
      var e = this.options;
      return !(this.helper || e.disabled || 0 < V(t.target).closest('.ui-resizable-handle').length) && (this.handle = this._getHandle(t), !!this.handle && (this._blurActiveElement(t), this._blockFrames(!0 === e.iframeFix ? 'iframe' : e.iframeFix), !0));
    },
    _blockFrames: function (t) {
      this.iframeBlocks = this.document.find(t).map(function () {
        var t = V(this);
        return V('<div>').css('position', 'absolute').appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0];
      });
    },
    _unblockFrames: function () {
      this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);
    },
    _blurActiveElement: function (t) {
      var e = V.ui.safeActiveElement(this.document[0]);
      V(t.target).closest(e).length || V.ui.safeBlur(e);
    },
    _mouseStart: function (t) {
      var e = this.options;
      return this.helper = this._createHelper(t), this._addClass(this.helper, 'ui-draggable-dragging'), this._cacheHelperProportions(), V.ui.ddmanager && (V.ui.ddmanager.current = this), this._cacheMargins(), this.cssPosition = this.helper.css('position'), this.scrollParent = this.helper.scrollParent(!0), this.offsetParent = this.helper.offsetParent(), this.hasFixedAncestor = 0 < this.helper.parents().filter(function () {
        return 'fixed' === V(this).css('position');
      }).length, this.positionAbs = this.element.offset(), this._refreshOffsets(t), this.originalPosition = this.position = this._generatePosition(t, !1), this.originalPageX = t.pageX, this.originalPageY = t.pageY, e.cursorAt && this._adjustOffsetFromHelper(e.cursorAt), this._setContainment(), !1 === this._trigger('start', t) ? (this._clear(), !1) : (this._cacheHelperProportions(), V.ui.ddmanager && !e.dropBehaviour && V.ui.ddmanager.prepareOffsets(this, t), this._mouseDrag(t, !0), V.ui.ddmanager && V.ui.ddmanager.dragStart(this, t), !0);
    },
    _refreshOffsets: function (t) {
      ;
      this.offset = {
        top: this.positionAbs.top - this.margins.top,
        left: this.positionAbs.left - this.margins.left,
        scroll: !1,
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset()
      }, this.offset.click = {
        left: t.pageX - this.offset.left,
        top: t.pageY - this.offset.top
      };
    },
    _mouseDrag: function (t, e) {
      if (this.hasFixedAncestor && (this.offset.parent = this._getParentOffset()), this.position = this._generatePosition(t, !0), this.positionAbs = this._convertPositionTo('absolute'), !e) {
        e = this._uiHash();
        if (!1 === this._trigger('drag', t, e)) return this._mouseUp(new V.Event('mouseup', t)), !1;
        this.position = e.position;
      }
      return this.helper[0].style.left = this.position.left + 'px', this.helper[0].style.top = this.position.top + 'px', V.ui.ddmanager && V.ui.ddmanager.drag(this, t), !1;
    },
    _mouseStop: function (t) {
      var e = this,
        i = !1;
      return V.ui.ddmanager && !this.options.dropBehaviour && (i = V.ui.ddmanager.drop(this, t)), this.dropped && (i = this.dropped, this.dropped = !1), 'invalid' === this.options.revert && !i || 'valid' === this.options.revert && i || !0 === this.options.revert || 'function' == typeof this.options.revert && this.options.revert.call(this.element, i) ? V(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {
        !1 !== e._trigger('stop', t) && e._clear();
      }) : !1 !== this._trigger('stop', t) && this._clear(), !1;
    },
    _mouseUp: function (t) {
      return this._unblockFrames(), V.ui.ddmanager && V.ui.ddmanager.dragStop(this, t), this.handleElement.is(t.target) && this.element.trigger('focus'), V.ui.mouse.prototype._mouseUp.call(this, t);
    },
    cancel: function () {
      return this.helper.is('.ui-draggable-dragging') ? this._mouseUp(new V.Event('mouseup', {
        target: this.element[0]
      })) : this._clear(), this;
    },
    _getHandle: function (t) {
      return !this.options.handle || !!V(t.target).closest(this.element.find(this.options.handle)).length;
    },
    _setHandleClassName: function () {
      ;
      this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element, this._addClass(this.handleElement, 'ui-draggable-handle');
    },
    _removeHandleClassName: function () {
      this._removeClass(this.handleElement, 'ui-draggable-handle');
    },
    _createHelper: function (t) {
      var e = this.options,
        i = 'function' == typeof e.helper,
        t = i ? V(e.helper.apply(this.element[0], [t])) : 'clone' === e.helper ? this.element.clone().removeAttr('id') : this.element;
      return t.parents('body').length || t.appendTo('parent' === e.appendTo ? this.element[0].parentNode : e.appendTo), i && t[0] === this.element[0] && this._setPositionRelative(), t[0] === this.element[0] || /(fixed|absolute)/.test(t.css('position')) || t.css('position', 'absolute'), t;
    },
    _setPositionRelative: function () {
      ;
      /^(?:r|a|f)/.test(this.element.css('position')) || (this.element[0].style.position = 'relative');
    },
    _adjustOffsetFromHelper: function (t) {
      'string' == typeof t && (t = t.split(' ')), 'left' in (t = Array.isArray(t) ? {
        left: +t[0],
        top: +t[1] || 0
      } : t) && (this.offset.click.left = t.left + this.margins.left), 'right' in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left), 'top' in t && (this.offset.click.top = t.top + this.margins.top), 'bottom' in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top);
    },
    _isRootNode: function (t) {
      return /(html|body)/i.test(t.tagName) || t === this.document[0];
    },
    _getParentOffset: function () {
      var t = this.offsetParent.offset(),
        e = this.document[0];
      return 'absolute' === this.cssPosition && this.scrollParent[0] !== e && V.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(), t.top += this.scrollParent.scrollTop()), {
        top: (t = this._isRootNode(this.offsetParent[0]) ? {
          top: 0,
          left: 0
        } : t).top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
        left: t.left + (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0)
      };
    },
    _getRelativeOffset: function () {
      if ('relative' !== this.cssPosition) return {
        top: 0,
        left: 0
      };
      var t = this.element.position(),
        e = this._isRootNode(this.scrollParent[0]);
      return {
        top: t.top - (parseInt(this.helper.css('top'), 10) || 0) + (e ? 0 : this.scrollParent.scrollTop()),
        left: t.left - (parseInt(this.helper.css('left'), 10) || 0) + (e ? 0 : this.scrollParent.scrollLeft())
      };
    },
    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.element.css('marginLeft'), 10) || 0,
        top: parseInt(this.element.css('marginTop'), 10) || 0,
        right: parseInt(this.element.css('marginRight'), 10) || 0,
        bottom: parseInt(this.element.css('marginBottom'), 10) || 0
      };
    },
    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight()
      };
    },
    _setContainment: function () {
      var t,
        e,
        i,
        s = this.options,
        n = this.document[0];
      this.relativeContainer = null, s.containment ? 'window' !== s.containment ? 'document' !== s.containment ? s.containment.constructor !== Array ? ('parent' === s.containment && (s.containment = this.helper[0].parentNode), (i = (e = V(s.containment))[0]) && (t = /(scroll|auto)/.test(e.css('overflow')), this.containment = [(parseInt(e.css('borderLeftWidth'), 10) || 0) + (parseInt(e.css('paddingLeft'), 10) || 0), (parseInt(e.css('borderTopWidth'), 10) || 0) + (parseInt(e.css('paddingTop'), 10) || 0), (t ? Math.max(i.scrollWidth, i.offsetWidth) : i.offsetWidth) - (parseInt(e.css('borderRightWidth'), 10) || 0) - (parseInt(e.css('paddingRight'), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (t ? Math.max(i.scrollHeight, i.offsetHeight) : i.offsetHeight) - (parseInt(e.css('borderBottomWidth'), 10) || 0) - (parseInt(e.css('paddingBottom'), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom], this.relativeContainer = e)) : this.containment = s.containment : this.containment = [0, 0, V(n).width() - this.helperProportions.width - this.margins.left, (V(n).height() || n.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top] : this.containment = [V(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, V(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, V(window).scrollLeft() + V(window).width() - this.helperProportions.width - this.margins.left, V(window).scrollTop() + (V(window).height() || n.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top] : this.containment = null;
    },
    _convertPositionTo: function (t, e) {
      e = e || this.position;
      var i = 'absolute' === t ? 1 : -1,
        t = this._isRootNode(this.scrollParent[0]);
      return {
        top: e.top + this.offset.relative.top * i + this.offset.parent.top * i - ('fixed' === this.cssPosition ? -this.offset.scroll.top : t ? 0 : this.offset.scroll.top) * i,
        left: e.left + this.offset.relative.left * i + this.offset.parent.left * i - ('fixed' === this.cssPosition ? -this.offset.scroll.left : t ? 0 : this.offset.scroll.left) * i
      };
    },
    _generatePosition: function (t, e) {
      var i,
        s = this.options,
        n = this._isRootNode(this.scrollParent[0]),
        o = t.pageX,
        a = t.pageY;
      return n && this.offset.scroll || (this.offset.scroll = {
        top: this.scrollParent.scrollTop(),
        left: this.scrollParent.scrollLeft()
      }), e && (this.containment && (i = this.relativeContainer ? (i = this.relativeContainer.offset(), [this.containment[0] + i.left, this.containment[1] + i.top, this.containment[2] + i.left, this.containment[3] + i.top]) : this.containment, t.pageX - this.offset.click.left < i[0] && (o = i[0] + this.offset.click.left), t.pageY - this.offset.click.top < i[1] && (a = i[1] + this.offset.click.top), t.pageX - this.offset.click.left > i[2] && (o = i[2] + this.offset.click.left), t.pageY - this.offset.click.top > i[3] && (a = i[3] + this.offset.click.top)), s.grid && (t = s.grid[1] ? this.originalPageY + Math.round((a - this.originalPageY) / s.grid[1]) * s.grid[1] : this.originalPageY, a = !i || t - this.offset.click.top >= i[1] || t - this.offset.click.top > i[3] ? t : t - this.offset.click.top >= i[1] ? t - s.grid[1] : t + s.grid[1], t = s.grid[0] ? this.originalPageX + Math.round((o - this.originalPageX) / s.grid[0]) * s.grid[0] : this.originalPageX, o = !i || t - this.offset.click.left >= i[0] || t - this.offset.click.left > i[2] ? t : t - this.offset.click.left >= i[0] ? t - s.grid[0] : t + s.grid[0]), 'y' === s.axis && (o = this.originalPageX), 'x' === s.axis && (a = this.originalPageY)), {
        top: a - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ('fixed' === this.cssPosition ? -this.offset.scroll.top : n ? 0 : this.offset.scroll.top),
        left: o - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ('fixed' === this.cssPosition ? -this.offset.scroll.left : n ? 0 : this.offset.scroll.left)
      };
    },
    _clear: function () {
      this._removeClass(this.helper, 'ui-draggable-dragging'), this.helper[0] === this.element[0] || this.cancelHelperRemoval || this.helper.remove(), this.helper = null, this.cancelHelperRemoval = !1, this.destroyOnClear && this.destroy();
    },
    _trigger: function (t, e, i) {
      return i = i || this._uiHash(), V.ui.plugin.call(this, t, [e, i, this], !0), /^(drag|start|stop)/.test(t) && (this.positionAbs = this._convertPositionTo('absolute'), i.offset = this.positionAbs), V.Widget.prototype._trigger.call(this, t, e, i);
    },
    plugins: {},
    _uiHash: function () {
      return {
        helper: this.helper,
        position: this.position,
        originalPosition: this.originalPosition,
        offset: this.positionAbs
      };
    }
  }), V.ui.plugin.add('draggable', 'connectToSortable', {
    start: function (e, t, i) {
      var s = V.extend({}, t, {
        item: i.element
      });
      i.sortables = [], V(i.options.connectToSortable).each(function () {
        var t = V(this).sortable('instance');
        t && !t.options.disabled && (i.sortables.push(t), t.refreshPositions(), t._trigger('activate', e, s));
      });
    },
    stop: function (e, t, i) {
      var s = V.extend({}, t, {
        item: i.element
      });
      i.cancelHelperRemoval = !1, V.each(i.sortables, function () {
        var t = this;
        t.isOver ? (t.isOver = 0, i.cancelHelperRemoval = !0, t.cancelHelperRemoval = !1, t._storedCSS = {
          position: t.placeholder.css('position'),
          top: t.placeholder.css('top'),
          left: t.placeholder.css('left')
        }, t._mouseStop(e), t.options.helper = t.options._helper) : (t.cancelHelperRemoval = !0, t._trigger('deactivate', e, s));
      });
    },
    drag: function (i, s, n) {
      V.each(n.sortables, function () {
        var t = !1,
          e = this;
        e.positionAbs = n.positionAbs, e.helperProportions = n.helperProportions, e.offset.click = n.offset.click, e._intersectsWith(e.containerCache) && (t = !0, V.each(n.sortables, function () {
          return this.positionAbs = n.positionAbs, this.helperProportions = n.helperProportions, this.offset.click = n.offset.click, t = this !== e && this._intersectsWith(this.containerCache) && V.contains(e.element[0], this.element[0]) ? !1 : t;
        })), t ? (e.isOver || (e.isOver = 1, n._parent = s.helper.parent(), e.currentItem = s.helper.appendTo(e.element).data('ui-sortable-item', !0), e.options._helper = e.options.helper, e.options.helper = function () {
          return s.helper[0];
        }, i.target = e.currentItem[0], e._mouseCapture(i, !0), e._mouseStart(i, !0, !0), e.offset.click.top = n.offset.click.top, e.offset.click.left = n.offset.click.left, e.offset.parent.left -= n.offset.parent.left - e.offset.parent.left, e.offset.parent.top -= n.offset.parent.top - e.offset.parent.top, n._trigger('toSortable', i), n.dropped = e.element, V.each(n.sortables, function () {
          this.refreshPositions();
        }), n.currentItem = n.element, e.fromOutside = n), e.currentItem && (e._mouseDrag(i), s.position = e.position)) : e.isOver && (e.isOver = 0, e.cancelHelperRemoval = !0, e.options._revert = e.options.revert, e.options.revert = !1, e._trigger('out', i, e._uiHash(e)), e._mouseStop(i, !0), e.options.revert = e.options._revert, e.options.helper = e.options._helper, e.placeholder && e.placeholder.remove(), s.helper.appendTo(n._parent), n._refreshOffsets(i), s.position = n._generatePosition(i, !0), n._trigger('fromSortable', i), n.dropped = !1, V.each(n.sortables, function () {
          this.refreshPositions();
        }));
      });
    }
  }), V.ui.plugin.add('draggable', 'cursor', {
    start: function (t, e, i) {
      var s = V('body'),
        i = i.options;
      s.css('cursor') && (i._cursor = s.css('cursor')), s.css('cursor', i.cursor);
    },
    stop: function (t, e, i) {
      i = i.options;
      i._cursor && V('body').css('cursor', i._cursor);
    }
  }), V.ui.plugin.add('draggable', 'opacity', {
    start: function (t, e, i) {
      ;
      e = V(e.helper), i = i.options;
      e.css('opacity') && (i._opacity = e.css('opacity')), e.css('opacity', i.opacity);
    },
    stop: function (t, e, i) {
      i = i.options;
      i._opacity && V(e.helper).css('opacity', i._opacity);
    }
  }), V.ui.plugin.add('draggable', 'scroll', {
    start: function (t, e, i) {
      i.scrollParentNotHidden || (i.scrollParentNotHidden = i.helper.scrollParent(!1)), i.scrollParentNotHidden[0] !== i.document[0] && 'HTML' !== i.scrollParentNotHidden[0].tagName && (i.overflowOffset = i.scrollParentNotHidden.offset());
    },
    drag: function (t, e, i) {
      var s = i.options,
        n = !1,
        o = i.scrollParentNotHidden[0],
        a = i.document[0];
      o !== a && 'HTML' !== o.tagName ? (s.axis && 'x' === s.axis || (i.overflowOffset.top + o.offsetHeight - t.pageY < s.scrollSensitivity ? o.scrollTop = n = o.scrollTop + s.scrollSpeed : t.pageY - i.overflowOffset.top < s.scrollSensitivity && (o.scrollTop = n = o.scrollTop - s.scrollSpeed)), s.axis && 'y' === s.axis || (i.overflowOffset.left + o.offsetWidth - t.pageX < s.scrollSensitivity ? o.scrollLeft = n = o.scrollLeft + s.scrollSpeed : t.pageX - i.overflowOffset.left < s.scrollSensitivity && (o.scrollLeft = n = o.scrollLeft - s.scrollSpeed))) : (s.axis && 'x' === s.axis || (t.pageY - V(a).scrollTop() < s.scrollSensitivity ? n = V(a).scrollTop(V(a).scrollTop() - s.scrollSpeed) : V(window).height() - (t.pageY - V(a).scrollTop()) < s.scrollSensitivity && (n = V(a).scrollTop(V(a).scrollTop() + s.scrollSpeed))), s.axis && 'y' === s.axis || (t.pageX - V(a).scrollLeft() < s.scrollSensitivity ? n = V(a).scrollLeft(V(a).scrollLeft() - s.scrollSpeed) : V(window).width() - (t.pageX - V(a).scrollLeft()) < s.scrollSensitivity && (n = V(a).scrollLeft(V(a).scrollLeft() + s.scrollSpeed)))), !1 !== n && V.ui.ddmanager && !s.dropBehaviour && V.ui.ddmanager.prepareOffsets(i, t);
    }
  }), V.ui.plugin.add('draggable', 'snap', {
    start: function (t, e, i) {
      var s = i.options;
      i.snapElements = [], V(s.snap.constructor !== String ? s.snap.items || ':data(ui-draggable)' : s.snap).each(function () {
        var t = V(this),
          e = t.offset();
        this !== i.element[0] && i.snapElements.push({
          item: this,
          width: t.outerWidth(),
          height: t.outerHeight(),
          top: e.top,
          left: e.left
        });
      });
    },
    drag: function (t, e, i) {
      for (var s, n, o, a, r, l, h, c, u, d = i.options, p = d.snapTolerance, f = e.offset.left, g = f + i.helperProportions.width, m = e.offset.top, _ = m + i.helperProportions.height, v = i.snapElements.length - 1; 0 <= v; v--) l = (r = i.snapElements[v].left - i.margins.left) + i.snapElements[v].width, c = (h = i.snapElements[v].top - i.margins.top) + i.snapElements[v].height, g < r - p || l + p < f || _ < h - p || c + p < m || !V.contains(i.snapElements[v].item.ownerDocument, i.snapElements[v].item) ? (i.snapElements[v].snapping && i.options.snap.release && i.options.snap.release.call(i.element, t, V.extend(i._uiHash(), {
        snapItem: i.snapElements[v].item
      })), i.snapElements[v].snapping = !1) : ('inner' !== d.snapMode && (s = Math.abs(h - _) <= p, n = Math.abs(c - m) <= p, o = Math.abs(r - g) <= p, a = Math.abs(l - f) <= p, s && (e.position.top = i._convertPositionTo('relative', {
        top: h - i.helperProportions.height,
        left: 0
      }).top), n && (e.position.top = i._convertPositionTo('relative', {
        top: c,
        left: 0
      }).top), o && (e.position.left = i._convertPositionTo('relative', {
        top: 0,
        left: r - i.helperProportions.width
      }).left), a && (e.position.left = i._convertPositionTo('relative', {
        top: 0,
        left: l
      }).left)), u = s || n || o || a, 'outer' !== d.snapMode && (s = Math.abs(h - m) <= p, n = Math.abs(c - _) <= p, o = Math.abs(r - f) <= p, a = Math.abs(l - g) <= p, s && (e.position.top = i._convertPositionTo('relative', {
        top: h,
        left: 0
      }).top), n && (e.position.top = i._convertPositionTo('relative', {
        top: c - i.helperProportions.height,
        left: 0
      }).top), o && (e.position.left = i._convertPositionTo('relative', {
        top: 0,
        left: r
      }).left), a && (e.position.left = i._convertPositionTo('relative', {
        top: 0,
        left: l - i.helperProportions.width
      }).left)), !i.snapElements[v].snapping && (s || n || o || a || u) && i.options.snap.snap && i.options.snap.snap.call(i.element, t, V.extend(i._uiHash(), {
        snapItem: i.snapElements[v].item
      })), i.snapElements[v].snapping = s || n || o || a || u);
    }
  }), V.ui.plugin.add('draggable', 'stack', {
    start: function (t, e, i) {
      var s,
        i = i.options,
        i = V.makeArray(V(i.stack)).sort(function (t, e) {
          return (parseInt(V(t).css('zIndex'), 10) || 0) - (parseInt(V(e).css('zIndex'), 10) || 0);
        });
      i.length && (s = parseInt(V(i[0]).css('zIndex'), 10) || 0, V(i).each(function (t) {
        V(this).css('zIndex', s + t);
      }), this.css('zIndex', s + i.length));
    }
  }), V.ui.plugin.add('draggable', 'zIndex', {
    start: function (t, e, i) {
      ;
      e = V(e.helper), i = i.options;
      e.css('zIndex') && (i._zIndex = e.css('zIndex')), e.css('zIndex', i.zIndex);
    },
    stop: function (t, e, i) {
      i = i.options;
      i._zIndex && V(e.helper).css('zIndex', i._zIndex);
    }
  });
  V.ui.draggable;
  V.widget('ui.resizable', V.ui.mouse, {
    version: '1.13.1',
    widgetEventPrefix: 'resize',
    options: {
      alsoResize: !1,
      animate: !1,
      animateDuration: 'slow',
      animateEasing: 'swing',
      aspectRatio: !1,
      autoHide: !1,
      classes: {
        'ui-resizable-se': 'ui-icon ui-icon-gripsmall-diagonal-se'
      },
      containment: !1,
      ghost: !1,
      grid: !1,
      handles: 'e,s,se',
      helper: !1,
      maxHeight: null,
      maxWidth: null,
      minHeight: 10,
      minWidth: 10,
      zIndex: 90,
      resize: null,
      start: null,
      stop: null
    },
    _num: function (t) {
      return parseFloat(t) || 0;
    },
    _isNumber: function (t) {
      return !isNaN(parseFloat(t));
    },
    _hasScroll: function (t, e) {
      if ('hidden' === V(t).css('overflow')) return !1;
      var i = e && 'left' === e ? 'scrollLeft' : 'scrollTop',
        e = !1;
      if (0 < t[i]) return !0;
      try {
        ;
        t[i] = 1, e = 0 < t[i], t[i] = 0;
      } catch (t) {}
      return e;
    },
    _create: function () {
      var t,
        e = this.options,
        i = this;
      this._addClass('ui-resizable'), V.extend(this, {
        _aspectRatio: !!e.aspectRatio,
        aspectRatio: e.aspectRatio,
        originalElement: this.element,
        _proportionallyResizeElements: [],
        _helper: e.helper || e.ghost || e.animate ? e.helper || 'ui-resizable-helper' : null
      }), this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i) && (this.element.wrap(V("<div class='ui-wrapper'></div>").css({
        overflow: 'hidden',
        position: this.element.css('position'),
        width: this.element.outerWidth(),
        height: this.element.outerHeight(),
        top: this.element.css('top'),
        left: this.element.css('left')
      })), this.element = this.element.parent().data('ui-resizable', this.element.resizable('instance')), this.elementIsWrapper = !0, t = {
        marginTop: this.originalElement.css('marginTop'),
        marginRight: this.originalElement.css('marginRight'),
        marginBottom: this.originalElement.css('marginBottom'),
        marginLeft: this.originalElement.css('marginLeft')
      }, this.element.css(t), this.originalElement.css('margin', 0), this.originalResizeStyle = this.originalElement.css('resize'), this.originalElement.css('resize', 'none'), this._proportionallyResizeElements.push(this.originalElement.css({
        position: 'static',
        zoom: 1,
        display: 'block'
      })), this.originalElement.css(t), this._proportionallyResize()), this._setupHandles(), e.autoHide && V(this.element).on('mouseenter', function () {
        e.disabled || (i._removeClass('ui-resizable-autohide'), i._handles.show());
      }).on('mouseleave', function () {
        e.disabled || i.resizing || (i._addClass('ui-resizable-autohide'), i._handles.hide());
      }), this._mouseInit();
    },
    _destroy: function () {
      this._mouseDestroy(), this._addedHandles.remove();
      function t(t) {
        V(t).removeData('resizable').removeData('ui-resizable').off('.resizable');
      }
      var e;
      return this.elementIsWrapper && (t(this.element), e = this.element, this.originalElement.css({
        position: e.css('position'),
        width: e.outerWidth(),
        height: e.outerHeight(),
        top: e.css('top'),
        left: e.css('left')
      }).insertAfter(e), e.remove()), this.originalElement.css('resize', this.originalResizeStyle), t(this.originalElement), this;
    },
    _setOption: function (t, e) {
      switch (this._super(t, e), t) {
        case 'handles':
          this._removeHandles(), this._setupHandles();
          break;
        case 'aspectRatio':
          this._aspectRatio = !!e;
      }
    },
    _setupHandles: function () {
      var t,
        e,
        i,
        s,
        n,
        o = this.options,
        a = this;
      if (this.handles = o.handles || (V('.ui-resizable-handle', this.element).length ? {
        n: '.ui-resizable-n',
        e: '.ui-resizable-e',
        s: '.ui-resizable-s',
        w: '.ui-resizable-w',
        se: '.ui-resizable-se',
        sw: '.ui-resizable-sw',
        ne: '.ui-resizable-ne',
        nw: '.ui-resizable-nw'
      } : 'e,s,se'), this._handles = V(), this._addedHandles = V(), this.handles.constructor === String) for ('all' === this.handles && (this.handles = 'n,e,s,w,se,sw,ne,nw'), i = this.handles.split(','), this.handles = {}, e = 0; e < i.length; e++) s = 'ui-resizable-' + (t = String.prototype.trim.call(i[e])), n = V('<div>'), this._addClass(n, 'ui-resizable-handle ' + s), n.css({
        zIndex: o.zIndex
      }), this.handles[t] = '.ui-resizable-' + t, this.element.children(this.handles[t]).length || (this.element.append(n), this._addedHandles = this._addedHandles.add(n));
      this._renderAxis = function (t) {
        var e, i, s;
        for (e in t = t || this.element, this.handles) this.handles[e].constructor === String ? this.handles[e] = this.element.children(this.handles[e]).first().show() : (this.handles[e].jquery || this.handles[e].nodeType) && (this.handles[e] = V(this.handles[e]), this._on(this.handles[e], {
          mousedown: a._mouseDown
        })), this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i) && (i = V(this.handles[e], this.element), s = /sw|ne|nw|se|n|s/.test(e) ? i.outerHeight() : i.outerWidth(), i = ['padding', /ne|nw|n/.test(e) ? 'Top' : /se|sw|s/.test(e) ? 'Bottom' : /^e$/.test(e) ? 'Right' : 'Left'].join(''), t.css(i, s), this._proportionallyResize()), this._handles = this._handles.add(this.handles[e]);
      }, this._renderAxis(this.element), this._handles = this._handles.add(this.element.find('.ui-resizable-handle')), this._handles.disableSelection(), this._handles.on('mouseover', function () {
        a.resizing || (this.className && (n = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)), a.axis = n && n[1] ? n[1] : 'se');
      }), o.autoHide && (this._handles.hide(), this._addClass('ui-resizable-autohide'));
    },
    _removeHandles: function () {
      this._addedHandles.remove();
    },
    _mouseCapture: function (t) {
      var e,
        i,
        s = !1;
      for (e in this.handles) (i = V(this.handles[e])[0]) !== t.target && !V.contains(i, t.target) || (s = !0);
      return !this.options.disabled && s;
    },
    _mouseStart: function (t) {
      var e,
        i,
        s = this.options,
        n = this.element;
      return this.resizing = !0, this._renderProxy(), e = this._num(this.helper.css('left')), i = this._num(this.helper.css('top')), s.containment && (e += V(s.containment).scrollLeft() || 0, i += V(s.containment).scrollTop() || 0), this.offset = this.helper.offset(), this.position = {
        left: e,
        top: i
      }, this.size = this._helper ? {
        width: this.helper.width(),
        height: this.helper.height()
      } : {
        width: n.width(),
        height: n.height()
      }, this.originalSize = this._helper ? {
        width: n.outerWidth(),
        height: n.outerHeight()
      } : {
        width: n.width(),
        height: n.height()
      }, this.sizeDiff = {
        width: n.outerWidth() - n.width(),
        height: n.outerHeight() - n.height()
      }, this.originalPosition = {
        left: e,
        top: i
      }, this.originalMousePosition = {
        left: t.pageX,
        top: t.pageY
      }, this.aspectRatio = 'number' == typeof s.aspectRatio ? s.aspectRatio : this.originalSize.width / this.originalSize.height || 1, s = V('.ui-resizable-' + this.axis).css('cursor'), V('body').css('cursor', 'auto' === s ? this.axis + '-resize' : s), this._addClass('ui-resizable-resizing'), this._propagate('start', t), !0;
    },
    _mouseDrag: function (t) {
      var e = this.originalMousePosition,
        i = this.axis,
        s = t.pageX - e.left || 0,
        e = t.pageY - e.top || 0,
        i = this._change[i];
      return this._updatePrevProperties(), i && (e = i.apply(this, [t, s, e]), this._updateVirtualBoundaries(t.shiftKey), (this._aspectRatio || t.shiftKey) && (e = this._updateRatio(e, t)), e = this._respectSize(e, t), this._updateCache(e), this._propagate('resize', t), e = this._applyChanges(), !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(), V.isEmptyObject(e) || (this._updatePrevProperties(), this._trigger('resize', t, this.ui()), this._applyChanges())), !1;
    },
    _mouseStop: function (t) {
      this.resizing = !1;
      var e,
        i,
        s,
        n = this.options,
        o = this;
      return this._helper && (s = (e = (i = this._proportionallyResizeElements).length && /textarea/i.test(i[0].nodeName)) && this._hasScroll(i[0], 'left') ? 0 : o.sizeDiff.height, i = e ? 0 : o.sizeDiff.width, e = {
        width: o.helper.width() - i,
        height: o.helper.height() - s
      }, i = parseFloat(o.element.css('left')) + (o.position.left - o.originalPosition.left) || null, s = parseFloat(o.element.css('top')) + (o.position.top - o.originalPosition.top) || null, n.animate || this.element.css(V.extend(e, {
        top: s,
        left: i
      })), o.helper.height(o.size.height), o.helper.width(o.size.width), this._helper && !n.animate && this._proportionallyResize()), V('body').css('cursor', 'auto'), this._removeClass('ui-resizable-resizing'), this._propagate('stop', t), this._helper && this.helper.remove(), !1;
    },
    _updatePrevProperties: function () {
      ;
      this.prevPosition = {
        top: this.position.top,
        left: this.position.left
      }, this.prevSize = {
        width: this.size.width,
        height: this.size.height
      };
    },
    _applyChanges: function () {
      var t = {};
      return this.position.top !== this.prevPosition.top && (t.top = this.position.top + 'px'), this.position.left !== this.prevPosition.left && (t.left = this.position.left + 'px'), this.size.width !== this.prevSize.width && (t.width = this.size.width + 'px'), this.size.height !== this.prevSize.height && (t.height = this.size.height + 'px'), this.helper.css(t), t;
    },
    _updateVirtualBoundaries: function (t) {
      var e,
        i,
        s = this.options,
        n = {
          minWidth: this._isNumber(s.minWidth) ? s.minWidth : 0,
          maxWidth: this._isNumber(s.maxWidth) ? s.maxWidth : 1 / 0,
          minHeight: this._isNumber(s.minHeight) ? s.minHeight : 0,
          maxHeight: this._isNumber(s.maxHeight) ? s.maxHeight : 1 / 0
        };
      (this._aspectRatio || t) && (e = n.minHeight * this.aspectRatio, i = n.minWidth / this.aspectRatio, s = n.maxHeight * this.aspectRatio, t = n.maxWidth / this.aspectRatio, e > n.minWidth && (n.minWidth = e), i > n.minHeight && (n.minHeight = i), s < n.maxWidth && (n.maxWidth = s), t < n.maxHeight && (n.maxHeight = t)), this._vBoundaries = n;
    },
    _updateCache: function (t) {
      ;
      this.offset = this.helper.offset(), this._isNumber(t.left) && (this.position.left = t.left), this._isNumber(t.top) && (this.position.top = t.top), this._isNumber(t.height) && (this.size.height = t.height), this._isNumber(t.width) && (this.size.width = t.width);
    },
    _updateRatio: function (t) {
      var e = this.position,
        i = this.size,
        s = this.axis;
      return this._isNumber(t.height) ? t.width = t.height * this.aspectRatio : this._isNumber(t.width) && (t.height = t.width / this.aspectRatio), 'sw' === s && (t.left = e.left + (i.width - t.width), t.top = null), 'nw' === s && (t.top = e.top + (i.height - t.height), t.left = e.left + (i.width - t.width)), t;
    },
    _respectSize: function (t) {
      var e = this._vBoundaries,
        i = this.axis,
        s = this._isNumber(t.width) && e.maxWidth && e.maxWidth < t.width,
        n = this._isNumber(t.height) && e.maxHeight && e.maxHeight < t.height,
        o = this._isNumber(t.width) && e.minWidth && e.minWidth > t.width,
        a = this._isNumber(t.height) && e.minHeight && e.minHeight > t.height,
        r = this.originalPosition.left + this.originalSize.width,
        l = this.originalPosition.top + this.originalSize.height,
        h = /sw|nw|w/.test(i),
        i = /nw|ne|n/.test(i);
      return o && (t.width = e.minWidth), a && (t.height = e.minHeight), s && (t.width = e.maxWidth), n && (t.height = e.maxHeight), o && h && (t.left = r - e.minWidth), s && h && (t.left = r - e.maxWidth), a && i && (t.top = l - e.minHeight), n && i && (t.top = l - e.maxHeight), t.width || t.height || t.left || !t.top ? t.width || t.height || t.top || !t.left || (t.left = null) : t.top = null, t;
    },
    _getPaddingPlusBorderDimensions: function (t) {
      for (var e = 0, i = [], s = [t.css('borderTopWidth'), t.css('borderRightWidth'), t.css('borderBottomWidth'), t.css('borderLeftWidth')], n = [t.css('paddingTop'), t.css('paddingRight'), t.css('paddingBottom'), t.css('paddingLeft')]; e < 4; e++) i[e] = parseFloat(s[e]) || 0, i[e] += parseFloat(n[e]) || 0;
      return {
        height: i[0] + i[2],
        width: i[1] + i[3]
      };
    },
    _proportionallyResize: function () {
      if (this._proportionallyResizeElements.length) for (var t, e = 0, i = this.helper || this.element; e < this._proportionallyResizeElements.length; e++) t = this._proportionallyResizeElements[e], this.outerDimensions || (this.outerDimensions = this._getPaddingPlusBorderDimensions(t)), t.css({
        height: i.height() - this.outerDimensions.height || 0,
        width: i.width() - this.outerDimensions.width || 0
      });
    },
    _renderProxy: function () {
      var t = this.element,
        e = this.options;
      this.elementOffset = t.offset(), this._helper ? (this.helper = this.helper || V('<div></div>').css({
        overflow: 'hidden'
      }), this._addClass(this.helper, this._helper), this.helper.css({
        width: this.element.outerWidth(),
        height: this.element.outerHeight(),
        position: 'absolute',
        left: this.elementOffset.left + 'px',
        top: this.elementOffset.top + 'px',
        zIndex: ++e.zIndex
      }), this.helper.appendTo('body').disableSelection()) : this.helper = this.element;
    },
    _change: {
      e: function (t, e) {
        return {
          width: this.originalSize.width + e
        };
      },
      w: function (t, e) {
        var i = this.originalSize;
        return {
          left: this.originalPosition.left + e,
          width: i.width - e
        };
      },
      n: function (t, e, i) {
        var s = this.originalSize;
        return {
          top: this.originalPosition.top + i,
          height: s.height - i
        };
      },
      s: function (t, e, i) {
        return {
          height: this.originalSize.height + i
        };
      },
      se: function (t, e, i) {
        return V.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [t, e, i]));
      },
      sw: function (t, e, i) {
        return V.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [t, e, i]));
      },
      ne: function (t, e, i) {
        return V.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [t, e, i]));
      },
      nw: function (t, e, i) {
        return V.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [t, e, i]));
      }
    },
    _propagate: function (t, e) {
      V.ui.plugin.call(this, t, [e, this.ui()]), 'resize' !== t && this._trigger(t, e, this.ui());
    },
    plugins: {},
    ui: function () {
      return {
        originalElement: this.originalElement,
        element: this.element,
        helper: this.helper,
        position: this.position,
        size: this.size,
        originalSize: this.originalSize,
        originalPosition: this.originalPosition
      };
    }
  }), V.ui.plugin.add('resizable', 'animate', {
    stop: function (e) {
      var i = V(this).resizable('instance'),
        t = i.options,
        s = i._proportionallyResizeElements,
        n = s.length && /textarea/i.test(s[0].nodeName),
        o = n && i._hasScroll(s[0], 'left') ? 0 : i.sizeDiff.height,
        a = n ? 0 : i.sizeDiff.width,
        n = {
          width: i.size.width - a,
          height: i.size.height - o
        },
        a = parseFloat(i.element.css('left')) + (i.position.left - i.originalPosition.left) || null,
        o = parseFloat(i.element.css('top')) + (i.position.top - i.originalPosition.top) || null;
      i.element.animate(V.extend(n, o && a ? {
        top: o,
        left: a
      } : {}), {
        duration: t.animateDuration,
        easing: t.animateEasing,
        step: function () {
          var t = {
            width: parseFloat(i.element.css('width')),
            height: parseFloat(i.element.css('height')),
            top: parseFloat(i.element.css('top')),
            left: parseFloat(i.element.css('left'))
          };
          s && s.length && V(s[0]).css({
            width: t.width,
            height: t.height
          }), i._updateCache(t), i._propagate('resize', e);
        }
      });
    }
  }), V.ui.plugin.add('resizable', 'containment', {
    start: function () {
      var i,
        s,
        n = V(this).resizable('instance'),
        t = n.options,
        e = n.element,
        o = t.containment,
        a = o instanceof V ? o.get(0) : /parent/.test(o) ? e.parent().get(0) : o;
      a && (n.containerElement = V(a), /document/.test(o) || o === document ? (n.containerOffset = {
        left: 0,
        top: 0
      }, n.containerPosition = {
        left: 0,
        top: 0
      }, n.parentData = {
        element: V(document),
        left: 0,
        top: 0,
        width: V(document).width(),
        height: V(document).height() || document.body.parentNode.scrollHeight
      }) : (i = V(a), s = [], V(['Top', 'Right', 'Left', 'Bottom']).each(function (t, e) {
        s[t] = n._num(i.css('padding' + e));
      }), n.containerOffset = i.offset(), n.containerPosition = i.position(), n.containerSize = {
        height: i.innerHeight() - s[3],
        width: i.innerWidth() - s[1]
      }, t = n.containerOffset, e = n.containerSize.height, o = n.containerSize.width, o = n._hasScroll(a, 'left') ? a.scrollWidth : o, e = n._hasScroll(a) ? a.scrollHeight : e, n.parentData = {
        element: a,
        left: t.left,
        top: t.top,
        width: o,
        height: e
      }));
    },
    resize: function (t) {
      var e = V(this).resizable('instance'),
        i = e.options,
        s = e.containerOffset,
        n = e.position,
        o = e._aspectRatio || t.shiftKey,
        a = {
          top: 0,
          left: 0
        },
        r = e.containerElement,
        t = !0;
      r[0] !== document && /static/.test(r.css('position')) && (a = s), n.left < (e._helper ? s.left : 0) && (e.size.width = e.size.width + (e._helper ? e.position.left - s.left : e.position.left - a.left), o && (e.size.height = e.size.width / e.aspectRatio, t = !1), e.position.left = i.helper ? s.left : 0), n.top < (e._helper ? s.top : 0) && (e.size.height = e.size.height + (e._helper ? e.position.top - s.top : e.position.top), o && (e.size.width = e.size.height * e.aspectRatio, t = !1), e.position.top = e._helper ? s.top : 0), i = e.containerElement.get(0) === e.element.parent().get(0), n = /relative|absolute/.test(e.containerElement.css('position')), i && n ? (e.offset.left = e.parentData.left + e.position.left, e.offset.top = e.parentData.top + e.position.top) : (e.offset.left = e.element.offset().left, e.offset.top = e.element.offset().top), n = Math.abs(e.sizeDiff.width + (e._helper ? e.offset.left - a.left : e.offset.left - s.left)), s = Math.abs(e.sizeDiff.height + (e._helper ? e.offset.top - a.top : e.offset.top - s.top)), n + e.size.width >= e.parentData.width && (e.size.width = e.parentData.width - n, o && (e.size.height = e.size.width / e.aspectRatio, t = !1)), s + e.size.height >= e.parentData.height && (e.size.height = e.parentData.height - s, o && (e.size.width = e.size.height * e.aspectRatio, t = !1)), t || (e.position.left = e.prevPosition.left, e.position.top = e.prevPosition.top, e.size.width = e.prevSize.width, e.size.height = e.prevSize.height);
    },
    stop: function () {
      var t = V(this).resizable('instance'),
        e = t.options,
        i = t.containerOffset,
        s = t.containerPosition,
        n = t.containerElement,
        o = V(t.helper),
        a = o.offset(),
        r = o.outerWidth() - t.sizeDiff.width,
        o = o.outerHeight() - t.sizeDiff.height;
      t._helper && !e.animate && /relative/.test(n.css('position')) && V(this).css({
        left: a.left - s.left - i.left,
        width: r,
        height: o
      }), t._helper && !e.animate && /static/.test(n.css('position')) && V(this).css({
        left: a.left - s.left - i.left,
        width: r,
        height: o
      });
    }
  }), V.ui.plugin.add('resizable', 'alsoResize', {
    start: function () {
      var t = V(this).resizable('instance').options;
      V(t.alsoResize).each(function () {
        var t = V(this);
        t.data('ui-resizable-alsoresize', {
          width: parseFloat(t.width()),
          height: parseFloat(t.height()),
          left: parseFloat(t.css('left')),
          top: parseFloat(t.css('top'))
        });
      });
    },
    resize: function (t, i) {
      var e = V(this).resizable('instance'),
        s = e.options,
        n = e.originalSize,
        o = e.originalPosition,
        a = {
          height: e.size.height - n.height || 0,
          width: e.size.width - n.width || 0,
          top: e.position.top - o.top || 0,
          left: e.position.left - o.left || 0
        };
      V(s.alsoResize).each(function () {
        var t = V(this),
          s = V(this).data('ui-resizable-alsoresize'),
          n = {},
          e = t.parents(i.originalElement[0]).length ? ['width', 'height'] : ['width', 'height', 'top', 'left'];
        V.each(e, function (t, e) {
          var i = (s[e] || 0) + (a[e] || 0);
          i && 0 <= i && (n[e] = i || null);
        }), t.css(n);
      });
    },
    stop: function () {
      V(this).removeData('ui-resizable-alsoresize');
    }
  }), V.ui.plugin.add('resizable', 'ghost', {
    start: function () {
      var t = V(this).resizable('instance'),
        e = t.size;
      t.ghost = t.originalElement.clone(), t.ghost.css({
        opacity: 0.25,
        display: 'block',
        position: 'relative',
        height: e.height,
        width: e.width,
        margin: 0,
        left: 0,
        top: 0
      }), t._addClass(t.ghost, 'ui-resizable-ghost'), !1 !== V.uiBackCompat && 'string' == typeof t.options.ghost && t.ghost.addClass(this.options.ghost), t.ghost.appendTo(t.helper);
    },
    resize: function () {
      var t = V(this).resizable('instance');
      t.ghost && t.ghost.css({
        position: 'relative',
        height: t.size.height,
        width: t.size.width
      });
    },
    stop: function () {
      var t = V(this).resizable('instance');
      t.ghost && t.helper && t.helper.get(0).removeChild(t.ghost.get(0));
    }
  }), V.ui.plugin.add('resizable', 'grid', {
    resize: function () {
      var t,
        e = V(this).resizable('instance'),
        i = e.options,
        s = e.size,
        n = e.originalSize,
        o = e.originalPosition,
        a = e.axis,
        r = 'number' == typeof i.grid ? [i.grid, i.grid] : i.grid,
        l = r[0] || 1,
        h = r[1] || 1,
        c = Math.round((s.width - n.width) / l) * l,
        u = Math.round((s.height - n.height) / h) * h,
        d = n.width + c,
        p = n.height + u,
        f = i.maxWidth && i.maxWidth < d,
        g = i.maxHeight && i.maxHeight < p,
        m = i.minWidth && i.minWidth > d,
        s = i.minHeight && i.minHeight > p;
      i.grid = r, m && (d += l), s && (p += h), f && (d -= l), g && (p -= h), /^(se|s|e)$/.test(a) ? (e.size.width = d, e.size.height = p) : /^(ne)$/.test(a) ? (e.size.width = d, e.size.height = p, e.position.top = o.top - u) : /^(sw)$/.test(a) ? (e.size.width = d, e.size.height = p, e.position.left = o.left - c) : ((p - h <= 0 || d - l <= 0) && (t = e._getPaddingPlusBorderDimensions(this)), 0 < p - h ? (e.size.height = p, e.position.top = o.top - u) : (p = h - t.height, e.size.height = p, e.position.top = o.top + n.height - p), 0 < d - l ? (e.size.width = d, e.position.left = o.left - c) : (d = l - t.width, e.size.width = d, e.position.left = o.left + n.width - d));
    }
  });
  V.ui.resizable;
  V.widget('ui.dialog', {
    version: '1.13.1',
    options: {
      appendTo: 'body',
      autoOpen: !0,
      buttons: [],
      classes: {
        'ui-dialog': 'ui-corner-all',
        'ui-dialog-titlebar': 'ui-corner-all'
      },
      closeOnEscape: !0,
      closeText: 'Close',
      draggable: !0,
      hide: null,
      height: 'auto',
      maxHeight: null,
      maxWidth: null,
      minHeight: 150,
      minWidth: 150,
      modal: !1,
      position: {
        my: 'center',
        at: 'center',
        of: window,
        collision: 'fit',
        using: function (t) {
          var e = V(this).css(t).offset().top;
          e < 0 && V(this).css('top', t.top - e);
        }
      },
      resizable: !0,
      show: null,
      title: null,
      width: 300,
      beforeClose: null,
      close: null,
      drag: null,
      dragStart: null,
      dragStop: null,
      focus: null,
      open: null,
      resize: null,
      resizeStart: null,
      resizeStop: null
    },
    sizeRelatedOptions: {
      buttons: !0,
      height: !0,
      maxHeight: !0,
      maxWidth: !0,
      minHeight: !0,
      minWidth: !0,
      width: !0
    },
    resizableRelatedOptions: {
      maxHeight: !0,
      maxWidth: !0,
      minHeight: !0,
      minWidth: !0
    },
    _create: function () {
      ;
      this.originalCss = {
        display: this.element[0].style.display,
        width: this.element[0].style.width,
        minHeight: this.element[0].style.minHeight,
        maxHeight: this.element[0].style.maxHeight,
        height: this.element[0].style.height
      }, this.originalPosition = {
        parent: this.element.parent(),
        index: this.element.parent().children().index(this.element)
      }, this.originalTitle = this.element.attr('title'), null == this.options.title && null != this.originalTitle && (this.options.title = this.originalTitle), this.options.disabled && (this.options.disabled = !1), this._createWrapper(), this.element.show().removeAttr('title').appendTo(this.uiDialog), this._addClass('ui-dialog-content', 'ui-widget-content'), this._createTitlebar(), this._createButtonPane(), this.options.draggable && V.fn.draggable && this._makeDraggable(), this.options.resizable && V.fn.resizable && this._makeResizable(), this._isOpen = !1, this._trackFocus();
    },
    _init: function () {
      this.options.autoOpen && this.open();
    },
    _appendTo: function () {
      var t = this.options.appendTo;
      return t && (t.jquery || t.nodeType) ? V(t) : this.document.find(t || 'body').eq(0);
    },
    _destroy: function () {
      var t,
        e = this.originalPosition;
      this._untrackInstance(), this._destroyOverlay(), this.element.removeUniqueId().css(this.originalCss).detach(), this.uiDialog.remove(), this.originalTitle && this.element.attr('title', this.originalTitle), (t = e.parent.children().eq(e.index)).length && t[0] !== this.element[0] ? t.before(this.element) : e.parent.append(this.element);
    },
    widget: function () {
      return this.uiDialog;
    },
    disable: V.noop,
    enable: V.noop,
    close: function (t) {
      var e = this;
      this._isOpen && !1 !== this._trigger('beforeClose', t) && (this._isOpen = !1, this._focusedElement = null, this._destroyOverlay(), this._untrackInstance(), this.opener.filter(':focusable').trigger('focus').length || V.ui.safeBlur(V.ui.safeActiveElement(this.document[0])), this._hide(this.uiDialog, this.options.hide, function () {
        e._trigger('close', t);
      }));
    },
    isOpen: function () {
      return this._isOpen;
    },
    moveToTop: function () {
      this._moveToTop();
    },
    _moveToTop: function (t, e) {
      var i = !1,
        s = this.uiDialog.siblings('.ui-front:visible').map(function () {
          return +V(this).css('z-index');
        }).get(),
        s = Math.max.apply(null, s);
      return s >= +this.uiDialog.css('z-index') && (this.uiDialog.css('z-index', s + 1), i = !0), i && !e && this._trigger('focus', t), i;
    },
    open: function () {
      var t = this;
      this._isOpen ? this._moveToTop() && this._focusTabbable() : (this._isOpen = !0, this.opener = V(V.ui.safeActiveElement(this.document[0])), this._size(), this._position(), this._createOverlay(), this._moveToTop(null, !0), this.overlay && this.overlay.css('z-index', this.uiDialog.css('z-index') - 1), this._show(this.uiDialog, this.options.show, function () {
        t._focusTabbable(), t._trigger('focus');
      }), this._makeFocusTarget(), this._trigger('open'));
    },
    _focusTabbable: function () {
      var t = this._focusedElement;
      (t = !(t = !(t = !(t = !(t = t || this.element.find('[autofocus]')).length ? this.element.find(':tabbable') : t).length ? this.uiDialogButtonPane.find(':tabbable') : t).length ? this.uiDialogTitlebarClose.filter(':tabbable') : t).length ? this.uiDialog : t).eq(0).trigger('focus');
    },
    _restoreTabbableFocus: function () {
      var t = V.ui.safeActiveElement(this.document[0]);
      this.uiDialog[0] === t || V.contains(this.uiDialog[0], t) || this._focusTabbable();
    },
    _keepFocus: function (t) {
      t.preventDefault(), this._restoreTabbableFocus(), this._delay(this._restoreTabbableFocus);
    },
    _createWrapper: function () {
      ;
      this.uiDialog = V('<div>').hide().attr({
        tabIndex: -1,
        role: 'dialog'
      }).appendTo(this._appendTo()), this._addClass(this.uiDialog, 'ui-dialog', 'ui-widget ui-widget-content ui-front'), this._on(this.uiDialog, {
        keydown: function (t) {
          if (this.options.closeOnEscape && !t.isDefaultPrevented() && t.keyCode && t.keyCode === V.ui.keyCode.ESCAPE) return t.preventDefault(), void this.close(t);
          var e, i, s;
          t.keyCode !== V.ui.keyCode.TAB || t.isDefaultPrevented() || (e = this.uiDialog.find(':tabbable'), i = e.first(), s = e.last(), t.target !== s[0] && t.target !== this.uiDialog[0] || t.shiftKey ? t.target !== i[0] && t.target !== this.uiDialog[0] || !t.shiftKey || (this._delay(function () {
            s.trigger('focus');
          }), t.preventDefault()) : (this._delay(function () {
            i.trigger('focus');
          }), t.preventDefault()));
        },
        mousedown: function (t) {
          this._moveToTop(t) && this._focusTabbable();
        }
      }), this.element.find('[aria-describedby]').length || this.uiDialog.attr({
        'aria-describedby': this.element.uniqueId().attr('id')
      });
    },
    _createTitlebar: function () {
      var t;
      this.uiDialogTitlebar = V('<div>'), this._addClass(this.uiDialogTitlebar, 'ui-dialog-titlebar', 'ui-widget-header ui-helper-clearfix'), this._on(this.uiDialogTitlebar, {
        mousedown: function (t) {
          V(t.target).closest('.ui-dialog-titlebar-close') || this.uiDialog.trigger('focus');
        }
      }), this.uiDialogTitlebarClose = V("<button type='button'></button>").button({
        label: V('<a>').text(this.options.closeText).html(),
        icon: 'ui-icon-closethick',
        showLabel: !1
      }).appendTo(this.uiDialogTitlebar), this._addClass(this.uiDialogTitlebarClose, 'ui-dialog-titlebar-close'), this._on(this.uiDialogTitlebarClose, {
        click: function (t) {
          t.preventDefault(), this.close(t);
        }
      }), t = V('<span>').uniqueId().prependTo(this.uiDialogTitlebar), this._addClass(t, 'ui-dialog-title'), this._title(t), this.uiDialogTitlebar.prependTo(this.uiDialog), this.uiDialog.attr({
        'aria-labelledby': t.attr('id')
      });
    },
    _title: function (t) {
      this.options.title ? t.text(this.options.title) : t.html('&#160;');
    },
    _createButtonPane: function () {
      ;
      this.uiDialogButtonPane = V('<div>'), this._addClass(this.uiDialogButtonPane, 'ui-dialog-buttonpane', 'ui-widget-content ui-helper-clearfix'), this.uiButtonSet = V('<div>').appendTo(this.uiDialogButtonPane), this._addClass(this.uiButtonSet, 'ui-dialog-buttonset'), this._createButtons();
    },
    _createButtons: function () {
      var s = this,
        t = this.options.buttons;
      this.uiDialogButtonPane.remove(), this.uiButtonSet.empty(), V.isEmptyObject(t) || Array.isArray(t) && !t.length ? this._removeClass(this.uiDialog, 'ui-dialog-buttons') : (V.each(t, function (t, e) {
        var i;
        e = V.extend({
          type: 'button'
        }, e = 'function' == typeof e ? {
          click: e,
          text: t
        } : e), i = e.click, t = {
          icon: e.icon,
          iconPosition: e.iconPosition,
          showLabel: e.showLabel,
          icons: e.icons,
          text: e.text
        }, delete e.click, delete e.icon, delete e.iconPosition, delete e.showLabel, delete e.icons, 'boolean' == typeof e.text && delete e.text, V('<button></button>', e).button(t).appendTo(s.uiButtonSet).on('click', function () {
          i.apply(s.element[0], arguments);
        });
      }), this._addClass(this.uiDialog, 'ui-dialog-buttons'), this.uiDialogButtonPane.appendTo(this.uiDialog));
    },
    _makeDraggable: function () {
      var n = this,
        o = this.options;
      function a(t) {
        return {
          position: t.position,
          offset: t.offset
        };
      }
      this.uiDialog.draggable({
        cancel: '.ui-dialog-content, .ui-dialog-titlebar-close',
        handle: '.ui-dialog-titlebar',
        containment: 'document',
        start: function (t, e) {
          n._addClass(V(this), 'ui-dialog-dragging'), n._blockFrames(), n._trigger('dragStart', t, a(e));
        },
        drag: function (t, e) {
          n._trigger('drag', t, a(e));
        },
        stop: function (t, e) {
          var i = e.offset.left - n.document.scrollLeft(),
            s = e.offset.top - n.document.scrollTop();
          o.position = {
            my: 'left top',
            at: 'left' + (0 <= i ? '+' : '') + i + ' top' + (0 <= s ? '+' : '') + s,
            of: n.window
          }, n._removeClass(V(this), 'ui-dialog-dragging'), n._unblockFrames(), n._trigger('dragStop', t, a(e));
        }
      });
    },
    _makeResizable: function () {
      var n = this,
        o = this.options,
        t = o.resizable,
        e = this.uiDialog.css('position'),
        t = 'string' == typeof t ? t : 'n,e,s,w,se,sw,ne,nw';
      function a(t) {
        return {
          originalPosition: t.originalPosition,
          originalSize: t.originalSize,
          position: t.position,
          size: t.size
        };
      }
      this.uiDialog.resizable({
        cancel: '.ui-dialog-content',
        containment: 'document',
        alsoResize: this.element,
        maxWidth: o.maxWidth,
        maxHeight: o.maxHeight,
        minWidth: o.minWidth,
        minHeight: this._minHeight(),
        handles: t,
        start: function (t, e) {
          n._addClass(V(this), 'ui-dialog-resizing'), n._blockFrames(), n._trigger('resizeStart', t, a(e));
        },
        resize: function (t, e) {
          n._trigger('resize', t, a(e));
        },
        stop: function (t, e) {
          var i = n.uiDialog.offset(),
            s = i.left - n.document.scrollLeft(),
            i = i.top - n.document.scrollTop();
          o.height = n.uiDialog.height(), o.width = n.uiDialog.width(), o.position = {
            my: 'left top',
            at: 'left' + (0 <= s ? '+' : '') + s + ' top' + (0 <= i ? '+' : '') + i,
            of: n.window
          }, n._removeClass(V(this), 'ui-dialog-resizing'), n._unblockFrames(), n._trigger('resizeStop', t, a(e));
        }
      }).css('position', e);
    },
    _trackFocus: function () {
      this._on(this.widget(), {
        focusin: function (t) {
          this._makeFocusTarget(), this._focusedElement = V(t.target);
        }
      });
    },
    _makeFocusTarget: function () {
      this._untrackInstance(), this._trackingInstances().unshift(this);
    },
    _untrackInstance: function () {
      var t = this._trackingInstances(),
        e = V.inArray(this, t);
      -1 !== e && t.splice(e, 1);
    },
    _trackingInstances: function () {
      var t = this.document.data('ui-dialog-instances');
      return t || this.document.data('ui-dialog-instances', t = []), t;
    },
    _minHeight: function () {
      var t = this.options;
      return 'auto' === t.height ? t.minHeight : Math.min(t.minHeight, t.height);
    },
    _position: function () {
      var t = this.uiDialog.is(':visible');
      t || this.uiDialog.show(), this.uiDialog.position(this.options.position), t || this.uiDialog.hide();
    },
    _setOptions: function (t) {
      var i = this,
        s = !1,
        n = {};
      V.each(t, function (t, e) {
        i._setOption(t, e), t in i.sizeRelatedOptions && (s = !0), t in i.resizableRelatedOptions && (n[t] = e);
      }), s && (this._size(), this._position()), this.uiDialog.is(':data(ui-resizable)') && this.uiDialog.resizable('option', n);
    },
    _setOption: function (t, e) {
      var i,
        s = this.uiDialog;
      'disabled' !== t && (this._super(t, e), 'appendTo' === t && this.uiDialog.appendTo(this._appendTo()), 'buttons' === t && this._createButtons(), 'closeText' === t && this.uiDialogTitlebarClose.button({
        label: V('<a>').text('' + this.options.closeText).html()
      }), 'draggable' === t && ((i = s.is(':data(ui-draggable)')) && !e && s.draggable('destroy'), !i && e && this._makeDraggable()), 'position' === t && this._position(), 'resizable' === t && ((i = s.is(':data(ui-resizable)')) && !e && s.resizable('destroy'), i && 'string' == typeof e && s.resizable('option', 'handles', e), i || !1 === e || this._makeResizable()), 'title' === t && this._title(this.uiDialogTitlebar.find('.ui-dialog-title')));
    },
    _size: function () {
      var t,
        e,
        i,
        s = this.options;
      this.element.show().css({
        width: 'auto',
        minHeight: 0,
        maxHeight: 'none',
        height: 0
      }), s.minWidth > s.width && (s.width = s.minWidth), t = this.uiDialog.css({
        height: 'auto',
        width: s.width
      }).outerHeight(), e = Math.max(0, s.minHeight - t), i = 'number' == typeof s.maxHeight ? Math.max(0, s.maxHeight - t) : 'none', 'auto' === s.height ? this.element.css({
        minHeight: e,
        maxHeight: i,
        height: 'auto'
      }) : this.element.height(Math.max(0, s.height - t)), this.uiDialog.is(':data(ui-resizable)') && this.uiDialog.resizable('option', 'minHeight', this._minHeight());
    },
    _blockFrames: function () {
      this.iframeBlocks = this.document.find('iframe').map(function () {
        var t = V(this);
        return V('<div>').css({
          position: 'absolute',
          width: t.outerWidth(),
          height: t.outerHeight()
        }).appendTo(t.parent()).offset(t.offset())[0];
      });
    },
    _unblockFrames: function () {
      this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);
    },
    _allowInteraction: function (t) {
      return !!V(t.target).closest('.ui-dialog').length || !!V(t.target).closest('.ui-datepicker').length;
    },
    _createOverlay: function () {
      var i, s;
      this.options.modal && (i = V.fn.jquery.substring(0, 4), s = !0, this._delay(function () {
        s = !1;
      }), this.document.data('ui-dialog-overlays') || this.document.on('focusin.ui-dialog', function (t) {
        var e;
        s || (e = this._trackingInstances()[0])._allowInteraction(t) || (t.preventDefault(), e._focusTabbable(), '3.4.' !== i && '3.5.' !== i || e._delay(e._restoreTabbableFocus));
      }.bind(this)), this.overlay = V('<div>').appendTo(this._appendTo()), this._addClass(this.overlay, null, 'ui-widget-overlay ui-front'), this._on(this.overlay, {
        mousedown: '_keepFocus'
      }), this.document.data('ui-dialog-overlays', (this.document.data('ui-dialog-overlays') || 0) + 1));
    },
    _destroyOverlay: function () {
      var t;
      this.options.modal && this.overlay && ((t = this.document.data('ui-dialog-overlays') - 1) ? this.document.data('ui-dialog-overlays', t) : (this.document.off('focusin.ui-dialog'), this.document.removeData('ui-dialog-overlays')), this.overlay.remove(), this.overlay = null);
    }
  }), !1 !== V.uiBackCompat && V.widget('ui.dialog', V.ui.dialog, {
    options: {
      dialogClass: ''
    },
    _createWrapper: function () {
      this._super(), this.uiDialog.addClass(this.options.dialogClass);
    },
    _setOption: function (t, e) {
      'dialogClass' === t && this.uiDialog.removeClass(this.options.dialogClass).addClass(e), this._superApply(arguments);
    }
  });
  V.ui.dialog;
  function lt(t, e, i) {
    return e <= t && t < e + i;
  }
  V.widget('ui.droppable', {
    version: '1.13.1',
    widgetEventPrefix: 'drop',
    options: {
      accept: '*',
      addClasses: !0,
      greedy: !1,
      scope: 'default',
      tolerance: 'intersect',
      activate: null,
      deactivate: null,
      drop: null,
      out: null,
      over: null
    },
    _create: function () {
      var t,
        e = this.options,
        i = e.accept;
      this.isover = !1, this.isout = !0, this.accept = 'function' == typeof i ? i : function (t) {
        return t.is(i);
      }, this.proportions = function () {
        if (!arguments.length) return t = t || {
          width: this.element[0].offsetWidth,
          height: this.element[0].offsetHeight
        };
        t = arguments[0];
      }, this._addToManager(e.scope), e.addClasses && this._addClass('ui-droppable');
    },
    _addToManager: function (t) {
      ;
      V.ui.ddmanager.droppables[t] = V.ui.ddmanager.droppables[t] || [], V.ui.ddmanager.droppables[t].push(this);
    },
    _splice: function (t) {
      for (var e = 0; e < t.length; e++) t[e] === this && t.splice(e, 1);
    },
    _destroy: function () {
      var t = V.ui.ddmanager.droppables[this.options.scope];
      this._splice(t);
    },
    _setOption: function (t, e) {
      var i;
      'accept' === t ? this.accept = 'function' == typeof e ? e : function (t) {
        return t.is(e);
      } : 'scope' === t && (i = V.ui.ddmanager.droppables[this.options.scope], this._splice(i), this._addToManager(e)), this._super(t, e);
    },
    _activate: function (t) {
      var e = V.ui.ddmanager.current;
      this._addActiveClass(), e && this._trigger('activate', t, this.ui(e));
    },
    _deactivate: function (t) {
      var e = V.ui.ddmanager.current;
      this._removeActiveClass(), e && this._trigger('deactivate', t, this.ui(e));
    },
    _over: function (t) {
      var e = V.ui.ddmanager.current;
      e && (e.currentItem || e.element)[0] !== this.element[0] && this.accept.call(this.element[0], e.currentItem || e.element) && (this._addHoverClass(), this._trigger('over', t, this.ui(e)));
    },
    _out: function (t) {
      var e = V.ui.ddmanager.current;
      e && (e.currentItem || e.element)[0] !== this.element[0] && this.accept.call(this.element[0], e.currentItem || e.element) && (this._removeHoverClass(), this._trigger('out', t, this.ui(e)));
    },
    _drop: function (e, t) {
      var i = t || V.ui.ddmanager.current,
        s = !1;
      return !(!i || (i.currentItem || i.element)[0] === this.element[0]) && (this.element.find(':data(ui-droppable)').not('.ui-draggable-dragging').each(function () {
        var t = V(this).droppable('instance');
        if (t.options.greedy && !t.options.disabled && t.options.scope === i.options.scope && t.accept.call(t.element[0], i.currentItem || i.element) && V.ui.intersect(i, V.extend(t, {
          offset: t.element.offset()
        }), t.options.tolerance, e)) return !(s = !0);
      }), !s && !!this.accept.call(this.element[0], i.currentItem || i.element) && (this._removeActiveClass(), this._removeHoverClass(), this._trigger('drop', e, this.ui(i)), this.element));
    },
    ui: function (t) {
      return {
        draggable: t.currentItem || t.element,
        helper: t.helper,
        position: t.position,
        offset: t.positionAbs
      };
    },
    _addHoverClass: function () {
      this._addClass('ui-droppable-hover');
    },
    _removeHoverClass: function () {
      this._removeClass('ui-droppable-hover');
    },
    _addActiveClass: function () {
      this._addClass('ui-droppable-active');
    },
    _removeActiveClass: function () {
      this._removeClass('ui-droppable-active');
    }
  }), V.ui.intersect = function (t, e, i, s) {
    if (!e.offset) return !1;
    var n = (t.positionAbs || t.position.absolute).left + t.margins.left,
      o = (t.positionAbs || t.position.absolute).top + t.margins.top,
      a = n + t.helperProportions.width,
      r = o + t.helperProportions.height,
      l = e.offset.left,
      h = e.offset.top,
      c = l + e.proportions().width,
      u = h + e.proportions().height;
    switch (i) {
      case 'fit':
        return l <= n && a <= c && h <= o && r <= u;
      case 'intersect':
        return l < n + t.helperProportions.width / 2 && a - t.helperProportions.width / 2 < c && h < o + t.helperProportions.height / 2 && r - t.helperProportions.height / 2 < u;
      case 'pointer':
        return lt(s.pageY, h, e.proportions().height) && lt(s.pageX, l, e.proportions().width);
      case 'touch':
        return (h <= o && o <= u || h <= r && r <= u || o < h && u < r) && (l <= n && n <= c || l <= a && a <= c || n < l && c < a);
      default:
        return !1;
    }
  }, !(V.ui.ddmanager = {
    current: null,
    droppables: {
      default: []
    },
    prepareOffsets: function (t, e) {
      var i,
        s,
        n = V.ui.ddmanager.droppables[t.options.scope] || [],
        o = e ? e.type : null,
        a = (t.currentItem || t.element).find(':data(ui-droppable)').addBack();
      t: for (i = 0; i < n.length; i++) if (!(n[i].options.disabled || t && !n[i].accept.call(n[i].element[0], t.currentItem || t.element))) {
        for (s = 0; s < a.length; s++) if (a[s] === n[i].element[0]) {
          n[i].proportions().height = 0;
          continue t;
        }
        ;
        n[i].visible = 'none' !== n[i].element.css('display'), n[i].visible && ('mousedown' === o && n[i]._activate.call(n[i], e), n[i].offset = n[i].element.offset(), n[i].proportions({
          width: n[i].element[0].offsetWidth,
          height: n[i].element[0].offsetHeight
        }));
      }
    },
    drop: function (t, e) {
      var i = !1;
      return V.each((V.ui.ddmanager.droppables[t.options.scope] || []).slice(), function () {
        this.options && (!this.options.disabled && this.visible && V.ui.intersect(t, this, this.options.tolerance, e) && (i = this._drop.call(this, e) || i), !this.options.disabled && this.visible && this.accept.call(this.element[0], t.currentItem || t.element) && (this.isout = !0, this.isover = !1, this._deactivate.call(this, e)));
      }), i;
    },
    dragStart: function (t, e) {
      t.element.parentsUntil('body').on('scroll.droppable', function () {
        t.options.refreshPositions || V.ui.ddmanager.prepareOffsets(t, e);
      });
    },
    drag: function (n, o) {
      n.options.refreshPositions && V.ui.ddmanager.prepareOffsets(n, o), V.each(V.ui.ddmanager.droppables[n.options.scope] || [], function () {
        var t, e, i, s;
        this.options.disabled || this.greedyChild || !this.visible || (s = !(i = V.ui.intersect(n, this, this.options.tolerance, o)) && this.isover ? 'isout' : i && !this.isover ? 'isover' : null) && (this.options.greedy && (e = this.options.scope, (i = this.element.parents(':data(ui-droppable)').filter(function () {
          return V(this).droppable('instance').options.scope === e;
        })).length && ((t = V(i[0]).droppable('instance')).greedyChild = 'isover' === s)), t && 'isover' === s && (t.isover = !1, t.isout = !0, t._out.call(t, o)), this[s] = !0, this['isout' === s ? 'isover' : 'isout'] = !1, this['isover' === s ? '_over' : '_out'].call(this, o), t && 'isout' === s && (t.isout = !1, t.isover = !0, t._over.call(t, o)));
      });
    },
    dragStop: function (t, e) {
      t.element.parentsUntil('body').off('scroll.droppable'), t.options.refreshPositions || V.ui.ddmanager.prepareOffsets(t, e);
    }
  }) !== V.uiBackCompat && V.widget('ui.droppable', V.ui.droppable, {
    options: {
      hoverClass: !1,
      activeClass: !1
    },
    _addActiveClass: function () {
      this._super(), this.options.activeClass && this.element.addClass(this.options.activeClass);
    },
    _removeActiveClass: function () {
      this._super(), this.options.activeClass && this.element.removeClass(this.options.activeClass);
    },
    _addHoverClass: function () {
      this._super(), this.options.hoverClass && this.element.addClass(this.options.hoverClass);
    },
    _removeHoverClass: function () {
      this._super(), this.options.hoverClass && this.element.removeClass(this.options.hoverClass);
    }
  });
  V.ui.droppable, V.widget('ui.progressbar', {
    version: '1.13.1',
    options: {
      classes: {
        'ui-progressbar': 'ui-corner-all',
        'ui-progressbar-value': 'ui-corner-left',
        'ui-progressbar-complete': 'ui-corner-right'
      },
      max: 100,
      value: 0,
      change: null,
      complete: null
    },
    min: 0,
    _create: function () {
      ;
      this.oldValue = this.options.value = this._constrainedValue(), this.element.attr({
        role: 'progressbar',
        'aria-valuemin': this.min
      }), this._addClass('ui-progressbar', 'ui-widget ui-widget-content'), this.valueDiv = V('<div>').appendTo(this.element), this._addClass(this.valueDiv, 'ui-progressbar-value', 'ui-widget-header'), this._refreshValue();
    },
    _destroy: function () {
      this.element.removeAttr('role aria-valuemin aria-valuemax aria-valuenow'), this.valueDiv.remove();
    },
    value: function (t) {
      if (void 0 === t) return this.options.value;
      this.options.value = this._constrainedValue(t), this._refreshValue();
    },
    _constrainedValue: function (t) {
      return void 0 === t && (t = this.options.value), this.indeterminate = !1 === t, 'number' != typeof t && (t = 0), !this.indeterminate && Math.min(this.options.max, Math.max(this.min, t));
    },
    _setOptions: function (t) {
      var e = t.value;
      delete t.value, this._super(t), this.options.value = this._constrainedValue(e), this._refreshValue();
    },
    _setOption: function (t, e) {
      'max' === t && (e = Math.max(this.min, e)), this._super(t, e);
    },
    _setOptionDisabled: function (t) {
      this._super(t), this.element.attr('aria-disabled', t), this._toggleClass(null, 'ui-state-disabled', !!t);
    },
    _percentage: function () {
      return this.indeterminate ? 100 : 100 * (this.options.value - this.min) / (this.options.max - this.min);
    },
    _refreshValue: function () {
      var t = this.options.value,
        e = this._percentage();
      this.valueDiv.toggle(this.indeterminate || t > this.min).width(e.toFixed(0) + '%'), this._toggleClass(this.valueDiv, 'ui-progressbar-complete', null, t === this.options.max)._toggleClass('ui-progressbar-indeterminate', null, this.indeterminate), this.indeterminate ? (this.element.removeAttr('aria-valuenow'), this.overlayDiv || (this.overlayDiv = V('<div>').appendTo(this.valueDiv), this._addClass(this.overlayDiv, 'ui-progressbar-overlay'))) : (this.element.attr({
        'aria-valuemax': this.options.max,
        'aria-valuenow': t
      }), this.overlayDiv && (this.overlayDiv.remove(), this.overlayDiv = null)), this.oldValue !== t && (this.oldValue = t, this._trigger('change')), t === this.options.max && this._trigger('complete');
    }
  }), V.widget('ui.selectable', V.ui.mouse, {
    version: '1.13.1',
    options: {
      appendTo: 'body',
      autoRefresh: !0,
      distance: 0,
      filter: '*',
      tolerance: 'touch',
      selected: null,
      selecting: null,
      start: null,
      stop: null,
      unselected: null,
      unselecting: null
    },
    _create: function () {
      var i = this;
      this._addClass('ui-selectable'), this.dragged = !1, this.refresh = function () {
        ;
        i.elementPos = V(i.element[0]).offset(), i.selectees = V(i.options.filter, i.element[0]), i._addClass(i.selectees, 'ui-selectee'), i.selectees.each(function () {
          var t = V(this),
            e = t.offset(),
            e = {
              left: e.left - i.elementPos.left,
              top: e.top - i.elementPos.top
            };
          V.data(this, 'selectable-item', {
            element: this,
            $element: t,
            left: e.left,
            top: e.top,
            right: e.left + t.outerWidth(),
            bottom: e.top + t.outerHeight(),
            startselected: !1,
            selected: t.hasClass('ui-selected'),
            selecting: t.hasClass('ui-selecting'),
            unselecting: t.hasClass('ui-unselecting')
          });
        });
      }, this.refresh(), this._mouseInit(), this.helper = V('<div>'), this._addClass(this.helper, 'ui-selectable-helper');
    },
    _destroy: function () {
      this.selectees.removeData('selectable-item'), this._mouseDestroy();
    },
    _mouseStart: function (i) {
      var s = this,
        t = this.options;
      this.opos = [i.pageX, i.pageY], this.elementPos = V(this.element[0]).offset(), this.options.disabled || (this.selectees = V(t.filter, this.element[0]), this._trigger('start', i), V(t.appendTo).append(this.helper), this.helper.css({
        left: i.pageX,
        top: i.pageY,
        width: 0,
        height: 0
      }), t.autoRefresh && this.refresh(), this.selectees.filter('.ui-selected').each(function () {
        var t = V.data(this, 'selectable-item');
        t.startselected = !0, i.metaKey || i.ctrlKey || (s._removeClass(t.$element, 'ui-selected'), t.selected = !1, s._addClass(t.$element, 'ui-unselecting'), t.unselecting = !0, s._trigger('unselecting', i, {
          unselecting: t.element
        }));
      }), V(i.target).parents().addBack().each(function () {
        var t,
          e = V.data(this, 'selectable-item');
        if (e) return t = !i.metaKey && !i.ctrlKey || !e.$element.hasClass('ui-selected'), s._removeClass(e.$element, t ? 'ui-unselecting' : 'ui-selected')._addClass(e.$element, t ? 'ui-selecting' : 'ui-unselecting'), e.unselecting = !t, e.selecting = t, (e.selected = t) ? s._trigger('selecting', i, {
          selecting: e.element
        }) : s._trigger('unselecting', i, {
          unselecting: e.element
        }), !1;
      }));
    },
    _mouseDrag: function (s) {
      if (this.dragged = !0, !this.options.disabled) {
        var t,
          n = this,
          o = this.options,
          a = this.opos[0],
          r = this.opos[1],
          l = s.pageX,
          h = s.pageY;
        return l < a && (t = l, l = a, a = t), h < r && (t = h, h = r, r = t), this.helper.css({
          left: a,
          top: r,
          width: l - a,
          height: h - r
        }), this.selectees.each(function () {
          var t = V.data(this, 'selectable-item'),
            e = !1,
            i = {};
          t && t.element !== n.element[0] && (i.left = t.left + n.elementPos.left, i.right = t.right + n.elementPos.left, i.top = t.top + n.elementPos.top, i.bottom = t.bottom + n.elementPos.top, 'touch' === o.tolerance ? e = !(i.left > l || i.right < a || i.top > h || i.bottom < r) : 'fit' === o.tolerance && (e = i.left > a && i.right < l && i.top > r && i.bottom < h), e ? (t.selected && (n._removeClass(t.$element, 'ui-selected'), t.selected = !1), t.unselecting && (n._removeClass(t.$element, 'ui-unselecting'), t.unselecting = !1), t.selecting || (n._addClass(t.$element, 'ui-selecting'), t.selecting = !0, n._trigger('selecting', s, {
            selecting: t.element
          }))) : (t.selecting && ((s.metaKey || s.ctrlKey) && t.startselected ? (n._removeClass(t.$element, 'ui-selecting'), t.selecting = !1, n._addClass(t.$element, 'ui-selected'), t.selected = !0) : (n._removeClass(t.$element, 'ui-selecting'), t.selecting = !1, t.startselected && (n._addClass(t.$element, 'ui-unselecting'), t.unselecting = !0), n._trigger('unselecting', s, {
            unselecting: t.element
          }))), t.selected && (s.metaKey || s.ctrlKey || t.startselected || (n._removeClass(t.$element, 'ui-selected'), t.selected = !1, n._addClass(t.$element, 'ui-unselecting'), t.unselecting = !0, n._trigger('unselecting', s, {
            unselecting: t.element
          })))));
        }), !1;
      }
    },
    _mouseStop: function (e) {
      var i = this;
      return this.dragged = !1, V('.ui-unselecting', this.element[0]).each(function () {
        var t = V.data(this, 'selectable-item');
        i._removeClass(t.$element, 'ui-unselecting'), t.unselecting = !1, t.startselected = !1, i._trigger('unselected', e, {
          unselected: t.element
        });
      }), V('.ui-selecting', this.element[0]).each(function () {
        var t = V.data(this, 'selectable-item');
        i._removeClass(t.$element, 'ui-selecting')._addClass(t.$element, 'ui-selected'), t.selecting = !1, t.selected = !0, t.startselected = !0, i._trigger('selected', e, {
          selected: t.element
        });
      }), this._trigger('stop', e), this.helper.remove(), !1;
    }
  }), V.widget('ui.selectmenu', [V.ui.formResetMixin, {
    version: '1.13.1',
    defaultElement: '<select>',
    options: {
      appendTo: null,
      classes: {
        'ui-selectmenu-button-open': 'ui-corner-top',
        'ui-selectmenu-button-closed': 'ui-corner-all'
      },
      disabled: null,
      icons: {
        button: 'ui-icon-triangle-1-s'
      },
      position: {
        my: 'left top',
        at: 'left bottom',
        collision: 'none'
      },
      width: !1,
      change: null,
      close: null,
      focus: null,
      open: null,
      select: null
    },
    _create: function () {
      var t = this.element.uniqueId().attr('id');
      this.ids = {
        element: t,
        button: t + '-button',
        menu: t + '-menu'
      }, this._drawButton(), this._drawMenu(), this._bindFormResetHandler(), this._rendered = !1, this.menuItems = V();
    },
    _drawButton: function () {
      var t,
        e = this,
        i = this._parseOption(this.element.find('option:selected'), this.element[0].selectedIndex);
      this.labels = this.element.labels().attr('for', this.ids.button), this._on(this.labels, {
        click: function (t) {
          this.button.trigger('focus'), t.preventDefault();
        }
      }), this.element.hide(), this.button = V('<span>', {
        tabindex: this.options.disabled ? -1 : 0,
        id: this.ids.button,
        role: 'combobox',
        'aria-expanded': 'false',
        'aria-autocomplete': 'list',
        'aria-owns': this.ids.menu,
        'aria-haspopup': 'true',
        title: this.element.attr('title')
      }).insertAfter(this.element), this._addClass(this.button, 'ui-selectmenu-button ui-selectmenu-button-closed', 'ui-button ui-widget'), t = V('<span>').appendTo(this.button), this._addClass(t, 'ui-selectmenu-icon', 'ui-icon ' + this.options.icons.button), this.buttonItem = this._renderButtonItem(i).appendTo(this.button), !1 !== this.options.width && this._resizeButton(), this._on(this.button, this._buttonEvents), this.button.one('focusin', function () {
        e._rendered || e._refreshMenu();
      });
    },
    _drawMenu: function () {
      var i = this;
      this.menu = V('<ul>', {
        'aria-hidden': 'true',
        'aria-labelledby': this.ids.button,
        id: this.ids.menu
      }), this.menuWrap = V('<div>').append(this.menu), this._addClass(this.menuWrap, 'ui-selectmenu-menu', 'ui-front'), this.menuWrap.appendTo(this._appendTo()), this.menuInstance = this.menu.menu({
        classes: {
          'ui-menu': 'ui-corner-bottom'
        },
        role: 'listbox',
        select: function (t, e) {
          t.preventDefault(), i._setSelection(), i._select(e.item.data('ui-selectmenu-item'), t);
        },
        focus: function (t, e) {
          e = e.item.data('ui-selectmenu-item');
          null != i.focusIndex && e.index !== i.focusIndex && (i._trigger('focus', t, {
            item: e
          }), i.isOpen || i._select(e, t)), i.focusIndex = e.index, i.button.attr('aria-activedescendant', i.menuItems.eq(e.index).attr('id'));
        }
      }).menu('instance'), this.menuInstance._off(this.menu, 'mouseleave'), this.menuInstance._closeOnDocumentClick = function () {
        return !1;
      }, this.menuInstance._isDivider = function () {
        return !1;
      };
    },
    refresh: function () {
      this._refreshMenu(), this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(this._getSelectedItem().data('ui-selectmenu-item') || {})), null === this.options.width && this._resizeButton();
    },
    _refreshMenu: function () {
      var t = this.element.find('option');
      this.menu.empty(), this._parseOptions(t), this._renderMenu(this.menu, this.items), this.menuInstance.refresh(), this.menuItems = this.menu.find('li').not('.ui-selectmenu-optgroup').find('.ui-menu-item-wrapper'), this._rendered = !0, t.length && (t = this._getSelectedItem(), this.menuInstance.focus(null, t), this._setAria(t.data('ui-selectmenu-item')), this._setOption('disabled', this.element.prop('disabled')));
    },
    open: function (t) {
      this.options.disabled || (this._rendered ? (this._removeClass(this.menu.find('.ui-state-active'), null, 'ui-state-active'), this.menuInstance.focus(null, this._getSelectedItem())) : this._refreshMenu(), this.menuItems.length && (this.isOpen = !0, this._toggleAttr(), this._resizeMenu(), this._position(), this._on(this.document, this._documentClick), this._trigger('open', t)));
    },
    _position: function () {
      this.menuWrap.position(V.extend({
        of: this.button
      }, this.options.position));
    },
    close: function (t) {
      this.isOpen && (this.isOpen = !1, this._toggleAttr(), this.range = null, this._off(this.document), this._trigger('close', t));
    },
    widget: function () {
      return this.button;
    },
    menuWidget: function () {
      return this.menu;
    },
    _renderButtonItem: function (t) {
      var e = V('<span>');
      return this._setText(e, t.label), this._addClass(e, 'ui-selectmenu-text'), e;
    },
    _renderMenu: function (s, t) {
      var n = this,
        o = '';
      V.each(t, function (t, e) {
        var i;
        e.optgroup !== o && (i = V('<li>', {
          text: e.optgroup
        }), n._addClass(i, 'ui-selectmenu-optgroup', 'ui-menu-divider' + (e.element.parent('optgroup').prop('disabled') ? ' ui-state-disabled' : '')), i.appendTo(s), o = e.optgroup), n._renderItemData(s, e);
      });
    },
    _renderItemData: function (t, e) {
      return this._renderItem(t, e).data('ui-selectmenu-item', e);
    },
    _renderItem: function (t, e) {
      var i = V('<li>'),
        s = V('<div>', {
          title: e.element.attr('title')
        });
      return e.disabled && this._addClass(i, null, 'ui-state-disabled'), this._setText(s, e.label), i.append(s).appendTo(t);
    },
    _setText: function (t, e) {
      e ? t.text(e) : t.html('&#160;');
    },
    _move: function (t, e) {
      var i,
        s = '.ui-menu-item';
      this.isOpen ? i = this.menuItems.eq(this.focusIndex).parent('li') : (i = this.menuItems.eq(this.element[0].selectedIndex).parent('li'), s += ':not(.ui-state-disabled)'), (s = 'first' === t || 'last' === t ? i['first' === t ? 'prevAll' : 'nextAll'](s).eq(-1) : i[t + 'All'](s).eq(0)).length && this.menuInstance.focus(e, s);
    },
    _getSelectedItem: function () {
      return this.menuItems.eq(this.element[0].selectedIndex).parent('li');
    },
    _toggle: function (t) {
      this[this.isOpen ? 'close' : 'open'](t);
    },
    _setSelection: function () {
      var t;
      this.range && (window.getSelection ? ((t = window.getSelection()).removeAllRanges(), t.addRange(this.range)) : this.range.select(), this.button.focus());
    },
    _documentClick: {
      mousedown: function (t) {
        this.isOpen && (V(t.target).closest('.ui-selectmenu-menu, #' + V.escapeSelector(this.ids.button)).length || this.close(t));
      }
    },
    _buttonEvents: {
      mousedown: function () {
        var t;
        window.getSelection ? (t = window.getSelection()).rangeCount && (this.range = t.getRangeAt(0)) : this.range = document.selection.createRange();
      },
      click: function (t) {
        this._setSelection(), this._toggle(t);
      },
      keydown: function (t) {
        var e = !0;
        switch (t.keyCode) {
          case V.ui.keyCode.TAB:
          case V.ui.keyCode.ESCAPE:
            this.close(t), e = !1;
            break;
          case V.ui.keyCode.ENTER:
            this.isOpen && this._selectFocusedItem(t);
            break;
          case V.ui.keyCode.UP:
            t.altKey ? this._toggle(t) : this._move('prev', t);
            break;
          case V.ui.keyCode.DOWN:
            t.altKey ? this._toggle(t) : this._move('next', t);
            break;
          case V.ui.keyCode.SPACE:
            this.isOpen ? this._selectFocusedItem(t) : this._toggle(t);
            break;
          case V.ui.keyCode.LEFT:
            this._move('prev', t);
            break;
          case V.ui.keyCode.RIGHT:
            this._move('next', t);
            break;
          case V.ui.keyCode.HOME:
          case V.ui.keyCode.PAGE_UP:
            this._move('first', t);
            break;
          case V.ui.keyCode.END:
          case V.ui.keyCode.PAGE_DOWN:
            this._move('last', t);
            break;
          default:
            this.menu.trigger(t), e = !1;
        }
        e && t.preventDefault();
      }
    },
    _selectFocusedItem: function (t) {
      var e = this.menuItems.eq(this.focusIndex).parent('li');
      e.hasClass('ui-state-disabled') || this._select(e.data('ui-selectmenu-item'), t);
    },
    _select: function (t, e) {
      var i = this.element[0].selectedIndex;
      this.element[0].selectedIndex = t.index, this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(t)), this._setAria(t), this._trigger('select', e, {
        item: t
      }), t.index !== i && this._trigger('change', e, {
        item: t
      }), this.close(e);
    },
    _setAria: function (t) {
      t = this.menuItems.eq(t.index).attr('id');
      this.button.attr({
        'aria-labelledby': t,
        'aria-activedescendant': t
      }), this.menu.attr('aria-activedescendant', t);
    },
    _setOption: function (t, e) {
      var i;
      'icons' === t && (i = this.button.find('span.ui-icon'), this._removeClass(i, null, this.options.icons.button)._addClass(i, null, e.button)), this._super(t, e), 'appendTo' === t && this.menuWrap.appendTo(this._appendTo()), 'width' === t && this._resizeButton();
    },
    _setOptionDisabled: function (t) {
      this._super(t), this.menuInstance.option('disabled', t), this.button.attr('aria-disabled', t), this._toggleClass(this.button, null, 'ui-state-disabled', t), this.element.prop('disabled', t), t ? (this.button.attr('tabindex', -1), this.close()) : this.button.attr('tabindex', 0);
    },
    _appendTo: function () {
      var t = this.options.appendTo;
      return t = !(t = !(t = t && (t.jquery || t.nodeType ? V(t) : this.document.find(t).eq(0))) || !t[0] ? this.element.closest('.ui-front, dialog') : t).length ? this.document[0].body : t;
    },
    _toggleAttr: function () {
      this.button.attr('aria-expanded', this.isOpen), this._removeClass(this.button, 'ui-selectmenu-button-' + (this.isOpen ? 'closed' : 'open'))._addClass(this.button, 'ui-selectmenu-button-' + (this.isOpen ? 'open' : 'closed'))._toggleClass(this.menuWrap, 'ui-selectmenu-open', null, this.isOpen), this.menu.attr('aria-hidden', !this.isOpen);
    },
    _resizeButton: function () {
      var t = this.options.width;
      !1 !== t ? (null === t && (t = this.element.show().outerWidth(), this.element.hide()), this.button.outerWidth(t)) : this.button.css('width', '');
    },
    _resizeMenu: function () {
      this.menu.outerWidth(Math.max(this.button.outerWidth(), this.menu.width('').outerWidth() + 1));
    },
    _getCreateOptions: function () {
      var t = this._super();
      return t.disabled = this.element.prop('disabled'), t;
    },
    _parseOptions: function (t) {
      var i = this,
        s = [];
      t.each(function (t, e) {
        e.hidden || s.push(i._parseOption(V(e), t));
      }), this.items = s;
    },
    _parseOption: function (t, e) {
      var i = t.parent('optgroup');
      return {
        element: t,
        index: e,
        value: t.val(),
        label: t.text(),
        optgroup: i.attr('label') || '',
        disabled: i.prop('disabled') || t.prop('disabled')
      };
    },
    _destroy: function () {
      this._unbindFormResetHandler(), this.menuWrap.remove(), this.button.remove(), this.element.show(), this.element.removeUniqueId(), this.labels.attr('for', this.ids.element);
    }
  }]), V.widget('ui.slider', V.ui.mouse, {
    version: '1.13.1',
    widgetEventPrefix: 'slide',
    options: {
      animate: !1,
      classes: {
        'ui-slider': 'ui-corner-all',
        'ui-slider-handle': 'ui-corner-all',
        'ui-slider-range': 'ui-corner-all ui-widget-header'
      },
      distance: 0,
      max: 100,
      min: 0,
      orientation: 'horizontal',
      range: !1,
      step: 1,
      value: 0,
      values: null,
      change: null,
      slide: null,
      start: null,
      stop: null
    },
    numPages: 5,
    _create: function () {
      ;
      this._keySliding = !1, this._mouseSliding = !1, this._animateOff = !0, this._handleIndex = null, this._detectOrientation(), this._mouseInit(), this._calculateNewMax(), this._addClass('ui-slider ui-slider-' + this.orientation, 'ui-widget ui-widget-content'), this._refresh(), this._animateOff = !1;
    },
    _refresh: function () {
      this._createRange(), this._createHandles(), this._setupEvents(), this._refreshValue();
    },
    _createHandles: function () {
      var t,
        e = this.options,
        i = this.element.find('.ui-slider-handle'),
        s = [],
        n = e.values && e.values.length || 1;
      for (i.length > n && (i.slice(n).remove(), i = i.slice(0, n)), t = i.length; t < n; t++) s.push("<span tabindex='0'></span>");
      this.handles = i.add(V(s.join('')).appendTo(this.element)), this._addClass(this.handles, 'ui-slider-handle', 'ui-state-default'), this.handle = this.handles.eq(0), this.handles.each(function (t) {
        V(this).data('ui-slider-handle-index', t).attr('tabIndex', 0);
      });
    },
    _createRange: function () {
      var t = this.options;
      t.range ? (!0 === t.range && (t.values ? t.values.length && 2 !== t.values.length ? t.values = [t.values[0], t.values[0]] : Array.isArray(t.values) && (t.values = t.values.slice(0)) : t.values = [this._valueMin(), this._valueMin()]), this.range && this.range.length ? (this._removeClass(this.range, 'ui-slider-range-min ui-slider-range-max'), this.range.css({
        left: '',
        bottom: ''
      })) : (this.range = V('<div>').appendTo(this.element), this._addClass(this.range, 'ui-slider-range')), 'min' !== t.range && 'max' !== t.range || this._addClass(this.range, 'ui-slider-range-' + t.range)) : (this.range && this.range.remove(), this.range = null);
    },
    _setupEvents: function () {
      this._off(this.handles), this._on(this.handles, this._handleEvents), this._hoverable(this.handles), this._focusable(this.handles);
    },
    _destroy: function () {
      this.handles.remove(), this.range && this.range.remove(), this._mouseDestroy();
    },
    _mouseCapture: function (t) {
      var i,
        s,
        n,
        o,
        e,
        a,
        r = this,
        l = this.options;
      return !l.disabled && (this.elementSize = {
        width: this.element.outerWidth(),
        height: this.element.outerHeight()
      }, this.elementOffset = this.element.offset(), a = {
        x: t.pageX,
        y: t.pageY
      }, i = this._normValueFromMouse(a), s = this._valueMax() - this._valueMin() + 1, this.handles.each(function (t) {
        var e = Math.abs(i - r.values(t));
        (e < s || s === e && (t === r._lastChangedValue || r.values(t) === l.min)) && (s = e, n = V(this), o = t);
      }), !1 !== this._start(t, o) && (this._mouseSliding = !0, this._handleIndex = o, this._addClass(n, null, 'ui-state-active'), n.trigger('focus'), e = n.offset(), a = !V(t.target).parents().addBack().is('.ui-slider-handle'), this._clickOffset = a ? {
        left: 0,
        top: 0
      } : {
        left: t.pageX - e.left - n.width() / 2,
        top: t.pageY - e.top - n.height() / 2 - (parseInt(n.css('borderTopWidth'), 10) || 0) - (parseInt(n.css('borderBottomWidth'), 10) || 0) + (parseInt(n.css('marginTop'), 10) || 0)
      }, this.handles.hasClass('ui-state-hover') || this._slide(t, o, i), this._animateOff = !0));
    },
    _mouseStart: function () {
      return !0;
    },
    _mouseDrag: function (t) {
      var e = {
          x: t.pageX,
          y: t.pageY
        },
        e = this._normValueFromMouse(e);
      return this._slide(t, this._handleIndex, e), !1;
    },
    _mouseStop: function (t) {
      return this._removeClass(this.handles, null, 'ui-state-active'), this._mouseSliding = !1, this._stop(t, this._handleIndex), this._change(t, this._handleIndex), this._handleIndex = null, this._clickOffset = null, this._animateOff = !1;
    },
    _detectOrientation: function () {
      this.orientation = 'vertical' === this.options.orientation ? 'vertical' : 'horizontal';
    },
    _normValueFromMouse: function (t) {
      var e,
        t = 'horizontal' === this.orientation ? (e = this.elementSize.width, t.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)) : (e = this.elementSize.height, t.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0)),
        t = t / e;
      return (t = 1 < t ? 1 : t) < 0 && (t = 0), 'vertical' === this.orientation && (t = 1 - t), e = this._valueMax() - this._valueMin(), e = this._valueMin() + t * e, this._trimAlignValue(e);
    },
    _uiHash: function (t, e, i) {
      var s = {
        handle: this.handles[t],
        handleIndex: t,
        value: void 0 !== e ? e : this.value()
      };
      return this._hasMultipleValues() && (s.value = void 0 !== e ? e : this.values(t), s.values = i || this.values()), s;
    },
    _hasMultipleValues: function () {
      return this.options.values && this.options.values.length;
    },
    _start: function (t, e) {
      return this._trigger('start', t, this._uiHash(e));
    },
    _slide: function (t, e, i) {
      var s,
        n = this.value(),
        o = this.values();
      this._hasMultipleValues() && (s = this.values(e ? 0 : 1), n = this.values(e), 2 === this.options.values.length && !0 === this.options.range && (i = 0 === e ? Math.min(s, i) : Math.max(s, i)), o[e] = i), i !== n && !1 !== this._trigger('slide', t, this._uiHash(e, i, o)) && (this._hasMultipleValues() ? this.values(e, i) : this.value(i));
    },
    _stop: function (t, e) {
      this._trigger('stop', t, this._uiHash(e));
    },
    _change: function (t, e) {
      this._keySliding || this._mouseSliding || (this._lastChangedValue = e, this._trigger('change', t, this._uiHash(e)));
    },
    value: function (t) {
      return arguments.length ? (this.options.value = this._trimAlignValue(t), this._refreshValue(), void this._change(null, 0)) : this._value();
    },
    values: function (t, e) {
      var i, s, n;
      if (1 < arguments.length) return this.options.values[t] = this._trimAlignValue(e), this._refreshValue(), void this._change(null, t);
      if (!arguments.length) return this._values();
      if (!Array.isArray(t)) return this._hasMultipleValues() ? this._values(t) : this.value();
      for (i = this.options.values, s = t, n = 0; n < i.length; n += 1) i[n] = this._trimAlignValue(s[n]), this._change(null, n);
      this._refreshValue();
    },
    _setOption: function (t, e) {
      var i,
        s = 0;
      switch ('range' === t && !0 === this.options.range && ('min' === e ? (this.options.value = this._values(0), this.options.values = null) : 'max' === e && (this.options.value = this._values(this.options.values.length - 1), this.options.values = null)), Array.isArray(this.options.values) && (s = this.options.values.length), this._super(t, e), t) {
        case 'orientation':
          this._detectOrientation(), this._removeClass('ui-slider-horizontal ui-slider-vertical')._addClass('ui-slider-' + this.orientation), this._refreshValue(), this.options.range && this._refreshRange(e), this.handles.css('horizontal' === e ? 'bottom' : 'left', '');
          break;
        case 'value':
          ;
          this._animateOff = !0, this._refreshValue(), this._change(null, 0), this._animateOff = !1;
          break;
        case 'values':
          for (this._animateOff = !0, this._refreshValue(), i = s - 1; 0 <= i; i--) this._change(null, i);
          this._animateOff = !1;
          break;
        case 'step':
        case 'min':
        case 'max':
          ;
          this._animateOff = !0, this._calculateNewMax(), this._refreshValue(), this._animateOff = !1;
          break;
        case 'range':
          ;
          this._animateOff = !0, this._refresh(), this._animateOff = !1;
      }
    },
    _setOptionDisabled: function (t) {
      this._super(t), this._toggleClass(null, 'ui-state-disabled', !!t);
    },
    _value: function () {
      var t = this.options.value;
      return t = this._trimAlignValue(t);
    },
    _values: function (t) {
      var e, i;
      if (arguments.length) return t = this.options.values[t], t = this._trimAlignValue(t);
      if (this._hasMultipleValues()) {
        for (e = this.options.values.slice(), i = 0; i < e.length; i += 1) e[i] = this._trimAlignValue(e[i]);
        return e;
      }
      return [];
    },
    _trimAlignValue: function (t) {
      if (t <= this._valueMin()) return this._valueMin();
      if (t >= this._valueMax()) return this._valueMax();
      var e = 0 < this.options.step ? this.options.step : 1,
        i = (t - this._valueMin()) % e,
        t = t - i;
      return 2 * Math.abs(i) >= e && (t += 0 < i ? e : -e), parseFloat(t.toFixed(5));
    },
    _calculateNewMax: function () {
      var t = this.options.max,
        e = this._valueMin(),
        i = this.options.step;
      (t = Math.round((t - e) / i) * i + e) > this.options.max && (t -= i), this.max = parseFloat(t.toFixed(this._precision()));
    },
    _precision: function () {
      var t = this._precisionOf(this.options.step);
      return t = null !== this.options.min ? Math.max(t, this._precisionOf(this.options.min)) : t;
    },
    _precisionOf: function (t) {
      var e = t.toString(),
        t = e.indexOf('.');
      return -1 === t ? 0 : e.length - t - 1;
    },
    _valueMin: function () {
      return this.options.min;
    },
    _valueMax: function () {
      return this.max;
    },
    _refreshRange: function (t) {
      'vertical' === t && this.range.css({
        width: '',
        left: ''
      }), 'horizontal' === t && this.range.css({
        height: '',
        bottom: ''
      });
    },
    _refreshValue: function () {
      var e,
        i,
        t,
        s,
        n,
        o = this.options.range,
        a = this.options,
        r = this,
        l = !this._animateOff && a.animate,
        h = {};
      this._hasMultipleValues() ? this.handles.each(function (t) {
        ;
        i = (r.values(t) - r._valueMin()) / (r._valueMax() - r._valueMin()) * 100, h['horizontal' === r.orientation ? 'left' : 'bottom'] = i + '%', V(this).stop(1, 1)[l ? 'animate' : 'css'](h, a.animate), !0 === r.options.range && ('horizontal' === r.orientation ? (0 === t && r.range.stop(1, 1)[l ? 'animate' : 'css']({
          left: i + '%'
        }, a.animate), 1 === t && r.range[l ? 'animate' : 'css']({
          width: i - e + '%'
        }, {
          queue: !1,
          duration: a.animate
        })) : (0 === t && r.range.stop(1, 1)[l ? 'animate' : 'css']({
          bottom: i + '%'
        }, a.animate), 1 === t && r.range[l ? 'animate' : 'css']({
          height: i - e + '%'
        }, {
          queue: !1,
          duration: a.animate
        }))), e = i;
      }) : (t = this.value(), s = this._valueMin(), n = this._valueMax(), i = n !== s ? (t - s) / (n - s) * 100 : 0, h['horizontal' === this.orientation ? 'left' : 'bottom'] = i + '%', this.handle.stop(1, 1)[l ? 'animate' : 'css'](h, a.animate), 'min' === o && 'horizontal' === this.orientation && this.range.stop(1, 1)[l ? 'animate' : 'css']({
        width: i + '%'
      }, a.animate), 'max' === o && 'horizontal' === this.orientation && this.range.stop(1, 1)[l ? 'animate' : 'css']({
        width: 100 - i + '%'
      }, a.animate), 'min' === o && 'vertical' === this.orientation && this.range.stop(1, 1)[l ? 'animate' : 'css']({
        height: i + '%'
      }, a.animate), 'max' === o && 'vertical' === this.orientation && this.range.stop(1, 1)[l ? 'animate' : 'css']({
        height: 100 - i + '%'
      }, a.animate));
    },
    _handleEvents: {
      keydown: function (t) {
        var e,
          i,
          s,
          n = V(t.target).data('ui-slider-handle-index');
        switch (t.keyCode) {
          case V.ui.keyCode.HOME:
          case V.ui.keyCode.END:
          case V.ui.keyCode.PAGE_UP:
          case V.ui.keyCode.PAGE_DOWN:
          case V.ui.keyCode.UP:
          case V.ui.keyCode.RIGHT:
          case V.ui.keyCode.DOWN:
          case V.ui.keyCode.LEFT:
            if (t.preventDefault(), !this._keySliding && (this._keySliding = !0, this._addClass(V(t.target), null, 'ui-state-active'), !1 === this._start(t, n))) return;
        }
        switch (s = this.options.step, e = i = this._hasMultipleValues() ? this.values(n) : this.value(), t.keyCode) {
          case V.ui.keyCode.HOME:
            i = this._valueMin();
            break;
          case V.ui.keyCode.END:
            i = this._valueMax();
            break;
          case V.ui.keyCode.PAGE_UP:
            i = this._trimAlignValue(e + (this._valueMax() - this._valueMin()) / this.numPages);
            break;
          case V.ui.keyCode.PAGE_DOWN:
            i = this._trimAlignValue(e - (this._valueMax() - this._valueMin()) / this.numPages);
            break;
          case V.ui.keyCode.UP:
          case V.ui.keyCode.RIGHT:
            if (e === this._valueMax()) return;
            i = this._trimAlignValue(e + s);
            break;
          case V.ui.keyCode.DOWN:
          case V.ui.keyCode.LEFT:
            if (e === this._valueMin()) return;
            i = this._trimAlignValue(e - s);
        }
        this._slide(t, n, i);
      },
      keyup: function (t) {
        var e = V(t.target).data('ui-slider-handle-index');
        this._keySliding && (this._keySliding = !1, this._stop(t, e), this._change(t, e), this._removeClass(V(t.target), null, 'ui-state-active'));
      }
    }
  }), V.widget('ui.sortable', V.ui.mouse, {
    version: '1.13.1',
    widgetEventPrefix: 'sort',
    ready: !1,
    options: {
      appendTo: 'parent',
      axis: !1,
      connectWith: !1,
      containment: !1,
      cursor: 'auto',
      cursorAt: !1,
      dropOnEmpty: !0,
      forcePlaceholderSize: !1,
      forceHelperSize: !1,
      grid: !1,
      handle: !1,
      helper: 'original',
      items: '> *',
      opacity: !1,
      placeholder: !1,
      revert: !1,
      scroll: !0,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      scope: 'default',
      tolerance: 'intersect',
      zIndex: 1e3,
      activate: null,
      beforeStop: null,
      change: null,
      deactivate: null,
      out: null,
      over: null,
      receive: null,
      remove: null,
      sort: null,
      start: null,
      stop: null,
      update: null
    },
    _isOverAxis: function (t, e, i) {
      return e <= t && t < e + i;
    },
    _isFloating: function (t) {
      return /left|right/.test(t.css('float')) || /inline|table-cell/.test(t.css('display'));
    },
    _create: function () {
      ;
      this.containerCache = {}, this._addClass('ui-sortable'), this.refresh(), this.offset = this.element.offset(), this._mouseInit(), this._setHandleClassName(), this.ready = !0;
    },
    _setOption: function (t, e) {
      this._super(t, e), 'handle' === t && this._setHandleClassName();
    },
    _setHandleClassName: function () {
      var t = this;
      this._removeClass(this.element.find('.ui-sortable-handle'), 'ui-sortable-handle'), V.each(this.items, function () {
        t._addClass(this.instance.options.handle ? this.item.find(this.instance.options.handle) : this.item, 'ui-sortable-handle');
      });
    },
    _destroy: function () {
      this._mouseDestroy();
      for (var t = this.items.length - 1; 0 <= t; t--) this.items[t].item.removeData(this.widgetName + '-item');
      return this;
    },
    _mouseCapture: function (t, e) {
      var i = null,
        s = !1,
        n = this;
      return !this.reverting && !this.options.disabled && 'static' !== this.options.type && (this._refreshItems(t), V(t.target).parents().each(function () {
        if (V.data(this, n.widgetName + '-item') === n) return i = V(this), !1;
      }), !!(i = V.data(t.target, n.widgetName + '-item') === n ? V(t.target) : i) && !(this.options.handle && !e && (V(this.options.handle, i).find('*').addBack().each(function () {
        this === t.target && (s = !0);
      }), !s)) && (this.currentItem = i, this._removeCurrentsFromItems(), !0));
    },
    _mouseStart: function (t, e, i) {
      var s,
        n,
        o = this.options;
      if ((this.currentContainer = this).refreshPositions(), this.appendTo = V('parent' !== o.appendTo ? o.appendTo : this.currentItem.parent()), this.helper = this._createHelper(t), this._cacheHelperProportions(), this._cacheMargins(), this.offset = this.currentItem.offset(), this.offset = {
        top: this.offset.top - this.margins.top,
        left: this.offset.left - this.margins.left
      }, V.extend(this.offset, {
        click: {
          left: t.pageX - this.offset.left,
          top: t.pageY - this.offset.top
        },
        relative: this._getRelativeOffset()
      }), this.helper.css('position', 'absolute'), this.cssPosition = this.helper.css('position'), o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt), this.domPosition = {
        prev: this.currentItem.prev()[0],
        parent: this.currentItem.parent()[0]
      }, this.helper[0] !== this.currentItem[0] && this.currentItem.hide(), this._createPlaceholder(), this.scrollParent = this.placeholder.scrollParent(), V.extend(this.offset, {
        parent: this._getParentOffset()
      }), o.containment && this._setContainment(), o.cursor && 'auto' !== o.cursor && (n = this.document.find('body'), this.storedCursor = n.css('cursor'), n.css('cursor', o.cursor), this.storedStylesheet = V('<style>*{ cursor: ' + o.cursor + ' !important; }</style>').appendTo(n)), o.zIndex && (this.helper.css('zIndex') && (this._storedZIndex = this.helper.css('zIndex')), this.helper.css('zIndex', o.zIndex)), o.opacity && (this.helper.css('opacity') && (this._storedOpacity = this.helper.css('opacity')), this.helper.css('opacity', o.opacity)), this.scrollParent[0] !== this.document[0] && 'HTML' !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()), this._trigger('start', t, this._uiHash()), this._preserveHelperProportions || this._cacheHelperProportions(), !i) for (s = this.containers.length - 1; 0 <= s; s--) this.containers[s]._trigger('activate', t, this._uiHash(this));
      return V.ui.ddmanager && (V.ui.ddmanager.current = this), V.ui.ddmanager && !o.dropBehaviour && V.ui.ddmanager.prepareOffsets(this, t), this.dragging = !0, this._addClass(this.helper, 'ui-sortable-helper'), this.helper.parent().is(this.appendTo) || (this.helper.detach().appendTo(this.appendTo), this.offset.parent = this._getParentOffset()), this.position = this.originalPosition = this._generatePosition(t), this.originalPageX = t.pageX, this.originalPageY = t.pageY, this.lastPositionAbs = this.positionAbs = this._convertPositionTo('absolute'), this._mouseDrag(t), !0;
    },
    _scroll: function (t) {
      var e = this.options,
        i = !1;
      return this.scrollParent[0] !== this.document[0] && 'HTML' !== this.scrollParent[0].tagName ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - t.pageY < e.scrollSensitivity ? this.scrollParent[0].scrollTop = i = this.scrollParent[0].scrollTop + e.scrollSpeed : t.pageY - this.overflowOffset.top < e.scrollSensitivity && (this.scrollParent[0].scrollTop = i = this.scrollParent[0].scrollTop - e.scrollSpeed), this.overflowOffset.left + this.scrollParent[0].offsetWidth - t.pageX < e.scrollSensitivity ? this.scrollParent[0].scrollLeft = i = this.scrollParent[0].scrollLeft + e.scrollSpeed : t.pageX - this.overflowOffset.left < e.scrollSensitivity && (this.scrollParent[0].scrollLeft = i = this.scrollParent[0].scrollLeft - e.scrollSpeed)) : (t.pageY - this.document.scrollTop() < e.scrollSensitivity ? i = this.document.scrollTop(this.document.scrollTop() - e.scrollSpeed) : this.window.height() - (t.pageY - this.document.scrollTop()) < e.scrollSensitivity && (i = this.document.scrollTop(this.document.scrollTop() + e.scrollSpeed)), t.pageX - this.document.scrollLeft() < e.scrollSensitivity ? i = this.document.scrollLeft(this.document.scrollLeft() - e.scrollSpeed) : this.window.width() - (t.pageX - this.document.scrollLeft()) < e.scrollSensitivity && (i = this.document.scrollLeft(this.document.scrollLeft() + e.scrollSpeed))), i;
    },
    _mouseDrag: function (t) {
      var e,
        i,
        s,
        n,
        o = this.options;
      for (this.position = this._generatePosition(t), this.positionAbs = this._convertPositionTo('absolute'), this.options.axis && 'y' === this.options.axis || (this.helper[0].style.left = this.position.left + 'px'), this.options.axis && 'x' === this.options.axis || (this.helper[0].style.top = this.position.top + 'px'), o.scroll && !1 !== this._scroll(t) && (this._refreshItemPositions(!0), V.ui.ddmanager && !o.dropBehaviour && V.ui.ddmanager.prepareOffsets(this, t)), this.dragDirection = {
        vertical: this._getDragVerticalDirection(),
        horizontal: this._getDragHorizontalDirection()
      }, e = this.items.length - 1; 0 <= e; e--) if (s = (i = this.items[e]).item[0], (n = this._intersectsWithPointer(i)) && i.instance === this.currentContainer && !(s === this.currentItem[0] || this.placeholder[1 === n ? 'next' : 'prev']()[0] === s || V.contains(this.placeholder[0], s) || 'semi-dynamic' === this.options.type && V.contains(this.element[0], s))) {
        if (this.direction = 1 === n ? 'down' : 'up', 'pointer' !== this.options.tolerance && !this._intersectsWithSides(i)) break;
        this._rearrange(t, i), this._trigger('change', t, this._uiHash());
        break;
      }
      return this._contactContainers(t), V.ui.ddmanager && V.ui.ddmanager.drag(this, t), this._trigger('sort', t, this._uiHash()), this.lastPositionAbs = this.positionAbs, !1;
    },
    _mouseStop: function (t, e) {
      var i, s, n, o;
      if (t) return V.ui.ddmanager && !this.options.dropBehaviour && V.ui.ddmanager.drop(this, t), this.options.revert ? (s = (i = this).placeholder.offset(), o = {}, (n = this.options.axis) && 'x' !== n || (o.left = s.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft)), n && 'y' !== n || (o.top = s.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop)), this.reverting = !0, V(this.helper).animate(o, parseInt(this.options.revert, 10) || 500, function () {
        i._clear(t);
      })) : this._clear(t, e), !1;
    },
    cancel: function () {
      if (this.dragging) {
        this._mouseUp(new V.Event('mouseup', {
          target: null
        })), 'original' === this.options.helper ? (this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, 'ui-sortable-helper')) : this.currentItem.show();
        for (var t = this.containers.length - 1; 0 <= t; t--) this.containers[t]._trigger('deactivate', null, this._uiHash(this)), this.containers[t].containerCache.over && (this.containers[t]._trigger('out', null, this._uiHash(this)), this.containers[t].containerCache.over = 0);
      }
      return this.placeholder && (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]), 'original' !== this.options.helper && this.helper && this.helper[0].parentNode && this.helper.remove(), V.extend(this, {
        helper: null,
        dragging: !1,
        reverting: !1,
        _noFinalSort: null
      }), this.domPosition.prev ? V(this.domPosition.prev).after(this.currentItem) : V(this.domPosition.parent).prepend(this.currentItem)), this;
    },
    serialize: function (e) {
      var t = this._getItemsAsjQuery(e && e.connected),
        i = [];
      return e = e || {}, V(t).each(function () {
        var t = (V(e.item || this).attr(e.attribute || 'id') || '').match(e.expression || /(.+)[\-=_](.+)/);
        t && i.push((e.key || t[1] + '[]') + '=' + (e.key && e.expression ? t[1] : t[2]));
      }), !i.length && e.key && i.push(e.key + '='), i.join('&');
    },
    toArray: function (t) {
      var e = this._getItemsAsjQuery(t && t.connected),
        i = [];
      return t = t || {}, e.each(function () {
        i.push(V(t.item || this).attr(t.attribute || 'id') || '');
      }), i;
    },
    _intersectsWith: function (t) {
      var e = this.positionAbs.left,
        i = e + this.helperProportions.width,
        s = this.positionAbs.top,
        n = s + this.helperProportions.height,
        o = t.left,
        a = o + t.width,
        r = t.top,
        l = r + t.height,
        h = this.offset.click.top,
        c = this.offset.click.left,
        h = 'x' === this.options.axis || r < s + h && s + h < l,
        c = 'y' === this.options.axis || o < e + c && e + c < a;
      return 'pointer' === this.options.tolerance || this.options.forcePointerForContainers || 'pointer' !== this.options.tolerance && this.helperProportions[this.floating ? 'width' : 'height'] > t[this.floating ? 'width' : 'height'] ? h && c : o < e + this.helperProportions.width / 2 && i - this.helperProportions.width / 2 < a && r < s + this.helperProportions.height / 2 && n - this.helperProportions.height / 2 < l;
    },
    _intersectsWithPointer: function (t) {
      var e = 'x' === this.options.axis || this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top, t.height),
        t = 'y' === this.options.axis || this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left, t.width);
      return !(!e || !t) && (e = this.dragDirection.vertical, t = this.dragDirection.horizontal, this.floating ? 'right' === t || 'down' === e ? 2 : 1 : e && ('down' === e ? 2 : 1));
    },
    _intersectsWithSides: function (t) {
      var e = this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top + t.height / 2, t.height),
        i = this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left + t.width / 2, t.width),
        s = this.dragDirection.vertical,
        t = this.dragDirection.horizontal;
      return this.floating && t ? 'right' === t && i || 'left' === t && !i : s && ('down' === s && e || 'up' === s && !e);
    },
    _getDragVerticalDirection: function () {
      var t = this.positionAbs.top - this.lastPositionAbs.top;
      return 0 != t && (0 < t ? 'down' : 'up');
    },
    _getDragHorizontalDirection: function () {
      var t = this.positionAbs.left - this.lastPositionAbs.left;
      return 0 != t && (0 < t ? 'right' : 'left');
    },
    refresh: function (t) {
      return this._refreshItems(t), this._setHandleClassName(), this.refreshPositions(), this;
    },
    _connectWith: function () {
      var t = this.options;
      return t.connectWith.constructor === String ? [t.connectWith] : t.connectWith;
    },
    _getItemsAsjQuery: function (t) {
      var e,
        i,
        s,
        n,
        o = [],
        a = [],
        r = this._connectWith();
      if (r && t) for (e = r.length - 1; 0 <= e; e--) for (i = (s = V(r[e], this.document[0])).length - 1; 0 <= i; i--) (n = V.data(s[i], this.widgetFullName)) && n !== this && !n.options.disabled && a.push(['function' == typeof n.options.items ? n.options.items.call(n.element) : V(n.options.items, n.element).not('.ui-sortable-helper').not('.ui-sortable-placeholder'), n]);
      function l() {
        o.push(this);
      }
      for (a.push(['function' == typeof this.options.items ? this.options.items.call(this.element, null, {
        options: this.options,
        item: this.currentItem
      }) : V(this.options.items, this.element).not('.ui-sortable-helper').not('.ui-sortable-placeholder'), this]), e = a.length - 1; 0 <= e; e--) a[e][0].each(l);
      return V(o);
    },
    _removeCurrentsFromItems: function () {
      var i = this.currentItem.find(':data(' + this.widgetName + '-item)');
      this.items = V.grep(this.items, function (t) {
        for (var e = 0; e < i.length; e++) if (i[e] === t.item[0]) return !1;
        return !0;
      });
    },
    _refreshItems: function (t) {
      ;
      this.items = [], this.containers = [this];
      var e,
        i,
        s,
        n,
        o,
        a,
        r,
        l,
        h = this.items,
        c = [['function' == typeof this.options.items ? this.options.items.call(this.element[0], t, {
          item: this.currentItem
        }) : V(this.options.items, this.element), this]],
        u = this._connectWith();
      if (u && this.ready) for (e = u.length - 1; 0 <= e; e--) for (i = (s = V(u[e], this.document[0])).length - 1; 0 <= i; i--) (n = V.data(s[i], this.widgetFullName)) && n !== this && !n.options.disabled && (c.push(['function' == typeof n.options.items ? n.options.items.call(n.element[0], t, {
        item: this.currentItem
      }) : V(n.options.items, n.element), n]), this.containers.push(n));
      for (e = c.length - 1; 0 <= e; e--) for (o = c[e][1], l = (a = c[e][i = 0]).length; i < l; i++) (r = V(a[i])).data(this.widgetName + '-item', o), h.push({
        item: r,
        instance: o,
        width: 0,
        height: 0,
        left: 0,
        top: 0
      });
    },
    _refreshItemPositions: function (t) {
      for (var e, i, s = this.items.length - 1; 0 <= s; s--) e = this.items[s], this.currentContainer && e.instance !== this.currentContainer && e.item[0] !== this.currentItem[0] || (i = this.options.toleranceElement ? V(this.options.toleranceElement, e.item) : e.item, t || (e.width = i.outerWidth(), e.height = i.outerHeight()), i = i.offset(), e.left = i.left, e.top = i.top);
    },
    refreshPositions: function (t) {
      var e, i;
      if (this.floating = !!this.items.length && ('x' === this.options.axis || this._isFloating(this.items[0].item)), this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset()), this._refreshItemPositions(t), this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this);else for (e = this.containers.length - 1; 0 <= e; e--) i = this.containers[e].element.offset(), this.containers[e].containerCache.left = i.left, this.containers[e].containerCache.top = i.top, this.containers[e].containerCache.width = this.containers[e].element.outerWidth(), this.containers[e].containerCache.height = this.containers[e].element.outerHeight();
      return this;
    },
    _createPlaceholder: function (i) {
      var s,
        n,
        o = (i = i || this).options;
      o.placeholder && o.placeholder.constructor !== String || (s = o.placeholder, n = i.currentItem[0].nodeName.toLowerCase(), o.placeholder = {
        element: function () {
          var t = V('<' + n + '>', i.document[0]);
          return i._addClass(t, 'ui-sortable-placeholder', s || i.currentItem[0].className)._removeClass(t, 'ui-sortable-helper'), 'tbody' === n ? i._createTrPlaceholder(i.currentItem.find('tr').eq(0), V('<tr>', i.document[0]).appendTo(t)) : 'tr' === n ? i._createTrPlaceholder(i.currentItem, t) : 'img' === n && t.attr('src', i.currentItem.attr('src')), s || t.css('visibility', 'hidden'), t;
        },
        update: function (t, e) {
          ;
          s && !o.forcePlaceholderSize || (e.height() && (!o.forcePlaceholderSize || 'tbody' !== n && 'tr' !== n) || e.height(i.currentItem.innerHeight() - parseInt(i.currentItem.css('paddingTop') || 0, 10) - parseInt(i.currentItem.css('paddingBottom') || 0, 10)), e.width() || e.width(i.currentItem.innerWidth() - parseInt(i.currentItem.css('paddingLeft') || 0, 10) - parseInt(i.currentItem.css('paddingRight') || 0, 10)));
        }
      }), i.placeholder = V(o.placeholder.element.call(i.element, i.currentItem)), i.currentItem.after(i.placeholder), o.placeholder.update(i, i.placeholder);
    },
    _createTrPlaceholder: function (t, e) {
      var i = this;
      t.children().each(function () {
        V('<td>&#160;</td>', i.document[0]).attr('colspan', V(this).attr('colspan') || 1).appendTo(e);
      });
    },
    _contactContainers: function (t) {
      for (var e, i, s, n, o, a, r, l, h, c = null, u = null, d = this.containers.length - 1; 0 <= d; d--) V.contains(this.currentItem[0], this.containers[d].element[0]) || (this._intersectsWith(this.containers[d].containerCache) ? c && V.contains(this.containers[d].element[0], c.element[0]) || (c = this.containers[d], u = d) : this.containers[d].containerCache.over && (this.containers[d]._trigger('out', t, this._uiHash(this)), this.containers[d].containerCache.over = 0));
      if (c) if (1 === this.containers.length) this.containers[u].containerCache.over || (this.containers[u]._trigger('over', t, this._uiHash(this)), this.containers[u].containerCache.over = 1);else {
        for (i = 1e4, s = null, n = (l = c.floating || this._isFloating(this.currentItem)) ? 'left' : 'top', o = l ? 'width' : 'height', h = l ? 'pageX' : 'pageY', e = this.items.length - 1; 0 <= e; e--) V.contains(this.containers[u].element[0], this.items[e].item[0]) && this.items[e].item[0] !== this.currentItem[0] && (a = this.items[e].item.offset()[n], r = !1, t[h] - a > this.items[e][o] / 2 && (r = !0), Math.abs(t[h] - a) < i && (i = Math.abs(t[h] - a), s = this.items[e], this.direction = r ? 'up' : 'down'));
        (s || this.options.dropOnEmpty) && (this.currentContainer !== this.containers[u] ? (s ? this._rearrange(t, s, null, !0) : this._rearrange(t, null, this.containers[u].element, !0), this._trigger('change', t, this._uiHash()), this.containers[u]._trigger('change', t, this._uiHash(this)), this.currentContainer = this.containers[u], this.options.placeholder.update(this.currentContainer, this.placeholder), this.scrollParent = this.placeholder.scrollParent(), this.scrollParent[0] !== this.document[0] && 'HTML' !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()), this.containers[u]._trigger('over', t, this._uiHash(this)), this.containers[u].containerCache.over = 1) : this.currentContainer.containerCache.over || (this.containers[u]._trigger('over', t, this._uiHash()), this.currentContainer.containerCache.over = 1));
      }
    },
    _createHelper: function (t) {
      var e = this.options,
        t = 'function' == typeof e.helper ? V(e.helper.apply(this.element[0], [t, this.currentItem])) : 'clone' === e.helper ? this.currentItem.clone() : this.currentItem;
      return t.parents('body').length || this.appendTo[0].appendChild(t[0]), t[0] === this.currentItem[0] && (this._storedCSS = {
        width: this.currentItem[0].style.width,
        height: this.currentItem[0].style.height,
        position: this.currentItem.css('position'),
        top: this.currentItem.css('top'),
        left: this.currentItem.css('left')
      }), t[0].style.width && !e.forceHelperSize || t.width(this.currentItem.width()), t[0].style.height && !e.forceHelperSize || t.height(this.currentItem.height()), t;
    },
    _adjustOffsetFromHelper: function (t) {
      'string' == typeof t && (t = t.split(' ')), 'left' in (t = Array.isArray(t) ? {
        left: +t[0],
        top: +t[1] || 0
      } : t) && (this.offset.click.left = t.left + this.margins.left), 'right' in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left), 'top' in t && (this.offset.click.top = t.top + this.margins.top), 'bottom' in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top);
    },
    _getParentOffset: function () {
      this.offsetParent = this.helper.offsetParent();
      var t = this.offsetParent.offset();
      return 'absolute' === this.cssPosition && this.scrollParent[0] !== this.document[0] && V.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(), t.top += this.scrollParent.scrollTop()), {
        top: (t = this.offsetParent[0] === this.document[0].body || this.offsetParent[0].tagName && 'html' === this.offsetParent[0].tagName.toLowerCase() && V.ui.ie ? {
          top: 0,
          left: 0
        } : t).top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
        left: t.left + (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0)
      };
    },
    _getRelativeOffset: function () {
      if ('relative' !== this.cssPosition) return {
        top: 0,
        left: 0
      };
      var t = this.currentItem.position();
      return {
        top: t.top - (parseInt(this.helper.css('top'), 10) || 0) + this.scrollParent.scrollTop(),
        left: t.left - (parseInt(this.helper.css('left'), 10) || 0) + this.scrollParent.scrollLeft()
      };
    },
    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.currentItem.css('marginLeft'), 10) || 0,
        top: parseInt(this.currentItem.css('marginTop'), 10) || 0
      };
    },
    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight()
      };
    },
    _setContainment: function () {
      var t,
        e,
        i = this.options;
      'parent' === i.containment && (i.containment = this.helper[0].parentNode), 'document' !== i.containment && 'window' !== i.containment || (this.containment = [0 - this.offset.relative.left - this.offset.parent.left, 0 - this.offset.relative.top - this.offset.parent.top, 'document' === i.containment ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left, ('document' === i.containment ? this.document.height() || document.body.parentNode.scrollHeight : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top]), /^(document|window|parent)$/.test(i.containment) || (t = V(i.containment)[0], e = V(i.containment).offset(), i = 'hidden' !== V(t).css('overflow'), this.containment = [e.left + (parseInt(V(t).css('borderLeftWidth'), 10) || 0) + (parseInt(V(t).css('paddingLeft'), 10) || 0) - this.margins.left, e.top + (parseInt(V(t).css('borderTopWidth'), 10) || 0) + (parseInt(V(t).css('paddingTop'), 10) || 0) - this.margins.top, e.left + (i ? Math.max(t.scrollWidth, t.offsetWidth) : t.offsetWidth) - (parseInt(V(t).css('borderLeftWidth'), 10) || 0) - (parseInt(V(t).css('paddingRight'), 10) || 0) - this.helperProportions.width - this.margins.left, e.top + (i ? Math.max(t.scrollHeight, t.offsetHeight) : t.offsetHeight) - (parseInt(V(t).css('borderTopWidth'), 10) || 0) - (parseInt(V(t).css('paddingBottom'), 10) || 0) - this.helperProportions.height - this.margins.top]);
    },
    _convertPositionTo: function (t, e) {
      e = e || this.position;
      var i = 'absolute' === t ? 1 : -1,
        s = 'absolute' !== this.cssPosition || this.scrollParent[0] !== this.document[0] && V.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,
        t = /(html|body)/i.test(s[0].tagName);
      return {
        top: e.top + this.offset.relative.top * i + this.offset.parent.top * i - ('fixed' === this.cssPosition ? -this.scrollParent.scrollTop() : t ? 0 : s.scrollTop()) * i,
        left: e.left + this.offset.relative.left * i + this.offset.parent.left * i - ('fixed' === this.cssPosition ? -this.scrollParent.scrollLeft() : t ? 0 : s.scrollLeft()) * i
      };
    },
    _generatePosition: function (t) {
      var e = this.options,
        i = t.pageX,
        s = t.pageY,
        n = 'absolute' !== this.cssPosition || this.scrollParent[0] !== this.document[0] && V.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,
        o = /(html|body)/i.test(n[0].tagName);
      return 'relative' !== this.cssPosition || this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0] || (this.offset.relative = this._getRelativeOffset()), this.originalPosition && (this.containment && (t.pageX - this.offset.click.left < this.containment[0] && (i = this.containment[0] + this.offset.click.left), t.pageY - this.offset.click.top < this.containment[1] && (s = this.containment[1] + this.offset.click.top), t.pageX - this.offset.click.left > this.containment[2] && (i = this.containment[2] + this.offset.click.left), t.pageY - this.offset.click.top > this.containment[3] && (s = this.containment[3] + this.offset.click.top)), e.grid && (t = this.originalPageY + Math.round((s - this.originalPageY) / e.grid[1]) * e.grid[1], s = !this.containment || t - this.offset.click.top >= this.containment[1] && t - this.offset.click.top <= this.containment[3] ? t : t - this.offset.click.top >= this.containment[1] ? t - e.grid[1] : t + e.grid[1], t = this.originalPageX + Math.round((i - this.originalPageX) / e.grid[0]) * e.grid[0], i = !this.containment || t - this.offset.click.left >= this.containment[0] && t - this.offset.click.left <= this.containment[2] ? t : t - this.offset.click.left >= this.containment[0] ? t - e.grid[0] : t + e.grid[0])), {
        top: s - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ('fixed' === this.cssPosition ? -this.scrollParent.scrollTop() : o ? 0 : n.scrollTop()),
        left: i - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ('fixed' === this.cssPosition ? -this.scrollParent.scrollLeft() : o ? 0 : n.scrollLeft())
      };
    },
    _rearrange: function (t, e, i, s) {
      i ? i[0].appendChild(this.placeholder[0]) : e.item[0].parentNode.insertBefore(this.placeholder[0], 'down' === this.direction ? e.item[0] : e.item[0].nextSibling), this.counter = this.counter ? ++this.counter : 1;
      var n = this.counter;
      this._delay(function () {
        n === this.counter && this.refreshPositions(!s);
      });
    },
    _clear: function (t, e) {
      this.reverting = !1;
      var i,
        s = [];
      if (!this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem), this._noFinalSort = null, this.helper[0] === this.currentItem[0]) {
        for (i in this._storedCSS) 'auto' !== this._storedCSS[i] && 'static' !== this._storedCSS[i] || (this._storedCSS[i] = '');
        this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, 'ui-sortable-helper');
      } else this.currentItem.show();
      function n(e, i, s) {
        return function (t) {
          s._trigger(e, t, i._uiHash(i));
        };
      }
      for (this.fromOutside && !e && s.push(function (t) {
        this._trigger('receive', t, this._uiHash(this.fromOutside));
      }), !this.fromOutside && this.domPosition.prev === this.currentItem.prev().not('.ui-sortable-helper')[0] && this.domPosition.parent === this.currentItem.parent()[0] || e || s.push(function (t) {
        this._trigger('update', t, this._uiHash());
      }), this !== this.currentContainer && (e || (s.push(function (t) {
        this._trigger('remove', t, this._uiHash());
      }), s.push(function (e) {
        return function (t) {
          e._trigger('receive', t, this._uiHash(this));
        };
      }.call(this, this.currentContainer)), s.push(function (e) {
        return function (t) {
          e._trigger('update', t, this._uiHash(this));
        };
      }.call(this, this.currentContainer)))), i = this.containers.length - 1; 0 <= i; i--) e || s.push(n('deactivate', this, this.containers[i])), this.containers[i].containerCache.over && (s.push(n('out', this, this.containers[i])), this.containers[i].containerCache.over = 0);
      if (this.storedCursor && (this.document.find('body').css('cursor', this.storedCursor), this.storedStylesheet.remove()), this._storedOpacity && this.helper.css('opacity', this._storedOpacity), this._storedZIndex && this.helper.css('zIndex', 'auto' === this._storedZIndex ? '' : this._storedZIndex), this.dragging = !1, e || this._trigger('beforeStop', t, this._uiHash()), this.placeholder[0].parentNode.removeChild(this.placeholder[0]), this.cancelHelperRemoval || (this.helper[0] !== this.currentItem[0] && this.helper.remove(), this.helper = null), !e) {
        for (i = 0; i < s.length; i++) s[i].call(this, t);
        this._trigger('stop', t, this._uiHash());
      }
      return this.fromOutside = !1, !this.cancelHelperRemoval;
    },
    _trigger: function () {
      !1 === V.Widget.prototype._trigger.apply(this, arguments) && this.cancel();
    },
    _uiHash: function (t) {
      var e = t || this;
      return {
        helper: e.helper,
        placeholder: e.placeholder || V([]),
        position: e.position,
        originalPosition: e.originalPosition,
        offset: e.positionAbs,
        item: e.currentItem,
        sender: t ? t.element : null
      };
    }
  });
  function ht(e) {
    return function () {
      var t = this.element.val();
      e.apply(this, arguments), this._refresh(), t !== this.element.val() && this._trigger('change');
    };
  }
  V.widget('ui.spinner', {
    version: '1.13.1',
    defaultElement: '<input>',
    widgetEventPrefix: 'spin',
    options: {
      classes: {
        'ui-spinner': 'ui-corner-all',
        'ui-spinner-down': 'ui-corner-br',
        'ui-spinner-up': 'ui-corner-tr'
      },
      culture: null,
      icons: {
        down: 'ui-icon-triangle-1-s',
        up: 'ui-icon-triangle-1-n'
      },
      incremental: !0,
      max: null,
      min: null,
      numberFormat: null,
      page: 10,
      step: 1,
      change: null,
      spin: null,
      start: null,
      stop: null
    },
    _create: function () {
      this._setOption('max', this.options.max), this._setOption('min', this.options.min), this._setOption('step', this.options.step), '' !== this.value() && this._value(this.element.val(), !0), this._draw(), this._on(this._events), this._refresh(), this._on(this.window, {
        beforeunload: function () {
          this.element.removeAttr('autocomplete');
        }
      });
    },
    _getCreateOptions: function () {
      var s = this._super(),
        n = this.element;
      return V.each(['min', 'max', 'step'], function (t, e) {
        var i = n.attr(e);
        null != i && i.length && (s[e] = i);
      }), s;
    },
    _events: {
      keydown: function (t) {
        this._start(t) && this._keydown(t) && t.preventDefault();
      },
      keyup: '_stop',
      focus: function () {
        this.previous = this.element.val();
      },
      blur: function (t) {
        this.cancelBlur ? delete this.cancelBlur : (this._stop(), this._refresh(), this.previous !== this.element.val() && this._trigger('change', t));
      },
      mousewheel: function (t, e) {
        var i = V.ui.safeActiveElement(this.document[0]);
        if (this.element[0] === i && e) {
          if (!this.spinning && !this._start(t)) return !1;
          this._spin((0 < e ? 1 : -1) * this.options.step, t), clearTimeout(this.mousewheelTimer), this.mousewheelTimer = this._delay(function () {
            this.spinning && this._stop(t);
          }, 100), t.preventDefault();
        }
      },
      'mousedown .ui-spinner-button': function (t) {
        var e;
        function i() {
          this.element[0] === V.ui.safeActiveElement(this.document[0]) || (this.element.trigger('focus'), this.previous = e, this._delay(function () {
            this.previous = e;
          }));
        }
        ;
        e = this.element[0] === V.ui.safeActiveElement(this.document[0]) ? this.previous : this.element.val(), t.preventDefault(), i.call(this), this.cancelBlur = !0, this._delay(function () {
          delete this.cancelBlur, i.call(this);
        }), !1 !== this._start(t) && this._repeat(null, V(t.currentTarget).hasClass('ui-spinner-up') ? 1 : -1, t);
      },
      'mouseup .ui-spinner-button': '_stop',
      'mouseenter .ui-spinner-button': function (t) {
        if (V(t.currentTarget).hasClass('ui-state-active')) return !1 !== this._start(t) && void this._repeat(null, V(t.currentTarget).hasClass('ui-spinner-up') ? 1 : -1, t);
      },
      'mouseleave .ui-spinner-button': '_stop'
    },
    _enhance: function () {
      this.uiSpinner = this.element.attr('autocomplete', 'off').wrap('<span>').parent().append('<a></a><a></a>');
    },
    _draw: function () {
      this._enhance(), this._addClass(this.uiSpinner, 'ui-spinner', 'ui-widget ui-widget-content'), this._addClass('ui-spinner-input'), this.element.attr('role', 'spinbutton'), this.buttons = this.uiSpinner.children('a').attr('tabIndex', -1).attr('aria-hidden', !0).button({
        classes: {
          'ui-button': ''
        }
      }), this._removeClass(this.buttons, 'ui-corner-all'), this._addClass(this.buttons.first(), 'ui-spinner-button ui-spinner-up'), this._addClass(this.buttons.last(), 'ui-spinner-button ui-spinner-down'), this.buttons.first().button({
        icon: this.options.icons.up,
        showLabel: !1
      }), this.buttons.last().button({
        icon: this.options.icons.down,
        showLabel: !1
      }), this.buttons.height() > Math.ceil(0.5 * this.uiSpinner.height()) && 0 < this.uiSpinner.height() && this.uiSpinner.height(this.uiSpinner.height());
    },
    _keydown: function (t) {
      var e = this.options,
        i = V.ui.keyCode;
      switch (t.keyCode) {
        case i.UP:
          return this._repeat(null, 1, t), !0;
        case i.DOWN:
          return this._repeat(null, -1, t), !0;
        case i.PAGE_UP:
          return this._repeat(null, e.page, t), !0;
        case i.PAGE_DOWN:
          return this._repeat(null, -e.page, t), !0;
      }
      return !1;
    },
    _start: function (t) {
      return !(!this.spinning && !1 === this._trigger('start', t)) && (this.counter || (this.counter = 1), this.spinning = !0);
    },
    _repeat: function (t, e, i) {
      ;
      t = t || 500, clearTimeout(this.timer), this.timer = this._delay(function () {
        this._repeat(40, e, i);
      }, t), this._spin(e * this.options.step, i);
    },
    _spin: function (t, e) {
      var i = this.value() || 0;
      this.counter || (this.counter = 1), i = this._adjustValue(i + t * this._increment(this.counter)), this.spinning && !1 === this._trigger('spin', e, {
        value: i
      }) || (this._value(i), this.counter++);
    },
    _increment: function (t) {
      var e = this.options.incremental;
      return e ? 'function' == typeof e ? e(t) : Math.floor(t * t * t / 5e4 - t * t / 500 + 17 * t / 200 + 1) : 1;
    },
    _precision: function () {
      var t = this._precisionOf(this.options.step);
      return t = null !== this.options.min ? Math.max(t, this._precisionOf(this.options.min)) : t;
    },
    _precisionOf: function (t) {
      var e = t.toString(),
        t = e.indexOf('.');
      return -1 === t ? 0 : e.length - t - 1;
    },
    _adjustValue: function (t) {
      var e = this.options,
        i = null !== e.min ? e.min : 0,
        s = t - i;
      return t = i + Math.round(s / e.step) * e.step, t = parseFloat(t.toFixed(this._precision())), null !== e.max && t > e.max ? e.max : null !== e.min && t < e.min ? e.min : t;
    },
    _stop: function (t) {
      this.spinning && (clearTimeout(this.timer), clearTimeout(this.mousewheelTimer), this.counter = 0, this.spinning = !1, this._trigger('stop', t));
    },
    _setOption: function (t, e) {
      var i;
      if ('culture' === t || 'numberFormat' === t) return i = this._parse(this.element.val()), this.options[t] = e, void this.element.val(this._format(i));
      'max' !== t && 'min' !== t && 'step' !== t || 'string' == typeof e && (e = this._parse(e)), 'icons' === t && (i = this.buttons.first().find('.ui-icon'), this._removeClass(i, null, this.options.icons.up), this._addClass(i, null, e.up), i = this.buttons.last().find('.ui-icon'), this._removeClass(i, null, this.options.icons.down), this._addClass(i, null, e.down)), this._super(t, e);
    },
    _setOptionDisabled: function (t) {
      this._super(t), this._toggleClass(this.uiSpinner, null, 'ui-state-disabled', !!t), this.element.prop('disabled', !!t), this.buttons.button(t ? 'disable' : 'enable');
    },
    _setOptions: ht(function (t) {
      this._super(t);
    }),
    _parse: function (t) {
      return '' === (t = 'string' == typeof t && '' !== t ? window.Globalize && this.options.numberFormat ? Globalize.parseFloat(t, 10, this.options.culture) : +t : t) || isNaN(t) ? null : t;
    },
    _format: function (t) {
      return '' === t ? '' : window.Globalize && this.options.numberFormat ? Globalize.format(t, this.options.numberFormat, this.options.culture) : t;
    },
    _refresh: function () {
      this.element.attr({
        'aria-valuemin': this.options.min,
        'aria-valuemax': this.options.max,
        'aria-valuenow': this._parse(this.element.val())
      });
    },
    isValid: function () {
      var t = this.value();
      return null !== t && t === this._adjustValue(t);
    },
    _value: function (t, e) {
      var i;
      '' !== t && null !== (i = this._parse(t)) && (e || (i = this._adjustValue(i)), t = this._format(i)), this.element.val(t), this._refresh();
    },
    _destroy: function () {
      this.element.prop('disabled', !1).removeAttr('autocomplete role aria-valuemin aria-valuemax aria-valuenow'), this.uiSpinner.replaceWith(this.element);
    },
    stepUp: ht(function (t) {
      this._stepUp(t);
    }),
    _stepUp: function (t) {
      this._start() && (this._spin((t || 1) * this.options.step), this._stop());
    },
    stepDown: ht(function (t) {
      this._stepDown(t);
    }),
    _stepDown: function (t) {
      this._start() && (this._spin((t || 1) * -this.options.step), this._stop());
    },
    pageUp: ht(function (t) {
      this._stepUp((t || 1) * this.options.page);
    }),
    pageDown: ht(function (t) {
      this._stepDown((t || 1) * this.options.page);
    }),
    value: function (t) {
      if (!arguments.length) return this._parse(this.element.val());
      ht(this._value).call(this, t);
    },
    widget: function () {
      return this.uiSpinner;
    }
  }), !1 !== V.uiBackCompat && V.widget('ui.spinner', V.ui.spinner, {
    _enhance: function () {
      this.uiSpinner = this.element.attr('autocomplete', 'off').wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());
    },
    _uiSpinnerHtml: function () {
      return '<span>';
    },
    _buttonHtml: function () {
      return '<a></a><a></a>';
    }
  });
  var ct;
  V.ui.spinner;
  V.widget('ui.tabs', {
    version: '1.13.1',
    delay: 300,
    options: {
      active: null,
      classes: {
        'ui-tabs': 'ui-corner-all',
        'ui-tabs-nav': 'ui-corner-all',
        'ui-tabs-panel': 'ui-corner-bottom',
        'ui-tabs-tab': 'ui-corner-top'
      },
      collapsible: !1,
      event: 'click',
      heightStyle: 'content',
      hide: null,
      show: null,
      activate: null,
      beforeActivate: null,
      beforeLoad: null,
      load: null
    },
    _isLocal: (ct = /#.*$/, function (t) {
      var e = t.href.replace(ct, ''),
        i = location.href.replace(ct, '');
      try {
        e = decodeURIComponent(e);
      } catch (t) {}
      try {
        i = decodeURIComponent(i);
      } catch (t) {}
      return 1 < t.hash.length && e === i;
    }),
    _create: function () {
      var e = this,
        t = this.options;
      this.running = !1, this._addClass('ui-tabs', 'ui-widget ui-widget-content'), this._toggleClass('ui-tabs-collapsible', null, t.collapsible), this._processTabs(), t.active = this._initialActive(), Array.isArray(t.disabled) && (t.disabled = V.uniqueSort(t.disabled.concat(V.map(this.tabs.filter('.ui-state-disabled'), function (t) {
        return e.tabs.index(t);
      }))).sort()), !1 !== this.options.active && this.anchors.length ? this.active = this._findActive(t.active) : this.active = V(), this._refresh(), this.active.length && this.load(t.active);
    },
    _initialActive: function () {
      var i = this.options.active,
        t = this.options.collapsible,
        s = location.hash.substring(1);
      return null === i && (s && this.tabs.each(function (t, e) {
        if (V(e).attr('aria-controls') === s) return i = t, !1;
      }), null !== (i = null === i ? this.tabs.index(this.tabs.filter('.ui-tabs-active')) : i) && -1 !== i || (i = !!this.tabs.length && 0)), !1 !== i && -1 === (i = this.tabs.index(this.tabs.eq(i))) && (i = !t && 0), i = !t && !1 === i && this.anchors.length ? 0 : i;
    },
    _getCreateEventData: function () {
      return {
        tab: this.active,
        panel: this.active.length ? this._getPanelForTab(this.active) : V()
      };
    },
    _tabKeydown: function (t) {
      var e = V(V.ui.safeActiveElement(this.document[0])).closest('li'),
        i = this.tabs.index(e),
        s = !0;
      if (!this._handlePageNav(t)) {
        switch (t.keyCode) {
          case V.ui.keyCode.RIGHT:
          case V.ui.keyCode.DOWN:
            i++;
            break;
          case V.ui.keyCode.UP:
          case V.ui.keyCode.LEFT:
            ;
            s = !1, i--;
            break;
          case V.ui.keyCode.END:
            i = this.anchors.length - 1;
            break;
          case V.ui.keyCode.HOME:
            i = 0;
            break;
          case V.ui.keyCode.SPACE:
            return t.preventDefault(), clearTimeout(this.activating), void this._activate(i);
          case V.ui.keyCode.ENTER:
            return t.preventDefault(), clearTimeout(this.activating), void this._activate(i !== this.options.active && i);
          default:
            return;
        }
        t.preventDefault(), clearTimeout(this.activating), i = this._focusNextTab(i, s), t.ctrlKey || t.metaKey || (e.attr('aria-selected', 'false'), this.tabs.eq(i).attr('aria-selected', 'true'), this.activating = this._delay(function () {
          this.option('active', i);
        }, this.delay));
      }
    },
    _panelKeydown: function (t) {
      this._handlePageNav(t) || t.ctrlKey && t.keyCode === V.ui.keyCode.UP && (t.preventDefault(), this.active.trigger('focus'));
    },
    _handlePageNav: function (t) {
      return t.altKey && t.keyCode === V.ui.keyCode.PAGE_UP ? (this._activate(this._focusNextTab(this.options.active - 1, !1)), !0) : t.altKey && t.keyCode === V.ui.keyCode.PAGE_DOWN ? (this._activate(this._focusNextTab(this.options.active + 1, !0)), !0) : void 0;
    },
    _findNextTab: function (t, e) {
      var i = this.tabs.length - 1;
      for (; -1 !== V.inArray(t = (t = i < t ? 0 : t) < 0 ? i : t, this.options.disabled);) t = e ? t + 1 : t - 1;
      return t;
    },
    _focusNextTab: function (t, e) {
      return t = this._findNextTab(t, e), this.tabs.eq(t).trigger('focus'), t;
    },
    _setOption: function (t, e) {
      'active' !== t ? (this._super(t, e), 'collapsible' === t && (this._toggleClass('ui-tabs-collapsible', null, e), e || !1 !== this.options.active || this._activate(0)), 'event' === t && this._setupEvents(e), 'heightStyle' === t && this._setupHeightStyle(e)) : this._activate(e);
    },
    _sanitizeSelector: function (t) {
      return t ? t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, '\\$&') : '';
    },
    refresh: function () {
      var t = this.options,
        e = this.tablist.children(':has(a[href])');
      t.disabled = V.map(e.filter('.ui-state-disabled'), function (t) {
        return e.index(t);
      }), this._processTabs(), !1 !== t.active && this.anchors.length ? this.active.length && !V.contains(this.tablist[0], this.active[0]) ? this.tabs.length === t.disabled.length ? (t.active = !1, this.active = V()) : this._activate(this._findNextTab(Math.max(0, t.active - 1), !1)) : t.active = this.tabs.index(this.active) : (t.active = !1, this.active = V()), this._refresh();
    },
    _refresh: function () {
      this._setOptionDisabled(this.options.disabled), this._setupEvents(this.options.event), this._setupHeightStyle(this.options.heightStyle), this.tabs.not(this.active).attr({
        'aria-selected': 'false',
        'aria-expanded': 'false',
        tabIndex: -1
      }), this.panels.not(this._getPanelForTab(this.active)).hide().attr({
        'aria-hidden': 'true'
      }), this.active.length ? (this.active.attr({
        'aria-selected': 'true',
        'aria-expanded': 'true',
        tabIndex: 0
      }), this._addClass(this.active, 'ui-tabs-active', 'ui-state-active'), this._getPanelForTab(this.active).show().attr({
        'aria-hidden': 'false'
      })) : this.tabs.eq(0).attr('tabIndex', 0);
    },
    _processTabs: function () {
      var l = this,
        t = this.tabs,
        e = this.anchors,
        i = this.panels;
      this.tablist = this._getList().attr('role', 'tablist'), this._addClass(this.tablist, 'ui-tabs-nav', 'ui-helper-reset ui-helper-clearfix ui-widget-header'), this.tablist.on('mousedown' + this.eventNamespace, '> li', function (t) {
        V(this).is('.ui-state-disabled') && t.preventDefault();
      }).on('focus' + this.eventNamespace, '.ui-tabs-anchor', function () {
        V(this).closest('li').is('.ui-state-disabled') && this.blur();
      }), this.tabs = this.tablist.find('> li:has(a[href])').attr({
        role: 'tab',
        tabIndex: -1
      }), this._addClass(this.tabs, 'ui-tabs-tab', 'ui-state-default'), this.anchors = this.tabs.map(function () {
        return V('a', this)[0];
      }).attr({
        tabIndex: -1
      }), this._addClass(this.anchors, 'ui-tabs-anchor'), this.panels = V(), this.anchors.each(function (t, e) {
        var i,
          s,
          n,
          o = V(e).uniqueId().attr('id'),
          a = V(e).closest('li'),
          r = a.attr('aria-controls');
        l._isLocal(e) ? (n = (i = e.hash).substring(1), s = l.element.find(l._sanitizeSelector(i))) : (n = a.attr('aria-controls') || V({}).uniqueId()[0].id, (s = l.element.find(i = '#' + n)).length || (s = l._createPanel(n)).insertAfter(l.panels[t - 1] || l.tablist), s.attr('aria-live', 'polite')), s.length && (l.panels = l.panels.add(s)), r && a.data('ui-tabs-aria-controls', r), a.attr({
          'aria-controls': n,
          'aria-labelledby': o
        }), s.attr('aria-labelledby', o);
      }), this.panels.attr('role', 'tabpanel'), this._addClass(this.panels, 'ui-tabs-panel', 'ui-widget-content'), t && (this._off(t.not(this.tabs)), this._off(e.not(this.anchors)), this._off(i.not(this.panels)));
    },
    _getList: function () {
      return this.tablist || this.element.find('ol, ul').eq(0);
    },
    _createPanel: function (t) {
      return V('<div>').attr('id', t).data('ui-tabs-destroy', !0);
    },
    _setOptionDisabled: function (t) {
      var e, i;
      for (Array.isArray(t) && (t.length ? t.length === this.anchors.length && (t = !0) : t = !1), i = 0; e = this.tabs[i]; i++) e = V(e), !0 === t || -1 !== V.inArray(i, t) ? (e.attr('aria-disabled', 'true'), this._addClass(e, null, 'ui-state-disabled')) : (e.removeAttr('aria-disabled'), this._removeClass(e, null, 'ui-state-disabled'));
      this.options.disabled = t, this._toggleClass(this.widget(), this.widgetFullName + '-disabled', null, !0 === t);
    },
    _setupEvents: function (t) {
      var i = {};
      t && V.each(t.split(' '), function (t, e) {
        i[e] = '_eventHandler';
      }), this._off(this.anchors.add(this.tabs).add(this.panels)), this._on(!0, this.anchors, {
        click: function (t) {
          t.preventDefault();
        }
      }), this._on(this.anchors, i), this._on(this.tabs, {
        keydown: '_tabKeydown'
      }), this._on(this.panels, {
        keydown: '_panelKeydown'
      }), this._focusable(this.tabs), this._hoverable(this.tabs);
    },
    _setupHeightStyle: function (t) {
      var i,
        e = this.element.parent();
      'fill' === t ? (i = e.height(), i -= this.element.outerHeight() - this.element.height(), this.element.siblings(':visible').each(function () {
        var t = V(this),
          e = t.css('position');
        'absolute' !== e && 'fixed' !== e && (i -= t.outerHeight(!0));
      }), this.element.children().not(this.panels).each(function () {
        i -= V(this).outerHeight(!0);
      }), this.panels.each(function () {
        V(this).height(Math.max(0, i - V(this).innerHeight() + V(this).height()));
      }).css('overflow', 'auto')) : 'auto' === t && (i = 0, this.panels.each(function () {
        i = Math.max(i, V(this).height('').height());
      }).height(i));
    },
    _eventHandler: function (t) {
      var e = this.options,
        i = this.active,
        s = V(t.currentTarget).closest('li'),
        n = s[0] === i[0],
        o = n && e.collapsible,
        a = o ? V() : this._getPanelForTab(s),
        r = i.length ? this._getPanelForTab(i) : V(),
        i = {
          oldTab: i,
          oldPanel: r,
          newTab: o ? V() : s,
          newPanel: a
        };
      t.preventDefault(), s.hasClass('ui-state-disabled') || s.hasClass('ui-tabs-loading') || this.running || n && !e.collapsible || !1 === this._trigger('beforeActivate', t, i) || (e.active = !o && this.tabs.index(s), this.active = n ? V() : s, this.xhr && this.xhr.abort(), r.length || a.length || V.error('jQuery UI Tabs: Mismatching fragment identifier.'), a.length && this.load(this.tabs.index(s), t), this._toggle(t, i));
    },
    _toggle: function (t, e) {
      var i = this,
        s = e.newPanel,
        n = e.oldPanel;
      function o() {
        ;
        i.running = !1, i._trigger('activate', t, e);
      }
      function a() {
        i._addClass(e.newTab.closest('li'), 'ui-tabs-active', 'ui-state-active'), s.length && i.options.show ? i._show(s, i.options.show, o) : (s.show(), o());
      }
      ;
      this.running = !0, n.length && this.options.hide ? this._hide(n, this.options.hide, function () {
        i._removeClass(e.oldTab.closest('li'), 'ui-tabs-active', 'ui-state-active'), a();
      }) : (this._removeClass(e.oldTab.closest('li'), 'ui-tabs-active', 'ui-state-active'), n.hide(), a()), n.attr('aria-hidden', 'true'), e.oldTab.attr({
        'aria-selected': 'false',
        'aria-expanded': 'false'
      }), s.length && n.length ? e.oldTab.attr('tabIndex', -1) : s.length && this.tabs.filter(function () {
        return 0 === V(this).attr('tabIndex');
      }).attr('tabIndex', -1), s.attr('aria-hidden', 'false'), e.newTab.attr({
        'aria-selected': 'true',
        'aria-expanded': 'true',
        tabIndex: 0
      });
    },
    _activate: function (t) {
      var t = this._findActive(t);
      t[0] !== this.active[0] && (t = (t = !t.length ? this.active : t).find('.ui-tabs-anchor')[0], this._eventHandler({
        target: t,
        currentTarget: t,
        preventDefault: V.noop
      }));
    },
    _findActive: function (t) {
      return !1 === t ? V() : this.tabs.eq(t);
    },
    _getIndex: function (t) {
      return t = 'string' == typeof t ? this.anchors.index(this.anchors.filter("[href$='" + V.escapeSelector(t) + "']")) : t;
    },
    _destroy: function () {
      this.xhr && this.xhr.abort(), this.tablist.removeAttr('role').off(this.eventNamespace), this.anchors.removeAttr('role tabIndex').removeUniqueId(), this.tabs.add(this.panels).each(function () {
        V.data(this, 'ui-tabs-destroy') ? V(this).remove() : V(this).removeAttr('role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded');
      }), this.tabs.each(function () {
        var t = V(this),
          e = t.data('ui-tabs-aria-controls');
        e ? t.attr('aria-controls', e).removeData('ui-tabs-aria-controls') : t.removeAttr('aria-controls');
      }), this.panels.show(), 'content' !== this.options.heightStyle && this.panels.css('height', '');
    },
    enable: function (i) {
      var t = this.options.disabled;
      !1 !== t && (t = void 0 !== i && (i = this._getIndex(i), Array.isArray(t) ? V.map(t, function (t) {
        return t !== i ? t : null;
      }) : V.map(this.tabs, function (t, e) {
        return e !== i ? e : null;
      })), this._setOptionDisabled(t));
    },
    disable: function (t) {
      var e = this.options.disabled;
      if (!0 !== e) {
        if (void 0 === t) e = !0;else {
          if (t = this._getIndex(t), -1 !== V.inArray(t, e)) return;
          e = Array.isArray(e) ? V.merge([t], e).sort() : [t];
        }
        this._setOptionDisabled(e);
      }
    },
    load: function (t, s) {
      t = this._getIndex(t);
      function n(t, e) {
        'abort' === e && o.panels.stop(!1, !0), o._removeClass(i, 'ui-tabs-loading'), a.removeAttr('aria-busy'), t === o.xhr && delete o.xhr;
      }
      var o = this,
        i = this.tabs.eq(t),
        t = i.find('.ui-tabs-anchor'),
        a = this._getPanelForTab(i),
        r = {
          tab: i,
          panel: a
        };
      this._isLocal(t[0]) || (this.xhr = V.ajax(this._ajaxSettings(t, s, r)), this.xhr && 'canceled' !== this.xhr.statusText && (this._addClass(i, 'ui-tabs-loading'), a.attr('aria-busy', 'true'), this.xhr.done(function (t, e, i) {
        setTimeout(function () {
          a.html(t), o._trigger('load', s, r), n(i, e);
        }, 1);
      }).fail(function (t, e) {
        setTimeout(function () {
          n(t, e);
        }, 1);
      })));
    },
    _ajaxSettings: function (t, i, s) {
      var n = this;
      return {
        url: t.attr('href').replace(/#.*$/, ''),
        beforeSend: function (t, e) {
          return n._trigger('beforeLoad', i, V.extend({
            jqXHR: t,
            ajaxSettings: e
          }, s));
        }
      };
    },
    _getPanelForTab: function (t) {
      t = V(t).attr('aria-controls');
      return this.element.find(this._sanitizeSelector('#' + t));
    }
  }), !1 !== V.uiBackCompat && V.widget('ui.tabs', V.ui.tabs, {
    _processTabs: function () {
      this._superApply(arguments), this._addClass(this.tabs, 'ui-tab');
    }
  });
  V.ui.tabs;
  V.widget('ui.tooltip', {
    version: '1.13.1',
    options: {
      classes: {
        'ui-tooltip': 'ui-corner-all ui-widget-shadow'
      },
      content: function () {
        var t = V(this).attr('title');
        return V('<a>').text(t).html();
      },
      hide: !0,
      items: '[title]:not([disabled])',
      position: {
        my: 'left top+15',
        at: 'left bottom',
        collision: 'flipfit flip'
      },
      show: !0,
      track: !1,
      close: null,
      open: null
    },
    _addDescribedBy: function (t, e) {
      var i = (t.attr('aria-describedby') || '').split(/\s+/);
      i.push(e), t.data('ui-tooltip-id', e).attr('aria-describedby', String.prototype.trim.call(i.join(' ')));
    },
    _removeDescribedBy: function (t) {
      var e = t.data('ui-tooltip-id'),
        i = (t.attr('aria-describedby') || '').split(/\s+/),
        e = V.inArray(e, i);
      -1 !== e && i.splice(e, 1), t.removeData('ui-tooltip-id'), (i = String.prototype.trim.call(i.join(' '))) ? t.attr('aria-describedby', i) : t.removeAttr('aria-describedby');
    },
    _create: function () {
      this._on({
        mouseover: 'open',
        focusin: 'open'
      }), this.tooltips = {}, this.parents = {}, this.liveRegion = V('<div>').attr({
        role: 'log',
        'aria-live': 'assertive',
        'aria-relevant': 'additions'
      }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, 'ui-helper-hidden-accessible'), this.disabledTitles = V([]);
    },
    _setOption: function (t, e) {
      var i = this;
      this._super(t, e), 'content' === t && V.each(this.tooltips, function (t, e) {
        i._updateContent(e.element);
      });
    },
    _setOptionDisabled: function (t) {
      this[t ? '_disable' : '_enable']();
    },
    _disable: function () {
      var s = this;
      V.each(this.tooltips, function (t, e) {
        var i = V.Event('blur');
        i.target = i.currentTarget = e.element[0], s.close(i, !0);
      }), this.disabledTitles = this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function () {
        var t = V(this);
        if (t.is('[title]')) return t.data('ui-tooltip-title', t.attr('title')).removeAttr('title');
      }));
    },
    _enable: function () {
      this.disabledTitles.each(function () {
        var t = V(this);
        t.data('ui-tooltip-title') && t.attr('title', t.data('ui-tooltip-title'));
      }), this.disabledTitles = V([]);
    },
    open: function (t) {
      var i = this,
        e = V(t ? t.target : this.element).closest(this.options.items);
      e.length && !e.data('ui-tooltip-id') && (e.attr('title') && e.data('ui-tooltip-title', e.attr('title')), e.data('ui-tooltip-open', !0), t && 'mouseover' === t.type && e.parents().each(function () {
        var t,
          e = V(this);
        e.data('ui-tooltip-open') && ((t = V.Event('blur')).target = t.currentTarget = this, i.close(t, !0)), e.attr('title') && (e.uniqueId(), i.parents[this.id] = {
          element: this,
          title: e.attr('title')
        }, e.attr('title', ''));
      }), this._registerCloseHandlers(t, e), this._updateContent(e, t));
    },
    _updateContent: function (e, i) {
      var t = this.options.content,
        s = this,
        n = i ? i.type : null;
      if ('string' == typeof t || t.nodeType || t.jquery) return this._open(i, e, t);
      (t = t.call(e[0], function (t) {
        s._delay(function () {
          e.data('ui-tooltip-open') && (i && (i.type = n), this._open(i, e, t));
        });
      })) && this._open(i, e, t);
    },
    _open: function (t, e, i) {
      var s,
        n,
        o,
        a = V.extend({}, this.options.position);
      function r(t) {
        ;
        a.of = t, n.is(':hidden') || n.position(a);
      }
      i && ((s = this._find(e)) ? s.tooltip.find('.ui-tooltip-content').html(i) : (e.is('[title]') && (t && 'mouseover' === t.type ? e.attr('title', '') : e.removeAttr('title')), s = this._tooltip(e), n = s.tooltip, this._addDescribedBy(e, n.attr('id')), n.find('.ui-tooltip-content').html(i), this.liveRegion.children().hide(), (i = V('<div>').html(n.find('.ui-tooltip-content').html())).removeAttr('name').find('[name]').removeAttr('name'), i.removeAttr('id').find('[id]').removeAttr('id'), i.appendTo(this.liveRegion), this.options.track && t && /^mouse/.test(t.type) ? (this._on(this.document, {
        mousemove: r
      }), r(t)) : n.position(V.extend({
        of: e
      }, this.options.position)), n.hide(), this._show(n, this.options.show), this.options.track && this.options.show && this.options.show.delay && (o = this.delayedShow = setInterval(function () {
        n.is(':visible') && (r(a.of), clearInterval(o));
      }, 13)), this._trigger('open', t, {
        tooltip: n
      })));
    },
    _registerCloseHandlers: function (t, e) {
      var i = {
        keyup: function (t) {
          t.keyCode === V.ui.keyCode.ESCAPE && ((t = V.Event(t)).currentTarget = e[0], this.close(t, !0));
        }
      };
      e[0] !== this.element[0] && (i.remove = function () {
        var t = this._find(e);
        t && this._removeTooltip(t.tooltip);
      }), t && 'mouseover' !== t.type || (i.mouseleave = 'close'), t && 'focusin' !== t.type || (i.focusout = 'close'), this._on(!0, e, i);
    },
    close: function (t) {
      var e,
        i = this,
        s = V(t ? t.currentTarget : this.element),
        n = this._find(s);
      n ? (e = n.tooltip, n.closing || (clearInterval(this.delayedShow), s.data('ui-tooltip-title') && !s.attr('title') && s.attr('title', s.data('ui-tooltip-title')), this._removeDescribedBy(s), n.hiding = !0, e.stop(!0), this._hide(e, this.options.hide, function () {
        i._removeTooltip(V(this));
      }), s.removeData('ui-tooltip-open'), this._off(s, 'mouseleave focusout keyup'), s[0] !== this.element[0] && this._off(s, 'remove'), this._off(this.document, 'mousemove'), t && 'mouseleave' === t.type && V.each(this.parents, function (t, e) {
        V(e.element).attr('title', e.title), delete i.parents[t];
      }), n.closing = !0, this._trigger('close', t, {
        tooltip: e
      }), n.hiding || (n.closing = !1))) : s.removeData('ui-tooltip-open');
    },
    _tooltip: function (t) {
      var e = V('<div>').attr('role', 'tooltip'),
        i = V('<div>').appendTo(e),
        s = e.uniqueId().attr('id');
      return this._addClass(i, 'ui-tooltip-content'), this._addClass(e, 'ui-tooltip', 'ui-widget ui-widget-content'), e.appendTo(this._appendTo(t)), this.tooltips[s] = {
        element: t,
        tooltip: e
      };
    },
    _find: function (t) {
      t = t.data('ui-tooltip-id');
      return t ? this.tooltips[t] : null;
    },
    _removeTooltip: function (t) {
      clearInterval(this.delayedShow), t.remove(), delete this.tooltips[t.attr('id')];
    },
    _appendTo: function (t) {
      t = t.closest('.ui-front, dialog');
      return t = !t.length ? this.document[0].body : t;
    },
    _destroy: function () {
      var s = this;
      V.each(this.tooltips, function (t, e) {
        var i = V.Event('blur'),
          e = e.element;
        i.target = i.currentTarget = e[0], s.close(i, !0), V('#' + t).remove(), e.data('ui-tooltip-title') && (e.attr('title') || e.attr('title', e.data('ui-tooltip-title')), e.removeData('ui-tooltip-title'));
      }), this.liveRegion.remove();
    }
  }), !1 !== V.uiBackCompat && V.widget('ui.tooltip', V.ui.tooltip, {
    options: {
      tooltipClass: null
    },
    _tooltip: function () {
      var t = this._superApply(arguments);
      return this.options.tooltipClass && t.tooltip.addClass(this.options.tooltipClass), t;
    }
  });
  V.ui.tooltip;
});

/***/ }),

/***/ "./src/assets/js/vendor/jquery.animateNumber.min.js":
/*!**********************************************************!*\
  !*** ./src/assets/js/vendor/jquery.animateNumber.min.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
 jQuery animateNumber plugin v0.0.14
 (c) 2013, Alexandr Borisov.
 https://github.com/aishek/jquery-animateNumber
*/
(function (d) {
  var r = function (b) {
      return b.split("").reverse().join("");
    },
    m = {
      numberStep: function (b, a) {
        var e = Math.floor(b);
        d(a.elem).text(e);
      }
    },
    g = function (b) {
      var a = b.elem;
      a.nodeType && a.parentNode && (a = a._animateNumberSetter, a || (a = m.numberStep), a(b.now, b));
    };
  d.Tween && d.Tween.propHooks ? d.Tween.propHooks.number = {
    set: g
  } : d.fx.step.number = g;
  d.animateNumber = {
    numberStepFactories: {
      append: function (b) {
        return function (a, e) {
          var f = Math.floor(a);
          d(e.elem).prop("number", a).text(f + b);
        };
      },
      separator: function (b, a, e) {
        b = b || " ";
        a = a || 3;
        e = e || "";
        return function (f, k) {
          var u = 0 > f,
            c = Math.floor((u ? -1 : 1) * f).toString(),
            n = d(k.elem);
          if (c.length > a) {
            for (var h = c, l = a, m = h.split("").reverse(), c = [], p, s, q, t = 0, g = Math.ceil(h.length / l); t < g; t++) {
              p = "";
              for (q = 0; q < l; q++) {
                s = t * l + q;
                if (s === h.length) break;
                p += m[s];
              }
              c.push(p);
            }
            h = c.length - 1;
            l = r(c[h]);
            c[h] = r(parseInt(l, 10).toString());
            c = c.join(b);
            c = r(c);
          }
          n.prop("number", f).text((u ? "-" : "") + c + e);
        };
      }
    }
  };
  d.fn.animateNumber = function () {
    for (var b = arguments[0], a = d.extend({}, m, b), e = d(this), f = [a], k = 1, g = arguments.length; k < g; k++) f.push(arguments[k]);
    if (b.numberStep) {
      var c = this.each(function () {
          this._animateNumberSetter = b.numberStep;
        }),
        n = a.complete;
      a.complete = function () {
        c.each(function () {
          delete this._animateNumberSetter;
        });
        n && n.apply(this, arguments);
      };
    }
    return e.animate.apply(e, f);
  };
})(jQuery);

/***/ }),

/***/ "./src/assets/js/vendor/jquery.viewportchecker.min.js":
/*!************************************************************!*\
  !*** ./src/assets/js/vendor/jquery.viewportchecker.min.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * jQuery-viewport-checker - v1.8.8 - 2017-09-25
 * https://github.com/dirkgroenen/jQuery-viewport-checker
 *
 * Copyright (c) 2017 Dirk Groenen
 * Licensed MIT <https://github.com/dirkgroenen/jQuery-viewport-checker/blob/master/LICENSE>
 */

!function (a) {
  a.fn.viewportChecker = function (b) {
    var c = {
      classToAdd: "visible",
      classToRemove: "invisible",
      classToAddForFullView: "full-visible",
      removeClassAfterAnimation: !1,
      offset: 100,
      repeat: !1,
      invertBottomOffset: !0,
      callbackFunction: function (a, b) {},
      scrollHorizontal: !1,
      scrollBox: window
    };
    a.extend(c, b);
    var d = this,
      e = {
        height: a(c.scrollBox).height(),
        width: a(c.scrollBox).width()
      };
    return this.checkElements = function () {
      var b, f;
      c.scrollHorizontal ? (b = Math.max(a("html").scrollLeft(), a("body").scrollLeft(), a(window).scrollLeft()), f = b + e.width) : (b = Math.max(a("html").scrollTop(), a("body").scrollTop(), a(window).scrollTop()), f = b + e.height), d.each(function () {
        var d = a(this),
          g = {},
          h = {};
        if (d.data("vp-add-class") && (h.classToAdd = d.data("vp-add-class")), d.data("vp-remove-class") && (h.classToRemove = d.data("vp-remove-class")), d.data("vp-add-class-full-view") && (h.classToAddForFullView = d.data("vp-add-class-full-view")), d.data("vp-keep-add-class") && (h.removeClassAfterAnimation = d.data("vp-remove-after-animation")), d.data("vp-offset") && (h.offset = d.data("vp-offset")), d.data("vp-repeat") && (h.repeat = d.data("vp-repeat")), d.data("vp-scrollHorizontal") && (h.scrollHorizontal = d.data("vp-scrollHorizontal")), d.data("vp-invertBottomOffset") && (h.scrollHorizontal = d.data("vp-invertBottomOffset")), a.extend(g, c), a.extend(g, h), !d.data("vp-animated") || g.repeat) {
          String(g.offset).indexOf("%") > 0 && (g.offset = parseInt(g.offset) / 100 * e.height);
          var i = g.scrollHorizontal ? d.offset().left : d.offset().top,
            j = g.scrollHorizontal ? i + d.width() : i + d.height(),
            k = Math.round(i) + g.offset,
            l = g.scrollHorizontal ? k + d.width() : k + d.height();
          g.invertBottomOffset && (l -= 2 * g.offset), k < f && l > b ? (d.removeClass(g.classToRemove), d.addClass(g.classToAdd), g.callbackFunction(d, "add"), j <= f && i >= b ? d.addClass(g.classToAddForFullView) : d.removeClass(g.classToAddForFullView), d.data("vp-animated", !0), g.removeClassAfterAnimation && d.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
            d.removeClass(g.classToAdd);
          })) : d.hasClass(g.classToAdd) && g.repeat && (d.removeClass(g.classToAdd + " " + g.classToAddForFullView), g.callbackFunction(d, "remove"), d.data("vp-animated", !1));
        }
      });
    }, ("ontouchstart" in window || "onmsgesturechange" in window) && a(document).bind("touchmove MSPointerMove pointermove", this.checkElements), a(c.scrollBox).bind("load scroll", this.checkElements), a(window).resize(function (b) {
      e = {
        height: a(c.scrollBox).height(),
        width: a(c.scrollBox).width()
      }, d.checkElements();
    }), this.checkElements(), this;
  };
}(jQuery);

/***/ }),

/***/ 0:
/*!********************************************************************************!*\
  !*** multi ./src/assets/js/blocks/env/develop.js ./src/assets/js/construct.js ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./src/assets/js/blocks/env/develop.js */"./src/assets/js/blocks/env/develop.js");
module.exports = __webpack_require__(/*! ./src/assets/js/construct.js */"./src/assets/js/construct.js");


/***/ }),

/***/ 1:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

/******/ });
